'use strict';

runBlock.$inject = ["$rootScope", "AppSettings", "UsersTable", "MeetingsTable", "ProjectsTable"];
routesConfig.$inject = ["$stateProvider", "$urlRouterProvider", "$locationProvider"];
var cov_12czxdznnt = function () {
    var path = '/home/lobo/repos/meetings-app/src/index.js',
        hash = '799421ff6a6ab92c3f63bbc61a1a159901df8d63',
        Function = function () {}.constructor,
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/meetings-app/src/index.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 26,
                    column: 15
                }
            },
            '1': {
                start: {
                    line: 30,
                    column: 4
                },
                end: {
                    line: 30,
                    column: 41
                }
            },
            '2': {
                start: {
                    line: 32,
                    column: 4
                },
                end: {
                    line: 36,
                    column: 6
                }
            },
            '3': {
                start: {
                    line: 33,
                    column: 8
                },
                end: {
                    line: 33,
                    column: 66
                }
            },
            '4': {
                start: {
                    line: 34,
                    column: 8
                },
                end: {
                    line: 34,
                    column: 75
                }
            },
            '5': {
                start: {
                    line: 35,
                    column: 8
                },
                end: {
                    line: 35,
                    column: 75
                }
            },
            '6': {
                start: {
                    line: 37,
                    column: 4
                },
                end: {
                    line: 37,
                    column: 32
                }
            }
        },
        fnMap: {
            '0': {
                name: 'runBlock',
                decl: {
                    start: {
                        line: 29,
                        column: 9
                    },
                    end: {
                        line: 29,
                        column: 17
                    }
                },
                loc: {
                    start: {
                        line: 29,
                        column: 85
                    },
                    end: {
                        line: 38,
                        column: 1
                    }
                },
                line: 29
            },
            '1': {
                name: '(anonymous_1)',
                decl: {
                    start: {
                        line: 32,
                        column: 32
                    },
                    end: {
                        line: 32,
                        column: 33
                    }
                },
                loc: {
                    start: {
                        line: 32,
                        column: 44
                    },
                    end: {
                        line: 36,
                        column: 5
                    }
                },
                line: 32
            }
        },
        branchMap: {},
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0
        },
        f: {
            '0': 0,
            '1': 0
        },
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_12czxdznnt.s[0]++;
angular.module('app', ['ui.router', 'restmod', 'restmod.styles.drfPaged', 'ngMaterial', 'satellizer', 'ngFileUpload', 'cgBusy', 'angularMoment', 'angular-loading-bar', 'angular.filter', 'ui.mask', 'as.sortable']).constant('moment', moment).constant('AppSettings', {
    appUrl: 'https://meetings.soloweb.pt',
    apiUrl: 'https://api.meetings.soloweb.pt',
    mediaUrl: 'https://api.meetings.soloweb.pt/static/media'
}).value('cgBusyDefaults', {
    message: '',
    templateUrl: 'app/shared/html/cgbusy/cgbusy.template.html'
}).run(runBlock);

/** @ngInject */
function runBlock($rootScope, AppSettings, UsersTable, MeetingsTable, ProjectsTable) {
    cov_12czxdznnt.f[0]++;
    cov_12czxdznnt.s[1]++;

    $rootScope.AppSettings = AppSettings; // You can now access AppSettings from any component with $root.AppSettings

    cov_12czxdznnt.s[2]++;
    $rootScope.loadStaticData = function () {
        cov_12czxdznnt.f[1]++;
        cov_12czxdznnt.s[3]++;

        $rootScope.users = UsersTable.$all = UsersTable.$search();
        cov_12czxdznnt.s[4]++;
        $rootScope.meetings = MeetingsTable.$all = MeetingsTable.$search();
        cov_12czxdznnt.s[5]++;
        $rootScope.projects = ProjectsTable.$all = ProjectsTable.$search();
    };
    cov_12czxdznnt.s[6]++;
    $rootScope.loadStaticData();
}
'use strict';

var cov_29ibtru1yn = function () {
    var path = '/home/lobo/repos/meetings-app/src/app/shared/js/media/media.table.factory.js',
        hash = '89f46090986f938c0671345904acec902fda62a7',
        Function = function () {}.constructor,
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/meetings-app/src/app/shared/js/media/media.table.factory.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 13,
                    column: 5
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 4
                },
                end: {
                    line: 6,
                    column: 47
                }
            },
            '2': {
                start: {
                    line: 11,
                    column: 8
                },
                end: {
                    line: 11,
                    column: 67
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 1,
                        column: 1
                    },
                    end: {
                        line: 1,
                        column: 2
                    }
                },
                loc: {
                    start: {
                        line: 1,
                        column: 13
                    },
                    end: {
                        line: 13,
                        column: 1
                    }
                },
                line: 1
            },
            '1': {
                name: 'RestmodFactory',
                decl: {
                    start: {
                        line: 9,
                        column: 13
                    },
                    end: {
                        line: 9,
                        column: 27
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 37
                    },
                    end: {
                        line: 12,
                        column: 5
                    }
                },
                line: 9
            }
        },
        branchMap: {},
        s: {
            '0': 0,
            '1': 0,
            '2': 0
        },
        f: {
            '0': 0,
            '1': 0
        },
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_29ibtru1yn.s[0]++;
(function () {
    'use strict';

    RestmodFactory.$inject = ["restmod"];
    cov_29ibtru1yn.f[0]++;
    cov_29ibtru1yn.s[1]++;
    angular.module('app').factory('MediaTable', RestmodFactory);

    /* @ngInject */
    function RestmodFactory(restmod) {
        cov_29ibtru1yn.f[1]++;
        cov_29ibtru1yn.s[2]++;


        return restmod.model('/media').mix('MixinContainable', {});
    }
})();
'use strict';

var cov_1lrp0fyyzt = function () {
    var path = '/home/lobo/repos/meetings-app/src/app/shared/js/media/media.service.js',
        hash = '8505dda9372fc2ec3ef0e905c0cca0b2d85a3910',
        Function = function () {}.constructor,
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/meetings-app/src/app/shared/js/media/media.service.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 36,
                    column: 5
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 4
                },
                end: {
                    line: 6,
                    column: 42
                }
            },
            '2': {
                start: {
                    line: 10,
                    column: 8
                },
                end: {
                    line: 10,
                    column: 29
                }
            },
            '3': {
                start: {
                    line: 13,
                    column: 12
                },
                end: {
                    line: 13,
                    column: 74
                }
            },
            '4': {
                start: {
                    line: 15,
                    column: 12
                },
                end: {
                    line: 33,
                    column: 13
                }
            },
            '5': {
                start: {
                    line: 16,
                    column: 16
                },
                end: {
                    line: 29,
                    column: 19
                }
            },
            '6': {
                start: {
                    line: 22,
                    column: 20
                },
                end: {
                    line: 22,
                    column: 42
                }
            },
            '7': {
                start: {
                    line: 24,
                    column: 20
                },
                end: {
                    line: 24,
                    column: 71
                }
            },
            '8': {
                start: {
                    line: 25,
                    column: 20
                },
                end: {
                    line: 25,
                    column: 37
                }
            },
            '9': {
                start: {
                    line: 27,
                    column: 45
                },
                end: {
                    line: 27,
                    column: 85
                }
            },
            '10': {
                start: {
                    line: 28,
                    column: 20
                },
                end: {
                    line: 28,
                    column: 90
                }
            },
            '11': {
                start: {
                    line: 31,
                    column: 16
                },
                end: {
                    line: 31,
                    column: 60
                }
            },
            '12': {
                start: {
                    line: 32,
                    column: 16
                },
                end: {
                    line: 32,
                    column: 33
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 1,
                        column: 1
                    },
                    end: {
                        line: 1,
                        column: 2
                    }
                },
                loc: {
                    start: {
                        line: 1,
                        column: 13
                    },
                    end: {
                        line: 36,
                        column: 1
                    }
                },
                line: 1
            },
            '1': {
                name: 'Service',
                decl: {
                    start: {
                        line: 9,
                        column: 13
                    },
                    end: {
                        line: 9,
                        column: 20
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 52
                    },
                    end: {
                        line: 35,
                        column: 5
                    }
                },
                line: 9
            },
            '2': {
                name: 'upload',
                decl: {
                    start: {
                        line: 12,
                        column: 17
                    },
                    end: {
                        line: 12,
                        column: 23
                    }
                },
                loc: {
                    start: {
                        line: 12,
                        column: 30
                    },
                    end: {
                        line: 34,
                        column: 9
                    }
                },
                line: 12
            },
            '3': {
                name: '(anonymous_3)',
                decl: {
                    start: {
                        line: 21,
                        column: 24
                    },
                    end: {
                        line: 21,
                        column: 25
                    }
                },
                loc: {
                    start: {
                        line: 21,
                        column: 40
                    },
                    end: {
                        line: 23,
                        column: 17
                    }
                },
                line: 21
            },
            '4': {
                name: '(anonymous_4)',
                decl: {
                    start: {
                        line: 23,
                        column: 19
                    },
                    end: {
                        line: 23,
                        column: 20
                    }
                },
                loc: {
                    start: {
                        line: 23,
                        column: 31
                    },
                    end: {
                        line: 26,
                        column: 17
                    }
                },
                line: 23
            },
            '5': {
                name: '(anonymous_5)',
                decl: {
                    start: {
                        line: 26,
                        column: 19
                    },
                    end: {
                        line: 26,
                        column: 20
                    }
                },
                loc: {
                    start: {
                        line: 26,
                        column: 34
                    },
                    end: {
                        line: 29,
                        column: 17
                    }
                },
                line: 26
            }
        },
        branchMap: {
            '0': {
                loc: {
                    start: {
                        line: 15,
                        column: 12
                    },
                    end: {
                        line: 33,
                        column: 13
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 15,
                        column: 12
                    },
                    end: {
                        line: 33,
                        column: 13
                    }
                }, {
                    start: {
                        line: 15,
                        column: 12
                    },
                    end: {
                        line: 33,
                        column: 13
                    }
                }],
                line: 15
            }
        },
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0,
            '7': 0,
            '8': 0,
            '9': 0,
            '10': 0,
            '11': 0,
            '12': 0
        },
        f: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0
        },
        b: {
            '0': [0, 0]
        },
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_1lrp0fyyzt.s[0]++;
(function () {
    'use strict';

    Service.$inject = ["Upload", "AppSettings", "$mdToast"];
    cov_1lrp0fyyzt.f[0]++;
    cov_1lrp0fyyzt.s[1]++;
    angular.module('app').service('MediaService', Service);

    /* @ngInject */
    function Service(Upload, AppSettings, $mdToast) {
        cov_1lrp0fyyzt.f[1]++;
        cov_1lrp0fyyzt.s[2]++;

        this.upload = upload;

        function upload(file) {
            cov_1lrp0fyyzt.f[2]++;
            cov_1lrp0fyyzt.s[3]++;

            $mdToast.show($mdToast.simple().textContent('Uploading ...'));

            cov_1lrp0fyyzt.s[4]++;
            if (file) {
                cov_1lrp0fyyzt.b[0][0]++;
                cov_1lrp0fyyzt.s[5]++;

                return Upload.upload({
                    url: AppSettings.apiUrl + '/media/',
                    data: {
                        'file': file
                    }
                }).then(function (data) {
                    cov_1lrp0fyyzt.f[3]++;
                    cov_1lrp0fyyzt.s[6]++;

                    return data.data.file;
                }, function () {
                    cov_1lrp0fyyzt.f[4]++;
                    cov_1lrp0fyyzt.s[7]++;

                    $mdToast.updateTextContent('An error has ocurred');
                    cov_1lrp0fyyzt.s[8]++;
                    return undefined;
                }, function (evt) {
                    cov_1lrp0fyyzt.f[5]++;

                    var progressPercentage = (cov_1lrp0fyyzt.s[9]++, parseInt(100.0 * evt.loaded / evt.total));
                    cov_1lrp0fyyzt.s[10]++;
                    $mdToast.updateTextContent('Uploading (' + progressPercentage + '%)');
                });
            } else {
                cov_1lrp0fyyzt.b[0][1]++;
                cov_1lrp0fyyzt.s[11]++;

                $mdToast.updateTextContent('Invalid file!');
                cov_1lrp0fyyzt.s[12]++;
                return undefined;
            }
        }
    }
})();
'use strict';

var cov_3phtuiwj6 = function () {
    var path = '/home/lobo/repos/meetings-app/src/app/shared/js/media/media.run.js',
        hash = '7ff3b3e0fd24177e462ee08fca9839baa2d69f1b',
        Function = function () {}.constructor,
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/meetings-app/src/app/shared/js/media/media.run.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 12,
                    column: 5
                }
            },
            '1': {
                start: {
                    line: 3,
                    column: 4
                },
                end: {
                    line: 5,
                    column: 23
                }
            },
            '2': {
                start: {
                    line: 9,
                    column: 8
                },
                end: {
                    line: 9,
                    column: 41
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 1,
                        column: 1
                    },
                    end: {
                        line: 1,
                        column: 2
                    }
                },
                loc: {
                    start: {
                        line: 1,
                        column: 13
                    },
                    end: {
                        line: 12,
                        column: 1
                    }
                },
                line: 1
            },
            '1': {
                name: 'runBlock',
                decl: {
                    start: {
                        line: 8,
                        column: 13
                    },
                    end: {
                        line: 8,
                        column: 21
                    }
                },
                loc: {
                    start: {
                        line: 8,
                        column: 48
                    },
                    end: {
                        line: 10,
                        column: 5
                    }
                },
                line: 8
            }
        },
        branchMap: {},
        s: {
            '0': 0,
            '1': 0,
            '2': 0
        },
        f: {
            '0': 0,
            '1': 0
        },
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_3phtuiwj6.s[0]++;
(function () {
    'use strict';

    runBlock.$inject = ["$rootScope", "MediaService"];
    cov_3phtuiwj6.f[0]++;
    cov_3phtuiwj6.s[1]++;
    angular.module('app').run(runBlock);

    /* @ngInject */
    function runBlock($rootScope, MediaService) {
        cov_3phtuiwj6.f[1]++;
        cov_3phtuiwj6.s[2]++;

        $rootScope.$Media = MediaService;
    }
})();
'use strict';

var cov_y7czjpqlz = function () {
    var path = '/home/lobo/repos/meetings-app/src/app/shared/js/media/media.filter.js',
        hash = '8e919dc84462fce5b2dd6ccf543caa25dba88c95',
        Function = function () {}.constructor,
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/meetings-app/src/app/shared/js/media/media.filter.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 18,
                    column: 5
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 4
                },
                end: {
                    line: 6,
                    column: 38
                }
            },
            '2': {
                start: {
                    line: 10,
                    column: 8
                },
                end: {
                    line: 16,
                    column: 10
                }
            },
            '3': {
                start: {
                    line: 11,
                    column: 12
                },
                end: {
                    line: 15,
                    column: 13
                }
            },
            '4': {
                start: {
                    line: 12,
                    column: 16
                },
                end: {
                    line: 12,
                    column: 58
                }
            },
            '5': {
                start: {
                    line: 14,
                    column: 16
                },
                end: {
                    line: 14,
                    column: 28
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 1,
                        column: 1
                    },
                    end: {
                        line: 1,
                        column: 2
                    }
                },
                loc: {
                    start: {
                        line: 1,
                        column: 13
                    },
                    end: {
                        line: 18,
                        column: 1
                    }
                },
                line: 1
            },
            '1': {
                name: 'MediaUrl',
                decl: {
                    start: {
                        line: 9,
                        column: 13
                    },
                    end: {
                        line: 9,
                        column: 21
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 35
                    },
                    end: {
                        line: 17,
                        column: 5
                    }
                },
                line: 9
            },
            '2': {
                name: '(anonymous_2)',
                decl: {
                    start: {
                        line: 10,
                        column: 15
                    },
                    end: {
                        line: 10,
                        column: 16
                    }
                },
                loc: {
                    start: {
                        line: 10,
                        column: 32
                    },
                    end: {
                        line: 16,
                        column: 9
                    }
                },
                line: 10
            }
        },
        branchMap: {
            '0': {
                loc: {
                    start: {
                        line: 11,
                        column: 12
                    },
                    end: {
                        line: 15,
                        column: 13
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 11,
                        column: 12
                    },
                    end: {
                        line: 15,
                        column: 13
                    }
                }, {
                    start: {
                        line: 11,
                        column: 12
                    },
                    end: {
                        line: 15,
                        column: 13
                    }
                }],
                line: 11
            }
        },
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0
        },
        f: {
            '0': 0,
            '1': 0,
            '2': 0
        },
        b: {
            '0': [0, 0]
        },
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_y7czjpqlz.s[0]++;
(function () {
    'use strict';

    MediaUrl.$inject = ["AppSettings"];
    cov_y7czjpqlz.f[0]++;
    cov_y7czjpqlz.s[1]++;
    angular.module('app').filter('mediaUrl', MediaUrl);

    /* @ngInject */
    function MediaUrl(AppSettings) {
        cov_y7czjpqlz.f[1]++;
        cov_y7czjpqlz.s[2]++;

        return function (input) {
            cov_y7czjpqlz.f[2]++;
            cov_y7czjpqlz.s[3]++;

            if (input) {
                cov_y7czjpqlz.b[0][0]++;
                cov_y7czjpqlz.s[4]++;

                return AppSettings.mediaUrl + '/' + input;
            } else {
                cov_y7czjpqlz.b[0][1]++;
                cov_y7czjpqlz.s[5]++;

                return null;
            }
        };
    }
})();
'use strict';

var cov_27vnfiqfb5 = function () {
    var path = '/home/lobo/repos/meetings-app/src/app/shared/js/media/media.directive.js',
        hash = 'bf8b18a67863438771efe7f1b7a899fee00d6ee7',
        Function = function () {}.constructor,
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/meetings-app/src/app/shared/js/media/media.directive.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 36,
                    column: 5
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 4
                },
                end: {
                    line: 6,
                    column: 54
                }
            },
            '2': {
                start: {
                    line: 10,
                    column: 8
                },
                end: {
                    line: 34,
                    column: 10
                }
            },
            '3': {
                start: {
                    line: 13,
                    column: 29
                },
                end: {
                    line: 13,
                    column: 55
                }
            },
            '4': {
                start: {
                    line: 14,
                    column: 29
                },
                end: {
                    line: 14,
                    column: 42
                }
            },
            '5': {
                start: {
                    line: 15,
                    column: 29
                },
                end: {
                    line: 15,
                    column: 34
                }
            },
            '6': {
                start: {
                    line: 17,
                    column: 16
                },
                end: {
                    line: 32,
                    column: 19
                }
            },
            '7': {
                start: {
                    line: 18,
                    column: 31
                },
                end: {
                    line: 18,
                    column: 45
                }
            },
            '8': {
                start: {
                    line: 19,
                    column: 20
                },
                end: {
                    line: 31,
                    column: 21
                }
            },
            '9': {
                start: {
                    line: 24,
                    column: 38
                },
                end: {
                    line: 24,
                    column: 70
                }
            },
            '10': {
                start: {
                    line: 25,
                    column: 24
                },
                end: {
                    line: 25,
                    column: 48
                }
            },
            '11': {
                start: {
                    line: 26,
                    column: 24
                },
                end: {
                    line: 30,
                    column: 27
                }
            },
            '12': {
                start: {
                    line: 27,
                    column: 28
                },
                end: {
                    line: 27,
                    column: 49
                }
            },
            '13': {
                start: {
                    line: 29,
                    column: 28
                },
                end: {
                    line: 29,
                    column: 49
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 1,
                        column: 1
                    },
                    end: {
                        line: 1,
                        column: 2
                    }
                },
                loc: {
                    start: {
                        line: 1,
                        column: 13
                    },
                    end: {
                        line: 36,
                        column: 1
                    }
                },
                line: 1
            },
            '1': {
                name: 'MediaDirective',
                decl: {
                    start: {
                        line: 9,
                        column: 13
                    },
                    end: {
                        line: 9,
                        column: 27
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 36
                    },
                    end: {
                        line: 35,
                        column: 5
                    }
                },
                line: 9
            },
            '2': {
                name: '(anonymous_2)',
                decl: {
                    start: {
                        line: 12,
                        column: 18
                    },
                    end: {
                        line: 12,
                        column: 19
                    }
                },
                loc: {
                    start: {
                        line: 12,
                        column: 56
                    },
                    end: {
                        line: 33,
                        column: 13
                    }
                },
                line: 12
            },
            '3': {
                name: '(anonymous_3)',
                decl: {
                    start: {
                        line: 17,
                        column: 50
                    },
                    end: {
                        line: 17,
                        column: 51
                    }
                },
                loc: {
                    start: {
                        line: 17,
                        column: 62
                    },
                    end: {
                        line: 32,
                        column: 17
                    }
                },
                line: 17
            },
            '4': {
                name: '(anonymous_4)',
                decl: {
                    start: {
                        line: 26,
                        column: 37
                    },
                    end: {
                        line: 26,
                        column: 38
                    }
                },
                loc: {
                    start: {
                        line: 26,
                        column: 53
                    },
                    end: {
                        line: 28,
                        column: 25
                    }
                },
                line: 26
            },
            '5': {
                name: '(anonymous_5)',
                decl: {
                    start: {
                        line: 28,
                        column: 27
                    },
                    end: {
                        line: 28,
                        column: 28
                    }
                },
                loc: {
                    start: {
                        line: 28,
                        column: 43
                    },
                    end: {
                        line: 30,
                        column: 25
                    }
                },
                line: 28
            }
        },
        branchMap: {
            '0': {
                loc: {
                    start: {
                        line: 19,
                        column: 20
                    },
                    end: {
                        line: 31,
                        column: 21
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 19,
                        column: 20
                    },
                    end: {
                        line: 31,
                        column: 21
                    }
                }, {
                    start: {
                        line: 19,
                        column: 20
                    },
                    end: {
                        line: 31,
                        column: 21
                    }
                }],
                line: 19
            },
            '1': {
                loc: {
                    start: {
                        line: 20,
                        column: 24
                    },
                    end: {
                        line: 22,
                        column: 70
                    }
                },
                type: 'binary-expr',
                locations: [{
                    start: {
                        line: 20,
                        column: 24
                    },
                    end: {
                        line: 20,
                        column: 28
                    }
                }, {
                    start: {
                        line: 21,
                        column: 24
                    },
                    end: {
                        line: 21,
                        column: 47
                    }
                }, {
                    start: {
                        line: 22,
                        column: 25
                    },
                    end: {
                        line: 22,
                        column: 45
                    }
                }, {
                    start: {
                        line: 22,
                        column: 49
                    },
                    end: {
                        line: 22,
                        column: 69
                    }
                }],
                line: 20
            }
        },
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0,
            '7': 0,
            '8': 0,
            '9': 0,
            '10': 0,
            '11': 0,
            '12': 0,
            '13': 0
        },
        f: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0
        },
        b: {
            '0': [0, 0],
            '1': [0, 0, 0, 0]
        },
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

cov_27vnfiqfb5.s[0]++;
(function () {
    'use strict';

    MediaDirective.$inject = ["$parse"];
    cov_27vnfiqfb5.f[0]++;
    cov_27vnfiqfb5.s[1]++;
    angular.module('app').directive('mediaAutoUpload', MediaDirective);

    /* @ngInject */
    function MediaDirective($parse) {
        cov_27vnfiqfb5.f[1]++;
        cov_27vnfiqfb5.s[2]++;

        return {
            require: '?ngModel',
            link: function link(scope, element, attributes) {
                cov_27vnfiqfb5.f[2]++;

                var getter = (cov_27vnfiqfb5.s[3]++, $parse(attributes.ngModel));
                var setter = (cov_27vnfiqfb5.s[4]++, getter.assign);
                var $scope = (cov_27vnfiqfb5.s[5]++, scope);

                cov_27vnfiqfb5.s[6]++;
                $scope.$watch(attributes.ngModel, function () {
                    cov_27vnfiqfb5.f[3]++;

                    var file = (cov_27vnfiqfb5.s[7]++, getter($scope));
                    cov_27vnfiqfb5.s[8]++;
                    if ((cov_27vnfiqfb5.b[1][0]++, file) && (cov_27vnfiqfb5.b[1][1]++, (typeof file === 'undefined' ? 'undefined' : _typeof(file)) == 'object') && ((cov_27vnfiqfb5.b[1][2]++, file instanceof File) || (cov_27vnfiqfb5.b[1][3]++, file instanceof Blob))) {
                        cov_27vnfiqfb5.b[0][0]++;

                        var promise = (cov_27vnfiqfb5.s[9]++, $scope.$root.$Media.upload(file));
                        cov_27vnfiqfb5.s[10]++;
                        setter($scope, promise);
                        cov_27vnfiqfb5.s[11]++;
                        promise.then(function (data) {
                            cov_27vnfiqfb5.f[4]++;
                            cov_27vnfiqfb5.s[12]++;

                            setter($scope, data);
                        }, function (data) {
                            cov_27vnfiqfb5.f[5]++;
                            cov_27vnfiqfb5.s[13]++;

                            setter($scope, data);
                        });
                    } else {
                        cov_27vnfiqfb5.b[0][1]++;
                    }
                });
            }
        };
    }
})();
'use strict';

var cov_2cz731d62l = function () {
    var path = '/home/lobo/repos/meetings-app/src/app/shared/js/ORM/tables.users.factory.js',
        hash = '08f5142d0677fbd21f0e47698fe5b1d55be7dd0d',
        Function = function () {}.constructor,
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/meetings-app/src/app/shared/js/ORM/tables.users.factory.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 13,
                    column: 5
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 4
                },
                end: {
                    line: 6,
                    column: 43
                }
            },
            '2': {
                start: {
                    line: 11,
                    column: 8
                },
                end: {
                    line: 11,
                    column: 67
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 1,
                        column: 1
                    },
                    end: {
                        line: 1,
                        column: 2
                    }
                },
                loc: {
                    start: {
                        line: 1,
                        column: 13
                    },
                    end: {
                        line: 13,
                        column: 1
                    }
                },
                line: 1
            },
            '1': {
                name: 'RestmodFactory',
                decl: {
                    start: {
                        line: 9,
                        column: 13
                    },
                    end: {
                        line: 9,
                        column: 27
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 38
                    },
                    end: {
                        line: 12,
                        column: 5
                    }
                },
                line: 9
            }
        },
        branchMap: {},
        s: {
            '0': 0,
            '1': 0,
            '2': 0
        },
        f: {
            '0': 0,
            '1': 0
        },
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_2cz731d62l.s[0]++;
(function () {
    'use strict';

    RestmodFactory.$inject = ["restmod"];
    cov_2cz731d62l.f[0]++;
    cov_2cz731d62l.s[1]++;
    angular.module('app').factory('UsersTable', RestmodFactory);

    /* @ngInject */
    function RestmodFactory(restmod) {
        cov_2cz731d62l.f[1]++;
        cov_2cz731d62l.s[2]++;


        return restmod.model('/users').mix('MixinContainable', {});
    }
})();
'use strict';

var cov_22p9k1utb1 = function () {
    var path = '/home/lobo/repos/meetings-app/src/app/shared/js/ORM/tables.topics.factory.js',
        hash = '81aca123185c6ce7bfab317932ba06623f941bf1',
        Function = function () {}.constructor,
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/meetings-app/src/app/shared/js/ORM/tables.topics.factory.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 28,
                    column: 5
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 4
                },
                end: {
                    line: 6,
                    column: 48
                }
            },
            '2': {
                start: {
                    line: 11,
                    column: 8
                },
                end: {
                    line: 26,
                    column: 11
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 1,
                        column: 1
                    },
                    end: {
                        line: 1,
                        column: 2
                    }
                },
                loc: {
                    start: {
                        line: 1,
                        column: 13
                    },
                    end: {
                        line: 28,
                        column: 1
                    }
                },
                line: 1
            },
            '1': {
                name: 'RestmodFactory',
                decl: {
                    start: {
                        line: 9,
                        column: 13
                    },
                    end: {
                        line: 9,
                        column: 27
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 38
                    },
                    end: {
                        line: 27,
                        column: 5
                    }
                },
                line: 9
            }
        },
        branchMap: {},
        s: {
            '0': 0,
            '1': 0,
            '2': 0
        },
        f: {
            '0': 0,
            '1': 0
        },
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_22p9k1utb1.s[0]++;
(function () {
    'use strict';

    RestmodFactory.$inject = ["restmod"];
    cov_22p9k1utb1.f[0]++;
    cov_22p9k1utb1.s[1]++;
    angular.module('app').factory('TopicsTable', RestmodFactory);

    /* @ngInject */
    function RestmodFactory(restmod) {
        cov_22p9k1utb1.f[1]++;
        cov_22p9k1utb1.s[2]++;


        return restmod.model('/topics').mix('MixinContainable', {
            $extend: {
                Collection: {
                    $limit: 1000
                }
            },
            $config: {
                contains: {
                    meetings: {
                        type: 'belongsTo',
                        table: 'MeetingsTable',
                        foreignKey: 'meeting'
                    }
                }
            }
        });
    }
})();
'use strict';

var cov_12kccvah69 = function () {
    var path = '/home/lobo/repos/meetings-app/src/app/shared/js/ORM/tables.templatetopics.factory.js',
        hash = '3271c41d90bf4f2fa2d9e510adb7579befa2b91d',
        Function = function () {}.constructor,
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/meetings-app/src/app/shared/js/ORM/tables.templatetopics.factory.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 18,
                    column: 5
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 4
                },
                end: {
                    line: 6,
                    column: 56
                }
            },
            '2': {
                start: {
                    line: 10,
                    column: 8
                },
                end: {
                    line: 16,
                    column: 11
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 1,
                        column: 1
                    },
                    end: {
                        line: 1,
                        column: 2
                    }
                },
                loc: {
                    start: {
                        line: 1,
                        column: 13
                    },
                    end: {
                        line: 18,
                        column: 1
                    }
                },
                line: 1
            },
            '1': {
                name: 'RestmodFactory',
                decl: {
                    start: {
                        line: 9,
                        column: 13
                    },
                    end: {
                        line: 9,
                        column: 27
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 38
                    },
                    end: {
                        line: 17,
                        column: 5
                    }
                },
                line: 9
            }
        },
        branchMap: {},
        s: {
            '0': 0,
            '1': 0,
            '2': 0
        },
        f: {
            '0': 0,
            '1': 0
        },
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_12kccvah69.s[0]++;
(function () {
    'use strict';

    RestmodFactory.$inject = ["restmod"];
    cov_12kccvah69.f[0]++;
    cov_12kccvah69.s[1]++;
    angular.module('app').factory('TemplateTopicsTable', RestmodFactory);

    /* @ngInject */
    function RestmodFactory(restmod) {
        cov_12kccvah69.f[1]++;
        cov_12kccvah69.s[2]++;

        return restmod.model('/template-topics').mix('MixinContainable', {
            $extend: {
                Collection: {
                    $limit: 1000
                }
            }
        });
    }
})();
'use strict';

var cov_1jn72pgoea = function () {
    var path = '/home/lobo/repos/meetings-app/src/app/shared/js/ORM/tables.templates.factory.js',
        hash = '1b7615616bcdf85cb0b56edf479e5ce41c33f64f',
        Function = function () {}.constructor,
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/meetings-app/src/app/shared/js/ORM/tables.templates.factory.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 28,
                    column: 5
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 4
                },
                end: {
                    line: 6,
                    column: 51
                }
            },
            '2': {
                start: {
                    line: 11,
                    column: 8
                },
                end: {
                    line: 26,
                    column: 11
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 1,
                        column: 1
                    },
                    end: {
                        line: 1,
                        column: 2
                    }
                },
                loc: {
                    start: {
                        line: 1,
                        column: 13
                    },
                    end: {
                        line: 28,
                        column: 1
                    }
                },
                line: 1
            },
            '1': {
                name: 'RestmodFactory',
                decl: {
                    start: {
                        line: 9,
                        column: 13
                    },
                    end: {
                        line: 9,
                        column: 27
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 38
                    },
                    end: {
                        line: 27,
                        column: 5
                    }
                },
                line: 9
            }
        },
        branchMap: {},
        s: {
            '0': 0,
            '1': 0,
            '2': 0
        },
        f: {
            '0': 0,
            '1': 0
        },
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_1jn72pgoea.s[0]++;
(function () {
    'use strict';

    RestmodFactory.$inject = ["restmod"];
    cov_1jn72pgoea.f[0]++;
    cov_1jn72pgoea.s[1]++;
    angular.module('app').factory('TemplatesTable', RestmodFactory);

    /* @ngInject */
    function RestmodFactory(restmod) {
        cov_1jn72pgoea.f[1]++;
        cov_1jn72pgoea.s[2]++;


        return restmod.model('/templates').mix('MixinContainable', {
            $extend: {
                Collection: {
                    $limit: 1000
                }
            },
            $config: {
                contains: {
                    templateTopics: {
                        type: 'hasMany',
                        table: 'TemplateTopicsTable',
                        foreignKey: 'template'
                    }
                }
            }
        });
    }
})();
'use strict';

var cov_1iy1kfj3dv = function () {
    var path = '/home/lobo/repos/meetings-app/src/app/shared/js/ORM/tables.projects.factory.js',
        hash = '08e79cce163ff17d955951b6b2d481d80664f2a1',
        Function = function () {}.constructor,
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/meetings-app/src/app/shared/js/ORM/tables.projects.factory.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 19,
                    column: 5
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 4
                },
                end: {
                    line: 6,
                    column: 50
                }
            },
            '2': {
                start: {
                    line: 11,
                    column: 8
                },
                end: {
                    line: 17,
                    column: 11
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 1,
                        column: 1
                    },
                    end: {
                        line: 1,
                        column: 2
                    }
                },
                loc: {
                    start: {
                        line: 1,
                        column: 13
                    },
                    end: {
                        line: 19,
                        column: 1
                    }
                },
                line: 1
            },
            '1': {
                name: 'RestmodFactory',
                decl: {
                    start: {
                        line: 9,
                        column: 13
                    },
                    end: {
                        line: 9,
                        column: 27
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 38
                    },
                    end: {
                        line: 18,
                        column: 5
                    }
                },
                line: 9
            }
        },
        branchMap: {},
        s: {
            '0': 0,
            '1': 0,
            '2': 0
        },
        f: {
            '0': 0,
            '1': 0
        },
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_1iy1kfj3dv.s[0]++;
(function () {
    'use strict';

    RestmodFactory.$inject = ["restmod"];
    cov_1iy1kfj3dv.f[0]++;
    cov_1iy1kfj3dv.s[1]++;
    angular.module('app').factory('ProjectsTable', RestmodFactory);

    /* @ngInject */
    function RestmodFactory(restmod) {
        cov_1iy1kfj3dv.f[1]++;
        cov_1iy1kfj3dv.s[2]++;


        return restmod.model('/projects').mix('MixinContainable', {
            $extend: {
                Collection: {
                    $limit: 1000
                }
            }
        });
    }
})();
'use strict';

var cov_14b6s7paq0 = function () {
    var path = '/home/lobo/repos/meetings-app/src/app/shared/js/ORM/tables.mixins.containable.factory.js',
        hash = '4f92d183524b68adaacb0ce9d5bf9167e0ab98d6',
        Function = function () {}.constructor,
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/meetings-app/src/app/shared/js/ORM/tables.mixins.containable.factory.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 154,
                    column: 5
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 4
                },
                end: {
                    line: 6,
                    column: 49
                }
            },
            '2': {
                start: {
                    line: 12,
                    column: 12
                },
                end: {
                    line: 12,
                    column: 56
                }
            },
            '3': {
                start: {
                    line: 15,
                    column: 16
                },
                end: {
                    line: 15,
                    column: 49
                }
            },
            '4': {
                start: {
                    line: 16,
                    column: 16
                },
                end: {
                    line: 21,
                    column: 19
                }
            },
            '5': {
                start: {
                    line: 17,
                    column: 20
                },
                end: {
                    line: 17,
                    column: 70
                }
            },
            '6': {
                start: {
                    line: 18,
                    column: 20
                },
                end: {
                    line: 20,
                    column: 21
                }
            },
            '7': {
                start: {
                    line: 19,
                    column: 24
                },
                end: {
                    line: 19,
                    column: 51
                }
            },
            '8': {
                start: {
                    line: 25,
                    column: 16
                },
                end: {
                    line: 25,
                    column: 73
                }
            },
            '9': {
                start: {
                    line: 26,
                    column: 16
                },
                end: {
                    line: 31,
                    column: 19
                }
            },
            '10': {
                start: {
                    line: 27,
                    column: 20
                },
                end: {
                    line: 30,
                    column: 21
                }
            },
            '11': {
                start: {
                    line: 28,
                    column: 24
                },
                end: {
                    line: 28,
                    column: 82
                }
            },
            '12': {
                start: {
                    line: 29,
                    column: 24
                },
                end: {
                    line: 29,
                    column: 51
                }
            },
            '13': {
                start: {
                    line: 34,
                    column: 25
                },
                end: {
                    line: 34,
                    column: 30
                }
            },
            '14': {
                start: {
                    line: 35,
                    column: 12
                },
                end: {
                    line: 44,
                    column: 13
                }
            },
            '15': {
                start: {
                    line: 37,
                    column: 20
                },
                end: {
                    line: 37,
                    column: 49
                }
            },
            '16': {
                start: {
                    line: 38,
                    column: 20
                },
                end: {
                    line: 38,
                    column: 26
                }
            },
            '17': {
                start: {
                    line: 40,
                    column: 20
                },
                end: {
                    line: 40,
                    column: 47
                }
            },
            '18': {
                start: {
                    line: 41,
                    column: 20
                },
                end: {
                    line: 41,
                    column: 26
                }
            },
            '19': {
                start: {
                    line: 43,
                    column: 20
                },
                end: {
                    line: 43,
                    column: 103
                }
            },
            '20': {
                start: {
                    line: 46,
                    column: 12
                },
                end: {
                    line: 46,
                    column: 44
                }
            },
            '21': {
                start: {
                    line: 47,
                    column: 12
                },
                end: {
                    line: 47,
                    column: 37
                }
            },
            '22': {
                start: {
                    line: 49,
                    column: 12
                },
                end: {
                    line: 49,
                    column: 26
                }
            },
            '23': {
                start: {
                    line: 53,
                    column: 12
                },
                end: {
                    line: 53,
                    column: 56
                }
            },
            '24': {
                start: {
                    line: 57,
                    column: 16
                },
                end: {
                    line: 78,
                    column: 19
                }
            },
            '25': {
                start: {
                    line: 58,
                    column: 31
                },
                end: {
                    line: 60,
                    column: 22
                }
            },
            '26': {
                start: {
                    line: 59,
                    column: 24
                },
                end: {
                    line: 59,
                    column: 54
                }
            },
            '27': {
                start: {
                    line: 62,
                    column: 34
                },
                end: {
                    line: 73,
                    column: 22
                }
            },
            '28': {
                start: {
                    line: 65,
                    column: 39
                },
                end: {
                    line: 65,
                    column: 41
                }
            },
            '29': {
                start: {
                    line: 66,
                    column: 24
                },
                end: {
                    line: 68,
                    column: 27
                }
            },
            '30': {
                start: {
                    line: 67,
                    column: 28
                },
                end: {
                    line: 67,
                    column: 60
                }
            },
            '31': {
                start: {
                    line: 70,
                    column: 24
                },
                end: {
                    line: 72,
                    column: 27
                }
            },
            '32': {
                start: {
                    line: 71,
                    column: 28
                },
                end: {
                    line: 71,
                    column: 80
                }
            },
            '33': {
                start: {
                    line: 74,
                    column: 20
                },
                end: {
                    line: 76,
                    column: 23
                }
            },
            '34': {
                start: {
                    line: 75,
                    column: 24
                },
                end: {
                    line: 75,
                    column: 50
                }
            },
            '35': {
                start: {
                    line: 77,
                    column: 20
                },
                end: {
                    line: 77,
                    column: 52
                }
            },
            '36': {
                start: {
                    line: 82,
                    column: 16
                },
                end: {
                    line: 82,
                    column: 80
                }
            },
            '37': {
                start: {
                    line: 85,
                    column: 25
                },
                end: {
                    line: 85,
                    column: 30
                }
            },
            '38': {
                start: {
                    line: 86,
                    column: 12
                },
                end: {
                    line: 95,
                    column: 13
                }
            },
            '39': {
                start: {
                    line: 88,
                    column: 20
                },
                end: {
                    line: 88,
                    column: 53
                }
            },
            '40': {
                start: {
                    line: 89,
                    column: 20
                },
                end: {
                    line: 89,
                    column: 26
                }
            },
            '41': {
                start: {
                    line: 91,
                    column: 20
                },
                end: {
                    line: 91,
                    column: 51
                }
            },
            '42': {
                start: {
                    line: 92,
                    column: 20
                },
                end: {
                    line: 92,
                    column: 26
                }
            },
            '43': {
                start: {
                    line: 94,
                    column: 20
                },
                end: {
                    line: 94,
                    column: 103
                }
            },
            '44': {
                start: {
                    line: 97,
                    column: 12
                },
                end: {
                    line: 97,
                    column: 44
                }
            },
            '45': {
                start: {
                    line: 98,
                    column: 12
                },
                end: {
                    line: 98,
                    column: 37
                }
            },
            '46': {
                start: {
                    line: 100,
                    column: 12
                },
                end: {
                    line: 100,
                    column: 30
                }
            },
            '47': {
                start: {
                    line: 104,
                    column: 27
                },
                end: {
                    line: 104,
                    column: 62
                }
            },
            '48': {
                start: {
                    line: 105,
                    column: 12
                },
                end: {
                    line: 116,
                    column: 13
                }
            },
            '49': {
                start: {
                    line: 106,
                    column: 29
                },
                end: {
                    line: 106,
                    column: 65
                }
            },
            '50': {
                start: {
                    line: 107,
                    column: 16
                },
                end: {
                    line: 107,
                    column: 60
                }
            },
            '51': {
                start: {
                    line: 108,
                    column: 16
                },
                end: {
                    line: 112,
                    column: 19
                }
            },
            '52': {
                start: {
                    line: 109,
                    column: 20
                },
                end: {
                    line: 111,
                    column: 21
                }
            },
            '53': {
                start: {
                    line: 110,
                    column: 24
                },
                end: {
                    line: 110,
                    column: 54
                }
            },
            '54': {
                start: {
                    line: 113,
                    column: 16
                },
                end: {
                    line: 113,
                    column: 30
                }
            },
            '55': {
                start: {
                    line: 115,
                    column: 16
                },
                end: {
                    line: 115,
                    column: 92
                }
            },
            '56': {
                start: {
                    line: 119,
                    column: 8
                },
                end: {
                    line: 152,
                    column: 11
                }
            },
            '57': {
                start: {
                    line: 124,
                    column: 38
                },
                end: {
                    line: 124,
                    column: 73
                }
            },
            '58': {
                start: {
                    line: 125,
                    column: 24
                },
                end: {
                    line: 125,
                    column: 95
                }
            },
            '59': {
                start: {
                    line: 126,
                    column: 24
                },
                end: {
                    line: 126,
                    column: 94
                }
            },
            '60': {
                start: {
                    line: 131,
                    column: 38
                },
                end: {
                    line: 131,
                    column: 73
                }
            },
            '61': {
                start: {
                    line: 132,
                    column: 24
                },
                end: {
                    line: 132,
                    column: 95
                }
            },
            '62': {
                start: {
                    line: 133,
                    column: 24
                },
                end: {
                    line: 133,
                    column: 90
                }
            },
            '63': {
                start: {
                    line: 136,
                    column: 16
                },
                end: {
                    line: 136,
                    column: 34
                }
            },
            '64': {
                start: {
                    line: 137,
                    column: 24
                },
                end: {
                    line: 139,
                    column: 25
                }
            },
            '65': {
                start: {
                    line: 138,
                    column: 28
                },
                end: {
                    line: 138,
                    column: 53
                }
            },
            '66': {
                start: {
                    line: 140,
                    column: 24
                },
                end: {
                    line: 140,
                    column: 42
                }
            },
            '67': {
                start: {
                    line: 146,
                    column: 20
                },
                end: {
                    line: 148,
                    column: 21
                }
            },
            '68': {
                start: {
                    line: 147,
                    column: 24
                },
                end: {
                    line: 147,
                    column: 41
                }
            },
            '69': {
                start: {
                    line: 149,
                    column: 20
                },
                end: {
                    line: 149,
                    column: 93
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 1,
                        column: 1
                    },
                    end: {
                        line: 1,
                        column: 2
                    }
                },
                loc: {
                    start: {
                        line: 1,
                        column: 13
                    },
                    end: {
                        line: 154,
                        column: 1
                    }
                },
                line: 1
            },
            '1': {
                name: 'RestmodFactory',
                decl: {
                    start: {
                        line: 9,
                        column: 13
                    },
                    end: {
                        line: 9,
                        column: 27
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 49
                    },
                    end: {
                        line: 153,
                        column: 5
                    }
                },
                line: 9
            },
            '2': {
                name: 'recordLoad',
                decl: {
                    start: {
                        line: 11,
                        column: 17
                    },
                    end: {
                        line: 11,
                        column: 27
                    }
                },
                loc: {
                    start: {
                        line: 11,
                        column: 69
                    },
                    end: {
                        line: 50,
                        column: 9
                    }
                },
                line: 11
            },
            '3': {
                name: 'recordLoadBelongsTo',
                decl: {
                    start: {
                        line: 14,
                        column: 21
                    },
                    end: {
                        line: 14,
                        column: 40
                    }
                },
                loc: {
                    start: {
                        line: 14,
                        column: 49
                    },
                    end: {
                        line: 22,
                        column: 13
                    }
                },
                line: 14
            },
            '4': {
                name: '(anonymous_4)',
                decl: {
                    start: {
                        line: 16,
                        column: 29
                    },
                    end: {
                        line: 16,
                        column: 30
                    }
                },
                loc: {
                    start: {
                        line: 16,
                        column: 41
                    },
                    end: {
                        line: 21,
                        column: 17
                    }
                },
                line: 16
            },
            '5': {
                name: 'recordLoadHasMany',
                decl: {
                    start: {
                        line: 24,
                        column: 21
                    },
                    end: {
                        line: 24,
                        column: 38
                    }
                },
                loc: {
                    start: {
                        line: 24,
                        column: 47
                    },
                    end: {
                        line: 32,
                        column: 13
                    }
                },
                line: 24
            },
            '6': {
                name: '(anonymous_6)',
                decl: {
                    start: {
                        line: 26,
                        column: 29
                    },
                    end: {
                        line: 26,
                        column: 30
                    }
                },
                loc: {
                    start: {
                        line: 26,
                        column: 41
                    },
                    end: {
                        line: 31,
                        column: 17
                    }
                },
                line: 26
            },
            '7': {
                name: 'collectionLoad',
                decl: {
                    start: {
                        line: 52,
                        column: 17
                    },
                    end: {
                        line: 52,
                        column: 31
                    }
                },
                loc: {
                    start: {
                        line: 52,
                        column: 77
                    },
                    end: {
                        line: 101,
                        column: 9
                    }
                },
                line: 52
            },
            '8': {
                name: 'collectionLoadBelongsTo',
                decl: {
                    start: {
                        line: 56,
                        column: 21
                    },
                    end: {
                        line: 56,
                        column: 44
                    }
                },
                loc: {
                    start: {
                        line: 56,
                        column: 53
                    },
                    end: {
                        line: 79,
                        column: 13
                    }
                },
                line: 56
            },
            '9': {
                name: '(anonymous_9)',
                decl: {
                    start: {
                        line: 57,
                        column: 33
                    },
                    end: {
                        line: 57,
                        column: 34
                    }
                },
                loc: {
                    start: {
                        line: 57,
                        column: 45
                    },
                    end: {
                        line: 78,
                        column: 17
                    }
                },
                line: 57
            },
            '10': {
                name: '(anonymous_10)',
                decl: {
                    start: {
                        line: 58,
                        column: 46
                    },
                    end: {
                        line: 58,
                        column: 47
                    }
                },
                loc: {
                    start: {
                        line: 58,
                        column: 61
                    },
                    end: {
                        line: 60,
                        column: 21
                    }
                },
                line: 58
            },
            '11': {
                name: '(anonymous_11)',
                decl: {
                    start: {
                        line: 64,
                        column: 29
                    },
                    end: {
                        line: 64,
                        column: 30
                    }
                },
                loc: {
                    start: {
                        line: 64,
                        column: 45
                    },
                    end: {
                        line: 73,
                        column: 21
                    }
                },
                line: 64
            },
            '12': {
                name: '(anonymous_12)',
                decl: {
                    start: {
                        line: 66,
                        column: 46
                    },
                    end: {
                        line: 66,
                        column: 47
                    }
                },
                loc: {
                    start: {
                        line: 66,
                        column: 65
                    },
                    end: {
                        line: 68,
                        column: 25
                    }
                },
                line: 66
            },
            '13': {
                name: '(anonymous_13)',
                decl: {
                    start: {
                        line: 70,
                        column: 52
                    },
                    end: {
                        line: 70,
                        column: 53
                    }
                },
                loc: {
                    start: {
                        line: 70,
                        column: 68
                    },
                    end: {
                        line: 72,
                        column: 25
                    }
                },
                line: 70
            },
            '14': {
                name: '(anonymous_14)',
                decl: {
                    start: {
                        line: 74,
                        column: 48
                    },
                    end: {
                        line: 74,
                        column: 49
                    }
                },
                loc: {
                    start: {
                        line: 74,
                        column: 64
                    },
                    end: {
                        line: 76,
                        column: 21
                    }
                },
                line: 74
            },
            '15': {
                name: 'collectionLoadHasMany',
                decl: {
                    start: {
                        line: 81,
                        column: 21
                    },
                    end: {
                        line: 81,
                        column: 42
                    }
                },
                loc: {
                    start: {
                        line: 81,
                        column: 51
                    },
                    end: {
                        line: 83,
                        column: 13
                    }
                },
                line: 81
            },
            '16': {
                name: 'getModelConfigs',
                decl: {
                    start: {
                        line: 103,
                        column: 17
                    },
                    end: {
                        line: 103,
                        column: 32
                    }
                },
                loc: {
                    start: {
                        line: 103,
                        column: 55
                    },
                    end: {
                        line: 117,
                        column: 9
                    }
                },
                line: 103
            },
            '17': {
                name: '(anonymous_17)',
                decl: {
                    start: {
                        line: 108,
                        column: 48
                    },
                    end: {
                        line: 108,
                        column: 49
                    }
                },
                loc: {
                    start: {
                        line: 108,
                        column: 70
                    },
                    end: {
                        line: 112,
                        column: 17
                    }
                },
                line: 108
            },
            '18': {
                name: '(anonymous_18)',
                decl: {
                    start: {
                        line: 123,
                        column: 27
                    },
                    end: {
                        line: 123,
                        column: 28
                    }
                },
                loc: {
                    start: {
                        line: 123,
                        column: 70
                    },
                    end: {
                        line: 127,
                        column: 21
                    }
                },
                line: 123
            },
            '19': {
                name: '(anonymous_19)',
                decl: {
                    start: {
                        line: 130,
                        column: 27
                    },
                    end: {
                        line: 130,
                        column: 28
                    }
                },
                loc: {
                    start: {
                        line: 130,
                        column: 70
                    },
                    end: {
                        line: 134,
                        column: 21
                    }
                },
                line: 130
            },
            '20': {
                name: '(anonymous_20)',
                decl: {
                    start: {
                        line: 135,
                        column: 10
                    },
                    end: {
                        line: 135,
                        column: 11
                    }
                },
                loc: {
                    start: {
                        line: 135,
                        column: 34
                    },
                    end: {
                        line: 141,
                        column: 21
                    }
                },
                line: 135
            },
            '21': {
                name: '(anonymous_21)',
                decl: {
                    start: {
                        line: 145,
                        column: 37
                    },
                    end: {
                        line: 145,
                        column: 38
                    }
                },
                loc: {
                    start: {
                        line: 145,
                        column: 53
                    },
                    end: {
                        line: 150,
                        column: 17
                    }
                },
                line: 145
            }
        },
        branchMap: {
            '0': {
                loc: {
                    start: {
                        line: 12,
                        column: 32
                    },
                    end: {
                        line: 12,
                        column: 55
                    }
                },
                type: 'binary-expr',
                locations: [{
                    start: {
                        line: 12,
                        column: 32
                    },
                    end: {
                        line: 12,
                        column: 49
                    }
                }, {
                    start: {
                        line: 12,
                        column: 53
                    },
                    end: {
                        line: 12,
                        column: 55
                    }
                }],
                line: 12
            },
            '1': {
                loc: {
                    start: {
                        line: 18,
                        column: 20
                    },
                    end: {
                        line: 20,
                        column: 21
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 18,
                        column: 20
                    },
                    end: {
                        line: 20,
                        column: 21
                    }
                }, {
                    start: {
                        line: 18,
                        column: 20
                    },
                    end: {
                        line: 20,
                        column: 21
                    }
                }],
                line: 18
            },
            '2': {
                loc: {
                    start: {
                        line: 27,
                        column: 20
                    },
                    end: {
                        line: 30,
                        column: 21
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 27,
                        column: 20
                    },
                    end: {
                        line: 30,
                        column: 21
                    }
                }, {
                    start: {
                        line: 27,
                        column: 20
                    },
                    end: {
                        line: 30,
                        column: 21
                    }
                }],
                line: 27
            },
            '3': {
                loc: {
                    start: {
                        line: 35,
                        column: 12
                    },
                    end: {
                        line: 44,
                        column: 13
                    }
                },
                type: 'switch',
                locations: [{
                    start: {
                        line: 36,
                        column: 16
                    },
                    end: {
                        line: 38,
                        column: 26
                    }
                }, {
                    start: {
                        line: 39,
                        column: 16
                    },
                    end: {
                        line: 41,
                        column: 26
                    }
                }, {
                    start: {
                        line: 42,
                        column: 16
                    },
                    end: {
                        line: 43,
                        column: 103
                    }
                }],
                line: 35
            },
            '4': {
                loc: {
                    start: {
                        line: 53,
                        column: 32
                    },
                    end: {
                        line: 53,
                        column: 55
                    }
                },
                type: 'binary-expr',
                locations: [{
                    start: {
                        line: 53,
                        column: 32
                    },
                    end: {
                        line: 53,
                        column: 49
                    }
                }, {
                    start: {
                        line: 53,
                        column: 53
                    },
                    end: {
                        line: 53,
                        column: 55
                    }
                }],
                line: 53
            },
            '5': {
                loc: {
                    start: {
                        line: 86,
                        column: 12
                    },
                    end: {
                        line: 95,
                        column: 13
                    }
                },
                type: 'switch',
                locations: [{
                    start: {
                        line: 87,
                        column: 16
                    },
                    end: {
                        line: 89,
                        column: 26
                    }
                }, {
                    start: {
                        line: 90,
                        column: 16
                    },
                    end: {
                        line: 92,
                        column: 26
                    }
                }, {
                    start: {
                        line: 93,
                        column: 16
                    },
                    end: {
                        line: 94,
                        column: 103
                    }
                }],
                line: 86
            },
            '6': {
                loc: {
                    start: {
                        line: 105,
                        column: 12
                    },
                    end: {
                        line: 116,
                        column: 13
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 105,
                        column: 12
                    },
                    end: {
                        line: 116,
                        column: 13
                    }
                }, {
                    start: {
                        line: 105,
                        column: 12
                    },
                    end: {
                        line: 116,
                        column: 13
                    }
                }],
                line: 105
            },
            '7': {
                loc: {
                    start: {
                        line: 105,
                        column: 16
                    },
                    end: {
                        line: 105,
                        column: 50
                    }
                },
                type: 'binary-expr',
                locations: [{
                    start: {
                        line: 105,
                        column: 16
                    },
                    end: {
                        line: 105,
                        column: 24
                    }
                }, {
                    start: {
                        line: 105,
                        column: 28
                    },
                    end: {
                        line: 105,
                        column: 50
                    }
                }],
                line: 105
            },
            '8': {
                loc: {
                    start: {
                        line: 107,
                        column: 36
                    },
                    end: {
                        line: 107,
                        column: 59
                    }
                },
                type: 'binary-expr',
                locations: [{
                    start: {
                        line: 107,
                        column: 36
                    },
                    end: {
                        line: 107,
                        column: 53
                    }
                }, {
                    start: {
                        line: 107,
                        column: 57
                    },
                    end: {
                        line: 107,
                        column: 59
                    }
                }],
                line: 107
            },
            '9': {
                loc: {
                    start: {
                        line: 109,
                        column: 20
                    },
                    end: {
                        line: 111,
                        column: 21
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 109,
                        column: 20
                    },
                    end: {
                        line: 111,
                        column: 21
                    }
                }, {
                    start: {
                        line: 109,
                        column: 20
                    },
                    end: {
                        line: 111,
                        column: 21
                    }
                }],
                line: 109
            },
            '10': {
                loc: {
                    start: {
                        line: 137,
                        column: 24
                    },
                    end: {
                        line: 139,
                        column: 25
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 137,
                        column: 24
                    },
                    end: {
                        line: 139,
                        column: 25
                    }
                }, {
                    start: {
                        line: 137,
                        column: 24
                    },
                    end: {
                        line: 139,
                        column: 25
                    }
                }],
                line: 137
            },
            '11': {
                loc: {
                    start: {
                        line: 146,
                        column: 20
                    },
                    end: {
                        line: 148,
                        column: 21
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 146,
                        column: 20
                    },
                    end: {
                        line: 148,
                        column: 21
                    }
                }, {
                    start: {
                        line: 146,
                        column: 20
                    },
                    end: {
                        line: 148,
                        column: 21
                    }
                }],
                line: 146
            },
            '12': {
                loc: {
                    start: {
                        line: 149,
                        column: 47
                    },
                    end: {
                        line: 149,
                        column: 92
                    }
                },
                type: 'binary-expr',
                locations: [{
                    start: {
                        line: 149,
                        column: 47
                    },
                    end: {
                        line: 149,
                        column: 71
                    }
                }, {
                    start: {
                        line: 149,
                        column: 75
                    },
                    end: {
                        line: 149,
                        column: 86
                    }
                }, {
                    start: {
                        line: 149,
                        column: 90
                    },
                    end: {
                        line: 149,
                        column: 92
                    }
                }],
                line: 149
            }
        },
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0,
            '7': 0,
            '8': 0,
            '9': 0,
            '10': 0,
            '11': 0,
            '12': 0,
            '13': 0,
            '14': 0,
            '15': 0,
            '16': 0,
            '17': 0,
            '18': 0,
            '19': 0,
            '20': 0,
            '21': 0,
            '22': 0,
            '23': 0,
            '24': 0,
            '25': 0,
            '26': 0,
            '27': 0,
            '28': 0,
            '29': 0,
            '30': 0,
            '31': 0,
            '32': 0,
            '33': 0,
            '34': 0,
            '35': 0,
            '36': 0,
            '37': 0,
            '38': 0,
            '39': 0,
            '40': 0,
            '41': 0,
            '42': 0,
            '43': 0,
            '44': 0,
            '45': 0,
            '46': 0,
            '47': 0,
            '48': 0,
            '49': 0,
            '50': 0,
            '51': 0,
            '52': 0,
            '53': 0,
            '54': 0,
            '55': 0,
            '56': 0,
            '57': 0,
            '58': 0,
            '59': 0,
            '60': 0,
            '61': 0,
            '62': 0,
            '63': 0,
            '64': 0,
            '65': 0,
            '66': 0,
            '67': 0,
            '68': 0,
            '69': 0
        },
        f: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0,
            '7': 0,
            '8': 0,
            '9': 0,
            '10': 0,
            '11': 0,
            '12': 0,
            '13': 0,
            '14': 0,
            '15': 0,
            '16': 0,
            '17': 0,
            '18': 0,
            '19': 0,
            '20': 0,
            '21': 0
        },
        b: {
            '0': [0, 0],
            '1': [0, 0],
            '2': [0, 0],
            '3': [0, 0, 0],
            '4': [0, 0],
            '5': [0, 0, 0],
            '6': [0, 0],
            '7': [0, 0],
            '8': [0, 0],
            '9': [0, 0],
            '10': [0, 0],
            '11': [0, 0],
            '12': [0, 0, 0]
        },
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_14b6s7paq0.s[0]++;
(function () {
    'use strict';

    RestmodFactory.$inject = ["restmod", "$injector"];
    cov_14b6s7paq0.f[0]++;
    cov_14b6s7paq0.s[1]++;
    angular.module('app').factory('MixinContainable', RestmodFactory);

    /* @ngInject */
    function RestmodFactory(restmod, $injector) {
        cov_14b6s7paq0.f[1]++;


        function recordLoad(record, key, config, additionalFilters) {
            cov_14b6s7paq0.f[2]++;
            cov_14b6s7paq0.s[2]++;

            additionalFilters = (cov_14b6s7paq0.b[0][0]++, additionalFilters) || (cov_14b6s7paq0.b[0][1]++, {});

            function recordLoadBelongsTo(table) {
                cov_14b6s7paq0.f[3]++;
                cov_14b6s7paq0.s[3]++;

                record['$' + key] = table.$new();
                cov_14b6s7paq0.s[4]++;
                record.$then(function () {
                    cov_14b6s7paq0.f[4]++;
                    cov_14b6s7paq0.s[5]++;

                    record['$' + key].$pk = record[config.foreignKey];
                    cov_14b6s7paq0.s[6]++;
                    if (record[config.foreignKey]) {
                        cov_14b6s7paq0.b[1][0]++;
                        cov_14b6s7paq0.s[7]++;

                        record['$' + key].$fetch();
                    } else {
                        cov_14b6s7paq0.b[1][1]++;
                    }
                });
            }

            function recordLoadHasMany(table) {
                cov_14b6s7paq0.f[5]++;
                cov_14b6s7paq0.s[8]++;

                record['$' + key] = table.$collection(additionalFilters);
                cov_14b6s7paq0.s[9]++;
                record.$then(function () {
                    cov_14b6s7paq0.f[6]++;
                    cov_14b6s7paq0.s[10]++;

                    if (record.$pk) {
                        cov_14b6s7paq0.b[2][0]++;
                        cov_14b6s7paq0.s[11]++;

                        record['$' + key].$params[config.foreignKey] = record.$pk;
                        cov_14b6s7paq0.s[12]++;
                        record['$' + key].$fetch();
                    } else {
                        cov_14b6s7paq0.b[2][1]++;
                    }
                });
            }

            var loader = (cov_14b6s7paq0.s[13]++, false);
            cov_14b6s7paq0.s[14]++;
            switch (config.type) {
                case 'belongsTo':
                    cov_14b6s7paq0.b[3][0]++;
                    cov_14b6s7paq0.s[15]++;

                    loader = recordLoadBelongsTo;
                    cov_14b6s7paq0.s[16]++;
                    break;
                case 'hasMany':
                    cov_14b6s7paq0.b[3][1]++;
                    cov_14b6s7paq0.s[17]++;

                    loader = recordLoadHasMany;
                    cov_14b6s7paq0.s[18]++;
                    break;
                default:
                    cov_14b6s7paq0.b[3][2]++;
                    cov_14b6s7paq0.s[19]++;

                    throw new Error('Unknown contain type "' + config.type + '" for MixinContainable');
            }

            cov_14b6s7paq0.s[20]++;
            loader.$inject = [config.table];
            cov_14b6s7paq0.s[21]++;
            $injector.invoke(loader);

            cov_14b6s7paq0.s[22]++;
            return record;
        }

        function collectionLoad(collection, key, config, additionalFilters) {
            cov_14b6s7paq0.f[7]++;
            cov_14b6s7paq0.s[23]++;

            additionalFilters = (cov_14b6s7paq0.b[4][0]++, additionalFilters) || (cov_14b6s7paq0.b[4][1]++, {});

            function collectionLoadBelongsTo(table) {
                cov_14b6s7paq0.f[8]++;
                cov_14b6s7paq0.s[24]++;

                collection.$then(function () {
                    cov_14b6s7paq0.f[9]++;

                    var keys = (cov_14b6s7paq0.s[25]++, collection.map(function (obj) {
                        cov_14b6s7paq0.f[10]++;
                        cov_14b6s7paq0.s[26]++;

                        return obj[config.foreignKey];
                    }));

                    var request = (cov_14b6s7paq0.s[27]++, table.$search({
                        'id__in': keys.join(',')
                    }).$then(function (data) {
                        cov_14b6s7paq0.f[11]++;

                        var objsById = (cov_14b6s7paq0.s[28]++, {});
                        cov_14b6s7paq0.s[29]++;
                        angular.forEach(data, function (respObj) {
                            cov_14b6s7paq0.f[12]++;
                            cov_14b6s7paq0.s[30]++;

                            objsById[respObj.$pk] = respObj;
                        });

                        cov_14b6s7paq0.s[31]++;
                        angular.forEach(collection, function (item) {
                            cov_14b6s7paq0.f[13]++;
                            cov_14b6s7paq0.s[32]++;

                            item['$' + key] = objsById[item[config.foreignKey]];
                        });
                    }));
                    cov_14b6s7paq0.s[33]++;
                    angular.forEach(collection, function (item) {
                        cov_14b6s7paq0.f[14]++;
                        cov_14b6s7paq0.s[34]++;

                        item['$' + key] = request;
                    });
                    cov_14b6s7paq0.s[35]++;
                    collection['$' + key] = request;
                });
            }

            function collectionLoadHasMany(table) {
                cov_14b6s7paq0.f[15]++;
                cov_14b6s7paq0.s[36]++;

                throw new Error('Collection load has many Not implemented yet');
            }

            var loader = (cov_14b6s7paq0.s[37]++, false);
            cov_14b6s7paq0.s[38]++;
            switch (config.type) {
                case 'belongsTo':
                    cov_14b6s7paq0.b[5][0]++;
                    cov_14b6s7paq0.s[39]++;

                    loader = collectionLoadBelongsTo;
                    cov_14b6s7paq0.s[40]++;
                    break;
                case 'hasMany':
                    cov_14b6s7paq0.b[5][1]++;
                    cov_14b6s7paq0.s[41]++;

                    loader = collectionLoadHasMany;
                    cov_14b6s7paq0.s[42]++;
                    break;
                default:
                    cov_14b6s7paq0.b[5][2]++;
                    cov_14b6s7paq0.s[43]++;

                    throw new Error('Unknown contain type "' + config.type + '" for MixinContainable');
            }

            cov_14b6s7paq0.s[44]++;
            loader.$inject = [config.table];
            cov_14b6s7paq0.s[45]++;
            $injector.invoke(loader);

            cov_14b6s7paq0.s[46]++;
            return collection;
        }

        function getModelConfigs(model, relatedModel) {
            cov_14b6s7paq0.f[16]++;

            var contains = (cov_14b6s7paq0.s[47]++, model.$type.getProperty('contains'));
            cov_14b6s7paq0.s[48]++;
            if ((cov_14b6s7paq0.b[7][0]++, contains) && (cov_14b6s7paq0.b[7][1]++, contains[relatedModel])) {
                cov_14b6s7paq0.b[6][0]++;

                var config = (cov_14b6s7paq0.s[49]++, angular.copy(contains[relatedModel]));
                cov_14b6s7paq0.s[50]++;
                config['filters'] = (cov_14b6s7paq0.b[8][0]++, config['filters']) || (cov_14b6s7paq0.b[8][1]++, {});
                cov_14b6s7paq0.s[51]++;
                angular.forEach(config.filters, function (value, key) {
                    cov_14b6s7paq0.f[17]++;
                    cov_14b6s7paq0.s[52]++;

                    if (angular.isFunction(config.filters[key])) {
                        cov_14b6s7paq0.b[9][0]++;
                        cov_14b6s7paq0.s[53]++;

                        config.filters[key] = value();
                    } else {
                        cov_14b6s7paq0.b[9][1]++;
                    }
                });
                cov_14b6s7paq0.s[54]++;
                return config;
            } else {
                cov_14b6s7paq0.b[6][1]++;
                cov_14b6s7paq0.s[55]++;

                throw new Error('Cannot find MixinContainable configs for ' + relatedModel);
            }
        }

        cov_14b6s7paq0.s[56]++;
        return restmod.mixin({
            $extend: {
                Collection: {
                    $limit: 25,
                    $load: function $load(relatedModel, additionalFilters) {
                        cov_14b6s7paq0.f[18]++;

                        var configs = (cov_14b6s7paq0.s[57]++, getModelConfigs(this, relatedModel));
                        cov_14b6s7paq0.s[58]++;
                        additionalFilters = angular.extend(configs.filters, additionalFilters);
                        cov_14b6s7paq0.s[59]++;
                        return collectionLoad(this, relatedModel, configs, additionalFilters);
                    }
                },
                Record: {
                    $load: function $load(relatedModel, additionalFilters) {
                        cov_14b6s7paq0.f[19]++;

                        var configs = (cov_14b6s7paq0.s[60]++, getModelConfigs(this, relatedModel));
                        cov_14b6s7paq0.s[61]++;
                        additionalFilters = angular.extend(configs.filters, additionalFilters);
                        cov_14b6s7paq0.s[62]++;
                        return recordLoad(this, relatedModel, configs, additionalFilters);
                    },
                    $_: function $_(relatedModel) {
                        cov_14b6s7paq0.f[20]++;

                        var name = (cov_14b6s7paq0.s[63]++, '$' + relatedModel);
                        cov_14b6s7paq0.s[64]++;
                        if (!this[name]) {
                            cov_14b6s7paq0.b[10][0]++;
                            cov_14b6s7paq0.s[65]++;

                            this.$load(relatedModel);
                        } else {
                            cov_14b6s7paq0.b[10][1]++;
                        }
                        cov_14b6s7paq0.s[66]++;
                        return this[name];
                    }
                }
            },
            $hooks: {
                'before-fetch-many': function beforeFetchMany(_req) {
                    cov_14b6s7paq0.f[21]++;
                    cov_14b6s7paq0.s[67]++;

                    if (_.isUndefined(_req.params)) {
                        cov_14b6s7paq0.b[11][0]++;
                        cov_14b6s7paq0.s[68]++;

                        _req.params = {};
                    } else {
                        cov_14b6s7paq0.b[11][1]++;
                    }
                    cov_14b6s7paq0.s[69]++;
                    _req.params['page_size'] = (cov_14b6s7paq0.b[12][0]++, _req.params['page_size']) || (cov_14b6s7paq0.b[12][1]++, this.$limit) || (cov_14b6s7paq0.b[12][2]++, 25);
                }
            }
        });
    }
})();
'use strict';

var cov_2kak7n2hcw = function () {
    var path = '/home/lobo/repos/meetings-app/src/app/shared/js/ORM/tables.meetingusers.factory.js',
        hash = '43aa228acf115224a6bc98f11cfaae96aa90bb90',
        Function = function () {}.constructor,
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/meetings-app/src/app/shared/js/ORM/tables.meetingusers.factory.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 33,
                    column: 5
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 4
                },
                end: {
                    line: 6,
                    column: 54
                }
            },
            '2': {
                start: {
                    line: 11,
                    column: 8
                },
                end: {
                    line: 31,
                    column: 11
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 1,
                        column: 1
                    },
                    end: {
                        line: 1,
                        column: 2
                    }
                },
                loc: {
                    start: {
                        line: 1,
                        column: 13
                    },
                    end: {
                        line: 33,
                        column: 1
                    }
                },
                line: 1
            },
            '1': {
                name: 'RestmodFactory',
                decl: {
                    start: {
                        line: 9,
                        column: 13
                    },
                    end: {
                        line: 9,
                        column: 27
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 38
                    },
                    end: {
                        line: 32,
                        column: 5
                    }
                },
                line: 9
            }
        },
        branchMap: {},
        s: {
            '0': 0,
            '1': 0,
            '2': 0
        },
        f: {
            '0': 0,
            '1': 0
        },
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_2kak7n2hcw.s[0]++;
(function () {
    'use strict';

    RestmodFactory.$inject = ["restmod"];
    cov_2kak7n2hcw.f[0]++;
    cov_2kak7n2hcw.s[1]++;
    angular.module('app').factory('MeetingUsersTable', RestmodFactory);

    /* @ngInject */
    function RestmodFactory(restmod) {
        cov_2kak7n2hcw.f[1]++;
        cov_2kak7n2hcw.s[2]++;


        return restmod.model('/meeting-users').mix('MixinContainable', {
            $extend: {
                Collection: {
                    $limit: 1000
                }
            },
            $config: {
                contains: {
                    user: {
                        type: 'belongsTo',
                        table: 'UsersTable',
                        foreignKey: 'user'
                    },
                    meeting: {
                        type: 'belongsTo',
                        table: 'MeetingsTable',
                        foreignKey: 'meeting'
                    }
                }
            }
        });
    }
})();
'use strict';

var cov_yc1a4c79l = function () {
    var path = '/home/lobo/repos/meetings-app/src/app/shared/js/ORM/tables.meetings.factory.js',
        hash = '609f2e2e34c0e2c67454c4dee6b3b08cc7d6014d',
        Function = function () {}.constructor,
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/meetings-app/src/app/shared/js/ORM/tables.meetings.factory.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 47,
                    column: 5
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 4
                },
                end: {
                    line: 6,
                    column: 50
                }
            },
            '2': {
                start: {
                    line: 10,
                    column: 8
                },
                end: {
                    line: 45,
                    column: 11
                }
            },
            '3': {
                start: {
                    line: 42,
                    column: 20
                },
                end: {
                    line: 42,
                    column: 43
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 1,
                        column: 1
                    },
                    end: {
                        line: 1,
                        column: 2
                    }
                },
                loc: {
                    start: {
                        line: 1,
                        column: 13
                    },
                    end: {
                        line: 47,
                        column: 1
                    }
                },
                line: 1
            },
            '1': {
                name: 'RestmodFactory',
                decl: {
                    start: {
                        line: 9,
                        column: 13
                    },
                    end: {
                        line: 9,
                        column: 27
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 38
                    },
                    end: {
                        line: 46,
                        column: 5
                    }
                },
                line: 9
            },
            '2': {
                name: '(anonymous_2)',
                decl: {
                    start: {
                        line: 41,
                        column: 24
                    },
                    end: {
                        line: 41,
                        column: 25
                    }
                },
                loc: {
                    start: {
                        line: 41,
                        column: 41
                    },
                    end: {
                        line: 43,
                        column: 17
                    }
                },
                line: 41
            }
        },
        branchMap: {},
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0
        },
        f: {
            '0': 0,
            '1': 0,
            '2': 0
        },
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_yc1a4c79l.s[0]++;
(function () {
    'use strict';

    RestmodFactory.$inject = ["restmod"];
    cov_yc1a4c79l.f[0]++;
    cov_yc1a4c79l.s[1]++;
    angular.module('app').factory('MeetingsTable', RestmodFactory);

    /* @ngInject */
    function RestmodFactory(restmod) {
        cov_yc1a4c79l.f[1]++;
        cov_yc1a4c79l.s[2]++;

        return restmod.model('/meetings').mix('MixinContainable', {
            $config: {
                contains: {
                    meetingUsers: {
                        type: 'hasMany',
                        table: 'MeetingUsersTable',
                        foreignKey: 'meeting'
                    },
                    topics: {
                        type: 'hasMany',
                        table: 'TopicsTable',
                        foreignKey: 'meeting'
                    },
                    decisions: {
                        type: 'hasMany',
                        table: 'DecisionsTable',
                        foreignKey: 'meeting'
                    },
                    project: {
                        type: 'belongsTo',
                        table: 'ProjectsTable',
                        foreignKey: 'project'
                    },
                    meetingFiles: {
                        type: 'hasMany',
                        table: 'MeetingFilesTable',
                        foreignKey: 'meeting'
                    }
                }
            },
            scheduleDate: {
                decode: function decode(value) {
                    cov_yc1a4c79l.f[2]++;
                    cov_yc1a4c79l.s[3]++;

                    return new Date(value);
                }
            }
        });
    }
})();
'use strict';

var cov_1wvdde22ez = function () {
    var path = '/home/lobo/repos/meetings-app/src/app/shared/js/ORM/tables.meetingfiles.factory.js',
        hash = 'd4dc81eb7249c9773d6441b57c9be9a1cbe7f005',
        Function = function () {}.constructor,
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/meetings-app/src/app/shared/js/ORM/tables.meetingfiles.factory.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 28,
                    column: 5
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 4
                },
                end: {
                    line: 6,
                    column: 54
                }
            },
            '2': {
                start: {
                    line: 11,
                    column: 8
                },
                end: {
                    line: 26,
                    column: 11
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 1,
                        column: 1
                    },
                    end: {
                        line: 1,
                        column: 2
                    }
                },
                loc: {
                    start: {
                        line: 1,
                        column: 13
                    },
                    end: {
                        line: 28,
                        column: 1
                    }
                },
                line: 1
            },
            '1': {
                name: 'RestmodFactory',
                decl: {
                    start: {
                        line: 9,
                        column: 13
                    },
                    end: {
                        line: 9,
                        column: 27
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 38
                    },
                    end: {
                        line: 27,
                        column: 5
                    }
                },
                line: 9
            }
        },
        branchMap: {},
        s: {
            '0': 0,
            '1': 0,
            '2': 0
        },
        f: {
            '0': 0,
            '1': 0
        },
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_1wvdde22ez.s[0]++;
(function () {
    'use strict';

    RestmodFactory.$inject = ["restmod"];
    cov_1wvdde22ez.f[0]++;
    cov_1wvdde22ez.s[1]++;
    angular.module('app').factory('MeetingFilesTable', RestmodFactory);

    /* @ngInject */
    function RestmodFactory(restmod) {
        cov_1wvdde22ez.f[1]++;
        cov_1wvdde22ez.s[2]++;


        return restmod.model('/meeting-files').mix('MixinContainable', {
            $extend: {
                Collection: {
                    $limit: 1000
                }
            },
            $config: {
                contains: {
                    meeting: {
                        type: 'belongsTo',
                        table: 'MeetingsTable',
                        foreignKey: 'meeting'
                    }
                }
            }
        });
    }
})();
'use strict';

var cov_b9l24pg2 = function () {
    var path = '/home/lobo/repos/meetings-app/src/app/shared/js/ORM/tables.decisions.factory.js',
        hash = '8ce0d8eca105293ac95388df8db34a206e98e33b',
        Function = function () {}.constructor,
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/meetings-app/src/app/shared/js/ORM/tables.decisions.factory.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 28,
                    column: 5
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 4
                },
                end: {
                    line: 6,
                    column: 51
                }
            },
            '2': {
                start: {
                    line: 11,
                    column: 8
                },
                end: {
                    line: 26,
                    column: 11
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 1,
                        column: 1
                    },
                    end: {
                        line: 1,
                        column: 2
                    }
                },
                loc: {
                    start: {
                        line: 1,
                        column: 13
                    },
                    end: {
                        line: 28,
                        column: 1
                    }
                },
                line: 1
            },
            '1': {
                name: 'RestmodFactory',
                decl: {
                    start: {
                        line: 9,
                        column: 13
                    },
                    end: {
                        line: 9,
                        column: 27
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 38
                    },
                    end: {
                        line: 27,
                        column: 5
                    }
                },
                line: 9
            }
        },
        branchMap: {},
        s: {
            '0': 0,
            '1': 0,
            '2': 0
        },
        f: {
            '0': 0,
            '1': 0
        },
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_b9l24pg2.s[0]++;
(function () {
    'use strict';

    RestmodFactory.$inject = ["restmod"];
    cov_b9l24pg2.f[0]++;
    cov_b9l24pg2.s[1]++;
    angular.module('app').factory('DecisionsTable', RestmodFactory);

    /* @ngInject */
    function RestmodFactory(restmod) {
        cov_b9l24pg2.f[1]++;
        cov_b9l24pg2.s[2]++;


        return restmod.model('/decisions').mix('MixinContainable', {
            $extend: {
                Collection: {
                    $limit: 1000
                }
            },
            $config: {
                contains: {
                    meetings: {
                        type: 'belongsTo',
                        table: 'MeetingsTable',
                        foreignKey: 'meeting'
                    }
                }
            }
        });
    }
})();
'use strict';

var cov_20s9qb8tyo = function () {
    var path = '/home/lobo/repos/meetings-app/src/app/shared/js/ORM/tables.config.js',
        hash = '9d04f0f5450117ad69b41d311d9cd96b06a93f9f',
        Function = function () {}.constructor,
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/meetings-app/src/app/shared/js/ORM/tables.config.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 17,
                    column: 5
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 4
                },
                end: {
                    line: 6,
                    column: 24
                }
            },
            '2': {
                start: {
                    line: 10,
                    column: 8
                },
                end: {
                    line: 14,
                    column: 11
                }
            },
            '3': {
                start: {
                    line: 15,
                    column: 8
                },
                end: {
                    line: 15,
                    column: 52
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 1,
                        column: 1
                    },
                    end: {
                        line: 1,
                        column: 2
                    }
                },
                loc: {
                    start: {
                        line: 1,
                        column: 13
                    },
                    end: {
                        line: 17,
                        column: 1
                    }
                },
                line: 1
            },
            '1': {
                name: 'Config',
                decl: {
                    start: {
                        line: 9,
                        column: 13
                    },
                    end: {
                        line: 9,
                        column: 19
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 50
                    },
                    end: {
                        line: 16,
                        column: 5
                    }
                },
                line: 9
            }
        },
        branchMap: {},
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0
        },
        f: {
            '0': 0,
            '1': 0
        },
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_20s9qb8tyo.s[0]++;
(function () {
    'use strict';

    Config.$inject = ["restmodProvider", "AppSettings"];
    cov_20s9qb8tyo.f[0]++;
    cov_20s9qb8tyo.s[1]++;
    angular.module('app').config(Config);

    /* @ngInject */
    function Config(restmodProvider, AppSettings) {
        cov_20s9qb8tyo.f[1]++;
        cov_20s9qb8tyo.s[2]++;

        restmodProvider.rebase({
            $config: {
                urlPrefix: AppSettings.apiUrl
            }
        });
        cov_20s9qb8tyo.s[3]++;
        restmodProvider.rebase('DjangoDRFPagedApi');
    }
})();
'use strict';

var cov_2iu1ul0tc0 = function () {
    var path = '/home/lobo/repos/meetings-app/src/app/shared/html/maintoolbar/maintoolbar.js',
        hash = '54a7adfc1c92308c4457035c1e746174467d5879',
        Function = function () {}.constructor,
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/meetings-app/src/app/shared/html/maintoolbar/maintoolbar.js',
        statementMap: {
            '0': {
                start: {
                    line: 4,
                    column: 8
                },
                end: {
                    line: 4,
                    column: 34
                }
            },
            '1': {
                start: {
                    line: 9,
                    column: 0
                },
                end: {
                    line: 14,
                    column: 7
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 3,
                        column: 4
                    },
                    end: {
                        line: 3,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 3,
                        column: 28
                    },
                    end: {
                        line: 5,
                        column: 5
                    }
                },
                line: 3
            }
        },
        branchMap: {},
        s: {
            '0': 0,
            '1': 0
        },
        f: {
            '0': 0
        },
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var MainToolbarController = function MainToolbarController($rootScope) {
    _classCallCheck(this, MainToolbarController);

    cov_2iu1ul0tc0.f[0]++;
    cov_2iu1ul0tc0.s[0]++;

    this.user = $rootScope.me;
};
MainToolbarController.$inject = ["$rootScope"];

cov_2iu1ul0tc0.s[1]++;


angular.module('app').component('maintoolbar', {
    templateUrl: 'app/shared/html/maintoolbar/maintoolbar.html',
    controller: MainToolbarController
});
'use strict';

var cov_2nixu6t4w4 = function () {
    var path = '/home/lobo/repos/meetings-app/src/app/shared/js/strings.js',
        hash = '720133e0e3d160b4712c84aa3c021df5347f0b6a',
        Function = function () {}.constructor,
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/meetings-app/src/app/shared/js/strings.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 3,
                    column: 2
                }
            },
            '1': {
                start: {
                    line: 2,
                    column: 4
                },
                end: {
                    line: 2,
                    column: 42
                }
            },
            '2': {
                start: {
                    line: 6,
                    column: 0
                },
                end: {
                    line: 10,
                    column: 2
                }
            },
            '3': {
                start: {
                    line: 7,
                    column: 4
                },
                end: {
                    line: 9,
                    column: 7
                }
            },
            '4': {
                start: {
                    line: 8,
                    column: 8
                },
                end: {
                    line: 8,
                    column: 49
                }
            },
            '5': {
                start: {
                    line: 13,
                    column: 0
                },
                end: {
                    line: 17,
                    column: 2
                }
            },
            '6': {
                start: {
                    line: 14,
                    column: 4
                },
                end: {
                    line: 16,
                    column: 7
                }
            },
            '7': {
                start: {
                    line: 15,
                    column: 8
                },
                end: {
                    line: 15,
                    column: 38
                }
            },
            '8': {
                start: {
                    line: 20,
                    column: 0
                },
                end: {
                    line: 24,
                    column: 2
                }
            },
            '9': {
                start: {
                    line: 21,
                    column: 4
                },
                end: {
                    line: 23,
                    column: 7
                }
            },
            '10': {
                start: {
                    line: 22,
                    column: 8
                },
                end: {
                    line: 22,
                    column: 38
                }
            },
            '11': {
                start: {
                    line: 26,
                    column: 0
                },
                end: {
                    line: 34,
                    column: 2
                }
            },
            '12': {
                start: {
                    line: 27,
                    column: 18
                },
                end: {
                    line: 27,
                    column: 36
                }
            },
            '13': {
                start: {
                    line: 28,
                    column: 16
                },
                end: {
                    line: 28,
                    column: 42
                }
            },
            '14': {
                start: {
                    line: 29,
                    column: 18
                },
                end: {
                    line: 29,
                    column: 61
                }
            },
            '15': {
                start: {
                    line: 31,
                    column: 4
                },
                end: {
                    line: 31,
                    column: 42
                }
            },
            '16': {
                start: {
                    line: 31,
                    column: 21
                },
                end: {
                    line: 31,
                    column: 41
                }
            },
            '17': {
                start: {
                    line: 32,
                    column: 4
                },
                end: {
                    line: 32,
                    column: 48
                }
            },
            '18': {
                start: {
                    line: 32,
                    column: 23
                },
                end: {
                    line: 32,
                    column: 47
                }
            },
            '19': {
                start: {
                    line: 33,
                    column: 4
                },
                end: {
                    line: 33,
                    column: 33
                }
            },
            '20': {
                start: {
                    line: 36,
                    column: 0
                },
                end: {
                    line: 46,
                    column: 2
                }
            },
            '21': {
                start: {
                    line: 37,
                    column: 18
                },
                end: {
                    line: 37,
                    column: 36
                }
            },
            '22': {
                start: {
                    line: 38,
                    column: 16
                },
                end: {
                    line: 38,
                    column: 42
                }
            },
            '23': {
                start: {
                    line: 39,
                    column: 18
                },
                end: {
                    line: 39,
                    column: 61
                }
            },
            '24': {
                start: {
                    line: 40,
                    column: 18
                },
                end: {
                    line: 40,
                    column: 59
                }
            },
            '25': {
                start: {
                    line: 42,
                    column: 4
                },
                end: {
                    line: 42,
                    column: 42
                }
            },
            '26': {
                start: {
                    line: 42,
                    column: 21
                },
                end: {
                    line: 42,
                    column: 41
                }
            },
            '27': {
                start: {
                    line: 43,
                    column: 4
                },
                end: {
                    line: 43,
                    column: 48
                }
            },
            '28': {
                start: {
                    line: 43,
                    column: 23
                },
                end: {
                    line: 43,
                    column: 47
                }
            },
            '29': {
                start: {
                    line: 44,
                    column: 4
                },
                end: {
                    line: 44,
                    column: 48
                }
            },
            '30': {
                start: {
                    line: 44,
                    column: 23
                },
                end: {
                    line: 44,
                    column: 47
                }
            },
            '31': {
                start: {
                    line: 45,
                    column: 4
                },
                end: {
                    line: 45,
                    column: 49
                }
            },
            '32': {
                start: {
                    line: 48,
                    column: 0
                },
                end: {
                    line: 55,
                    column: 2
                }
            },
            '33': {
                start: {
                    line: 49,
                    column: 18
                },
                end: {
                    line: 49,
                    column: 36
                }
            },
            '34': {
                start: {
                    line: 50,
                    column: 16
                },
                end: {
                    line: 50,
                    column: 42
                }
            },
            '35': {
                start: {
                    line: 51,
                    column: 18
                },
                end: {
                    line: 51,
                    column: 61
                }
            },
            '36': {
                start: {
                    line: 52,
                    column: 18
                },
                end: {
                    line: 52,
                    column: 59
                }
            },
            '37': {
                start: {
                    line: 54,
                    column: 4
                },
                end: {
                    line: 54,
                    column: 99
                }
            },
            '38': {
                start: {
                    line: 57,
                    column: 0
                },
                end: {
                    line: 87,
                    column: 1
                }
            },
            '39': {
                start: {
                    line: 58,
                    column: 17
                },
                end: {
                    line: 58,
                    column: 149
                }
            },
            '40': {
                start: {
                    line: 59,
                    column: 15
                },
                end: {
                    line: 59,
                    column: 93
                }
            },
            '41': {
                start: {
                    line: 60,
                    column: 20
                },
                end: {
                    line: 60,
                    column: 35
                }
            },
            '42': {
                start: {
                    line: 61,
                    column: 20
                },
                end: {
                    line: 61,
                    column: 46
                }
            },
            '43': {
                start: {
                    line: 62,
                    column: 21
                },
                end: {
                    line: 62,
                    column: 47
                }
            },
            '44': {
                start: {
                    line: 63,
                    column: 4
                },
                end: {
                    line: 86,
                    column: 5
                }
            },
            '45': {
                start: {
                    line: 64,
                    column: 20
                },
                end: {
                    line: 64,
                    column: 37
                }
            },
            '46': {
                start: {
                    line: 65,
                    column: 8
                },
                end: {
                    line: 65,
                    column: 42
                }
            },
            '47': {
                start: {
                    line: 67,
                    column: 9
                },
                end: {
                    line: 86,
                    column: 5
                }
            },
            '48': {
                start: {
                    line: 68,
                    column: 19
                },
                end: {
                    line: 68,
                    column: 83
                }
            },
            '49': {
                start: {
                    line: 69,
                    column: 22
                },
                end: {
                    line: 69,
                    column: 35
                }
            },
            '50': {
                start: {
                    line: 70,
                    column: 20
                },
                end: {
                    line: 70,
                    column: 38
                }
            },
            '51': {
                start: {
                    line: 71,
                    column: 21
                },
                end: {
                    line: 81,
                    column: 9
                }
            },
            '52': {
                start: {
                    line: 72,
                    column: 24
                },
                end: {
                    line: 72,
                    column: 54
                }
            },
            '53': {
                start: {
                    line: 73,
                    column: 12
                },
                end: {
                    line: 79,
                    column: 13
                }
            },
            '54': {
                start: {
                    line: 74,
                    column: 16
                },
                end: {
                    line: 78,
                    column: 17
                }
            },
            '55': {
                start: {
                    line: 75,
                    column: 30
                },
                end: {
                    line: 75,
                    column: 42
                }
            },
            '56': {
                start: {
                    line: 76,
                    column: 30
                },
                end: {
                    line: 76,
                    column: 42
                }
            },
            '57': {
                start: {
                    line: 77,
                    column: 30
                },
                end: {
                    line: 77,
                    column: 42
                }
            },
            '58': {
                start: {
                    line: 80,
                    column: 12
                },
                end: {
                    line: 80,
                    column: 24
                }
            },
            '59': {
                start: {
                    line: 82,
                    column: 8
                },
                end: {
                    line: 82,
                    column: 82
                }
            },
            '60': {
                start: {
                    line: 85,
                    column: 8
                },
                end: {
                    line: 85,
                    column: 20
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 1,
                        column: 24
                    },
                    end: {
                        line: 1,
                        column: 25
                    }
                },
                loc: {
                    start: {
                        line: 1,
                        column: 36
                    },
                    end: {
                        line: 3,
                        column: 1
                    }
                },
                line: 1
            },
            '1': {
                name: '(anonymous_1)',
                decl: {
                    start: {
                        line: 6,
                        column: 27
                    },
                    end: {
                        line: 6,
                        column: 28
                    }
                },
                loc: {
                    start: {
                        line: 6,
                        column: 39
                    },
                    end: {
                        line: 10,
                        column: 1
                    }
                },
                line: 6
            },
            '2': {
                name: '(anonymous_2)',
                decl: {
                    start: {
                        line: 7,
                        column: 38
                    },
                    end: {
                        line: 7,
                        column: 39
                    }
                },
                loc: {
                    start: {
                        line: 7,
                        column: 52
                    },
                    end: {
                        line: 9,
                        column: 5
                    }
                },
                line: 7
            },
            '3': {
                name: '(anonymous_3)',
                decl: {
                    start: {
                        line: 13,
                        column: 26
                    },
                    end: {
                        line: 13,
                        column: 27
                    }
                },
                loc: {
                    start: {
                        line: 13,
                        column: 38
                    },
                    end: {
                        line: 17,
                        column: 1
                    }
                },
                line: 13
            },
            '4': {
                name: '(anonymous_4)',
                decl: {
                    start: {
                        line: 14,
                        column: 36
                    },
                    end: {
                        line: 14,
                        column: 37
                    }
                },
                loc: {
                    start: {
                        line: 14,
                        column: 50
                    },
                    end: {
                        line: 16,
                        column: 5
                    }
                },
                line: 14
            },
            '5': {
                name: '(anonymous_5)',
                decl: {
                    start: {
                        line: 20,
                        column: 32
                    },
                    end: {
                        line: 20,
                        column: 33
                    }
                },
                loc: {
                    start: {
                        line: 20,
                        column: 44
                    },
                    end: {
                        line: 24,
                        column: 1
                    }
                },
                line: 20
            },
            '6': {
                name: '(anonymous_6)',
                decl: {
                    start: {
                        line: 21,
                        column: 36
                    },
                    end: {
                        line: 21,
                        column: 37
                    }
                },
                loc: {
                    start: {
                        line: 21,
                        column: 50
                    },
                    end: {
                        line: 23,
                        column: 5
                    }
                },
                line: 21
            },
            '7': {
                name: '(anonymous_7)',
                decl: {
                    start: {
                        line: 26,
                        column: 26
                    },
                    end: {
                        line: 26,
                        column: 27
                    }
                },
                loc: {
                    start: {
                        line: 26,
                        column: 38
                    },
                    end: {
                        line: 34,
                        column: 1
                    }
                },
                line: 26
            },
            '8': {
                name: '(anonymous_8)',
                decl: {
                    start: {
                        line: 36,
                        column: 28
                    },
                    end: {
                        line: 36,
                        column: 29
                    }
                },
                loc: {
                    start: {
                        line: 36,
                        column: 40
                    },
                    end: {
                        line: 46,
                        column: 1
                    }
                },
                line: 36
            },
            '9': {
                name: '(anonymous_9)',
                decl: {
                    start: {
                        line: 48,
                        column: 29
                    },
                    end: {
                        line: 48,
                        column: 30
                    }
                },
                loc: {
                    start: {
                        line: 48,
                        column: 41
                    },
                    end: {
                        line: 55,
                        column: 1
                    }
                },
                line: 48
            },
            '10': {
                name: '(anonymous_10)',
                decl: {
                    start: {
                        line: 57,
                        column: 33
                    },
                    end: {
                        line: 57,
                        column: 34
                    }
                },
                loc: {
                    start: {
                        line: 57,
                        column: 45
                    },
                    end: {
                        line: 87,
                        column: 1
                    }
                },
                line: 57
            },
            '11': {
                name: '(anonymous_11)',
                decl: {
                    start: {
                        line: 71,
                        column: 21
                    },
                    end: {
                        line: 71,
                        column: 22
                    }
                },
                loc: {
                    start: {
                        line: 71,
                        column: 35
                    },
                    end: {
                        line: 81,
                        column: 9
                    }
                },
                line: 71
            }
        },
        branchMap: {
            '0': {
                loc: {
                    start: {
                        line: 31,
                        column: 4
                    },
                    end: {
                        line: 31,
                        column: 42
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 31,
                        column: 4
                    },
                    end: {
                        line: 31,
                        column: 42
                    }
                }, {
                    start: {
                        line: 31,
                        column: 4
                    },
                    end: {
                        line: 31,
                        column: 42
                    }
                }],
                line: 31
            },
            '1': {
                loc: {
                    start: {
                        line: 32,
                        column: 4
                    },
                    end: {
                        line: 32,
                        column: 48
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 32,
                        column: 4
                    },
                    end: {
                        line: 32,
                        column: 48
                    }
                }, {
                    start: {
                        line: 32,
                        column: 4
                    },
                    end: {
                        line: 32,
                        column: 48
                    }
                }],
                line: 32
            },
            '2': {
                loc: {
                    start: {
                        line: 42,
                        column: 4
                    },
                    end: {
                        line: 42,
                        column: 42
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 42,
                        column: 4
                    },
                    end: {
                        line: 42,
                        column: 42
                    }
                }, {
                    start: {
                        line: 42,
                        column: 4
                    },
                    end: {
                        line: 42,
                        column: 42
                    }
                }],
                line: 42
            },
            '3': {
                loc: {
                    start: {
                        line: 43,
                        column: 4
                    },
                    end: {
                        line: 43,
                        column: 48
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 43,
                        column: 4
                    },
                    end: {
                        line: 43,
                        column: 48
                    }
                }, {
                    start: {
                        line: 43,
                        column: 4
                    },
                    end: {
                        line: 43,
                        column: 48
                    }
                }],
                line: 43
            },
            '4': {
                loc: {
                    start: {
                        line: 44,
                        column: 4
                    },
                    end: {
                        line: 44,
                        column: 48
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 44,
                        column: 4
                    },
                    end: {
                        line: 44,
                        column: 48
                    }
                }, {
                    start: {
                        line: 44,
                        column: 4
                    },
                    end: {
                        line: 44,
                        column: 48
                    }
                }],
                line: 44
            },
            '5': {
                loc: {
                    start: {
                        line: 54,
                        column: 12
                    },
                    end: {
                        line: 54,
                        column: 43
                    }
                },
                type: 'cond-expr',
                locations: [{
                    start: {
                        line: 54,
                        column: 26
                    },
                    end: {
                        line: 54,
                        column: 38
                    }
                }, {
                    start: {
                        line: 54,
                        column: 41
                    },
                    end: {
                        line: 54,
                        column: 43
                    }
                }],
                line: 54
            },
            '6': {
                loc: {
                    start: {
                        line: 54,
                        column: 65
                    },
                    end: {
                        line: 54,
                        column: 97
                    }
                },
                type: 'cond-expr',
                locations: [{
                    start: {
                        line: 54,
                        column: 79
                    },
                    end: {
                        line: 54,
                        column: 81
                    }
                }, {
                    start: {
                        line: 54,
                        column: 84
                    },
                    end: {
                        line: 54,
                        column: 97
                    }
                }],
                line: 54
            },
            '7': {
                loc: {
                    start: {
                        line: 63,
                        column: 4
                    },
                    end: {
                        line: 86,
                        column: 5
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 63,
                        column: 4
                    },
                    end: {
                        line: 86,
                        column: 5
                    }
                }, {
                    start: {
                        line: 63,
                        column: 4
                    },
                    end: {
                        line: 86,
                        column: 5
                    }
                }],
                line: 63
            },
            '8': {
                loc: {
                    start: {
                        line: 67,
                        column: 9
                    },
                    end: {
                        line: 86,
                        column: 5
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 67,
                        column: 9
                    },
                    end: {
                        line: 86,
                        column: 5
                    }
                }, {
                    start: {
                        line: 67,
                        column: 9
                    },
                    end: {
                        line: 86,
                        column: 5
                    }
                }],
                line: 67
            },
            '9': {
                loc: {
                    start: {
                        line: 73,
                        column: 12
                    },
                    end: {
                        line: 79,
                        column: 13
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 73,
                        column: 12
                    },
                    end: {
                        line: 79,
                        column: 13
                    }
                }, {
                    start: {
                        line: 73,
                        column: 12
                    },
                    end: {
                        line: 79,
                        column: 13
                    }
                }],
                line: 73
            },
            '10': {
                loc: {
                    start: {
                        line: 74,
                        column: 16
                    },
                    end: {
                        line: 78,
                        column: 17
                    }
                },
                type: 'switch',
                locations: [{
                    start: {
                        line: 75,
                        column: 20
                    },
                    end: {
                        line: 75,
                        column: 42
                    }
                }, {
                    start: {
                        line: 76,
                        column: 20
                    },
                    end: {
                        line: 76,
                        column: 42
                    }
                }, {
                    start: {
                        line: 77,
                        column: 20
                    },
                    end: {
                        line: 77,
                        column: 42
                    }
                }],
                line: 74
            }
        },
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0,
            '7': 0,
            '8': 0,
            '9': 0,
            '10': 0,
            '11': 0,
            '12': 0,
            '13': 0,
            '14': 0,
            '15': 0,
            '16': 0,
            '17': 0,
            '18': 0,
            '19': 0,
            '20': 0,
            '21': 0,
            '22': 0,
            '23': 0,
            '24': 0,
            '25': 0,
            '26': 0,
            '27': 0,
            '28': 0,
            '29': 0,
            '30': 0,
            '31': 0,
            '32': 0,
            '33': 0,
            '34': 0,
            '35': 0,
            '36': 0,
            '37': 0,
            '38': 0,
            '39': 0,
            '40': 0,
            '41': 0,
            '42': 0,
            '43': 0,
            '44': 0,
            '45': 0,
            '46': 0,
            '47': 0,
            '48': 0,
            '49': 0,
            '50': 0,
            '51': 0,
            '52': 0,
            '53': 0,
            '54': 0,
            '55': 0,
            '56': 0,
            '57': 0,
            '58': 0,
            '59': 0,
            '60': 0
        },
        f: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0,
            '7': 0,
            '8': 0,
            '9': 0,
            '10': 0,
            '11': 0
        },
        b: {
            '0': [0, 0],
            '1': [0, 0],
            '2': [0, 0],
            '3': [0, 0],
            '4': [0, 0],
            '5': [0, 0],
            '6': [0, 0],
            '7': [0, 0],
            '8': [0, 0],
            '9': [0, 0],
            '10': [0, 0, 0]
        },
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_2nixu6t4w4.s[0]++;
String.prototype.trim = function () {
    cov_2nixu6t4w4.f[0]++;
    cov_2nixu6t4w4.s[1]++;

    return this.replace(/^\s+|\s+$/g, "");
};

//To Camel Case
cov_2nixu6t4w4.s[2]++;
String.prototype.toCamel = function () {
    cov_2nixu6t4w4.f[1]++;
    cov_2nixu6t4w4.s[3]++;

    return this.replace(/(\-[a-z])/g, function ($1) {
        cov_2nixu6t4w4.f[2]++;
        cov_2nixu6t4w4.s[4]++;

        return $1.toUpperCase().replace('-', '');
    });
};

//To Dashed from Camel Case
cov_2nixu6t4w4.s[5]++;
String.prototype.toDash = function () {
    cov_2nixu6t4w4.f[3]++;
    cov_2nixu6t4w4.s[6]++;

    return this.replace(/([A-Z])/g, function ($1) {
        cov_2nixu6t4w4.f[4]++;
        cov_2nixu6t4w4.s[7]++;

        return "-" + $1.toLowerCase();
    });
};

//To Underscore from Camel Case
cov_2nixu6t4w4.s[8]++;
String.prototype.toUnderscore = function () {
    cov_2nixu6t4w4.f[5]++;
    cov_2nixu6t4w4.s[9]++;

    return this.replace(/([A-Z])/g, function ($1) {
        cov_2nixu6t4w4.f[6]++;
        cov_2nixu6t4w4.s[10]++;

        return "_" + $1.toLowerCase();
    });
};

cov_2nixu6t4w4.s[11]++;
String.prototype.toHHMM = function () {
    cov_2nixu6t4w4.f[7]++;

    var sec_num = (cov_2nixu6t4w4.s[12]++, parseInt(this, 10)); // don't forget the second param
    var hours = (cov_2nixu6t4w4.s[13]++, Math.floor(sec_num / 3600));
    var minutes = (cov_2nixu6t4w4.s[14]++, Math.floor((sec_num - hours * 3600) / 60));

    cov_2nixu6t4w4.s[15]++;
    if (hours < 10) {
        cov_2nixu6t4w4.b[0][0]++;
        cov_2nixu6t4w4.s[16]++;
        hours = "0" + hours;
    } else {
        cov_2nixu6t4w4.b[0][1]++;
    }
    cov_2nixu6t4w4.s[17]++;
    if (minutes < 10) {
        cov_2nixu6t4w4.b[1][0]++;
        cov_2nixu6t4w4.s[18]++;
        minutes = "0" + minutes;
    } else {
        cov_2nixu6t4w4.b[1][1]++;
    }
    cov_2nixu6t4w4.s[19]++;
    return hours + ':' + minutes;
};

cov_2nixu6t4w4.s[20]++;
String.prototype.toHHMMSS = function () {
    cov_2nixu6t4w4.f[8]++;

    var sec_num = (cov_2nixu6t4w4.s[21]++, parseInt(this, 10)); // don't forget the second param
    var hours = (cov_2nixu6t4w4.s[22]++, Math.floor(sec_num / 3600));
    var minutes = (cov_2nixu6t4w4.s[23]++, Math.floor((sec_num - hours * 3600) / 60));
    var seconds = (cov_2nixu6t4w4.s[24]++, sec_num - hours * 3600 - minutes * 60);

    cov_2nixu6t4w4.s[25]++;
    if (hours < 10) {
        cov_2nixu6t4w4.b[2][0]++;
        cov_2nixu6t4w4.s[26]++;
        hours = "0" + hours;
    } else {
        cov_2nixu6t4w4.b[2][1]++;
    }
    cov_2nixu6t4w4.s[27]++;
    if (minutes < 10) {
        cov_2nixu6t4w4.b[3][0]++;
        cov_2nixu6t4w4.s[28]++;
        minutes = "0" + minutes;
    } else {
        cov_2nixu6t4w4.b[3][1]++;
    }
    cov_2nixu6t4w4.s[29]++;
    if (seconds < 10) {
        cov_2nixu6t4w4.b[4][0]++;
        cov_2nixu6t4w4.s[30]++;
        seconds = "0" + seconds;
    } else {
        cov_2nixu6t4w4.b[4][1]++;
    }
    cov_2nixu6t4w4.s[31]++;
    return hours + ':' + minutes + ':' + seconds;
};

cov_2nixu6t4w4.s[32]++;
String.prototype.toHhMmSSs = function () {
    cov_2nixu6t4w4.f[9]++;

    var sec_num = (cov_2nixu6t4w4.s[33]++, parseInt(this, 10)); // don't forget the second param
    var hours = (cov_2nixu6t4w4.s[34]++, Math.floor(sec_num / 3600));
    var minutes = (cov_2nixu6t4w4.s[35]++, Math.floor((sec_num - hours * 3600) / 60));
    var seconds = (cov_2nixu6t4w4.s[36]++, sec_num - hours * 3600 - minutes * 60);

    cov_2nixu6t4w4.s[37]++;
    return (hours > 0 ? (cov_2nixu6t4w4.b[5][0]++, hours + 'h ') : (cov_2nixu6t4w4.b[5][1]++, '')) + minutes + 'm ' + (hours > 0 ? (cov_2nixu6t4w4.b[6][0]++, '') : (cov_2nixu6t4w4.b[6][1]++, seconds + 's'));
};

cov_2nixu6t4w4.s[38]++;
String.prototype.toVerboseDate = function () {
    cov_2nixu6t4w4.f[10]++;

    var months = (cov_2nixu6t4w4.s[39]++, ["Months", "January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]);
    var days = (cov_2nixu6t4w4.s[40]++, ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]);
    var dateParts = (cov_2nixu6t4w4.s[41]++, this.split("-"));
    var sec_first = (cov_2nixu6t4w4.s[42]++, parseInt(dateParts[0], 10));
    var sec_second = (cov_2nixu6t4w4.s[43]++, parseInt(dateParts[1], 10));
    cov_2nixu6t4w4.s[44]++;
    if (dateParts.length === 2) {
        cov_2nixu6t4w4.b[7][0]++;

        var month = (cov_2nixu6t4w4.s[45]++, months[sec_first]);
        cov_2nixu6t4w4.s[46]++;
        return month + " " + dateParts[1];
    } else {
            cov_2nixu6t4w4.b[7][1]++;
            cov_2nixu6t4w4.s[47]++;
            if (dateParts.length === 3) {
                cov_2nixu6t4w4.b[8][0]++;

                var date = (cov_2nixu6t4w4.s[48]++, new Date(dateParts[2] + "-" + dateParts[1] + "-" + dateParts[0]));
                var weekDay = (cov_2nixu6t4w4.s[49]++, date.getDay());
                var month = (cov_2nixu6t4w4.s[50]++, months[sec_second]);
                cov_2nixu6t4w4.s[51]++;
                var suffix = function suffix(num) {
                    cov_2nixu6t4w4.f[11]++;

                    var array = (cov_2nixu6t4w4.s[52]++, ("" + num).split("").reverse()); // E.g. 123 = array("3","2","1")
                    cov_2nixu6t4w4.s[53]++;
                    if (array[1] != "1") {
                        cov_2nixu6t4w4.b[9][0]++;
                        cov_2nixu6t4w4.s[54]++;
                        // Number is in the teens
                        switch (array[0]) {
                            case "1":
                                cov_2nixu6t4w4.b[10][0]++;
                                cov_2nixu6t4w4.s[55]++;
                                return "st";
                            case "2":
                                cov_2nixu6t4w4.b[10][1]++;
                                cov_2nixu6t4w4.s[56]++;
                                return "nd";
                            case "3":
                                cov_2nixu6t4w4.b[10][2]++;
                                cov_2nixu6t4w4.s[57]++;
                                return "rd";
                        }
                    } else {
                        cov_2nixu6t4w4.b[9][1]++;
                    }
                    cov_2nixu6t4w4.s[58]++;
                    return "th";
                };
                cov_2nixu6t4w4.s[59]++;
                return days[weekDay] + ", " + month + " " + sec_first + suffix(sec_first);
            } else {
                cov_2nixu6t4w4.b[8][1]++;
                cov_2nixu6t4w4.s[60]++;

                return this;
            }
        }
};
'use strict';

var cov_2iniejme99 = function () {
    var path = '/home/lobo/repos/meetings-app/src/app/shared/js/projects.js',
        hash = 'b641ceb9a4984c4e9e3b51abc70ca9c9e3e9a7d1',
        Function = function () {}.constructor,
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/meetings-app/src/app/shared/js/projects.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 17,
                    column: 5
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 4
                },
                end: {
                    line: 6,
                    column: 38
                }
            },
            '2': {
                start: {
                    line: 10,
                    column: 8
                },
                end: {
                    line: 15,
                    column: 10
                }
            },
            '3': {
                start: {
                    line: 11,
                    column: 12
                },
                end: {
                    line: 14,
                    column: 13
                }
            },
            '4': {
                start: {
                    line: 12,
                    column: 19
                },
                end: {
                    line: 12,
                    column: 77
                }
            },
            '5': {
                start: {
                    line: 12,
                    column: 57
                },
                end: {
                    line: 12,
                    column: 76
                }
            },
            '6': {
                start: {
                    line: 13,
                    column: 2
                },
                end: {
                    line: 13,
                    column: 40
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 1,
                        column: 1
                    },
                    end: {
                        line: 1,
                        column: 2
                    }
                },
                loc: {
                    start: {
                        line: 1,
                        column: 13
                    },
                    end: {
                        line: 17,
                        column: 1
                    }
                },
                line: 1
            },
            '1': {
                name: 'projects',
                decl: {
                    start: {
                        line: 9,
                        column: 13
                    },
                    end: {
                        line: 9,
                        column: 21
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 34
                    },
                    end: {
                        line: 16,
                        column: 5
                    }
                },
                line: 9
            },
            '2': {
                name: '(anonymous_2)',
                decl: {
                    start: {
                        line: 10,
                        column: 15
                    },
                    end: {
                        line: 10,
                        column: 16
                    }
                },
                loc: {
                    start: {
                        line: 10,
                        column: 32
                    },
                    end: {
                        line: 15,
                        column: 9
                    }
                },
                line: 10
            },
            '3': {
                name: '(anonymous_3)',
                decl: {
                    start: {
                        line: 12,
                        column: 46
                    },
                    end: {
                        line: 12,
                        column: 47
                    }
                },
                loc: {
                    start: {
                        line: 12,
                        column: 57
                    },
                    end: {
                        line: 12,
                        column: 76
                    }
                },
                line: 12
            }
        },
        branchMap: {
            '0': {
                loc: {
                    start: {
                        line: 11,
                        column: 12
                    },
                    end: {
                        line: 14,
                        column: 13
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 11,
                        column: 12
                    },
                    end: {
                        line: 14,
                        column: 13
                    }
                }, {
                    start: {
                        line: 11,
                        column: 12
                    },
                    end: {
                        line: 14,
                        column: 13
                    }
                }],
                line: 11
            }
        },
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0
        },
        f: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0
        },
        b: {
            '0': [0, 0]
        },
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_2iniejme99.s[0]++;
(function () {
    'use strict';

    projects.$inject = ["$rootScope"];
    cov_2iniejme99.f[0]++;
    cov_2iniejme99.s[1]++;
    angular.module('app').filter('projects', projects);

    /* @ngInject */
    function projects($rootScope) {
        cov_2iniejme99.f[1]++;
        cov_2iniejme99.s[2]++;

        return function (input) {
            cov_2iniejme99.f[2]++;
            cov_2iniejme99.s[3]++;

            if (input) {
                cov_2iniejme99.b[0][0]++;

                var filtered = (cov_2iniejme99.s[4]++, $rootScope.projects.filter(function (project) {
                    cov_2iniejme99.f[3]++;
                    cov_2iniejme99.s[5]++;
                    return project.id == input;
                }));
                cov_2iniejme99.s[6]++;
                return filtered[0].name.toUpperCase();
            } else {
                cov_2iniejme99.b[0][1]++;
            }
        };
    }
})();
'use strict';

var cov_24eqk9guu = function () {
    var path = '/home/lobo/repos/meetings-app/src/app/shared/js/projectFilter.js',
        hash = '18508830dca12e45aea901b44747810931a9d52b',
        Function = function () {}.constructor,
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/meetings-app/src/app/shared/js/projectFilter.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 17,
                    column: 5
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 4
                },
                end: {
                    line: 6,
                    column: 38
                }
            },
            '2': {
                start: {
                    line: 10,
                    column: 8
                },
                end: {
                    line: 15,
                    column: 10
                }
            },
            '3': {
                start: {
                    line: 11,
                    column: 12
                },
                end: {
                    line: 14,
                    column: 13
                }
            },
            '4': {
                start: {
                    line: 12,
                    column: 19
                },
                end: {
                    line: 12,
                    column: 77
                }
            },
            '5': {
                start: {
                    line: 12,
                    column: 57
                },
                end: {
                    line: 12,
                    column: 76
                }
            },
            '6': {
                start: {
                    line: 13,
                    column: 2
                },
                end: {
                    line: 13,
                    column: 40
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 1,
                        column: 1
                    },
                    end: {
                        line: 1,
                        column: 2
                    }
                },
                loc: {
                    start: {
                        line: 1,
                        column: 13
                    },
                    end: {
                        line: 17,
                        column: 1
                    }
                },
                line: 1
            },
            '1': {
                name: 'projects',
                decl: {
                    start: {
                        line: 9,
                        column: 13
                    },
                    end: {
                        line: 9,
                        column: 21
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 34
                    },
                    end: {
                        line: 16,
                        column: 5
                    }
                },
                line: 9
            },
            '2': {
                name: '(anonymous_2)',
                decl: {
                    start: {
                        line: 10,
                        column: 15
                    },
                    end: {
                        line: 10,
                        column: 16
                    }
                },
                loc: {
                    start: {
                        line: 10,
                        column: 32
                    },
                    end: {
                        line: 15,
                        column: 9
                    }
                },
                line: 10
            },
            '3': {
                name: '(anonymous_3)',
                decl: {
                    start: {
                        line: 12,
                        column: 46
                    },
                    end: {
                        line: 12,
                        column: 47
                    }
                },
                loc: {
                    start: {
                        line: 12,
                        column: 57
                    },
                    end: {
                        line: 12,
                        column: 76
                    }
                },
                line: 12
            }
        },
        branchMap: {
            '0': {
                loc: {
                    start: {
                        line: 11,
                        column: 12
                    },
                    end: {
                        line: 14,
                        column: 13
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 11,
                        column: 12
                    },
                    end: {
                        line: 14,
                        column: 13
                    }
                }, {
                    start: {
                        line: 11,
                        column: 12
                    },
                    end: {
                        line: 14,
                        column: 13
                    }
                }],
                line: 11
            }
        },
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0
        },
        f: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0
        },
        b: {
            '0': [0, 0]
        },
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_24eqk9guu.s[0]++;
(function () {
    'use strict';

    projects.$inject = ["$rootScope"];
    cov_24eqk9guu.f[0]++;
    cov_24eqk9guu.s[1]++;
    angular.module('app').filter('projects', projects);

    /* @ngInject */
    function projects($rootScope) {
        cov_24eqk9guu.f[1]++;
        cov_24eqk9guu.s[2]++;

        return function (input) {
            cov_24eqk9guu.f[2]++;
            cov_24eqk9guu.s[3]++;

            if (input) {
                cov_24eqk9guu.b[0][0]++;

                var filtered = (cov_24eqk9guu.s[4]++, $rootScope.projects.filter(function (project) {
                    cov_24eqk9guu.f[3]++;
                    cov_24eqk9guu.s[5]++;
                    return project.id == input;
                }));
                cov_24eqk9guu.s[6]++;
                return filtered[0].name.toUpperCase();
            } else {
                cov_24eqk9guu.b[0][1]++;
            }
        };
    }
})();
'use strict';

var cov_1xjdffxkyk = function () {
    var path = '/home/lobo/repos/meetings-app/src/app/shared/js/contenteditable.directive.js',
        hash = 'e206ed85c67651600ba65ab83eff750ca08a9731',
        Function = function () {}.constructor,
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/meetings-app/src/app/shared/js/contenteditable.directive.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 27,
                    column: 5
                }
            },
            '1': {
                start: {
                    line: 3,
                    column: 4
                },
                end: {
                    line: 25,
                    column: 7
                }
            },
            '2': {
                start: {
                    line: 6,
                    column: 8
                },
                end: {
                    line: 24,
                    column: 10
                }
            },
            '3': {
                start: {
                    line: 12,
                    column: 20
                },
                end: {
                    line: 12,
                    column: 58
                }
            },
            '4': {
                start: {
                    line: 13,
                    column: 20
                },
                end: {
                    line: 13,
                    column: 59
                }
            },
            '5': {
                start: {
                    line: 16,
                    column: 16
                },
                end: {
                    line: 18,
                    column: 18
                }
            },
            '6': {
                start: {
                    line: 17,
                    column: 20
                },
                end: {
                    line: 17,
                    column: 59
                }
            },
            '7': {
                start: {
                    line: 20,
                    column: 16
                },
                end: {
                    line: 22,
                    column: 19
                }
            },
            '8': {
                start: {
                    line: 21,
                    column: 20
                },
                end: {
                    line: 21,
                    column: 39
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 1,
                        column: 1
                    },
                    end: {
                        line: 1,
                        column: 2
                    }
                },
                loc: {
                    start: {
                        line: 1,
                        column: 13
                    },
                    end: {
                        line: 27,
                        column: 1
                    }
                },
                line: 1
            },
            '1': {
                name: '(anonymous_1)',
                decl: {
                    start: {
                        line: 5,
                        column: 34
                    },
                    end: {
                        line: 5,
                        column: 35
                    }
                },
                loc: {
                    start: {
                        line: 5,
                        column: 46
                    },
                    end: {
                        line: 25,
                        column: 5
                    }
                },
                line: 5
            },
            '2': {
                name: '(anonymous_2)',
                decl: {
                    start: {
                        line: 9,
                        column: 18
                    },
                    end: {
                        line: 9,
                        column: 19
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 60
                    },
                    end: {
                        line: 23,
                        column: 13
                    }
                },
                line: 9
            },
            '3': {
                name: 'read',
                decl: {
                    start: {
                        line: 11,
                        column: 25
                    },
                    end: {
                        line: 11,
                        column: 29
                    }
                },
                loc: {
                    start: {
                        line: 11,
                        column: 33
                    },
                    end: {
                        line: 14,
                        column: 17
                    }
                },
                line: 11
            },
            '4': {
                name: '(anonymous_4)',
                decl: {
                    start: {
                        line: 16,
                        column: 34
                    },
                    end: {
                        line: 16,
                        column: 35
                    }
                },
                loc: {
                    start: {
                        line: 16,
                        column: 46
                    },
                    end: {
                        line: 18,
                        column: 17
                    }
                },
                line: 16
            },
            '5': {
                name: '(anonymous_5)',
                decl: {
                    start: {
                        line: 20,
                        column: 50
                    },
                    end: {
                        line: 20,
                        column: 51
                    }
                },
                loc: {
                    start: {
                        line: 20,
                        column: 62
                    },
                    end: {
                        line: 22,
                        column: 17
                    }
                },
                line: 20
            }
        },
        branchMap: {
            '0': {
                loc: {
                    start: {
                        line: 13,
                        column: 33
                    },
                    end: {
                        line: 13,
                        column: 57
                    }
                },
                type: 'binary-expr',
                locations: [{
                    start: {
                        line: 13,
                        column: 33
                    },
                    end: {
                        line: 13,
                        column: 51
                    }
                }, {
                    start: {
                        line: 13,
                        column: 55
                    },
                    end: {
                        line: 13,
                        column: 57
                    }
                }],
                line: 13
            },
            '1': {
                loc: {
                    start: {
                        line: 17,
                        column: 33
                    },
                    end: {
                        line: 17,
                        column: 57
                    }
                },
                type: 'binary-expr',
                locations: [{
                    start: {
                        line: 17,
                        column: 33
                    },
                    end: {
                        line: 17,
                        column: 51
                    }
                }, {
                    start: {
                        line: 17,
                        column: 55
                    },
                    end: {
                        line: 17,
                        column: 57
                    }
                }],
                line: 17
            }
        },
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0,
            '7': 0,
            '8': 0
        },
        f: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0
        },
        b: {
            '0': [0, 0],
            '1': [0, 0]
        },
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_1xjdffxkyk.s[0]++;
(function () {
    'use strict';

    cov_1xjdffxkyk.f[0]++;
    cov_1xjdffxkyk.s[1]++;
    angular.module('app').directive("contenteditable", function () {
        cov_1xjdffxkyk.f[1]++;
        cov_1xjdffxkyk.s[2]++;

        return {
            restrict: "A",
            require: "ngModel",
            link: function link(scope, element, attrs, ngModel) {
                cov_1xjdffxkyk.f[2]++;


                function read() {
                    cov_1xjdffxkyk.f[3]++;
                    cov_1xjdffxkyk.s[3]++;

                    ngModel.$setViewValue(element.text());
                    cov_1xjdffxkyk.s[4]++;
                    element.text((cov_1xjdffxkyk.b[0][0]++, ngModel.$viewValue) || (cov_1xjdffxkyk.b[0][1]++, ""));
                }

                cov_1xjdffxkyk.s[5]++;
                ngModel.$render = function () {
                    cov_1xjdffxkyk.f[4]++;
                    cov_1xjdffxkyk.s[6]++;

                    element.text((cov_1xjdffxkyk.b[1][0]++, ngModel.$viewValue) || (cov_1xjdffxkyk.b[1][1]++, ""));
                };

                cov_1xjdffxkyk.s[7]++;
                element.bind("blur keyup change", function () {
                    cov_1xjdffxkyk.f[5]++;
                    cov_1xjdffxkyk.s[8]++;

                    scope.$apply(read);
                });
            }
        };
    });
})();
'use strict';

var cov_21jzk3mtww = function () {
    var path = '/home/lobo/repos/meetings-app/src/app/components/templatesList/templatesList.js',
        hash = '9f34e232998214e3200b0e45d04de48c730dd4b1',
        Function = function () {}.constructor,
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/meetings-app/src/app/components/templatesList/templatesList.js',
        statementMap: {
            '0': {
                start: {
                    line: 3,
                    column: 8
                },
                end: {
                    line: 3,
                    column: 63
                }
            },
            '1': {
                start: {
                    line: 7,
                    column: 8
                },
                end: {
                    line: 11,
                    column: 11
                }
            },
            '2': {
                start: {
                    line: 8,
                    column: 12
                },
                end: {
                    line: 8,
                    column: 42
                }
            },
            '3': {
                start: {
                    line: 15,
                    column: 0
                },
                end: {
                    line: 23,
                    column: 7
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 2,
                        column: 4
                    },
                    end: {
                        line: 2,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 2,
                        column: 42
                    },
                    end: {
                        line: 4,
                        column: 5
                    }
                },
                line: 2
            },
            '1': {
                name: '(anonymous_1)',
                decl: {
                    start: {
                        line: 6,
                        column: 4
                    },
                    end: {
                        line: 6,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 6,
                        column: 31
                    },
                    end: {
                        line: 12,
                        column: 5
                    }
                },
                line: 6
            },
            '2': {
                name: '(anonymous_2)',
                decl: {
                    start: {
                        line: 7,
                        column: 52
                    },
                    end: {
                        line: 7,
                        column: 53
                    }
                },
                loc: {
                    start: {
                        line: 7,
                        column: 66
                    },
                    end: {
                        line: 9,
                        column: 9
                    }
                },
                line: 7
            },
            '3': {
                name: '(anonymous_3)',
                decl: {
                    start: {
                        line: 9,
                        column: 11
                    },
                    end: {
                        line: 9,
                        column: 12
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 23
                    },
                    end: {
                        line: 11,
                        column: 9
                    }
                },
                line: 9
            }
        },
        branchMap: {},
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0
        },
        f: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0
        },
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var TemplatesListController = function () {
    TemplatesListController.$inject = ["NewTemplateModalService"];
    function TemplatesListController(NewTemplateModalService) {
        _classCallCheck(this, TemplatesListController);

        cov_21jzk3mtww.f[0]++;
        cov_21jzk3mtww.s[0]++;

        this.NewTemplateModalService = NewTemplateModalService;
    }

    _createClass(TemplatesListController, [{
        key: 'displayNewTemplateModal',
        value: function displayNewTemplateModal() {
            var _this = this;

            cov_21jzk3mtww.f[1]++;
            cov_21jzk3mtww.s[1]++;

            this.NewTemplateModalService.display().then(function (template) {
                cov_21jzk3mtww.f[2]++;
                cov_21jzk3mtww.s[2]++;

                _this.templates.$add(template);
            }, function () {
                cov_21jzk3mtww.f[3]++;
            });
        }
    }]);

    return TemplatesListController;
}();

cov_21jzk3mtww.s[3]++;


angular.module('app').component('templatesList', {
    templateUrl: 'app/components/templatesList/templatesList.html',
    controller: TemplatesListController,
    bindings: {
        templates: '<'
    }
});
'use strict';

var cov_nymy334xq = function () {
    var path = '/home/lobo/repos/meetings-app/src/app/components/templateDetails/templateDetails.js',
        hash = 'f1f87fdb9aec5c51fde1a5d6138c3ad6cdf528d8',
        Function = function () {}.constructor,
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/meetings-app/src/app/components/templateDetails/templateDetails.js',
        statementMap: {
            '0': {
                start: {
                    line: 4,
                    column: 8
                },
                end: {
                    line: 4,
                    column: 35
                }
            },
            '1': {
                start: {
                    line: 5,
                    column: 8
                },
                end: {
                    line: 5,
                    column: 37
                }
            },
            '2': {
                start: {
                    line: 6,
                    column: 8
                },
                end: {
                    line: 6,
                    column: 29
                }
            },
            '3': {
                start: {
                    line: 7,
                    column: 8
                },
                end: {
                    line: 23,
                    column: 10
                }
            },
            '4': {
                start: {
                    line: 9,
                    column: 16
                },
                end: {
                    line: 9,
                    column: 27
                }
            },
            '5': {
                start: {
                    line: 14,
                    column: 29
                },
                end: {
                    line: 14,
                    column: 49
                }
            },
            '6': {
                start: {
                    line: 15,
                    column: 28
                },
                end: {
                    line: 15,
                    column: 56
                }
            },
            '7': {
                start: {
                    line: 16,
                    column: 16
                },
                end: {
                    line: 16,
                    column: 37
                }
            },
            '8': {
                start: {
                    line: 18,
                    column: 16
                },
                end: {
                    line: 20,
                    column: 19
                }
            },
            '9': {
                start: {
                    line: 19,
                    column: 20
                },
                end: {
                    line: 19,
                    column: 61
                }
            },
            '10': {
                start: {
                    line: 27,
                    column: 8
                },
                end: {
                    line: 27,
                    column: 46
                }
            },
            '11': {
                start: {
                    line: 28,
                    column: 8
                },
                end: {
                    line: 28,
                    column: 33
                }
            },
            '12': {
                start: {
                    line: 32,
                    column: 8
                },
                end: {
                    line: 35,
                    column: 11
                }
            },
            '13': {
                start: {
                    line: 36,
                    column: 8
                },
                end: {
                    line: 36,
                    column: 33
                }
            },
            '14': {
                start: {
                    line: 40,
                    column: 8
                },
                end: {
                    line: 46,
                    column: 15
                }
            },
            '15': {
                start: {
                    line: 45,
                    column: 16
                },
                end: {
                    line: 45,
                    column: 37
                }
            },
            '16': {
                start: {
                    line: 50,
                    column: 22
                },
                end: {
                    line: 50,
                    column: 27
                }
            },
            '17': {
                start: {
                    line: 51,
                    column: 19
                },
                end: {
                    line: 51,
                    column: 47
                }
            },
            '18': {
                start: {
                    line: 52,
                    column: 8
                },
                end: {
                    line: 56,
                    column: 9
                }
            },
            '19': {
                start: {
                    line: 53,
                    column: 12
                },
                end: {
                    line: 55,
                    column: 13
                }
            },
            '20': {
                start: {
                    line: 54,
                    column: 16
                },
                end: {
                    line: 54,
                    column: 31
                }
            },
            '21': {
                start: {
                    line: 57,
                    column: 8
                },
                end: {
                    line: 57,
                    column: 23
                }
            },
            '22': {
                start: {
                    line: 62,
                    column: 0
                },
                end: {
                    line: 70,
                    column: 7
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 3,
                        column: 4
                    },
                    end: {
                        line: 3,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 3,
                        column: 47
                    },
                    end: {
                        line: 24,
                        column: 5
                    }
                },
                line: 3
            },
            '1': {
                name: '(anonymous_1)',
                decl: {
                    start: {
                        line: 8,
                        column: 20
                    },
                    end: {
                        line: 8,
                        column: 21
                    }
                },
                loc: {
                    start: {
                        line: 8,
                        column: 66
                    },
                    end: {
                        line: 10,
                        column: 13
                    }
                },
                line: 8
            },
            '2': {
                name: '(anonymous_2)',
                decl: {
                    start: {
                        line: 11,
                        column: 23
                    },
                    end: {
                        line: 11,
                        column: 24
                    }
                },
                loc: {
                    start: {
                        line: 11,
                        column: 34
                    },
                    end: {
                        line: 12,
                        column: 13
                    }
                },
                line: 11
            },
            '3': {
                name: '(anonymous_3)',
                decl: {
                    start: {
                        line: 13,
                        column: 26
                    },
                    end: {
                        line: 13,
                        column: 27
                    }
                },
                loc: {
                    start: {
                        line: 13,
                        column: 37
                    },
                    end: {
                        line: 21,
                        column: 13
                    }
                },
                line: 13
            },
            '4': {
                name: '(anonymous_4)',
                decl: {
                    start: {
                        line: 18,
                        column: 45
                    },
                    end: {
                        line: 18,
                        column: 46
                    }
                },
                loc: {
                    start: {
                        line: 18,
                        column: 51
                    },
                    end: {
                        line: 20,
                        column: 17
                    }
                },
                line: 18
            },
            '5': {
                name: '(anonymous_5)',
                decl: {
                    start: {
                        line: 26,
                        column: 4
                    },
                    end: {
                        line: 26,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 26,
                        column: 14
                    },
                    end: {
                        line: 29,
                        column: 5
                    }
                },
                line: 26
            },
            '6': {
                name: '(anonymous_6)',
                decl: {
                    start: {
                        line: 31,
                        column: 4
                    },
                    end: {
                        line: 31,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 31,
                        column: 26
                    },
                    end: {
                        line: 37,
                        column: 5
                    }
                },
                line: 31
            },
            '7': {
                name: '(anonymous_7)',
                decl: {
                    start: {
                        line: 39,
                        column: 4
                    },
                    end: {
                        line: 39,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 39,
                        column: 29
                    },
                    end: {
                        line: 47,
                        column: 5
                    }
                },
                line: 39
            },
            '8': {
                name: '(anonymous_8)',
                decl: {
                    start: {
                        line: 44,
                        column: 18
                    },
                    end: {
                        line: 44,
                        column: 19
                    }
                },
                loc: {
                    start: {
                        line: 44,
                        column: 24
                    },
                    end: {
                        line: 46,
                        column: 13
                    }
                },
                line: 44
            },
            '9': {
                name: '(anonymous_9)',
                decl: {
                    start: {
                        line: 49,
                        column: 4
                    },
                    end: {
                        line: 49,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 49,
                        column: 19
                    },
                    end: {
                        line: 58,
                        column: 5
                    }
                },
                line: 49
            }
        },
        branchMap: {
            '0': {
                loc: {
                    start: {
                        line: 51,
                        column: 19
                    },
                    end: {
                        line: 51,
                        column: 47
                    }
                },
                type: 'binary-expr',
                locations: [{
                    start: {
                        line: 51,
                        column: 19
                    },
                    end: {
                        line: 51,
                        column: 32
                    }
                }, {
                    start: {
                        line: 51,
                        column: 36
                    },
                    end: {
                        line: 51,
                        column: 47
                    }
                }],
                line: 51
            },
            '1': {
                loc: {
                    start: {
                        line: 52,
                        column: 8
                    },
                    end: {
                        line: 56,
                        column: 9
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 52,
                        column: 8
                    },
                    end: {
                        line: 56,
                        column: 9
                    }
                }, {
                    start: {
                        line: 52,
                        column: 8
                    },
                    end: {
                        line: 56,
                        column: 9
                    }
                }],
                line: 52
            },
            '2': {
                loc: {
                    start: {
                        line: 53,
                        column: 12
                    },
                    end: {
                        line: 55,
                        column: 13
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 53,
                        column: 12
                    },
                    end: {
                        line: 55,
                        column: 13
                    }
                }, {
                    start: {
                        line: 53,
                        column: 12
                    },
                    end: {
                        line: 55,
                        column: 13
                    }
                }],
                line: 53
            }
        },
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0,
            '7': 0,
            '8': 0,
            '9': 0,
            '10': 0,
            '11': 0,
            '12': 0,
            '13': 0,
            '14': 0,
            '15': 0,
            '16': 0,
            '17': 0,
            '18': 0,
            '19': 0,
            '20': 0,
            '21': 0,
            '22': 0
        },
        f: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0,
            '7': 0,
            '8': 0,
            '9': 0
        },
        b: {
            '0': [0, 0],
            '1': [0, 0],
            '2': [0, 0]
        },
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var TemplateDetailsController = function () {
    TemplateDetailsController.$inject = ["$mdDialog", "$rootScope", "$scope"];
    function TemplateDetailsController($mdDialog, $rootScope, $scope) {
        var _this = this;

        _classCallCheck(this, TemplateDetailsController);

        cov_nymy334xq.f[0]++;
        cov_nymy334xq.s[0]++;

        this.$mdDialog = $mdDialog;
        cov_nymy334xq.s[1]++;
        this.$rootScope = $rootScope;
        cov_nymy334xq.s[2]++;
        this.$scope = $scope;
        cov_nymy334xq.s[3]++;
        this.sortableListeners = {
            accept: function accept(sourceItemHandleScope, destSortableScope) {
                cov_nymy334xq.f[1]++;
                cov_nymy334xq.s[4]++;

                return true;
            },
            itemMoved: function itemMoved(event) {
                cov_nymy334xq.f[2]++;
            },
            orderChanged: function orderChanged(event) {
                cov_nymy334xq.f[3]++;

                var newPos = (cov_nymy334xq.s[5]++, event.dest.index + 1);
                var topic = (cov_nymy334xq.s[6]++, event.source.itemScope.topic);
                cov_nymy334xq.s[7]++;
                topic.order = newPos;

                cov_nymy334xq.s[8]++;
                topic.$save(['order']).$then(function () {
                    cov_nymy334xq.f[4]++;
                    cov_nymy334xq.s[9]++;

                    _this.template.$templateTopics.$refresh();
                });
            },
            placeholder: '<div style="min-height: 60px;"></div>'
        };
    }

    _createClass(TemplateDetailsController, [{
        key: '$onInit',
        value: function $onInit() {
            cov_nymy334xq.f[5]++;
            cov_nymy334xq.s[10]++;

            this.template.$load('templateTopics');
            cov_nymy334xq.s[11]++;
            this.newDescription = '';
        }
    }, {
        key: 'addTopic',
        value: function addTopic(description) {
            cov_nymy334xq.f[6]++;
            cov_nymy334xq.s[12]++;

            this.template.$templateTopics.$create({
                template: this.template.id,
                name: description
            });
            cov_nymy334xq.s[13]++;
            this.newDescription = '';
        }
    }, {
        key: 'confirmDelete',
        value: function confirmDelete(toDestroy) {
            cov_nymy334xq.f[7]++;
            cov_nymy334xq.s[14]++;

            this.$mdDialog.show(this.$mdDialog.confirm().title("Are you sure you want to delete?").ok('Delete').cancel('Cancel')).then(function () {
                cov_nymy334xq.f[8]++;
                cov_nymy334xq.s[15]++;

                toDestroy.$destroy();
            });
        }
    }, {
        key: 'isEnter',
        value: function isEnter(event) {
            cov_nymy334xq.f[9]++;

            var isEnter = (cov_nymy334xq.s[16]++, false);
            var code = (cov_nymy334xq.s[17]++, (cov_nymy334xq.b[0][0]++, event.keyCode) || (cov_nymy334xq.b[0][1]++, event.which));
            cov_nymy334xq.s[18]++;
            if (code === 13) {
                cov_nymy334xq.b[1][0]++;
                cov_nymy334xq.s[19]++;

                if (!event.shiftKey) {
                    cov_nymy334xq.b[2][0]++;
                    cov_nymy334xq.s[20]++;

                    isEnter = true;
                } else {
                    cov_nymy334xq.b[2][1]++;
                }
            } else {
                cov_nymy334xq.b[1][1]++;
            }
            cov_nymy334xq.s[21]++;
            return isEnter;
        }
    }]);

    return TemplateDetailsController;
}();

cov_nymy334xq.s[22]++;


angular.module('app').component('templateDetails', {
    templateUrl: 'app/components/templateDetails/templateDetails.html',
    controller: TemplateDetailsController,
    bindings: {
        template: '<'
    }
});
'use strict';

var cov_2lg39acsvc = function () {
    var path = '/home/lobo/repos/meetings-app/src/app/components/projectsList/projectsList.js',
        hash = 'c2a8733ce26971840127bd3596f0914b56a73f4e',
        Function = function () {}.constructor,
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/meetings-app/src/app/components/projectsList/projectsList.js',
        statementMap: {
            '0': {
                start: {
                    line: 3,
                    column: 8
                },
                end: {
                    line: 3,
                    column: 61
                }
            },
            '1': {
                start: {
                    line: 7,
                    column: 8
                },
                end: {
                    line: 11,
                    column: 11
                }
            },
            '2': {
                start: {
                    line: 8,
                    column: 12
                },
                end: {
                    line: 8,
                    column: 40
                }
            },
            '3': {
                start: {
                    line: 15,
                    column: 0
                },
                end: {
                    line: 23,
                    column: 7
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 2,
                        column: 4
                    },
                    end: {
                        line: 2,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 2,
                        column: 41
                    },
                    end: {
                        line: 4,
                        column: 5
                    }
                },
                line: 2
            },
            '1': {
                name: '(anonymous_1)',
                decl: {
                    start: {
                        line: 6,
                        column: 4
                    },
                    end: {
                        line: 6,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 6,
                        column: 30
                    },
                    end: {
                        line: 12,
                        column: 5
                    }
                },
                line: 6
            },
            '2': {
                name: '(anonymous_2)',
                decl: {
                    start: {
                        line: 7,
                        column: 51
                    },
                    end: {
                        line: 7,
                        column: 52
                    }
                },
                loc: {
                    start: {
                        line: 7,
                        column: 64
                    },
                    end: {
                        line: 9,
                        column: 9
                    }
                },
                line: 7
            },
            '3': {
                name: '(anonymous_3)',
                decl: {
                    start: {
                        line: 9,
                        column: 11
                    },
                    end: {
                        line: 9,
                        column: 12
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 23
                    },
                    end: {
                        line: 11,
                        column: 9
                    }
                },
                line: 9
            }
        },
        branchMap: {},
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0
        },
        f: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0
        },
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ProjectsListController = function () {
    ProjectsListController.$inject = ["NewProjectModalService"];
    function ProjectsListController(NewProjectModalService) {
        _classCallCheck(this, ProjectsListController);

        cov_2lg39acsvc.f[0]++;
        cov_2lg39acsvc.s[0]++;

        this.NewProjectModalService = NewProjectModalService;
    }

    _createClass(ProjectsListController, [{
        key: 'displayNewProjectModal',
        value: function displayNewProjectModal() {
            var _this = this;

            cov_2lg39acsvc.f[1]++;
            cov_2lg39acsvc.s[1]++;

            this.NewProjectModalService.display().then(function (project) {
                cov_2lg39acsvc.f[2]++;
                cov_2lg39acsvc.s[2]++;

                _this.projects.$add(project);
            }, function () {
                cov_2lg39acsvc.f[3]++;
            });
        }
    }]);

    return ProjectsListController;
}();

cov_2lg39acsvc.s[3]++;


angular.module('app').component('projectsList', {
    templateUrl: 'app/components/projectsList/projectsList.html',
    controller: ProjectsListController,
    bindings: {
        projects: '<'
    }
});
'use strict';

var cov_jj2dgt2av = function () {
    var path = '/home/lobo/repos/meetings-app/src/app/components/projectSelector/projectSelector.js',
        hash = '660df78c25c978fd994749c98ad899290301d858',
        Function = function () {}.constructor,
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/meetings-app/src/app/components/projectSelector/projectSelector.js',
        statementMap: {
            '0': {
                start: {
                    line: 3,
                    column: 8
                },
                end: {
                    line: 5,
                    column: 9
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 12
                },
                end: {
                    line: 4,
                    column: 32
                }
            },
            '2': {
                start: {
                    line: 6,
                    column: 8
                },
                end: {
                    line: 8,
                    column: 9
                }
            },
            '3': {
                start: {
                    line: 7,
                    column: 12
                },
                end: {
                    line: 7,
                    column: 37
                }
            },
            '4': {
                start: {
                    line: 9,
                    column: 8
                },
                end: {
                    line: 9,
                    column: 48
                }
            },
            '5': {
                start: {
                    line: 13,
                    column: 0
                },
                end: {
                    line: 22,
                    column: 3
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 2,
                        column: 4
                    },
                    end: {
                        line: 2,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 2,
                        column: 15
                    },
                    end: {
                        line: 10,
                        column: 5
                    }
                },
                line: 2
            }
        },
        branchMap: {
            '0': {
                loc: {
                    start: {
                        line: 3,
                        column: 8
                    },
                    end: {
                        line: 5,
                        column: 9
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 3,
                        column: 8
                    },
                    end: {
                        line: 5,
                        column: 9
                    }
                }, {
                    start: {
                        line: 3,
                        column: 8
                    },
                    end: {
                        line: 5,
                        column: 9
                    }
                }],
                line: 3
            },
            '1': {
                loc: {
                    start: {
                        line: 6,
                        column: 8
                    },
                    end: {
                        line: 8,
                        column: 9
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 6,
                        column: 8
                    },
                    end: {
                        line: 8,
                        column: 9
                    }
                }, {
                    start: {
                        line: 6,
                        column: 8
                    },
                    end: {
                        line: 8,
                        column: 9
                    }
                }],
                line: 6
            }
        },
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0
        },
        f: {
            '0': 0
        },
        b: {
            '0': [0, 0],
            '1': [0, 0]
        },
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ProjectSelectorController = function () {
    function ProjectSelectorController() {
        _classCallCheck(this, ProjectSelectorController);
    }

    _createClass(ProjectSelectorController, [{
        key: 'changed',
        value: function changed() {
            cov_jj2dgt2av.f[0]++;
            cov_jj2dgt2av.s[0]++;

            if (this.ngModel == 'null') {
                cov_jj2dgt2av.b[0][0]++;
                cov_jj2dgt2av.s[1]++;

                this.ngModel = null;
            } else {
                cov_jj2dgt2av.b[0][1]++;
            }
            cov_jj2dgt2av.s[2]++;
            if (this.ngModel == '') {
                cov_jj2dgt2av.b[1][0]++;
                cov_jj2dgt2av.s[3]++;

                this.ngModel = undefined;
            } else {
                cov_jj2dgt2av.b[1][1]++;
            }
            cov_jj2dgt2av.s[4]++;
            this.ngChange({ $project: this.ngModel });
        }
    }]);

    return ProjectSelectorController;
}();

cov_jj2dgt2av.s[5]++;


angular.module('app').component('projectSelector', {
    templateUrl: 'app/components/projectSelector/projectSelector.html',
    controller: ProjectSelectorController,
    bindings: {
        ngChange: '&',
        ngModel: '='
    }
});
'use strict';

var cov_1hm35amat4 = function () {
    var path = '/home/lobo/repos/meetings-app/src/app/components/paginator/paginator.js',
        hash = '3c8fc1731fa2120211f0c9bbfb7ee48e21788355',
        Function = function () {}.constructor,
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/meetings-app/src/app/components/paginator/paginator.js',
        statementMap: {
            '0': {
                start: {
                    line: 4,
                    column: 8
                },
                end: {
                    line: 4,
                    column: 35
                }
            },
            '1': {
                start: {
                    line: 5,
                    column: 8
                },
                end: {
                    line: 5,
                    column: 41
                }
            },
            '2': {
                start: {
                    line: 9,
                    column: 8
                },
                end: {
                    line: 9,
                    column: 64
                }
            },
            '3': {
                start: {
                    line: 10,
                    column: 8
                },
                end: {
                    line: 12,
                    column: 9
                }
            },
            '4': {
                start: {
                    line: 11,
                    column: 12
                },
                end: {
                    line: 11,
                    column: 64
                }
            },
            '5': {
                start: {
                    line: 16,
                    column: 25
                },
                end: {
                    line: 16,
                    column: 65
                }
            },
            '6': {
                start: {
                    line: 17,
                    column: 8
                },
                end: {
                    line: 17,
                    column: 32
                }
            },
            '7': {
                start: {
                    line: 21,
                    column: 8
                },
                end: {
                    line: 23,
                    column: 9
                }
            },
            '8': {
                start: {
                    line: 22,
                    column: 12
                },
                end: {
                    line: 22,
                    column: 38
                }
            },
            '9': {
                start: {
                    line: 24,
                    column: 22
                },
                end: {
                    line: 24,
                    column: 47
                }
            },
            '10': {
                start: {
                    line: 25,
                    column: 8
                },
                end: {
                    line: 25,
                    column: 28
                }
            },
            '11': {
                start: {
                    line: 29,
                    column: 8
                },
                end: {
                    line: 29,
                    column: 37
                }
            },
            '12': {
                start: {
                    line: 30,
                    column: 8
                },
                end: {
                    line: 30,
                    column: 44
                }
            },
            '13': {
                start: {
                    line: 31,
                    column: 8
                },
                end: {
                    line: 31,
                    column: 35
                }
            },
            '14': {
                start: {
                    line: 35,
                    column: 0
                },
                end: {
                    line: 43,
                    column: 7
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 3,
                        column: 4
                    },
                    end: {
                        line: 3,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 3,
                        column: 41
                    },
                    end: {
                        line: 6,
                        column: 5
                    }
                },
                line: 3
            },
            '1': {
                name: '(anonymous_1)',
                decl: {
                    start: {
                        line: 8,
                        column: 4
                    },
                    end: {
                        line: 8,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 8,
                        column: 14
                    },
                    end: {
                        line: 13,
                        column: 5
                    }
                },
                line: 8
            },
            '2': {
                name: '(anonymous_2)',
                decl: {
                    start: {
                        line: 15,
                        column: 4
                    },
                    end: {
                        line: 15,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 15,
                        column: 23
                    },
                    end: {
                        line: 18,
                        column: 5
                    }
                },
                line: 15
            },
            '3': {
                name: '(anonymous_3)',
                decl: {
                    start: {
                        line: 20,
                        column: 4
                    },
                    end: {
                        line: 20,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 20,
                        column: 19
                    },
                    end: {
                        line: 26,
                        column: 5
                    }
                },
                line: 20
            },
            '4': {
                name: '(anonymous_4)',
                decl: {
                    start: {
                        line: 28,
                        column: 4
                    },
                    end: {
                        line: 28,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 28,
                        column: 19
                    },
                    end: {
                        line: 32,
                        column: 5
                    }
                },
                line: 28
            }
        },
        branchMap: {
            '0': {
                loc: {
                    start: {
                        line: 9,
                        column: 24
                    },
                    end: {
                        line: 9,
                        column: 63
                    }
                },
                type: 'binary-expr',
                locations: [{
                    start: {
                        line: 9,
                        column: 24
                    },
                    end: {
                        line: 9,
                        column: 57
                    }
                }, {
                    start: {
                        line: 9,
                        column: 61
                    },
                    end: {
                        line: 9,
                        column: 63
                    }
                }],
                line: 9
            },
            '1': {
                loc: {
                    start: {
                        line: 10,
                        column: 8
                    },
                    end: {
                        line: 12,
                        column: 9
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 10,
                        column: 8
                    },
                    end: {
                        line: 12,
                        column: 9
                    }
                }, {
                    start: {
                        line: 10,
                        column: 8
                    },
                    end: {
                        line: 12,
                        column: 9
                    }
                }],
                line: 10
            },
            '2': {
                loc: {
                    start: {
                        line: 21,
                        column: 8
                    },
                    end: {
                        line: 23,
                        column: 9
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 21,
                        column: 8
                    },
                    end: {
                        line: 23,
                        column: 9
                    }
                }, {
                    start: {
                        line: 21,
                        column: 8
                    },
                    end: {
                        line: 23,
                        column: 9
                    }
                }],
                line: 21
            }
        },
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0,
            '7': 0,
            '8': 0,
            '9': 0,
            '10': 0,
            '11': 0,
            '12': 0,
            '13': 0,
            '14': 0
        },
        f: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0
        },
        b: {
            '0': [0, 0],
            '1': [0, 0],
            '2': [0, 0]
        },
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PaginatorController = function () {
    PaginatorController.$inject = ["$stateParams", "$location"];
    function PaginatorController($stateParams, $location) {
        _classCallCheck(this, PaginatorController);

        cov_1hm35amat4.f[0]++;
        cov_1hm35amat4.s[0]++;

        this.$location = $location;
        cov_1hm35amat4.s[1]++;
        this.$stateParams = $stateParams;
    }

    _createClass(PaginatorController, [{
        key: '$onInit',
        value: function $onInit() {
            cov_1hm35amat4.f[1]++;
            cov_1hm35amat4.s[2]++;

            this.pageSize = (cov_1hm35amat4.b[0][0]++, this.collection.$params.page_size) || (cov_1hm35amat4.b[0][1]++, 25);
            cov_1hm35amat4.s[3]++;
            if (this.$stateParams.page) {
                cov_1hm35amat4.b[1][0]++;
                cov_1hm35amat4.s[4]++;

                this.goToPage(parseInt(this.$stateParams.page, 10));
            } else {
                cov_1hm35amat4.b[1][1]++;
            }
        }
    }, {
        key: 'goToPreviousPage',
        value: function goToPreviousPage() {
            cov_1hm35amat4.f[2]++;

            var previous = (cov_1hm35amat4.s[5]++, Math.max(1, this.collection.$page - 1));
            cov_1hm35amat4.s[6]++;
            this.goToPage(previous);
        }
    }, {
        key: 'goToNextPage',
        value: function goToNextPage() {
            cov_1hm35amat4.f[3]++;
            cov_1hm35amat4.s[7]++;

            if (!this.collection.$page) {
                cov_1hm35amat4.b[2][0]++;
                cov_1hm35amat4.s[8]++;

                this.collection.$page = 0;
            } else {
                cov_1hm35amat4.b[2][1]++;
            }
            var next = (cov_1hm35amat4.s[9]++, this.collection.$page + 1);
            cov_1hm35amat4.s[10]++;
            this.goToPage(next);
        }
    }, {
        key: 'goToPage',
        value: function goToPage(page) {
            cov_1hm35amat4.f[4]++;
            cov_1hm35amat4.s[11]++;

            this.collection.$page = page;
            cov_1hm35amat4.s[12]++;
            this.$location.search('page', page);
            cov_1hm35amat4.s[13]++;
            this.collection.$refresh();
        }
    }]);

    return PaginatorController;
}();

cov_1hm35amat4.s[14]++;


angular.module('app').component('paginator', {
    templateUrl: 'app/components/paginator/paginator.html',
    controller: PaginatorController,
    bindings: {
        collection: '<'
    }
});
'use strict';

var cov_16dg9fh0h4 = function () {
    var path = '/home/lobo/repos/meetings-app/src/app/components/offline/offline.js',
        hash = '981c188f844d1627ec9e341ea60a1b419c4b7225',
        Function = function () {}.constructor,
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/meetings-app/src/app/components/offline/offline.js',
        statementMap: {
            '0': {
                start: {
                    line: 3,
                    column: 8
                },
                end: {
                    line: 3,
                    column: 31
                }
            },
            '1': {
                start: {
                    line: 5,
                    column: 8
                },
                end: {
                    line: 16,
                    column: 21
                }
            },
            '2': {
                start: {
                    line: 6,
                    column: 12
                },
                end: {
                    line: 15,
                    column: 14
                }
            },
            '3': {
                start: {
                    line: 10,
                    column: 20
                },
                end: {
                    line: 10,
                    column: 43
                }
            },
            '4': {
                start: {
                    line: 13,
                    column: 20
                },
                end: {
                    line: 13,
                    column: 42
                }
            },
            '5': {
                start: {
                    line: 20,
                    column: 0
                },
                end: {
                    line: 25,
                    column: 3
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 2,
                        column: 4
                    },
                    end: {
                        line: 2,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 2,
                        column: 48
                    },
                    end: {
                        line: 17,
                        column: 5
                    }
                },
                line: 2
            },
            '1': {
                name: '(anonymous_1)',
                decl: {
                    start: {
                        line: 5,
                        column: 18
                    },
                    end: {
                        line: 5,
                        column: 19
                    }
                },
                loc: {
                    start: {
                        line: 5,
                        column: 24
                    },
                    end: {
                        line: 16,
                        column: 9
                    }
                },
                line: 5
            },
            '2': {
                name: '(anonymous_2)',
                decl: {
                    start: {
                        line: 9,
                        column: 16
                    },
                    end: {
                        line: 9,
                        column: 17
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 22
                    },
                    end: {
                        line: 11,
                        column: 17
                    }
                },
                line: 9
            },
            '3': {
                name: '(anonymous_3)',
                decl: {
                    start: {
                        line: 12,
                        column: 16
                    },
                    end: {
                        line: 12,
                        column: 17
                    }
                },
                loc: {
                    start: {
                        line: 12,
                        column: 22
                    },
                    end: {
                        line: 14,
                        column: 17
                    }
                },
                line: 12
            }
        },
        branchMap: {},
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0
        },
        f: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0
        },
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var OfflineController = function OfflineController($interval, $http, AppSettings) {
    var _this = this;

    _classCallCheck(this, OfflineController);

    cov_16dg9fh0h4.f[0]++;
    cov_16dg9fh0h4.s[0]++;

    this.isOffline = false;

    cov_16dg9fh0h4.s[1]++;
    $interval(function () {
        cov_16dg9fh0h4.f[1]++;
        cov_16dg9fh0h4.s[2]++;

        $http.get(AppSettings.apiUrl + '/api-status/', {
            timeout: 4500
        }).then(function () {
            cov_16dg9fh0h4.f[2]++;
            cov_16dg9fh0h4.s[3]++;

            _this.isOffline = false;
        }, function () {
            cov_16dg9fh0h4.f[3]++;
            cov_16dg9fh0h4.s[4]++;

            _this.isOffline = true;
        });
    }, 1000 * 5);
};
OfflineController.$inject = ["$interval", "$http", "AppSettings"];

cov_16dg9fh0h4.s[5]++;


angular.module('app').component('offline', {
    templateUrl: 'app/components/offline/offline.html',
    controller: OfflineController
});
'use strict';

var cov_24qpqabz0h = function () {
    var path = '/home/lobo/repos/meetings-app/src/app/components/newMeeting/newMeeting.js',
        hash = '685522ed388cf2f0d85243806dcfd152214f1106',
        Function = function () {}.constructor,
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/meetings-app/src/app/components/newMeeting/newMeeting.js',
        statementMap: {
            '0': {
                start: {
                    line: 4,
                    column: 8
                },
                end: {
                    line: 4,
                    column: 42
                }
            },
            '1': {
                start: {
                    line: 5,
                    column: 8
                },
                end: {
                    line: 5,
                    column: 50
                }
            },
            '2': {
                start: {
                    line: 7,
                    column: 8
                },
                end: {
                    line: 7,
                    column: 55
                }
            },
            '3': {
                start: {
                    line: 8,
                    column: 8
                },
                end: {
                    line: 8,
                    column: 43
                }
            },
            '4': {
                start: {
                    line: 9,
                    column: 8
                },
                end: {
                    line: 9,
                    column: 51
                }
            },
            '5': {
                start: {
                    line: 10,
                    column: 8
                },
                end: {
                    line: 10,
                    column: 39
                }
            },
            '6': {
                start: {
                    line: 11,
                    column: 8
                },
                end: {
                    line: 11,
                    column: 51
                }
            },
            '7': {
                start: {
                    line: 13,
                    column: 8
                },
                end: {
                    line: 13,
                    column: 35
                }
            },
            '8': {
                start: {
                    line: 14,
                    column: 8
                },
                end: {
                    line: 14,
                    column: 37
                }
            },
            '9': {
                start: {
                    line: 15,
                    column: 8
                },
                end: {
                    line: 15,
                    column: 29
                }
            },
            '10': {
                start: {
                    line: 16,
                    column: 8
                },
                end: {
                    line: 16,
                    column: 29
                }
            },
            '11': {
                start: {
                    line: 17,
                    column: 8
                },
                end: {
                    line: 37,
                    column: 10
                }
            },
            '12': {
                start: {
                    line: 19,
                    column: 16
                },
                end: {
                    line: 19,
                    column: 27
                }
            },
            '13': {
                start: {
                    line: 24,
                    column: 29
                },
                end: {
                    line: 24,
                    column: 45
                }
            },
            '14': {
                start: {
                    line: 25,
                    column: 28
                },
                end: {
                    line: 25,
                    column: 56
                }
            },
            '15': {
                start: {
                    line: 26,
                    column: 28
                },
                end: {
                    line: 26,
                    column: 61
                }
            },
            '16': {
                start: {
                    line: 27,
                    column: 31
                },
                end: {
                    line: 27,
                    column: 56
                }
            },
            '17': {
                start: {
                    line: 28,
                    column: 16
                },
                end: {
                    line: 28,
                    column: 52
                }
            },
            '18': {
                start: {
                    line: 29,
                    column: 16
                },
                end: {
                    line: 34,
                    column: 17
                }
            },
            '19': {
                start: {
                    line: 30,
                    column: 20
                },
                end: {
                    line: 30,
                    column: 54
                }
            },
            '20': {
                start: {
                    line: 33,
                    column: 20
                },
                end: {
                    line: 33,
                    column: 67
                }
            },
            '21': {
                start: {
                    line: 39,
                    column: 8
                },
                end: {
                    line: 39,
                    column: 49
                }
            },
            '22': {
                start: {
                    line: 42,
                    column: 12
                },
                end: {
                    line: 44,
                    column: 14
                }
            },
            '23': {
                start: {
                    line: 43,
                    column: 16
                },
                end: {
                    line: 43,
                    column: 49
                }
            },
            '24': {
                start: {
                    line: 49,
                    column: 8
                },
                end: {
                    line: 49,
                    column: 31
                }
            },
            '25': {
                start: {
                    line: 50,
                    column: 8
                },
                end: {
                    line: 50,
                    column: 121
                }
            },
            '26': {
                start: {
                    line: 51,
                    column: 8
                },
                end: {
                    line: 51,
                    column: 136
                }
            },
            '27': {
                start: {
                    line: 52,
                    column: 8
                },
                end: {
                    line: 52,
                    column: 28
                }
            },
            '28': {
                start: {
                    line: 53,
                    column: 8
                },
                end: {
                    line: 53,
                    column: 31
                }
            },
            '29': {
                start: {
                    line: 54,
                    column: 8
                },
                end: {
                    line: 54,
                    column: 31
                }
            },
            '30': {
                start: {
                    line: 55,
                    column: 8
                },
                end: {
                    line: 55,
                    column: 32
                }
            },
            '31': {
                start: {
                    line: 57,
                    column: 8
                },
                end: {
                    line: 57,
                    column: 33
                }
            },
            '32': {
                start: {
                    line: 58,
                    column: 8
                },
                end: {
                    line: 58,
                    column: 32
                }
            },
            '33': {
                start: {
                    line: 59,
                    column: 8
                },
                end: {
                    line: 59,
                    column: 62
                }
            },
            '34': {
                start: {
                    line: 60,
                    column: 8
                },
                end: {
                    line: 65,
                    column: 11
                }
            },
            '35': {
                start: {
                    line: 61,
                    column: 12
                },
                end: {
                    line: 64,
                    column: 13
                }
            },
            '36': {
                start: {
                    line: 62,
                    column: 16
                },
                end: {
                    line: 62,
                    column: 56
                }
            },
            '37': {
                start: {
                    line: 63,
                    column: 16
                },
                end: {
                    line: 63,
                    column: 39
                }
            },
            '38': {
                start: {
                    line: 69,
                    column: 8
                },
                end: {
                    line: 74,
                    column: 9
                }
            },
            '39': {
                start: {
                    line: 70,
                    column: 20
                },
                end: {
                    line: 70,
                    column: 59
                }
            },
            '40': {
                start: {
                    line: 71,
                    column: 12
                },
                end: {
                    line: 73,
                    column: 13
                }
            },
            '41': {
                start: {
                    line: 72,
                    column: 16
                },
                end: {
                    line: 72,
                    column: 41
                }
            },
            '42': {
                start: {
                    line: 75,
                    column: 8
                },
                end: {
                    line: 75,
                    column: 18
                }
            },
            '43': {
                start: {
                    line: 79,
                    column: 32
                },
                end: {
                    line: 79,
                    column: 53
                }
            },
            '44': {
                start: {
                    line: 80,
                    column: 8
                },
                end: {
                    line: 80,
                    column: 58
                }
            },
            '45': {
                start: {
                    line: 84,
                    column: 8
                },
                end: {
                    line: 84,
                    column: 37
                }
            },
            '46': {
                start: {
                    line: 88,
                    column: 8
                },
                end: {
                    line: 94,
                    column: 15
                }
            },
            '47': {
                start: {
                    line: 93,
                    column: 16
                },
                end: {
                    line: 93,
                    column: 77
                }
            },
            '48': {
                start: {
                    line: 98,
                    column: 28
                },
                end: {
                    line: 98,
                    column: 33
                }
            },
            '49': {
                start: {
                    line: 99,
                    column: 8
                },
                end: {
                    line: 101,
                    column: 9
                }
            },
            '50': {
                start: {
                    line: 100,
                    column: 12
                },
                end: {
                    line: 100,
                    column: 33
                }
            },
            '51': {
                start: {
                    line: 102,
                    column: 8
                },
                end: {
                    line: 102,
                    column: 29
                }
            },
            '52': {
                start: {
                    line: 106,
                    column: 8
                },
                end: {
                    line: 106,
                    column: 69
                }
            },
            '53': {
                start: {
                    line: 110,
                    column: 8
                },
                end: {
                    line: 112,
                    column: 10
                }
            },
            '54': {
                start: {
                    line: 113,
                    column: 8
                },
                end: {
                    line: 113,
                    column: 33
                }
            },
            '55': {
                start: {
                    line: 117,
                    column: 8
                },
                end: {
                    line: 123,
                    column: 15
                }
            },
            '56': {
                start: {
                    line: 122,
                    column: 16
                },
                end: {
                    line: 122,
                    column: 80
                }
            },
            '57': {
                start: {
                    line: 127,
                    column: 8
                },
                end: {
                    line: 133,
                    column: 11
                }
            },
            '58': {
                start: {
                    line: 128,
                    column: 12
                },
                end: {
                    line: 132,
                    column: 15
                }
            },
            '59': {
                start: {
                    line: 129,
                    column: 16
                },
                end: {
                    line: 131,
                    column: 18
                }
            },
            '60': {
                start: {
                    line: 137,
                    column: 8
                },
                end: {
                    line: 153,
                    column: 11
                }
            },
            '61': {
                start: {
                    line: 138,
                    column: 12
                },
                end: {
                    line: 141,
                    column: 15
                }
            },
            '62': {
                start: {
                    line: 139,
                    column: 16
                },
                end: {
                    line: 139,
                    column: 48
                }
            },
            '63': {
                start: {
                    line: 140,
                    column: 16
                },
                end: {
                    line: 140,
                    column: 30
                }
            },
            '64': {
                start: {
                    line: 142,
                    column: 12
                },
                end: {
                    line: 144,
                    column: 15
                }
            },
            '65': {
                start: {
                    line: 143,
                    column: 16
                },
                end: {
                    line: 143,
                    column: 90
                }
            },
            '66': {
                start: {
                    line: 145,
                    column: 12
                },
                end: {
                    line: 147,
                    column: 15
                }
            },
            '67': {
                start: {
                    line: 146,
                    column: 16
                },
                end: {
                    line: 146,
                    column: 94
                }
            },
            '68': {
                start: {
                    line: 148,
                    column: 12
                },
                end: {
                    line: 151,
                    column: 14
                }
            },
            '69': {
                start: {
                    line: 149,
                    column: 16
                },
                end: {
                    line: 149,
                    column: 54
                }
            },
            '70': {
                start: {
                    line: 150,
                    column: 16
                },
                end: {
                    line: 150,
                    column: 39
                }
            },
            '71': {
                start: {
                    line: 152,
                    column: 12
                },
                end: {
                    line: 152,
                    column: 68
                }
            },
            '72': {
                start: {
                    line: 158,
                    column: 8
                },
                end: {
                    line: 160,
                    column: 10
                }
            },
            '73': {
                start: {
                    line: 163,
                    column: 22
                },
                end: {
                    line: 163,
                    column: 27
                }
            },
            '74': {
                start: {
                    line: 164,
                    column: 19
                },
                end: {
                    line: 164,
                    column: 47
                }
            },
            '75': {
                start: {
                    line: 165,
                    column: 8
                },
                end: {
                    line: 169,
                    column: 9
                }
            },
            '76': {
                start: {
                    line: 166,
                    column: 12
                },
                end: {
                    line: 168,
                    column: 13
                }
            },
            '77': {
                start: {
                    line: 167,
                    column: 16
                },
                end: {
                    line: 167,
                    column: 31
                }
            },
            '78': {
                start: {
                    line: 170,
                    column: 8
                },
                end: {
                    line: 170,
                    column: 23
                }
            },
            '79': {
                start: {
                    line: 174,
                    column: 0
                },
                end: {
                    line: 179,
                    column: 7
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 3,
                        column: 4
                    },
                    end: {
                        line: 3,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 3,
                        column: 182
                    },
                    end: {
                        line: 46,
                        column: 5
                    }
                },
                line: 3
            },
            '1': {
                name: '(anonymous_1)',
                decl: {
                    start: {
                        line: 18,
                        column: 20
                    },
                    end: {
                        line: 18,
                        column: 21
                    }
                },
                loc: {
                    start: {
                        line: 18,
                        column: 66
                    },
                    end: {
                        line: 20,
                        column: 13
                    }
                },
                line: 18
            },
            '2': {
                name: '(anonymous_2)',
                decl: {
                    start: {
                        line: 21,
                        column: 23
                    },
                    end: {
                        line: 21,
                        column: 24
                    }
                },
                loc: {
                    start: {
                        line: 21,
                        column: 34
                    },
                    end: {
                        line: 22,
                        column: 13
                    }
                },
                line: 21
            },
            '3': {
                name: '(anonymous_3)',
                decl: {
                    start: {
                        line: 23,
                        column: 26
                    },
                    end: {
                        line: 23,
                        column: 27
                    }
                },
                loc: {
                    start: {
                        line: 23,
                        column: 37
                    },
                    end: {
                        line: 35,
                        column: 13
                    }
                },
                line: 23
            },
            '4': {
                name: 'buildToggler',
                decl: {
                    start: {
                        line: 41,
                        column: 17
                    },
                    end: {
                        line: 41,
                        column: 29
                    }
                },
                loc: {
                    start: {
                        line: 41,
                        column: 43
                    },
                    end: {
                        line: 45,
                        column: 9
                    }
                },
                line: 41
            },
            '5': {
                name: '(anonymous_5)',
                decl: {
                    start: {
                        line: 42,
                        column: 19
                    },
                    end: {
                        line: 42,
                        column: 20
                    }
                },
                loc: {
                    start: {
                        line: 42,
                        column: 30
                    },
                    end: {
                        line: 44,
                        column: 13
                    }
                },
                line: 42
            },
            '6': {
                name: '(anonymous_6)',
                decl: {
                    start: {
                        line: 48,
                        column: 4
                    },
                    end: {
                        line: 48,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 48,
                        column: 14
                    },
                    end: {
                        line: 66,
                        column: 5
                    }
                },
                line: 48
            },
            '7': {
                name: '(anonymous_7)',
                decl: {
                    start: {
                        line: 60,
                        column: 47
                    },
                    end: {
                        line: 60,
                        column: 48
                    }
                },
                loc: {
                    start: {
                        line: 60,
                        column: 61
                    },
                    end: {
                        line: 65,
                        column: 9
                    }
                },
                line: 60
            },
            '8': {
                name: '(anonymous_8)',
                decl: {
                    start: {
                        line: 68,
                        column: 4
                    },
                    end: {
                        line: 68,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 68,
                        column: 20
                    },
                    end: {
                        line: 76,
                        column: 5
                    }
                },
                line: 68
            },
            '9': {
                name: '(anonymous_9)',
                decl: {
                    start: {
                        line: 78,
                        column: 4
                    },
                    end: {
                        line: 78,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 78,
                        column: 18
                    },
                    end: {
                        line: 81,
                        column: 5
                    }
                },
                line: 78
            },
            '10': {
                name: '(anonymous_10)',
                decl: {
                    start: {
                        line: 83,
                        column: 4
                    },
                    end: {
                        line: 83,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 83,
                        column: 18
                    },
                    end: {
                        line: 85,
                        column: 5
                    }
                },
                line: 83
            },
            '11': {
                name: '(anonymous_11)',
                decl: {
                    start: {
                        line: 87,
                        column: 4
                    },
                    end: {
                        line: 87,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 87,
                        column: 28
                    },
                    end: {
                        line: 95,
                        column: 5
                    }
                },
                line: 87
            },
            '12': {
                name: '(anonymous_12)',
                decl: {
                    start: {
                        line: 92,
                        column: 18
                    },
                    end: {
                        line: 92,
                        column: 19
                    }
                },
                loc: {
                    start: {
                        line: 92,
                        column: 24
                    },
                    end: {
                        line: 94,
                        column: 13
                    }
                },
                line: 92
            },
            '13': {
                name: '(anonymous_13)',
                decl: {
                    start: {
                        line: 97,
                        column: 4
                    },
                    end: {
                        line: 97,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 97,
                        column: 28
                    },
                    end: {
                        line: 103,
                        column: 5
                    }
                },
                line: 97
            },
            '14': {
                name: '(anonymous_14)',
                decl: {
                    start: {
                        line: 105,
                        column: 4
                    },
                    end: {
                        line: 105,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 105,
                        column: 28
                    },
                    end: {
                        line: 107,
                        column: 5
                    }
                },
                line: 105
            },
            '15': {
                name: '(anonymous_15)',
                decl: {
                    start: {
                        line: 109,
                        column: 4
                    },
                    end: {
                        line: 109,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 109,
                        column: 19
                    },
                    end: {
                        line: 114,
                        column: 5
                    }
                },
                line: 109
            },
            '16': {
                name: '(anonymous_16)',
                decl: {
                    start: {
                        line: 116,
                        column: 4
                    },
                    end: {
                        line: 116,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 116,
                        column: 30
                    },
                    end: {
                        line: 124,
                        column: 5
                    }
                },
                line: 116
            },
            '17': {
                name: '(anonymous_17)',
                decl: {
                    start: {
                        line: 121,
                        column: 18
                    },
                    end: {
                        line: 121,
                        column: 19
                    }
                },
                loc: {
                    start: {
                        line: 121,
                        column: 24
                    },
                    end: {
                        line: 123,
                        column: 13
                    }
                },
                line: 121
            },
            '18': {
                name: '(anonymous_18)',
                decl: {
                    start: {
                        line: 126,
                        column: 4
                    },
                    end: {
                        line: 126,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 126,
                        column: 28
                    },
                    end: {
                        line: 134,
                        column: 5
                    }
                },
                line: 126
            },
            '19': {
                name: '(anonymous_19)',
                decl: {
                    start: {
                        line: 127,
                        column: 90
                    },
                    end: {
                        line: 127,
                        column: 91
                    }
                },
                loc: {
                    start: {
                        line: 127,
                        column: 110
                    },
                    end: {
                        line: 133,
                        column: 9
                    }
                },
                line: 127
            },
            '20': {
                name: '(anonymous_20)',
                decl: {
                    start: {
                        line: 128,
                        column: 35
                    },
                    end: {
                        line: 128,
                        column: 36
                    }
                },
                loc: {
                    start: {
                        line: 128,
                        column: 46
                    },
                    end: {
                        line: 132,
                        column: 13
                    }
                },
                line: 128
            },
            '21': {
                name: '(anonymous_21)',
                decl: {
                    start: {
                        line: 136,
                        column: 4
                    },
                    end: {
                        line: 136,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 136,
                        column: 18
                    },
                    end: {
                        line: 155,
                        column: 5
                    }
                },
                line: 136
            },
            '22': {
                name: '(anonymous_22)',
                decl: {
                    start: {
                        line: 137,
                        column: 35
                    },
                    end: {
                        line: 137,
                        column: 36
                    }
                },
                loc: {
                    start: {
                        line: 137,
                        column: 41
                    },
                    end: {
                        line: 153,
                        column: 9
                    }
                },
                line: 137
            },
            '23': {
                name: '(anonymous_23)',
                decl: {
                    start: {
                        line: 138,
                        column: 39
                    },
                    end: {
                        line: 138,
                        column: 40
                    }
                },
                loc: {
                    start: {
                        line: 138,
                        column: 50
                    },
                    end: {
                        line: 141,
                        column: 13
                    }
                },
                line: 138
            },
            '24': {
                name: '(anonymous_24)',
                decl: {
                    start: {
                        line: 142,
                        column: 38
                    },
                    end: {
                        line: 142,
                        column: 39
                    }
                },
                loc: {
                    start: {
                        line: 142,
                        column: 48
                    },
                    end: {
                        line: 144,
                        column: 13
                    }
                },
                line: 142
            },
            '25': {
                name: '(anonymous_25)',
                decl: {
                    start: {
                        line: 145,
                        column: 38
                    },
                    end: {
                        line: 145,
                        column: 39
                    }
                },
                loc: {
                    start: {
                        line: 145,
                        column: 55
                    },
                    end: {
                        line: 147,
                        column: 13
                    }
                },
                line: 145
            },
            '26': {
                name: '(anonymous_26)',
                decl: {
                    start: {
                        line: 148,
                        column: 106
                    },
                    end: {
                        line: 148,
                        column: 107
                    }
                },
                loc: {
                    start: {
                        line: 148,
                        column: 123
                    },
                    end: {
                        line: 151,
                        column: 13
                    }
                },
                line: 148
            },
            '27': {
                name: '(anonymous_27)',
                decl: {
                    start: {
                        line: 157,
                        column: 4
                    },
                    end: {
                        line: 157,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 157,
                        column: 19
                    },
                    end: {
                        line: 161,
                        column: 5
                    }
                },
                line: 157
            },
            '28': {
                name: '(anonymous_28)',
                decl: {
                    start: {
                        line: 162,
                        column: 4
                    },
                    end: {
                        line: 162,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 162,
                        column: 19
                    },
                    end: {
                        line: 171,
                        column: 5
                    }
                },
                line: 162
            }
        },
        branchMap: {
            '0': {
                loc: {
                    start: {
                        line: 29,
                        column: 16
                    },
                    end: {
                        line: 34,
                        column: 17
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 29,
                        column: 16
                    },
                    end: {
                        line: 34,
                        column: 17
                    }
                }, {
                    start: {
                        line: 29,
                        column: 16
                    },
                    end: {
                        line: 34,
                        column: 17
                    }
                }],
                line: 29
            },
            '1': {
                loc: {
                    start: {
                        line: 61,
                        column: 12
                    },
                    end: {
                        line: 64,
                        column: 13
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 61,
                        column: 12
                    },
                    end: {
                        line: 64,
                        column: 13
                    }
                }, {
                    start: {
                        line: 61,
                        column: 12
                    },
                    end: {
                        line: 64,
                        column: 13
                    }
                }],
                line: 61
            },
            '2': {
                loc: {
                    start: {
                        line: 69,
                        column: 8
                    },
                    end: {
                        line: 74,
                        column: 9
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 69,
                        column: 8
                    },
                    end: {
                        line: 74,
                        column: 9
                    }
                }, {
                    start: {
                        line: 69,
                        column: 8
                    },
                    end: {
                        line: 74,
                        column: 9
                    }
                }],
                line: 69
            },
            '3': {
                loc: {
                    start: {
                        line: 71,
                        column: 12
                    },
                    end: {
                        line: 73,
                        column: 13
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 71,
                        column: 12
                    },
                    end: {
                        line: 73,
                        column: 13
                    }
                }, {
                    start: {
                        line: 71,
                        column: 12
                    },
                    end: {
                        line: 73,
                        column: 13
                    }
                }],
                line: 71
            },
            '4': {
                loc: {
                    start: {
                        line: 71,
                        column: 16
                    },
                    end: {
                        line: 71,
                        column: 33
                    }
                },
                type: 'binary-expr',
                locations: [{
                    start: {
                        line: 71,
                        column: 16
                    },
                    end: {
                        line: 71,
                        column: 17
                    }
                }, {
                    start: {
                        line: 71,
                        column: 21
                    },
                    end: {
                        line: 71,
                        column: 33
                    }
                }],
                line: 71
            },
            '5': {
                loc: {
                    start: {
                        line: 99,
                        column: 8
                    },
                    end: {
                        line: 101,
                        column: 9
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 99,
                        column: 8
                    },
                    end: {
                        line: 101,
                        column: 9
                    }
                }, {
                    start: {
                        line: 99,
                        column: 8
                    },
                    end: {
                        line: 101,
                        column: 9
                    }
                }],
                line: 99
            },
            '6': {
                loc: {
                    start: {
                        line: 158,
                        column: 16
                    },
                    end: {
                        line: 159,
                        column: 46
                    }
                },
                type: 'binary-expr',
                locations: [{
                    start: {
                        line: 158,
                        column: 16
                    },
                    end: {
                        line: 158,
                        column: 47
                    }
                }, {
                    start: {
                        line: 158,
                        column: 51
                    },
                    end: {
                        line: 158,
                        column: 75
                    }
                }, {
                    start: {
                        line: 159,
                        column: 12
                    },
                    end: {
                        line: 159,
                        column: 46
                    }
                }],
                line: 158
            },
            '7': {
                loc: {
                    start: {
                        line: 164,
                        column: 19
                    },
                    end: {
                        line: 164,
                        column: 47
                    }
                },
                type: 'binary-expr',
                locations: [{
                    start: {
                        line: 164,
                        column: 19
                    },
                    end: {
                        line: 164,
                        column: 32
                    }
                }, {
                    start: {
                        line: 164,
                        column: 36
                    },
                    end: {
                        line: 164,
                        column: 47
                    }
                }],
                line: 164
            },
            '8': {
                loc: {
                    start: {
                        line: 165,
                        column: 8
                    },
                    end: {
                        line: 169,
                        column: 9
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 165,
                        column: 8
                    },
                    end: {
                        line: 169,
                        column: 9
                    }
                }, {
                    start: {
                        line: 165,
                        column: 8
                    },
                    end: {
                        line: 169,
                        column: 9
                    }
                }],
                line: 165
            },
            '9': {
                loc: {
                    start: {
                        line: 166,
                        column: 12
                    },
                    end: {
                        line: 168,
                        column: 13
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 166,
                        column: 12
                    },
                    end: {
                        line: 168,
                        column: 13
                    }
                }, {
                    start: {
                        line: 166,
                        column: 12
                    },
                    end: {
                        line: 168,
                        column: 13
                    }
                }],
                line: 166
            }
        },
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0,
            '7': 0,
            '8': 0,
            '9': 0,
            '10': 0,
            '11': 0,
            '12': 0,
            '13': 0,
            '14': 0,
            '15': 0,
            '16': 0,
            '17': 0,
            '18': 0,
            '19': 0,
            '20': 0,
            '21': 0,
            '22': 0,
            '23': 0,
            '24': 0,
            '25': 0,
            '26': 0,
            '27': 0,
            '28': 0,
            '29': 0,
            '30': 0,
            '31': 0,
            '32': 0,
            '33': 0,
            '34': 0,
            '35': 0,
            '36': 0,
            '37': 0,
            '38': 0,
            '39': 0,
            '40': 0,
            '41': 0,
            '42': 0,
            '43': 0,
            '44': 0,
            '45': 0,
            '46': 0,
            '47': 0,
            '48': 0,
            '49': 0,
            '50': 0,
            '51': 0,
            '52': 0,
            '53': 0,
            '54': 0,
            '55': 0,
            '56': 0,
            '57': 0,
            '58': 0,
            '59': 0,
            '60': 0,
            '61': 0,
            '62': 0,
            '63': 0,
            '64': 0,
            '65': 0,
            '66': 0,
            '67': 0,
            '68': 0,
            '69': 0,
            '70': 0,
            '71': 0,
            '72': 0,
            '73': 0,
            '74': 0,
            '75': 0,
            '76': 0,
            '77': 0,
            '78': 0,
            '79': 0
        },
        f: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0,
            '7': 0,
            '8': 0,
            '9': 0,
            '10': 0,
            '11': 0,
            '12': 0,
            '13': 0,
            '14': 0,
            '15': 0,
            '16': 0,
            '17': 0,
            '18': 0,
            '19': 0,
            '20': 0,
            '21': 0,
            '22': 0,
            '23': 0,
            '24': 0,
            '25': 0,
            '26': 0,
            '27': 0,
            '28': 0
        },
        b: {
            '0': [0, 0],
            '1': [0, 0],
            '2': [0, 0],
            '3': [0, 0],
            '4': [0, 0],
            '5': [0, 0],
            '6': [0, 0, 0],
            '7': [0, 0],
            '8': [0, 0],
            '9': [0, 0]
        },
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var NewMeetingController = function () {
    NewMeetingController.$inject = ["UsersTable", "TemplatesTable", "TemplateTopicsTable", "MeetingsTable", "MeetingUsersTable", "TopicsTable", "MeetingFilesTable", "$mdDialog", "$mdSidenav", "$rootScope", "$scope", "$state"];
    function NewMeetingController(UsersTable, TemplatesTable, TemplateTopicsTable, MeetingsTable, MeetingUsersTable, TopicsTable, MeetingFilesTable, $mdDialog, $mdSidenav, $rootScope, $scope, $state) {
        var _this = this;

        _classCallCheck(this, NewMeetingController);

        cov_24qpqabz0h.f[0]++;
        cov_24qpqabz0h.s[0]++;

        this.users = UsersTable.$search();
        cov_24qpqabz0h.s[1]++;
        this.templates = TemplatesTable.$search();

        cov_24qpqabz0h.s[2]++;
        this.templateTopicsTable = TemplateTopicsTable;
        cov_24qpqabz0h.s[3]++;
        this.meetingsTable = MeetingsTable;
        cov_24qpqabz0h.s[4]++;
        this.meetingUsersTable = MeetingUsersTable;
        cov_24qpqabz0h.s[5]++;
        this.topicsTable = TopicsTable;
        cov_24qpqabz0h.s[6]++;
        this.meetingFilesTable = MeetingFilesTable;

        cov_24qpqabz0h.s[7]++;
        this.$mdDialog = $mdDialog;
        cov_24qpqabz0h.s[8]++;
        this.$rootScope = $rootScope;
        cov_24qpqabz0h.s[9]++;
        this.$scope = $scope;
        cov_24qpqabz0h.s[10]++;
        this.$state = $state;
        cov_24qpqabz0h.s[11]++;
        this.sortableListeners = {
            accept: function accept(sourceItemHandleScope, destSortableScope) {
                cov_24qpqabz0h.f[1]++;
                cov_24qpqabz0h.s[12]++;

                return true;
            },
            itemMoved: function itemMoved(event) {
                cov_24qpqabz0h.f[2]++;
            },
            orderChanged: function orderChanged(event) {
                cov_24qpqabz0h.f[3]++;

                var newPos = (cov_24qpqabz0h.s[13]++, event.dest.index);
                var topic = (cov_24qpqabz0h.s[14]++, event.source.itemScope.topic);
                var index = (cov_24qpqabz0h.s[15]++, _this.meetingTopics.indexOf(topic));
                var oldTopic = (cov_24qpqabz0h.s[16]++, _this.meetingTopics[index]);
                cov_24qpqabz0h.s[17]++;
                _this.meetingTopics.splice(index, 1);
                cov_24qpqabz0h.s[18]++;
                if (newPos >= _this.meetingTopics.length) {
                    cov_24qpqabz0h.b[0][0]++;
                    cov_24qpqabz0h.s[19]++;

                    _this.meetingTopics.push(oldTopic);
                } else {
                    cov_24qpqabz0h.b[0][1]++;
                    cov_24qpqabz0h.s[20]++;

                    _this.meetingTopics.splice(newPos, 0, oldTopic);
                }
            },
            placeholder: '<div style="min-height: 60px;"></div>'
        };

        cov_24qpqabz0h.s[21]++;
        this.toggleRight = buildToggler('right');

        function buildToggler(componentId) {
            cov_24qpqabz0h.f[4]++;
            cov_24qpqabz0h.s[22]++;

            return function () {
                cov_24qpqabz0h.f[5]++;
                cov_24qpqabz0h.s[23]++;

                $mdSidenav(componentId).toggle();
            };
        }
    }

    _createClass(NewMeetingController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this2 = this;

            cov_24qpqabz0h.f[6]++;
            cov_24qpqabz0h.s[24]++;

            this.date = new Date();
            cov_24qpqabz0h.s[25]++;
            this.meetingDate = new Date(this.date.getFullYear(), this.date.getMonth(), this.date.getDate() + 1, 10, 30, 0);
            cov_24qpqabz0h.s[26]++;
            this.meeting = this.meetingsTable.$build({ user: this.$rootScope.me.id, name: 'Weekly Meeting', scheduleDate: this.meetingDate });
            cov_24qpqabz0h.s[27]++;
            this.userNotes = '';
            cov_24qpqabz0h.s[28]++;
            this.meetingUsers = [];
            cov_24qpqabz0h.s[29]++;
            this.meetingFiles = [];
            cov_24qpqabz0h.s[30]++;
            this.meetingTopics = [];

            cov_24qpqabz0h.s[31]++;
            this.newDescription = '';
            cov_24qpqabz0h.s[32]++;
            this.duration = '01:00';
            cov_24qpqabz0h.s[33]++;
            this.meeting.scheduleDuration = this.duration + ":00";
            cov_24qpqabz0h.s[34]++;
            this.$scope.$watch('$ctrl.fileUpload', function (uploaded) {
                cov_24qpqabz0h.f[7]++;
                cov_24qpqabz0h.s[35]++;

                if (angular.isString(uploaded)) {
                    cov_24qpqabz0h.b[1][0]++;
                    cov_24qpqabz0h.s[36]++;

                    _this2.meetingFiles.push(_this2.fileUpload);
                    cov_24qpqabz0h.s[37]++;
                    _this2.fileUpload = null;
                } else {
                    cov_24qpqabz0h.b[1][1]++;
                }
            });
        }
    }, {
        key: 'fileToName',
        value: function fileToName(url) {
            cov_24qpqabz0h.f[8]++;
            cov_24qpqabz0h.s[38]++;

            if (url) {
                cov_24qpqabz0h.b[2][0]++;

                var m = (cov_24qpqabz0h.s[39]++, url.toString().match(/.*\/(.+?)\.(.+)/));
                cov_24qpqabz0h.s[40]++;
                if ((cov_24qpqabz0h.b[4][0]++, m) && (cov_24qpqabz0h.b[4][1]++, m.length > 1)) {
                    cov_24qpqabz0h.b[3][0]++;
                    cov_24qpqabz0h.s[41]++;

                    return m[1] + '.' + m[2];
                } else {
                    cov_24qpqabz0h.b[3][1]++;
                }
            } else {
                cov_24qpqabz0h.b[2][1]++;
            }
            cov_24qpqabz0h.s[42]++;
            return "";
        }
    }, {
        key: 'editDuration',
        value: function editDuration() {
            cov_24qpqabz0h.f[9]++;

            var scheduledDuration = (cov_24qpqabz0h.s[43]++, this.duration + ':00');
            cov_24qpqabz0h.s[44]++;
            this.meeting.scheduleDuration = scheduledDuration;
        }
    }, {
        key: 'addUser',
        value: function addUser(user) {
            cov_24qpqabz0h.f[10]++;
            cov_24qpqabz0h.s[45]++;

            this.meetingUsers.push(user);
        }
    }, {
        key: 'confirmRemoveUser',
        value: function confirmRemoveUser(user) {
            var _this3 = this;

            cov_24qpqabz0h.f[11]++;
            cov_24qpqabz0h.s[46]++;

            this.$mdDialog.show(this.$mdDialog.confirm().title("Are you sure you want to remove user from meeting?").ok('Remove').cancel('Cancel')).then(function () {
                cov_24qpqabz0h.f[12]++;
                cov_24qpqabz0h.s[47]++;

                _this3.meetingUsers.splice(_this3.meetingUsers.indexOf(user), 1);
            });
        }
    }, {
        key: 'userIsParticipant',
        value: function userIsParticipant(user) {
            cov_24qpqabz0h.f[13]++;

            var isParticipant = (cov_24qpqabz0h.s[48]++, false);
            cov_24qpqabz0h.s[49]++;
            if (this.meetingUsers.indexOf(user) !== -1) {
                cov_24qpqabz0h.b[5][0]++;
                cov_24qpqabz0h.s[50]++;

                isParticipant = true;
            } else {
                cov_24qpqabz0h.b[5][1]++;
            }
            cov_24qpqabz0h.s[51]++;
            return isParticipant;
        }
    }, {
        key: 'removeMeetingFile',
        value: function removeMeetingFile(file) {
            cov_24qpqabz0h.f[14]++;
            cov_24qpqabz0h.s[52]++;

            this.meetingFiles.splice(this.meetingFiles.indexOf(file), 1);
        }
    }, {
        key: 'addTopic',
        value: function addTopic(name) {
            cov_24qpqabz0h.f[15]++;
            cov_24qpqabz0h.s[53]++;

            this.meetingTopics.push(this.topicsTable.$build({ description: name }));
            cov_24qpqabz0h.s[54]++;
            this.newDescription = '';
        }
    }, {
        key: 'confirmDeleteTopic',
        value: function confirmDeleteTopic(topic) {
            var _this4 = this;

            cov_24qpqabz0h.f[16]++;
            cov_24qpqabz0h.s[55]++;

            this.$mdDialog.show(this.$mdDialog.confirm().title("Are you sure you want to remove this topic?").ok('Remove').cancel('Cancel')).then(function () {
                cov_24qpqabz0h.f[17]++;
                cov_24qpqabz0h.s[56]++;

                _this4.meetingTopics.splice(_this4.meetingTopics.indexOf(topic), 1);
            });
        }
    }, {
        key: 'addTemplate',
        value: function addTemplate(templateId) {
            var _this5 = this;

            cov_24qpqabz0h.f[18]++;
            cov_24qpqabz0h.s[57]++;

            this.templateTopicsTable.$search({ template: templateId, ordering: 'order' }).$then(function (templateTopics) {
                cov_24qpqabz0h.f[19]++;
                cov_24qpqabz0h.s[58]++;

                templateTopics.forEach(function (topic) {
                    cov_24qpqabz0h.f[20]++;
                    cov_24qpqabz0h.s[59]++;

                    _this5.meetingTopics.push(_this5.topicsTable.$build({ description: topic.name }));
                });
            });
        }
    }, {
        key: 'saveMeeting',
        value: function saveMeeting() {
            var _this6 = this;

            cov_24qpqabz0h.f[21]++;
            cov_24qpqabz0h.s[60]++;

            this.meeting.$save().$then(function () {
                cov_24qpqabz0h.f[22]++;
                cov_24qpqabz0h.s[61]++;

                _this6.meetingTopics.forEach(function (topic) {
                    cov_24qpqabz0h.f[23]++;
                    cov_24qpqabz0h.s[62]++;

                    topic.meeting = _this6.meeting.id;
                    cov_24qpqabz0h.s[63]++;
                    topic.$save();
                });
                cov_24qpqabz0h.s[64]++;
                _this6.meetingUsers.forEach(function (user) {
                    cov_24qpqabz0h.f[24]++;
                    cov_24qpqabz0h.s[65]++;

                    _this6.meetingUsersTable.$create({ user: user.id, meeting: _this6.meeting.id });
                });
                cov_24qpqabz0h.s[66]++;
                _this6.meetingFiles.forEach(function (meetingFile) {
                    cov_24qpqabz0h.f[25]++;
                    cov_24qpqabz0h.s[67]++;

                    _this6.meetingFilesTable.$create({ meeting: _this6.meeting.id, file: meetingFile });
                });
                cov_24qpqabz0h.s[68]++;
                _this6.meetingUsersTable.$search({ user: _this6.$rootScope.me.id, meeting: _this6.meeting.id }).$then(function (meetingUser) {
                    cov_24qpqabz0h.f[26]++;
                    cov_24qpqabz0h.s[69]++;

                    meetingUser[0].notes = _this6.userNotes;
                    cov_24qpqabz0h.s[70]++;
                    meetingUser[0].$save();
                });
                cov_24qpqabz0h.s[71]++;
                _this6.$state.go('meetingDetails', { id: _this6.meeting.id });
            });
        }
    }, {
        key: 'requirements',
        value: function requirements() {
            cov_24qpqabz0h.f[27]++;
            cov_24qpqabz0h.s[72]++;

            return (cov_24qpqabz0h.b[6][0]++, this.meeting.name === undefined) || (cov_24qpqabz0h.b[6][1]++, this.meeting.name === '') || (cov_24qpqabz0h.b[6][2]++, this.meeting.scheduleDate === null);
        }
    }, {
        key: 'isEnter',
        value: function isEnter(event) {
            cov_24qpqabz0h.f[28]++;

            var isEnter = (cov_24qpqabz0h.s[73]++, false);
            var code = (cov_24qpqabz0h.s[74]++, (cov_24qpqabz0h.b[7][0]++, event.keyCode) || (cov_24qpqabz0h.b[7][1]++, event.which));
            cov_24qpqabz0h.s[75]++;
            if (code === 13) {
                cov_24qpqabz0h.b[8][0]++;
                cov_24qpqabz0h.s[76]++;

                if (!event.shiftKey) {
                    cov_24qpqabz0h.b[9][0]++;
                    cov_24qpqabz0h.s[77]++;

                    isEnter = true;
                } else {
                    cov_24qpqabz0h.b[9][1]++;
                }
            } else {
                cov_24qpqabz0h.b[8][1]++;
            }
            cov_24qpqabz0h.s[78]++;
            return isEnter;
        }
    }]);

    return NewMeetingController;
}();

cov_24qpqabz0h.s[79]++;


angular.module('app').component('newMeeting', {
    templateUrl: 'app/components/newMeeting/newMeeting.html',
    controller: NewMeetingController
});
'use strict';

var cov_25290g87wp = function () {
    var path = '/home/lobo/repos/meetings-app/src/app/components/meetingsList/meetingsList.js',
        hash = '3e22ec171eafaa952019752ea686ce54dc984e3e',
        Function = function () {}.constructor,
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/meetings-app/src/app/components/meetingsList/meetingsList.js',
        statementMap: {
            '0': {
                start: {
                    line: 4,
                    column: 8
                },
                end: {
                    line: 4,
                    column: 61
                }
            },
            '1': {
                start: {
                    line: 5,
                    column: 8
                },
                end: {
                    line: 5,
                    column: 41
                }
            },
            '2': {
                start: {
                    line: 6,
                    column: 8
                },
                end: {
                    line: 6,
                    column: 35
                }
            },
            '3': {
                start: {
                    line: 7,
                    column: 8
                },
                end: {
                    line: 7,
                    column: 26
                }
            },
            '4': {
                start: {
                    line: 11,
                    column: 8
                },
                end: {
                    line: 11,
                    column: 41
                }
            },
            '5': {
                start: {
                    line: 13,
                    column: 8
                },
                end: {
                    line: 13,
                    column: 55
                }
            },
            '6': {
                start: {
                    line: 15,
                    column: 8
                },
                end: {
                    line: 15,
                    column: 58
                }
            },
            '7': {
                start: {
                    line: 16,
                    column: 8
                },
                end: {
                    line: 18,
                    column: 10
                }
            },
            '8': {
                start: {
                    line: 19,
                    column: 8
                },
                end: {
                    line: 19,
                    column: 24
                }
            },
            '9': {
                start: {
                    line: 23,
                    column: 8
                },
                end: {
                    line: 23,
                    column: 45
                }
            },
            '10': {
                start: {
                    line: 27,
                    column: 8
                },
                end: {
                    line: 29,
                    column: 9
                }
            },
            '11': {
                start: {
                    line: 28,
                    column: 12
                },
                end: {
                    line: 28,
                    column: 36
                }
            },
            '12': {
                start: {
                    line: 31,
                    column: 8
                },
                end: {
                    line: 36,
                    column: 9
                }
            },
            '13': {
                start: {
                    line: 32,
                    column: 12
                },
                end: {
                    line: 32,
                    column: 40
                }
            },
            '14': {
                start: {
                    line: 33,
                    column: 12
                },
                end: {
                    line: 33,
                    column: 49
                }
            },
            '15': {
                start: {
                    line: 35,
                    column: 12
                },
                end: {
                    line: 35,
                    column: 41
                }
            },
            '16': {
                start: {
                    line: 38,
                    column: 8
                },
                end: {
                    line: 38,
                    column: 32
                }
            },
            '17': {
                start: {
                    line: 39,
                    column: 8
                },
                end: {
                    line: 39,
                    column: 41
                }
            },
            '18': {
                start: {
                    line: 40,
                    column: 8
                },
                end: {
                    line: 40,
                    column: 45
                }
            },
            '19': {
                start: {
                    line: 41,
                    column: 8
                },
                end: {
                    line: 41,
                    column: 24
                }
            },
            '20': {
                start: {
                    line: 45,
                    column: 8
                },
                end: {
                    line: 49,
                    column: 11
                }
            },
            '21': {
                start: {
                    line: 46,
                    column: 12
                },
                end: {
                    line: 46,
                    column: 40
                }
            },
            '22': {
                start: {
                    line: 53,
                    column: 0
                },
                end: {
                    line: 80,
                    column: 7
                }
            },
            '23': {
                start: {
                    line: 63,
                    column: 8
                },
                end: {
                    line: 79,
                    column: 10
                }
            },
            '24': {
                start: {
                    line: 67,
                    column: 16
                },
                end: {
                    line: 77,
                    column: 19
                }
            },
            '25': {
                start: {
                    line: 68,
                    column: 39
                },
                end: {
                    line: 68,
                    column: 46
                }
            },
            '26': {
                start: {
                    line: 69,
                    column: 20
                },
                end: {
                    line: 71,
                    column: 21
                }
            },
            '27': {
                start: {
                    line: 70,
                    column: 24
                },
                end: {
                    line: 70,
                    column: 61
                }
            },
            '28': {
                start: {
                    line: 72,
                    column: 20
                },
                end: {
                    line: 72,
                    column: 62
                }
            },
            '29': {
                start: {
                    line: 74,
                    column: 20
                },
                end: {
                    line: 76,
                    column: 21
                }
            },
            '30': {
                start: {
                    line: 75,
                    column: 24
                },
                end: {
                    line: 75,
                    column: 40
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 3,
                        column: 4
                    },
                    end: {
                        line: 3,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 3,
                        column: 66
                    },
                    end: {
                        line: 8,
                        column: 5
                    }
                },
                line: 3
            },
            '1': {
                name: '(anonymous_1)',
                decl: {
                    start: {
                        line: 10,
                        column: 4
                    },
                    end: {
                        line: 10,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 10,
                        column: 14
                    },
                    end: {
                        line: 20,
                        column: 5
                    }
                },
                line: 10
            },
            '2': {
                name: '(anonymous_2)',
                decl: {
                    start: {
                        line: 22,
                        column: 4
                    },
                    end: {
                        line: 22,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 22,
                        column: 15
                    },
                    end: {
                        line: 24,
                        column: 5
                    }
                },
                line: 22
            },
            '3': {
                name: '(anonymous_3)',
                decl: {
                    start: {
                        line: 26,
                        column: 4
                    },
                    end: {
                        line: 26,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 26,
                        column: 33
                    },
                    end: {
                        line: 42,
                        column: 5
                    }
                },
                line: 26
            },
            '4': {
                name: '(anonymous_4)',
                decl: {
                    start: {
                        line: 44,
                        column: 4
                    },
                    end: {
                        line: 44,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 44,
                        column: 30
                    },
                    end: {
                        line: 50,
                        column: 5
                    }
                },
                line: 44
            },
            '5': {
                name: '(anonymous_5)',
                decl: {
                    start: {
                        line: 45,
                        column: 51
                    },
                    end: {
                        line: 45,
                        column: 52
                    }
                },
                loc: {
                    start: {
                        line: 45,
                        column: 64
                    },
                    end: {
                        line: 47,
                        column: 9
                    }
                },
                line: 45
            },
            '6': {
                name: '(anonymous_6)',
                decl: {
                    start: {
                        line: 47,
                        column: 11
                    },
                    end: {
                        line: 47,
                        column: 12
                    }
                },
                loc: {
                    start: {
                        line: 47,
                        column: 23
                    },
                    end: {
                        line: 49,
                        column: 9
                    }
                },
                line: 47
            },
            '7': {
                name: '(anonymous_7)',
                decl: {
                    start: {
                        line: 62,
                        column: 35
                    },
                    end: {
                        line: 62,
                        column: 36
                    }
                },
                loc: {
                    start: {
                        line: 62,
                        column: 47
                    },
                    end: {
                        line: 80,
                        column: 5
                    }
                },
                line: 62
            },
            '8': {
                name: '(anonymous_8)',
                decl: {
                    start: {
                        line: 66,
                        column: 18
                    },
                    end: {
                        line: 66,
                        column: 19
                    }
                },
                loc: {
                    start: {
                        line: 66,
                        column: 56
                    },
                    end: {
                        line: 78,
                        column: 13
                    }
                },
                line: 66
            },
            '9': {
                name: '(anonymous_9)',
                decl: {
                    start: {
                        line: 67,
                        column: 29
                    },
                    end: {
                        line: 67,
                        column: 30
                    }
                },
                loc: {
                    start: {
                        line: 67,
                        column: 41
                    },
                    end: {
                        line: 73,
                        column: 17
                    }
                },
                line: 67
            },
            '10': {
                name: '(anonymous_10)',
                decl: {
                    start: {
                        line: 73,
                        column: 19
                    },
                    end: {
                        line: 73,
                        column: 20
                    }
                },
                loc: {
                    start: {
                        line: 73,
                        column: 37
                    },
                    end: {
                        line: 77,
                        column: 17
                    }
                },
                line: 73
            }
        },
        branchMap: {
            '0': {
                loc: {
                    start: {
                        line: 15,
                        column: 30
                    },
                    end: {
                        line: 15,
                        column: 57
                    }
                },
                type: 'binary-expr',
                locations: [{
                    start: {
                        line: 15,
                        column: 30
                    },
                    end: {
                        line: 15,
                        column: 52
                    }
                }, {
                    start: {
                        line: 15,
                        column: 56
                    },
                    end: {
                        line: 15,
                        column: 57
                    }
                }],
                line: 15
            },
            '1': {
                loc: {
                    start: {
                        line: 27,
                        column: 8
                    },
                    end: {
                        line: 29,
                        column: 9
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 27,
                        column: 8
                    },
                    end: {
                        line: 29,
                        column: 9
                    }
                }, {
                    start: {
                        line: 27,
                        column: 8
                    },
                    end: {
                        line: 29,
                        column: 9
                    }
                }],
                line: 27
            },
            '2': {
                loc: {
                    start: {
                        line: 31,
                        column: 8
                    },
                    end: {
                        line: 36,
                        column: 9
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 31,
                        column: 8
                    },
                    end: {
                        line: 36,
                        column: 9
                    }
                }, {
                    start: {
                        line: 31,
                        column: 8
                    },
                    end: {
                        line: 36,
                        column: 9
                    }
                }],
                line: 31
            },
            '3': {
                loc: {
                    start: {
                        line: 74,
                        column: 20
                    },
                    end: {
                        line: 76,
                        column: 21
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 74,
                        column: 20
                    },
                    end: {
                        line: 76,
                        column: 21
                    }
                }, {
                    start: {
                        line: 74,
                        column: 20
                    },
                    end: {
                        line: 76,
                        column: 21
                    }
                }],
                line: 74
            }
        },
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0,
            '7': 0,
            '8': 0,
            '9': 0,
            '10': 0,
            '11': 0,
            '12': 0,
            '13': 0,
            '14': 0,
            '15': 0,
            '16': 0,
            '17': 0,
            '18': 0,
            '19': 0,
            '20': 0,
            '21': 0,
            '22': 0,
            '23': 0,
            '24': 0,
            '25': 0,
            '26': 0,
            '27': 0,
            '28': 0,
            '29': 0,
            '30': 0
        },
        f: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0,
            '7': 0,
            '8': 0,
            '9': 0,
            '10': 0
        },
        b: {
            '0': [0, 0],
            '1': [0, 0],
            '2': [0, 0],
            '3': [0, 0]
        },
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var MeetingsListController = function () {
    MeetingsListController.$inject = ["NewMeetingModalService", "$stateParams", "$location"];
    function MeetingsListController(NewMeetingModalService, $stateParams, $location) {
        _classCallCheck(this, MeetingsListController);

        cov_25290g87wp.f[0]++;
        cov_25290g87wp.s[0]++;

        this.NewMeetingModalService = NewMeetingModalService;
        cov_25290g87wp.s[1]++;
        this.$stateParams = $stateParams;
        cov_25290g87wp.s[2]++;
        this.$location = $location;
        cov_25290g87wp.s[3]++;
        this.filters = {};
    }

    _createClass(MeetingsListController, [{
        key: '$onInit',
        value: function $onInit() {
            cov_25290g87wp.f[1]++;
            cov_25290g87wp.s[4]++;

            this.filters = this.$stateParams;

            cov_25290g87wp.s[5]++;
            this.projectFilter = this.$stateParams.project;

            cov_25290g87wp.s[6]++;
            this.meetings.$page = (cov_25290g87wp.b[0][0]++, this.$stateParams.page) || (cov_25290g87wp.b[0][1]++, 1);
            cov_25290g87wp.s[7]++;
            this.meetings.$params = {
                page_size: 25
            };
            cov_25290g87wp.s[8]++;
            this._refresh();
        }
    }, {
        key: '_refresh',
        value: function _refresh() {
            cov_25290g87wp.f[2]++;
            cov_25290g87wp.s[9]++;

            this.meetings.$refresh(this.filters);
        }
    }, {
        key: 'changeFilters',
        value: function changeFilters(filter, value) {
            cov_25290g87wp.f[3]++;
            cov_25290g87wp.s[10]++;

            if (angular.isArray(value)) {
                cov_25290g87wp.b[1][0]++;
                cov_25290g87wp.s[11]++;

                value = value.join(',');
            } else {
                cov_25290g87wp.b[1][1]++;
            }

            cov_25290g87wp.s[12]++;
            if (value === null) {
                cov_25290g87wp.b[2][0]++;
                cov_25290g87wp.s[13]++;

                delete this.filters[filter];
                cov_25290g87wp.s[14]++;
                delete this.meetings.$params[filter];
            } else {
                cov_25290g87wp.b[2][1]++;
                cov_25290g87wp.s[15]++;

                this.filters[filter] = value;
            }

            cov_25290g87wp.s[16]++;
            this.meetings.$page = 1;
            cov_25290g87wp.s[17]++;
            this.$location.search('page', 1);
            cov_25290g87wp.s[18]++;
            this.$location.search(filter, value);
            cov_25290g87wp.s[19]++;
            this._refresh();
        }
    }, {
        key: 'displayNewMeetingModal',
        value: function displayNewMeetingModal() {
            var _this = this;

            cov_25290g87wp.f[4]++;
            cov_25290g87wp.s[20]++;

            this.NewMeetingModalService.display().then(function (meeting) {
                cov_25290g87wp.f[5]++;
                cov_25290g87wp.s[21]++;

                _this.meetings.$add(meeting);
            }, function () {
                cov_25290g87wp.f[6]++;
            });
        }
    }]);

    return MeetingsListController;
}();

cov_25290g87wp.s[22]++;


angular.module('app').component('meetingsList', {
    templateUrl: 'app/components/meetingsList/meetingsList.html',
    controller: MeetingsListController,
    bindings: {
        meetings: '<'
    }
}).directive('forceSelectFocus', function () {
    cov_25290g87wp.f[7]++;
    cov_25290g87wp.s[23]++;

    return {
        restrict: 'A',
        require: ['^^mdSelect', '^ngModel'],
        link: function link(scope, element, controller) {
            cov_25290g87wp.f[8]++;
            cov_25290g87wp.s[24]++;

            scope.$watch(function () {
                cov_25290g87wp.f[9]++;

                var foundElement = (cov_25290g87wp.s[25]++, element);
                cov_25290g87wp.s[26]++;
                while (!foundElement.hasClass('md-select-menu-container')) {
                    cov_25290g87wp.s[27]++;

                    foundElement = foundElement.parent();
                }
                cov_25290g87wp.s[28]++;
                return foundElement.hasClass('md-active');
            }, function (newVal) {
                cov_25290g87wp.f[10]++;
                cov_25290g87wp.s[29]++;

                if (newVal) {
                    cov_25290g87wp.b[3][0]++;
                    cov_25290g87wp.s[30]++;

                    element.focus();
                } else {
                    cov_25290g87wp.b[3][1]++;
                }
            });
        }
    };
});
'use strict';

var cov_1cxr34lntn = function () {
    var path = '/home/lobo/repos/meetings-app/src/app/components/meetingDetails/meetingDetails.js',
        hash = '2776797a164c7a126ddec7e19bbc574c252dde12',
        Function = function () {}.constructor,
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/meetings-app/src/app/components/meetingDetails/meetingDetails.js',
        statementMap: {
            '0': {
                start: {
                    line: 4,
                    column: 8
                },
                end: {
                    line: 4,
                    column: 42
                }
            },
            '1': {
                start: {
                    line: 5,
                    column: 8
                },
                end: {
                    line: 5,
                    column: 35
                }
            },
            '2': {
                start: {
                    line: 6,
                    column: 8
                },
                end: {
                    line: 6,
                    column: 50
                }
            },
            '3': {
                start: {
                    line: 7,
                    column: 8
                },
                end: {
                    line: 7,
                    column: 55
                }
            },
            '4': {
                start: {
                    line: 8,
                    column: 8
                },
                end: {
                    line: 8,
                    column: 37
                }
            },
            '5': {
                start: {
                    line: 9,
                    column: 8
                },
                end: {
                    line: 9,
                    column: 29
                }
            },
            '6': {
                start: {
                    line: 10,
                    column: 8
                },
                end: {
                    line: 26,
                    column: 10
                }
            },
            '7': {
                start: {
                    line: 12,
                    column: 16
                },
                end: {
                    line: 12,
                    column: 27
                }
            },
            '8': {
                start: {
                    line: 17,
                    column: 29
                },
                end: {
                    line: 17,
                    column: 49
                }
            },
            '9': {
                start: {
                    line: 18,
                    column: 28
                },
                end: {
                    line: 18,
                    column: 56
                }
            },
            '10': {
                start: {
                    line: 19,
                    column: 16
                },
                end: {
                    line: 19,
                    column: 37
                }
            },
            '11': {
                start: {
                    line: 21,
                    column: 16
                },
                end: {
                    line: 23,
                    column: 19
                }
            },
            '12': {
                start: {
                    line: 22,
                    column: 20
                },
                end: {
                    line: 22,
                    column: 52
                }
            },
            '13': {
                start: {
                    line: 28,
                    column: 8
                },
                end: {
                    line: 28,
                    column: 49
                }
            },
            '14': {
                start: {
                    line: 31,
                    column: 12
                },
                end: {
                    line: 33,
                    column: 14
                }
            },
            '15': {
                start: {
                    line: 32,
                    column: 16
                },
                end: {
                    line: 32,
                    column: 49
                }
            },
            '16': {
                start: {
                    line: 38,
                    column: 8
                },
                end: {
                    line: 38,
                    column: 100
                }
            },
            '17': {
                start: {
                    line: 39,
                    column: 8
                },
                end: {
                    line: 45,
                    column: 11
                }
            },
            '18': {
                start: {
                    line: 40,
                    column: 12
                },
                end: {
                    line: 44,
                    column: 15
                }
            },
            '19': {
                start: {
                    line: 41,
                    column: 16
                },
                end: {
                    line: 41,
                    column: 59
                }
            },
            '20': {
                start: {
                    line: 43,
                    column: 16
                },
                end: {
                    line: 43,
                    column: 56
                }
            },
            '21': {
                start: {
                    line: 47,
                    column: 8
                },
                end: {
                    line: 47,
                    column: 33
                }
            },
            '22': {
                start: {
                    line: 48,
                    column: 8
                },
                end: {
                    line: 48,
                    column: 54
                }
            },
            '23': {
                start: {
                    line: 49,
                    column: 8
                },
                end: {
                    line: 49,
                    column: 41
                }
            },
            '24': {
                start: {
                    line: 50,
                    column: 8
                },
                end: {
                    line: 58,
                    column: 11
                }
            },
            '25': {
                start: {
                    line: 51,
                    column: 12
                },
                end: {
                    line: 57,
                    column: 13
                }
            },
            '26': {
                start: {
                    line: 52,
                    column: 16
                },
                end: {
                    line: 54,
                    column: 19
                }
            },
            '27': {
                start: {
                    line: 53,
                    column: 20
                },
                end: {
                    line: 53,
                    column: 62
                }
            },
            '28': {
                start: {
                    line: 55,
                    column: 16
                },
                end: {
                    line: 55,
                    column: 39
                }
            },
            '29': {
                start: {
                    line: 56,
                    column: 16
                },
                end: {
                    line: 56,
                    column: 54
                }
            },
            '30': {
                start: {
                    line: 62,
                    column: 8
                },
                end: {
                    line: 67,
                    column: 9
                }
            },
            '31': {
                start: {
                    line: 63,
                    column: 20
                },
                end: {
                    line: 63,
                    column: 59
                }
            },
            '32': {
                start: {
                    line: 64,
                    column: 12
                },
                end: {
                    line: 66,
                    column: 13
                }
            },
            '33': {
                start: {
                    line: 65,
                    column: 16
                },
                end: {
                    line: 65,
                    column: 41
                }
            },
            '34': {
                start: {
                    line: 68,
                    column: 8
                },
                end: {
                    line: 68,
                    column: 18
                }
            },
            '35': {
                start: {
                    line: 72,
                    column: 32
                },
                end: {
                    line: 72,
                    column: 53
                }
            },
            '36': {
                start: {
                    line: 73,
                    column: 8
                },
                end: {
                    line: 73,
                    column: 58
                }
            },
            '37': {
                start: {
                    line: 74,
                    column: 8
                },
                end: {
                    line: 74,
                    column: 49
                }
            },
            '38': {
                start: {
                    line: 78,
                    column: 8
                },
                end: {
                    line: 83,
                    column: 11
                }
            },
            '39': {
                start: {
                    line: 82,
                    column: 12
                },
                end: {
                    line: 82,
                    column: 38
                }
            },
            '40': {
                start: {
                    line: 87,
                    column: 8
                },
                end: {
                    line: 90,
                    column: 11
                }
            },
            '41': {
                start: {
                    line: 91,
                    column: 8
                },
                end: {
                    line: 91,
                    column: 33
                }
            },
            '42': {
                start: {
                    line: 95,
                    column: 8
                },
                end: {
                    line: 98,
                    column: 11
                }
            },
            '43': {
                start: {
                    line: 99,
                    column: 8
                },
                end: {
                    line: 99,
                    column: 41
                }
            },
            '44': {
                start: {
                    line: 103,
                    column: 8
                },
                end: {
                    line: 109,
                    column: 15
                }
            },
            '45': {
                start: {
                    line: 108,
                    column: 16
                },
                end: {
                    line: 108,
                    column: 37
                }
            },
            '46': {
                start: {
                    line: 113,
                    column: 28
                },
                end: {
                    line: 113,
                    column: 33
                }
            },
            '47': {
                start: {
                    line: 114,
                    column: 8
                },
                end: {
                    line: 118,
                    column: 11
                }
            },
            '48': {
                start: {
                    line: 115,
                    column: 12
                },
                end: {
                    line: 117,
                    column: 13
                }
            },
            '49': {
                start: {
                    line: 116,
                    column: 16
                },
                end: {
                    line: 116,
                    column: 37
                }
            },
            '50': {
                start: {
                    line: 119,
                    column: 8
                },
                end: {
                    line: 119,
                    column: 29
                }
            },
            '51': {
                start: {
                    line: 123,
                    column: 8
                },
                end: {
                    line: 130,
                    column: 11
                }
            },
            '52': {
                start: {
                    line: 124,
                    column: 12
                },
                end: {
                    line: 129,
                    column: 15
                }
            },
            '53': {
                start: {
                    line: 125,
                    column: 16
                },
                end: {
                    line: 128,
                    column: 76
                }
            },
            '54': {
                start: {
                    line: 128,
                    column: 39
                },
                end: {
                    line: 128,
                    column: 74
                }
            },
            '55': {
                start: {
                    line: 134,
                    column: 22
                },
                end: {
                    line: 134,
                    column: 27
                }
            },
            '56': {
                start: {
                    line: 135,
                    column: 19
                },
                end: {
                    line: 135,
                    column: 47
                }
            },
            '57': {
                start: {
                    line: 136,
                    column: 8
                },
                end: {
                    line: 140,
                    column: 9
                }
            },
            '58': {
                start: {
                    line: 137,
                    column: 12
                },
                end: {
                    line: 139,
                    column: 13
                }
            },
            '59': {
                start: {
                    line: 138,
                    column: 16
                },
                end: {
                    line: 138,
                    column: 31
                }
            },
            '60': {
                start: {
                    line: 141,
                    column: 8
                },
                end: {
                    line: 141,
                    column: 23
                }
            },
            '61': {
                start: {
                    line: 146,
                    column: 0
                },
                end: {
                    line: 154,
                    column: 7
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 3,
                        column: 4
                    },
                    end: {
                        line: 3,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 3,
                        column: 108
                    },
                    end: {
                        line: 35,
                        column: 5
                    }
                },
                line: 3
            },
            '1': {
                name: '(anonymous_1)',
                decl: {
                    start: {
                        line: 11,
                        column: 20
                    },
                    end: {
                        line: 11,
                        column: 21
                    }
                },
                loc: {
                    start: {
                        line: 11,
                        column: 66
                    },
                    end: {
                        line: 13,
                        column: 13
                    }
                },
                line: 11
            },
            '2': {
                name: '(anonymous_2)',
                decl: {
                    start: {
                        line: 14,
                        column: 23
                    },
                    end: {
                        line: 14,
                        column: 24
                    }
                },
                loc: {
                    start: {
                        line: 14,
                        column: 34
                    },
                    end: {
                        line: 15,
                        column: 13
                    }
                },
                line: 14
            },
            '3': {
                name: '(anonymous_3)',
                decl: {
                    start: {
                        line: 16,
                        column: 26
                    },
                    end: {
                        line: 16,
                        column: 27
                    }
                },
                loc: {
                    start: {
                        line: 16,
                        column: 37
                    },
                    end: {
                        line: 24,
                        column: 13
                    }
                },
                line: 16
            },
            '4': {
                name: '(anonymous_4)',
                decl: {
                    start: {
                        line: 21,
                        column: 45
                    },
                    end: {
                        line: 21,
                        column: 46
                    }
                },
                loc: {
                    start: {
                        line: 21,
                        column: 51
                    },
                    end: {
                        line: 23,
                        column: 17
                    }
                },
                line: 21
            },
            '5': {
                name: 'buildToggler',
                decl: {
                    start: {
                        line: 30,
                        column: 17
                    },
                    end: {
                        line: 30,
                        column: 29
                    }
                },
                loc: {
                    start: {
                        line: 30,
                        column: 43
                    },
                    end: {
                        line: 34,
                        column: 9
                    }
                },
                line: 30
            },
            '6': {
                name: '(anonymous_6)',
                decl: {
                    start: {
                        line: 31,
                        column: 19
                    },
                    end: {
                        line: 31,
                        column: 20
                    }
                },
                loc: {
                    start: {
                        line: 31,
                        column: 30
                    },
                    end: {
                        line: 33,
                        column: 13
                    }
                },
                line: 31
            },
            '7': {
                name: '(anonymous_7)',
                decl: {
                    start: {
                        line: 37,
                        column: 4
                    },
                    end: {
                        line: 37,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 37,
                        column: 14
                    },
                    end: {
                        line: 59,
                        column: 5
                    }
                },
                line: 37
            },
            '8': {
                name: '(anonymous_8)',
                decl: {
                    start: {
                        line: 39,
                        column: 55
                    },
                    end: {
                        line: 39,
                        column: 56
                    }
                },
                loc: {
                    start: {
                        line: 39,
                        column: 73
                    },
                    end: {
                        line: 45,
                        column: 9
                    }
                },
                line: 39
            },
            '9': {
                name: '(anonymous_9)',
                decl: {
                    start: {
                        line: 40,
                        column: 70
                    },
                    end: {
                        line: 40,
                        column: 71
                    }
                },
                loc: {
                    start: {
                        line: 40,
                        column: 87
                    },
                    end: {
                        line: 42,
                        column: 13
                    }
                },
                line: 40
            },
            '10': {
                name: '(anonymous_10)',
                decl: {
                    start: {
                        line: 42,
                        column: 21
                    },
                    end: {
                        line: 42,
                        column: 22
                    }
                },
                loc: {
                    start: {
                        line: 42,
                        column: 44
                    },
                    end: {
                        line: 44,
                        column: 13
                    }
                },
                line: 42
            },
            '11': {
                name: '(anonymous_11)',
                decl: {
                    start: {
                        line: 50,
                        column: 47
                    },
                    end: {
                        line: 50,
                        column: 48
                    }
                },
                loc: {
                    start: {
                        line: 50,
                        column: 61
                    },
                    end: {
                        line: 58,
                        column: 9
                    }
                },
                line: 50
            },
            '12': {
                name: '(anonymous_12)',
                decl: {
                    start: {
                        line: 52,
                        column: 108
                    },
                    end: {
                        line: 52,
                        column: 109
                    }
                },
                loc: {
                    start: {
                        line: 52,
                        column: 122
                    },
                    end: {
                        line: 54,
                        column: 17
                    }
                },
                line: 52
            },
            '13': {
                name: '(anonymous_13)',
                decl: {
                    start: {
                        line: 61,
                        column: 4
                    },
                    end: {
                        line: 61,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 61,
                        column: 20
                    },
                    end: {
                        line: 69,
                        column: 5
                    }
                },
                line: 61
            },
            '14': {
                name: '(anonymous_14)',
                decl: {
                    start: {
                        line: 71,
                        column: 4
                    },
                    end: {
                        line: 71,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 71,
                        column: 18
                    },
                    end: {
                        line: 75,
                        column: 5
                    }
                },
                line: 71
            },
            '15': {
                name: '(anonymous_15)',
                decl: {
                    start: {
                        line: 77,
                        column: 4
                    },
                    end: {
                        line: 77,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 77,
                        column: 19
                    },
                    end: {
                        line: 84,
                        column: 5
                    }
                },
                line: 77
            },
            '16': {
                name: '(anonymous_16)',
                decl: {
                    start: {
                        line: 81,
                        column: 17
                    },
                    end: {
                        line: 81,
                        column: 18
                    }
                },
                loc: {
                    start: {
                        line: 81,
                        column: 34
                    },
                    end: {
                        line: 83,
                        column: 9
                    }
                },
                line: 81
            },
            '17': {
                name: '(anonymous_17)',
                decl: {
                    start: {
                        line: 86,
                        column: 4
                    },
                    end: {
                        line: 86,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 86,
                        column: 26
                    },
                    end: {
                        line: 92,
                        column: 5
                    }
                },
                line: 86
            },
            '18': {
                name: '(anonymous_18)',
                decl: {
                    start: {
                        line: 94,
                        column: 4
                    },
                    end: {
                        line: 94,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 94,
                        column: 29
                    },
                    end: {
                        line: 100,
                        column: 5
                    }
                },
                line: 94
            },
            '19': {
                name: '(anonymous_19)',
                decl: {
                    start: {
                        line: 102,
                        column: 4
                    },
                    end: {
                        line: 102,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 102,
                        column: 29
                    },
                    end: {
                        line: 110,
                        column: 5
                    }
                },
                line: 102
            },
            '20': {
                name: '(anonymous_20)',
                decl: {
                    start: {
                        line: 107,
                        column: 18
                    },
                    end: {
                        line: 107,
                        column: 19
                    }
                },
                loc: {
                    start: {
                        line: 107,
                        column: 24
                    },
                    end: {
                        line: 109,
                        column: 13
                    }
                },
                line: 107
            },
            '21': {
                name: '(anonymous_21)',
                decl: {
                    start: {
                        line: 112,
                        column: 4
                    },
                    end: {
                        line: 112,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 112,
                        column: 28
                    },
                    end: {
                        line: 120,
                        column: 5
                    }
                },
                line: 112
            },
            '22': {
                name: '(anonymous_22)',
                decl: {
                    start: {
                        line: 114,
                        column: 43
                    },
                    end: {
                        line: 114,
                        column: 44
                    }
                },
                loc: {
                    start: {
                        line: 114,
                        column: 60
                    },
                    end: {
                        line: 118,
                        column: 9
                    }
                },
                line: 114
            },
            '23': {
                name: '(anonymous_23)',
                decl: {
                    start: {
                        line: 122,
                        column: 4
                    },
                    end: {
                        line: 122,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 122,
                        column: 28
                    },
                    end: {
                        line: 131,
                        column: 5
                    }
                },
                line: 122
            },
            '24': {
                name: '(anonymous_24)',
                decl: {
                    start: {
                        line: 123,
                        column: 90
                    },
                    end: {
                        line: 123,
                        column: 91
                    }
                },
                loc: {
                    start: {
                        line: 123,
                        column: 110
                    },
                    end: {
                        line: 130,
                        column: 9
                    }
                },
                line: 123
            },
            '25': {
                name: '(anonymous_25)',
                decl: {
                    start: {
                        line: 124,
                        column: 35
                    },
                    end: {
                        line: 124,
                        column: 36
                    }
                },
                loc: {
                    start: {
                        line: 124,
                        column: 46
                    },
                    end: {
                        line: 129,
                        column: 13
                    }
                },
                line: 124
            },
            '26': {
                name: '(anonymous_26)',
                decl: {
                    start: {
                        line: 128,
                        column: 25
                    },
                    end: {
                        line: 128,
                        column: 26
                    }
                },
                loc: {
                    start: {
                        line: 128,
                        column: 39
                    },
                    end: {
                        line: 128,
                        column: 74
                    }
                },
                line: 128
            },
            '27': {
                name: '(anonymous_27)',
                decl: {
                    start: {
                        line: 133,
                        column: 4
                    },
                    end: {
                        line: 133,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 133,
                        column: 19
                    },
                    end: {
                        line: 142,
                        column: 5
                    }
                },
                line: 133
            }
        },
        branchMap: {
            '0': {
                loc: {
                    start: {
                        line: 51,
                        column: 12
                    },
                    end: {
                        line: 57,
                        column: 13
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 51,
                        column: 12
                    },
                    end: {
                        line: 57,
                        column: 13
                    }
                }, {
                    start: {
                        line: 51,
                        column: 12
                    },
                    end: {
                        line: 57,
                        column: 13
                    }
                }],
                line: 51
            },
            '1': {
                loc: {
                    start: {
                        line: 62,
                        column: 8
                    },
                    end: {
                        line: 67,
                        column: 9
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 62,
                        column: 8
                    },
                    end: {
                        line: 67,
                        column: 9
                    }
                }, {
                    start: {
                        line: 62,
                        column: 8
                    },
                    end: {
                        line: 67,
                        column: 9
                    }
                }],
                line: 62
            },
            '2': {
                loc: {
                    start: {
                        line: 64,
                        column: 12
                    },
                    end: {
                        line: 66,
                        column: 13
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 64,
                        column: 12
                    },
                    end: {
                        line: 66,
                        column: 13
                    }
                }, {
                    start: {
                        line: 64,
                        column: 12
                    },
                    end: {
                        line: 66,
                        column: 13
                    }
                }],
                line: 64
            },
            '3': {
                loc: {
                    start: {
                        line: 64,
                        column: 16
                    },
                    end: {
                        line: 64,
                        column: 33
                    }
                },
                type: 'binary-expr',
                locations: [{
                    start: {
                        line: 64,
                        column: 16
                    },
                    end: {
                        line: 64,
                        column: 17
                    }
                }, {
                    start: {
                        line: 64,
                        column: 21
                    },
                    end: {
                        line: 64,
                        column: 33
                    }
                }],
                line: 64
            },
            '4': {
                loc: {
                    start: {
                        line: 115,
                        column: 12
                    },
                    end: {
                        line: 117,
                        column: 13
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 115,
                        column: 12
                    },
                    end: {
                        line: 117,
                        column: 13
                    }
                }, {
                    start: {
                        line: 115,
                        column: 12
                    },
                    end: {
                        line: 117,
                        column: 13
                    }
                }],
                line: 115
            },
            '5': {
                loc: {
                    start: {
                        line: 135,
                        column: 19
                    },
                    end: {
                        line: 135,
                        column: 47
                    }
                },
                type: 'binary-expr',
                locations: [{
                    start: {
                        line: 135,
                        column: 19
                    },
                    end: {
                        line: 135,
                        column: 32
                    }
                }, {
                    start: {
                        line: 135,
                        column: 36
                    },
                    end: {
                        line: 135,
                        column: 47
                    }
                }],
                line: 135
            },
            '6': {
                loc: {
                    start: {
                        line: 136,
                        column: 8
                    },
                    end: {
                        line: 140,
                        column: 9
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 136,
                        column: 8
                    },
                    end: {
                        line: 140,
                        column: 9
                    }
                }, {
                    start: {
                        line: 136,
                        column: 8
                    },
                    end: {
                        line: 140,
                        column: 9
                    }
                }],
                line: 136
            },
            '7': {
                loc: {
                    start: {
                        line: 137,
                        column: 12
                    },
                    end: {
                        line: 139,
                        column: 13
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 137,
                        column: 12
                    },
                    end: {
                        line: 139,
                        column: 13
                    }
                }, {
                    start: {
                        line: 137,
                        column: 12
                    },
                    end: {
                        line: 139,
                        column: 13
                    }
                }],
                line: 137
            }
        },
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0,
            '7': 0,
            '8': 0,
            '9': 0,
            '10': 0,
            '11': 0,
            '12': 0,
            '13': 0,
            '14': 0,
            '15': 0,
            '16': 0,
            '17': 0,
            '18': 0,
            '19': 0,
            '20': 0,
            '21': 0,
            '22': 0,
            '23': 0,
            '24': 0,
            '25': 0,
            '26': 0,
            '27': 0,
            '28': 0,
            '29': 0,
            '30': 0,
            '31': 0,
            '32': 0,
            '33': 0,
            '34': 0,
            '35': 0,
            '36': 0,
            '37': 0,
            '38': 0,
            '39': 0,
            '40': 0,
            '41': 0,
            '42': 0,
            '43': 0,
            '44': 0,
            '45': 0,
            '46': 0,
            '47': 0,
            '48': 0,
            '49': 0,
            '50': 0,
            '51': 0,
            '52': 0,
            '53': 0,
            '54': 0,
            '55': 0,
            '56': 0,
            '57': 0,
            '58': 0,
            '59': 0,
            '60': 0,
            '61': 0
        },
        f: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0,
            '7': 0,
            '8': 0,
            '9': 0,
            '10': 0,
            '11': 0,
            '12': 0,
            '13': 0,
            '14': 0,
            '15': 0,
            '16': 0,
            '17': 0,
            '18': 0,
            '19': 0,
            '20': 0,
            '21': 0,
            '22': 0,
            '23': 0,
            '24': 0,
            '25': 0,
            '26': 0,
            '27': 0
        },
        b: {
            '0': [0, 0],
            '1': [0, 0],
            '2': [0, 0],
            '3': [0, 0],
            '4': [0, 0],
            '5': [0, 0],
            '6': [0, 0],
            '7': [0, 0]
        },
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var MeetingDetailsController = function () {
    MeetingDetailsController.$inject = ["UsersTable", "TemplatesTable", "TemplateTopicsTable", "$mdDialog", "$mdSidenav", "$rootScope", "$scope"];
    function MeetingDetailsController(UsersTable, TemplatesTable, TemplateTopicsTable, $mdDialog, $mdSidenav, $rootScope, $scope) {
        var _this = this;

        _classCallCheck(this, MeetingDetailsController);

        cov_1cxr34lntn.f[0]++;
        cov_1cxr34lntn.s[0]++;

        this.users = UsersTable.$search();
        cov_1cxr34lntn.s[1]++;
        this.$mdDialog = $mdDialog;
        cov_1cxr34lntn.s[2]++;
        this.templates = TemplatesTable.$search();
        cov_1cxr34lntn.s[3]++;
        this.templateTopicsTable = TemplateTopicsTable;
        cov_1cxr34lntn.s[4]++;
        this.$rootScope = $rootScope;
        cov_1cxr34lntn.s[5]++;
        this.$scope = $scope;
        cov_1cxr34lntn.s[6]++;
        this.sortableListeners = {
            accept: function accept(sourceItemHandleScope, destSortableScope) {
                cov_1cxr34lntn.f[1]++;
                cov_1cxr34lntn.s[7]++;

                return true;
            },
            itemMoved: function itemMoved(event) {
                cov_1cxr34lntn.f[2]++;
            },
            orderChanged: function orderChanged(event) {
                cov_1cxr34lntn.f[3]++;

                var newPos = (cov_1cxr34lntn.s[8]++, event.dest.index + 1);
                var topic = (cov_1cxr34lntn.s[9]++, event.source.itemScope.topic);
                cov_1cxr34lntn.s[10]++;
                topic.order = newPos;

                cov_1cxr34lntn.s[11]++;
                topic.$save(['order']).$then(function () {
                    cov_1cxr34lntn.f[4]++;
                    cov_1cxr34lntn.s[12]++;

                    _this.meeting.$topics.$refresh();
                });
            },
            placeholder: '<div style="min-height: 60px;"></div>'
        };

        cov_1cxr34lntn.s[13]++;
        this.toggleRight = buildToggler('right');

        function buildToggler(componentId) {
            cov_1cxr34lntn.f[5]++;
            cov_1cxr34lntn.s[14]++;

            return function () {
                cov_1cxr34lntn.f[6]++;
                cov_1cxr34lntn.s[15]++;

                $mdSidenav(componentId).toggle();
            };
        }
    }

    _createClass(MeetingDetailsController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this2 = this;

            cov_1cxr34lntn.f[7]++;
            cov_1cxr34lntn.s[16]++;

            this.meeting.$load('meetingUsers').$load('topics').$load('decisions').$load('meetingFiles');
            cov_1cxr34lntn.s[17]++;
            this.meeting.$meetingUsers.$load('user').$then(function (meetingUsers) {
                cov_1cxr34lntn.f[8]++;
                cov_1cxr34lntn.s[18]++;

                meetingUsers.$search({ user: _this2.$rootScope.me.id }).$then(function (meetingUser) {
                    cov_1cxr34lntn.f[9]++;
                    cov_1cxr34lntn.s[19]++;

                    meetingUser.$load('meeting').$load('user');
                }).$then(function (searchMeetingUser) {
                    cov_1cxr34lntn.f[10]++;
                    cov_1cxr34lntn.s[20]++;

                    _this2.meetingUser = searchMeetingUser[0];
                });
            });

            cov_1cxr34lntn.s[21]++;
            this.newDescription = '';
            cov_1cxr34lntn.s[22]++;
            this.duration = this.meeting.scheduleDuration;
            cov_1cxr34lntn.s[23]++;
            this.newDecisionDescription = '';
            cov_1cxr34lntn.s[24]++;
            this.$scope.$watch('$ctrl.fileUpload', function (uploaded) {
                cov_1cxr34lntn.f[11]++;
                cov_1cxr34lntn.s[25]++;

                if (angular.isString(uploaded)) {
                    cov_1cxr34lntn.b[0][0]++;
                    cov_1cxr34lntn.s[26]++;

                    _this2.meeting.$meetingFiles.$create({ meeting: _this2.meeting.id, file: _this2.fileUpload }).$then(function (newImage) {
                        cov_1cxr34lntn.f[12]++;
                        cov_1cxr34lntn.s[27]++;

                        _this2.meeting.$meetingFiles.$add(newImage);
                    });
                    cov_1cxr34lntn.s[28]++;
                    _this2.fileUpload = null;
                    cov_1cxr34lntn.s[29]++;
                    _this2.meeting.$refresh('meetingFiles');
                } else {
                    cov_1cxr34lntn.b[0][1]++;
                }
            });
        }
    }, {
        key: 'fileToName',
        value: function fileToName(url) {
            cov_1cxr34lntn.f[13]++;
            cov_1cxr34lntn.s[30]++;

            if (url) {
                cov_1cxr34lntn.b[1][0]++;

                var m = (cov_1cxr34lntn.s[31]++, url.toString().match(/.*\/(.+?)\.(.+)/));
                cov_1cxr34lntn.s[32]++;
                if ((cov_1cxr34lntn.b[3][0]++, m) && (cov_1cxr34lntn.b[3][1]++, m.length > 1)) {
                    cov_1cxr34lntn.b[2][0]++;
                    cov_1cxr34lntn.s[33]++;

                    return m[1] + '.' + m[2];
                } else {
                    cov_1cxr34lntn.b[2][1]++;
                }
            } else {
                cov_1cxr34lntn.b[1][1]++;
            }
            cov_1cxr34lntn.s[34]++;
            return "";
        }
    }, {
        key: 'editDuration',
        value: function editDuration() {
            cov_1cxr34lntn.f[14]++;

            var scheduledDuration = (cov_1cxr34lntn.s[35]++, this.duration + ':00');
            cov_1cxr34lntn.s[36]++;
            this.meeting.scheduleDuration = scheduledDuration;
            cov_1cxr34lntn.s[37]++;
            this.meeting.$save(['scheduleDuration']);
        }
    }, {
        key: 'addUser',
        value: function addUser(index) {
            cov_1cxr34lntn.f[15]++;
            cov_1cxr34lntn.s[38]++;

            this.meeting.$meetingUsers.$create({
                meeting: this.meeting.id,
                user: index
            }).$then(function (meetingUser) {
                cov_1cxr34lntn.f[16]++;
                cov_1cxr34lntn.s[39]++;

                meetingUser.$load('user');
            });
        }
    }, {
        key: 'addTopic',
        value: function addTopic(description) {
            cov_1cxr34lntn.f[17]++;
            cov_1cxr34lntn.s[40]++;

            this.meeting.$topics.$create({
                meeting: this.meeting.id,
                description: description
            });
            cov_1cxr34lntn.s[41]++;
            this.newDescription = '';
        }
    }, {
        key: 'addDecision',
        value: function addDecision(description) {
            cov_1cxr34lntn.f[18]++;
            cov_1cxr34lntn.s[42]++;

            this.meeting.$decisions.$create({
                meeting: this.meeting.id,
                description: description
            });
            cov_1cxr34lntn.s[43]++;
            this.newDecisionDescription = '';
        }
    }, {
        key: 'confirmDelete',
        value: function confirmDelete(toDestroy) {
            cov_1cxr34lntn.f[19]++;
            cov_1cxr34lntn.s[44]++;

            this.$mdDialog.show(this.$mdDialog.confirm().title("Are you sure you want to delete?").ok('Delete').cancel('Cancel')).then(function () {
                cov_1cxr34lntn.f[20]++;
                cov_1cxr34lntn.s[45]++;

                toDestroy.$destroy();
            });
        }
    }, {
        key: 'userIsParticipant',
        value: function userIsParticipant(user) {
            cov_1cxr34lntn.f[21]++;

            var isParticipant = (cov_1cxr34lntn.s[46]++, false);
            cov_1cxr34lntn.s[47]++;
            this.meeting.$meetingUsers.forEach(function (meetingUser) {
                cov_1cxr34lntn.f[22]++;
                cov_1cxr34lntn.s[48]++;

                if (meetingUser.user == user.id) {
                    cov_1cxr34lntn.b[4][0]++;
                    cov_1cxr34lntn.s[49]++;

                    isParticipant = true;
                } else {
                    cov_1cxr34lntn.b[4][1]++;
                }
            });
            cov_1cxr34lntn.s[50]++;
            return isParticipant;
        }
    }, {
        key: 'addTemplate',
        value: function addTemplate(templateId) {
            var _this3 = this;

            cov_1cxr34lntn.f[23]++;
            cov_1cxr34lntn.s[51]++;

            this.templateTopicsTable.$search({ template: templateId, ordering: 'order' }).$then(function (templateTopics) {
                cov_1cxr34lntn.f[24]++;
                cov_1cxr34lntn.s[52]++;

                templateTopics.forEach(function (topic) {
                    cov_1cxr34lntn.f[25]++;
                    cov_1cxr34lntn.s[53]++;

                    _this3.meeting.$topics.$create({
                        meeting: _this3.meeting.id,
                        description: topic.name
                    }).$then(function (newTopic) {
                        cov_1cxr34lntn.f[26]++;
                        cov_1cxr34lntn.s[54]++;
                        return _this3.meeting.$topics.$add(newTopic);
                    });
                });
            });
        }
    }, {
        key: 'isEnter',
        value: function isEnter(event) {
            cov_1cxr34lntn.f[27]++;

            var isEnter = (cov_1cxr34lntn.s[55]++, false);
            var code = (cov_1cxr34lntn.s[56]++, (cov_1cxr34lntn.b[5][0]++, event.keyCode) || (cov_1cxr34lntn.b[5][1]++, event.which));
            cov_1cxr34lntn.s[57]++;
            if (code === 13) {
                cov_1cxr34lntn.b[6][0]++;
                cov_1cxr34lntn.s[58]++;

                if (!event.shiftKey) {
                    cov_1cxr34lntn.b[7][0]++;
                    cov_1cxr34lntn.s[59]++;

                    isEnter = true;
                } else {
                    cov_1cxr34lntn.b[7][1]++;
                }
            } else {
                cov_1cxr34lntn.b[6][1]++;
            }
            cov_1cxr34lntn.s[60]++;
            return isEnter;
        }
    }]);

    return MeetingDetailsController;
}();

cov_1cxr34lntn.s[61]++;


angular.module('app').component('meetingDetails', {
    templateUrl: 'app/components/meetingDetails/meetingDetails.html',
    controller: MeetingDetailsController,
    bindings: {
        meeting: '<'
    }
});
'use strict';

var cov_1zobpbmjy2 = function () {
    var path = '/home/lobo/repos/meetings-app/src/app/components/homeView/homeView.js',
        hash = 'aec94b3ccf46166690c85d6c68cb5cc3c272daad',
        Function = function () {}.constructor,
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/meetings-app/src/app/components/homeView/homeView.js',
        statementMap: {
            '0': {
                start: {
                    line: 10,
                    column: 0
                },
                end: {
                    line: 18,
                    column: 3
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 2,
                        column: 4
                    },
                    end: {
                        line: 2,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 2,
                        column: 19
                    },
                    end: {
                        line: 4,
                        column: 5
                    }
                },
                line: 2
            },
            '1': {
                name: '(anonymous_1)',
                decl: {
                    start: {
                        line: 5,
                        column: 4
                    },
                    end: {
                        line: 5,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 5,
                        column: 15
                    },
                    end: {
                        line: 7,
                        column: 5
                    }
                },
                line: 5
            }
        },
        branchMap: {},
        s: {
            '0': 0
        },
        f: {
            '0': 0,
            '1': 0
        },
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var HomeViewController = function () {
    function HomeViewController() {
        _classCallCheck(this, HomeViewController);

        cov_1zobpbmjy2.f[0]++;
    }

    _createClass(HomeViewController, [{
        key: '$onInit',
        value: function $onInit() {
            cov_1zobpbmjy2.f[1]++;
        }
    }]);

    return HomeViewController;
}();

cov_1zobpbmjy2.s[0]++;


angular.module('app').component('homeView', {
    templateUrl: 'app/components/homeView/homeView.html',
    controller: HomeViewController,
    bindings: {
        welcomeMsg: '<'
    }
});
'use strict';

var cov_2luh6lp6xx = function () {
    var path = '/home/lobo/repos/meetings-app/src/app/components/editProfile/editProfile.js',
        hash = '9b682220685df561af928c28a34f162c60b5d527',
        Function = function () {}.constructor,
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/meetings-app/src/app/components/editProfile/editProfile.js',
        statementMap: {
            '0': {
                start: {
                    line: 3,
                    column: 8
                },
                end: {
                    line: 3,
                    column: 33
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 8
                },
                end: {
                    line: 4,
                    column: 39
                }
            },
            '2': {
                start: {
                    line: 5,
                    column: 8
                },
                end: {
                    line: 5,
                    column: 29
                }
            },
            '3': {
                start: {
                    line: 7,
                    column: 8
                },
                end: {
                    line: 23,
                    column: 11
                }
            },
            '4': {
                start: {
                    line: 8,
                    column: 12
                },
                end: {
                    line: 11,
                    column: 15
                }
            },
            '5': {
                start: {
                    line: 12,
                    column: 12
                },
                end: {
                    line: 22,
                    column: 13
                }
            },
            '6': {
                start: {
                    line: 13,
                    column: 16
                },
                end: {
                    line: 13,
                    column: 51
                }
            },
            '7': {
                start: {
                    line: 14,
                    column: 16
                },
                end: {
                    line: 19,
                    column: 19
                }
            },
            '8': {
                start: {
                    line: 15,
                    column: 20
                },
                end: {
                    line: 15,
                    column: 99
                }
            },
            '9': {
                start: {
                    line: 16,
                    column: 20
                },
                end: {
                    line: 16,
                    column: 59
                }
            },
            '10': {
                start: {
                    line: 18,
                    column: 20
                },
                end: {
                    line: 18,
                    column: 98
                }
            },
            '11': {
                start: {
                    line: 20,
                    column: 16
                },
                end: {
                    line: 20,
                    column: 39
                }
            },
            '12': {
                start: {
                    line: 27,
                    column: 8
                },
                end: {
                    line: 33,
                    column: 11
                }
            },
            '13': {
                start: {
                    line: 28,
                    column: 12
                },
                end: {
                    line: 32,
                    column: 15
                }
            },
            '14': {
                start: {
                    line: 29,
                    column: 16
                },
                end: {
                    line: 29,
                    column: 91
                }
            },
            '15': {
                start: {
                    line: 31,
                    column: 16
                },
                end: {
                    line: 31,
                    column: 41
                }
            },
            '16': {
                start: {
                    line: 37,
                    column: 8
                },
                end: {
                    line: 40,
                    column: 11
                }
            },
            '17': {
                start: {
                    line: 38,
                    column: 12
                },
                end: {
                    line: 38,
                    column: 88
                }
            },
            '18': {
                start: {
                    line: 39,
                    column: 12
                },
                end: {
                    line: 39,
                    column: 67
                }
            },
            '19': {
                start: {
                    line: 44,
                    column: 0
                },
                end: {
                    line: 52,
                    column: 7
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 2,
                        column: 4
                    },
                    end: {
                        line: 2,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 2,
                        column: 68
                    },
                    end: {
                        line: 24,
                        column: 5
                    }
                },
                line: 2
            },
            '1': {
                name: '(anonymous_1)',
                decl: {
                    start: {
                        line: 7,
                        column: 42
                    },
                    end: {
                        line: 7,
                        column: 43
                    }
                },
                loc: {
                    start: {
                        line: 7,
                        column: 48
                    },
                    end: {
                        line: 23,
                        column: 9
                    }
                },
                line: 7
            },
            '2': {
                name: '(anonymous_2)',
                decl: {
                    start: {
                        line: 14,
                        column: 50
                    },
                    end: {
                        line: 14,
                        column: 51
                    }
                },
                loc: {
                    start: {
                        line: 14,
                        column: 56
                    },
                    end: {
                        line: 17,
                        column: 17
                    }
                },
                line: 14
            },
            '3': {
                name: '(anonymous_3)',
                decl: {
                    start: {
                        line: 17,
                        column: 19
                    },
                    end: {
                        line: 17,
                        column: 20
                    }
                },
                loc: {
                    start: {
                        line: 17,
                        column: 25
                    },
                    end: {
                        line: 19,
                        column: 17
                    }
                },
                line: 17
            },
            '4': {
                name: '(anonymous_4)',
                decl: {
                    start: {
                        line: 26,
                        column: 4
                    },
                    end: {
                        line: 26,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 26,
                        column: 18
                    },
                    end: {
                        line: 34,
                        column: 5
                    }
                },
                line: 26
            },
            '5': {
                name: '(anonymous_5)',
                decl: {
                    start: {
                        line: 27,
                        column: 40
                    },
                    end: {
                        line: 27,
                        column: 41
                    }
                },
                loc: {
                    start: {
                        line: 27,
                        column: 46
                    },
                    end: {
                        line: 33,
                        column: 9
                    }
                },
                line: 27
            },
            '6': {
                name: '(anonymous_6)',
                decl: {
                    start: {
                        line: 28,
                        column: 62
                    },
                    end: {
                        line: 28,
                        column: 63
                    }
                },
                loc: {
                    start: {
                        line: 28,
                        column: 68
                    },
                    end: {
                        line: 30,
                        column: 13
                    }
                },
                line: 28
            },
            '7': {
                name: '(anonymous_7)',
                decl: {
                    start: {
                        line: 30,
                        column: 15
                    },
                    end: {
                        line: 30,
                        column: 16
                    }
                },
                loc: {
                    start: {
                        line: 30,
                        column: 21
                    },
                    end: {
                        line: 32,
                        column: 13
                    }
                },
                line: 30
            },
            '8': {
                name: '(anonymous_8)',
                decl: {
                    start: {
                        line: 36,
                        column: 4
                    },
                    end: {
                        line: 36,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 36,
                        column: 18
                    },
                    end: {
                        line: 41,
                        column: 5
                    }
                },
                line: 36
            },
            '9': {
                name: '(anonymous_9)',
                decl: {
                    start: {
                        line: 37,
                        column: 64
                    },
                    end: {
                        line: 37,
                        column: 65
                    }
                },
                loc: {
                    start: {
                        line: 37,
                        column: 70
                    },
                    end: {
                        line: 40,
                        column: 9
                    }
                },
                line: 37
            }
        },
        branchMap: {
            '0': {
                loc: {
                    start: {
                        line: 12,
                        column: 12
                    },
                    end: {
                        line: 22,
                        column: 13
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 12,
                        column: 12
                    },
                    end: {
                        line: 22,
                        column: 13
                    }
                }, {
                    start: {
                        line: 12,
                        column: 12
                    },
                    end: {
                        line: 22,
                        column: 13
                    }
                }],
                line: 12
            },
            '1': {
                loc: {
                    start: {
                        line: 12,
                        column: 16
                    },
                    end: {
                        line: 12,
                        column: 92
                    }
                },
                type: 'binary-expr',
                locations: [{
                    start: {
                        line: 12,
                        column: 16
                    },
                    end: {
                        line: 12,
                        column: 49
                    }
                }, {
                    start: {
                        line: 12,
                        column: 53
                    },
                    end: {
                        line: 12,
                        column: 92
                    }
                }],
                line: 12
            }
        },
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0,
            '7': 0,
            '8': 0,
            '9': 0,
            '10': 0,
            '11': 0,
            '12': 0,
            '13': 0,
            '14': 0,
            '15': 0,
            '16': 0,
            '17': 0,
            '18': 0,
            '19': 0
        },
        f: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0,
            '7': 0,
            '8': 0,
            '9': 0
        },
        b: {
            '0': [0, 0],
            '1': [0, 0]
        },
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var EditProfileController = function () {
    EditProfileController.$inject = ["$mdToast", "AuthService", "$state", "$rootScope", "$scope"];
    function EditProfileController($mdToast, AuthService, $state, $rootScope, $scope) {
        var _this = this;

        _classCallCheck(this, EditProfileController);

        cov_2luh6lp6xx.f[0]++;
        cov_2luh6lp6xx.s[0]++;

        this.$mdToast = $mdToast;
        cov_2luh6lp6xx.s[1]++;
        this.AuthService = AuthService;
        cov_2luh6lp6xx.s[2]++;
        this.$state = $state;

        cov_2luh6lp6xx.s[3]++;
        $scope.$watch('$ctrl.fileUpload', function () {
            cov_2luh6lp6xx.f[1]++;
            cov_2luh6lp6xx.s[4]++;

            console.log({
                'this': _this.fileUpload,
                'root': $rootScope.me.avatar
            });
            cov_2luh6lp6xx.s[5]++;
            if ((cov_2luh6lp6xx.b[1][0]++, angular.isString(_this.fileUpload)) && (cov_2luh6lp6xx.b[1][1]++, _this.fileUpload != $rootScope.me.avatar)) {
                cov_2luh6lp6xx.b[0][0]++;
                cov_2luh6lp6xx.s[6]++;

                _this.user.avatar = _this.fileUpload;
                cov_2luh6lp6xx.s[7]++;
                _this.user.$save(['avatar']).$then(function () {
                    cov_2luh6lp6xx.f[2]++;
                    cov_2luh6lp6xx.s[8]++;

                    $mdToast.show($mdToast.simple().textContent(gettext('Profile image updated')));
                    cov_2luh6lp6xx.s[9]++;
                    AuthService.refreshAuthenticatedInfo();
                }, function () {
                    cov_2luh6lp6xx.f[3]++;
                    cov_2luh6lp6xx.s[10]++;

                    $mdToast.show($mdToast.simple().textContent(gettext('An error has ocurred')));
                });
                cov_2luh6lp6xx.s[11]++;
                _this.fileUpload = null;
            } else {
                cov_2luh6lp6xx.b[0][1]++;
            }
        });
    }

    _createClass(EditProfileController, [{
        key: 'changeInfo',
        value: function changeInfo() {
            var _this2 = this;

            cov_2luh6lp6xx.f[4]++;
            cov_2luh6lp6xx.s[12]++;

            this.user.$save(['name']).$then(function () {
                cov_2luh6lp6xx.f[5]++;
                cov_2luh6lp6xx.s[13]++;

                _this2.AuthService.refreshAuthenticatedInfo().$then(function () {
                    cov_2luh6lp6xx.f[6]++;
                    cov_2luh6lp6xx.s[14]++;

                    _this2.$mdToast.show(_this2.$mdToast.simple().textContent('Profile updated!'));
                }, function () {
                    cov_2luh6lp6xx.f[7]++;
                    cov_2luh6lp6xx.s[15]++;

                    _this2.$state.go('logout');
                });
            });
        }
    }, {
        key: 'changePass',
        value: function changePass() {
            var _this3 = this;

            cov_2luh6lp6xx.f[8]++;
            cov_2luh6lp6xx.s[16]++;

            this.user.$save(['password', 'confirm_password']).$then(function () {
                cov_2luh6lp6xx.f[9]++;
                cov_2luh6lp6xx.s[17]++;

                _this3.$mdToast.show(_this3.$mdToast.simple().textContent('Password changed!'));
                cov_2luh6lp6xx.s[18]++;
                _this3.user.password = _this3.user.confirm_password = null;
            });
        }
    }]);

    return EditProfileController;
}();

cov_2luh6lp6xx.s[19]++;


angular.module('app').component('editProfile', {
    templateUrl: 'app/components/editProfile/editProfile.html',
    controller: EditProfileController,
    bindings: {
        user: '<'
    }
});
'use strict';

var cov_259e512qa7 = function () {
    var path = '/home/lobo/repos/meetings-app/src/app/components/dashboard/dashboard.controller.js',
        hash = '8740534c3dfb75393cf9b6ee2866794406d1e407',
        Function = function () {}.constructor,
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/meetings-app/src/app/components/dashboard/dashboard.controller.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 19,
                    column: 5
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 4
                },
                end: {
                    line: 6,
                    column: 51
                }
            },
            '2': {
                start: {
                    line: 10,
                    column: 17
                },
                end: {
                    line: 10,
                    column: 21
                }
            },
            '3': {
                start: {
                    line: 11,
                    column: 8
                },
                end: {
                    line: 11,
                    column: 19
                }
            },
            '4': {
                start: {
                    line: 14,
                    column: 12
                },
                end: {
                    line: 16,
                    column: 14
                }
            },
            '5': {
                start: {
                    line: 15,
                    column: 16
                },
                end: {
                    line: 15,
                    column: 42
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 1,
                        column: 1
                    },
                    end: {
                        line: 1,
                        column: 2
                    }
                },
                loc: {
                    start: {
                        line: 1,
                        column: 13
                    },
                    end: {
                        line: 19,
                        column: 1
                    }
                },
                line: 1
            },
            '1': {
                name: 'Controller',
                decl: {
                    start: {
                        line: 9,
                        column: 13
                    },
                    end: {
                        line: 9,
                        column: 23
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 45
                    },
                    end: {
                        line: 18,
                        column: 5
                    }
                },
                line: 9
            },
            '2': {
                name: 'activate',
                decl: {
                    start: {
                        line: 13,
                        column: 17
                    },
                    end: {
                        line: 13,
                        column: 25
                    }
                },
                loc: {
                    start: {
                        line: 13,
                        column: 29
                    },
                    end: {
                        line: 17,
                        column: 9
                    }
                },
                line: 13
            },
            '3': {
                name: '(anonymous_3)',
                decl: {
                    start: {
                        line: 14,
                        column: 32
                    },
                    end: {
                        line: 14,
                        column: 33
                    }
                },
                loc: {
                    start: {
                        line: 14,
                        column: 44
                    },
                    end: {
                        line: 16,
                        column: 13
                    }
                },
                line: 14
            }
        },
        branchMap: {},
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0
        },
        f: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0
        },
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_259e512qa7.s[0]++;
(function () {
    'use strict';

    Controller.$inject = ["$rootScope", "$state"];
    cov_259e512qa7.f[0]++;
    cov_259e512qa7.s[1]++;
    angular.module('app').controller('DashboardController', Controller);

    /* @ngInject */
    function Controller($rootScope, $state) {
        cov_259e512qa7.f[1]++;

        var vm = (cov_259e512qa7.s[2]++, this);
        cov_259e512qa7.s[3]++;
        activate();

        function activate() {
            cov_259e512qa7.f[2]++;
            cov_259e512qa7.s[4]++;

            $rootScope.me.$then(function () {
                cov_259e512qa7.f[3]++;
                cov_259e512qa7.s[5]++;

                $state.go('meetingsList');
            });
        }
    }
})();
'use strict';

var cov_bk216egus = function () {
    var path = '/home/lobo/repos/meetings-app/src/app/components/createTemplateModal/createTemplateModal.js',
        hash = '04b15589df2340deca2c533d2e8a2ee5577277cf',
        Function = function () {}.constructor,
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/meetings-app/src/app/components/createTemplateModal/createTemplateModal.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 35,
                    column: 12
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 4
                },
                end: {
                    line: 6,
                    column: 69
                }
            },
            '2': {
                start: {
                    line: 10,
                    column: 22
                },
                end: {
                    line: 10,
                    column: 26
                }
            },
            '3': {
                start: {
                    line: 11,
                    column: 8
                },
                end: {
                    line: 18,
                    column: 10
                }
            },
            '4': {
                start: {
                    line: 12,
                    column: 12
                },
                end: {
                    line: 17,
                    column: 15
                }
            },
            '5': {
                start: {
                    line: 23,
                    column: 8
                },
                end: {
                    line: 23,
                    column: 53
                }
            },
            '6': {
                start: {
                    line: 25,
                    column: 8
                },
                end: {
                    line: 27,
                    column: 10
                }
            },
            '7': {
                start: {
                    line: 26,
                    column: 12
                },
                end: {
                    line: 26,
                    column: 31
                }
            },
            '8': {
                start: {
                    line: 29,
                    column: 8
                },
                end: {
                    line: 33,
                    column: 10
                }
            },
            '9': {
                start: {
                    line: 30,
                    column: 12
                },
                end: {
                    line: 32,
                    column: 14
                }
            },
            '10': {
                start: {
                    line: 31,
                    column: 16
                },
                end: {
                    line: 31,
                    column: 41
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 1,
                        column: 1
                    },
                    end: {
                        line: 1,
                        column: 2
                    }
                },
                loc: {
                    start: {
                        line: 1,
                        column: 13
                    },
                    end: {
                        line: 35,
                        column: 1
                    }
                },
                line: 1
            },
            '1': {
                name: 'NewTemplateModalService',
                decl: {
                    start: {
                        line: 9,
                        column: 13
                    },
                    end: {
                        line: 9,
                        column: 36
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 49
                    },
                    end: {
                        line: 19,
                        column: 5
                    }
                },
                line: 9
            },
            '2': {
                name: '(anonymous_2)',
                decl: {
                    start: {
                        line: 11,
                        column: 23
                    },
                    end: {
                        line: 11,
                        column: 24
                    }
                },
                loc: {
                    start: {
                        line: 11,
                        column: 35
                    },
                    end: {
                        line: 18,
                        column: 9
                    }
                },
                line: 11
            },
            '3': {
                name: 'CreateTemplateModalController',
                decl: {
                    start: {
                        line: 22,
                        column: 13
                    },
                    end: {
                        line: 22,
                        column: 42
                    }
                },
                loc: {
                    start: {
                        line: 22,
                        column: 79
                    },
                    end: {
                        line: 34,
                        column: 5
                    }
                },
                line: 22
            },
            '4': {
                name: '(anonymous_4)',
                decl: {
                    start: {
                        line: 25,
                        column: 29
                    },
                    end: {
                        line: 25,
                        column: 30
                    }
                },
                loc: {
                    start: {
                        line: 25,
                        column: 41
                    },
                    end: {
                        line: 27,
                        column: 9
                    }
                },
                line: 25
            },
            '5': {
                name: '(anonymous_5)',
                decl: {
                    start: {
                        line: 29,
                        column: 32
                    },
                    end: {
                        line: 29,
                        column: 33
                    }
                },
                loc: {
                    start: {
                        line: 29,
                        column: 44
                    },
                    end: {
                        line: 33,
                        column: 9
                    }
                },
                line: 29
            },
            '6': {
                name: '(anonymous_6)',
                decl: {
                    start: {
                        line: 30,
                        column: 45
                    },
                    end: {
                        line: 30,
                        column: 46
                    }
                },
                loc: {
                    start: {
                        line: 30,
                        column: 65
                    },
                    end: {
                        line: 32,
                        column: 13
                    }
                },
                line: 30
            }
        },
        branchMap: {},
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0,
            '7': 0,
            '8': 0,
            '9': 0,
            '10': 0
        },
        f: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0
        },
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_bk216egus.s[0]++;
(function () {
    'use strict';

    NewTemplateModalService.$inject = ["$mdDialog"];
    CreateTemplateModalController.$inject = ["$scope", "$mdDialog", "TemplatesTable"];
    cov_bk216egus.f[0]++;
    cov_bk216egus.s[1]++;
    angular.module('app').service('NewTemplateModalService', NewTemplateModalService);

    /* @ngInject */
    function NewTemplateModalService($mdDialog) {
        cov_bk216egus.f[1]++;

        var Service = (cov_bk216egus.s[2]++, this);
        cov_bk216egus.s[3]++;
        this.display = function () {
            cov_bk216egus.f[2]++;
            cov_bk216egus.s[4]++;

            return $mdDialog.show({
                templateUrl: 'app/components/createTemplateModal/createTemplateModal.html',
                controller: CreateTemplateModalController,
                clickOutsideToClose: true,
                escapeToClose: true
            });
        };
    }

    /* @ngInject */
    function CreateTemplateModalController($scope, $mdDialog, TemplatesTable) {
        cov_bk216egus.f[3]++;
        cov_bk216egus.s[5]++;

        $scope.newTemplate = TemplatesTable.$build();

        cov_bk216egus.s[6]++;
        $scope.closeDialog = function () {
            cov_bk216egus.f[4]++;
            cov_bk216egus.s[7]++;

            $mdDialog.cancel();
        };

        cov_bk216egus.s[8]++;
        $scope.createTemplate = function () {
            cov_bk216egus.f[5]++;
            cov_bk216egus.s[9]++;

            $scope.newTemplate.$save().$then(function (template) {
                cov_bk216egus.f[6]++;
                cov_bk216egus.s[10]++;

                $mdDialog.hide(template);
            });
        };
    }
})(angular);
'use strict';

var cov_1209krtb2s = function () {
    var path = '/home/lobo/repos/meetings-app/src/app/components/createProjectModal/createProjectModal.js',
        hash = '1226e29a103e187dcf3c75c0baf14ed81c896845',
        Function = function () {}.constructor,
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/meetings-app/src/app/components/createProjectModal/createProjectModal.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 35,
                    column: 12
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 4
                },
                end: {
                    line: 6,
                    column: 63
                }
            },
            '2': {
                start: {
                    line: 10,
                    column: 22
                },
                end: {
                    line: 10,
                    column: 26
                }
            },
            '3': {
                start: {
                    line: 11,
                    column: 8
                },
                end: {
                    line: 18,
                    column: 10
                }
            },
            '4': {
                start: {
                    line: 12,
                    column: 12
                },
                end: {
                    line: 17,
                    column: 15
                }
            },
            '5': {
                start: {
                    line: 23,
                    column: 8
                },
                end: {
                    line: 23,
                    column: 51
                }
            },
            '6': {
                start: {
                    line: 25,
                    column: 8
                },
                end: {
                    line: 27,
                    column: 10
                }
            },
            '7': {
                start: {
                    line: 26,
                    column: 12
                },
                end: {
                    line: 26,
                    column: 31
                }
            },
            '8': {
                start: {
                    line: 29,
                    column: 8
                },
                end: {
                    line: 33,
                    column: 10
                }
            },
            '9': {
                start: {
                    line: 30,
                    column: 12
                },
                end: {
                    line: 32,
                    column: 14
                }
            },
            '10': {
                start: {
                    line: 31,
                    column: 16
                },
                end: {
                    line: 31,
                    column: 40
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 1,
                        column: 1
                    },
                    end: {
                        line: 1,
                        column: 2
                    }
                },
                loc: {
                    start: {
                        line: 1,
                        column: 13
                    },
                    end: {
                        line: 35,
                        column: 1
                    }
                },
                line: 1
            },
            '1': {
                name: 'NewProjectModalService',
                decl: {
                    start: {
                        line: 9,
                        column: 13
                    },
                    end: {
                        line: 9,
                        column: 35
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 48
                    },
                    end: {
                        line: 19,
                        column: 5
                    }
                },
                line: 9
            },
            '2': {
                name: '(anonymous_2)',
                decl: {
                    start: {
                        line: 11,
                        column: 23
                    },
                    end: {
                        line: 11,
                        column: 24
                    }
                },
                loc: {
                    start: {
                        line: 11,
                        column: 35
                    },
                    end: {
                        line: 18,
                        column: 9
                    }
                },
                line: 11
            },
            '3': {
                name: 'CreateProjectModalController',
                decl: {
                    start: {
                        line: 22,
                        column: 13
                    },
                    end: {
                        line: 22,
                        column: 41
                    }
                },
                loc: {
                    start: {
                        line: 22,
                        column: 77
                    },
                    end: {
                        line: 34,
                        column: 5
                    }
                },
                line: 22
            },
            '4': {
                name: '(anonymous_4)',
                decl: {
                    start: {
                        line: 25,
                        column: 29
                    },
                    end: {
                        line: 25,
                        column: 30
                    }
                },
                loc: {
                    start: {
                        line: 25,
                        column: 41
                    },
                    end: {
                        line: 27,
                        column: 9
                    }
                },
                line: 25
            },
            '5': {
                name: '(anonymous_5)',
                decl: {
                    start: {
                        line: 29,
                        column: 31
                    },
                    end: {
                        line: 29,
                        column: 32
                    }
                },
                loc: {
                    start: {
                        line: 29,
                        column: 43
                    },
                    end: {
                        line: 33,
                        column: 9
                    }
                },
                line: 29
            },
            '6': {
                name: '(anonymous_6)',
                decl: {
                    start: {
                        line: 30,
                        column: 44
                    },
                    end: {
                        line: 30,
                        column: 45
                    }
                },
                loc: {
                    start: {
                        line: 30,
                        column: 63
                    },
                    end: {
                        line: 32,
                        column: 13
                    }
                },
                line: 30
            }
        },
        branchMap: {},
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0,
            '7': 0,
            '8': 0,
            '9': 0,
            '10': 0
        },
        f: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0
        },
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_1209krtb2s.s[0]++;
(function () {
    'use strict';

    NewProjectModalService.$inject = ["$mdDialog"];
    CreateProjectModalController.$inject = ["$scope", "$mdDialog", "ProjectsTable"];
    cov_1209krtb2s.f[0]++;
    cov_1209krtb2s.s[1]++;
    angular.module('app').service('NewProjectModalService', NewProjectModalService);

    /* @ngInject */
    function NewProjectModalService($mdDialog) {
        cov_1209krtb2s.f[1]++;

        var Service = (cov_1209krtb2s.s[2]++, this);
        cov_1209krtb2s.s[3]++;
        this.display = function () {
            cov_1209krtb2s.f[2]++;
            cov_1209krtb2s.s[4]++;

            return $mdDialog.show({
                templateUrl: 'app/components/createProjectModal/createProjectModal.html',
                controller: CreateProjectModalController,
                clickOutsideToClose: true,
                escapeToClose: true
            });
        };
    }

    /* @ngInject */
    function CreateProjectModalController($scope, $mdDialog, ProjectsTable) {
        cov_1209krtb2s.f[3]++;
        cov_1209krtb2s.s[5]++;

        $scope.newProject = ProjectsTable.$build();

        cov_1209krtb2s.s[6]++;
        $scope.closeDialog = function () {
            cov_1209krtb2s.f[4]++;
            cov_1209krtb2s.s[7]++;

            $mdDialog.cancel();
        };

        cov_1209krtb2s.s[8]++;
        $scope.createProject = function () {
            cov_1209krtb2s.f[5]++;
            cov_1209krtb2s.s[9]++;

            $scope.newProject.$save().$then(function (project) {
                cov_1209krtb2s.f[6]++;
                cov_1209krtb2s.s[10]++;

                $mdDialog.hide(project);
            });
        };
    }
})(angular);
'use strict';

var cov_x60onx50x = function () {
    var path = '/home/lobo/repos/meetings-app/src/app/components/createMeetingModal/createMeetingModal.js',
        hash = 'a6e18428b93da5e0a9cdd5a7fde9e43981a5a434',
        Function = function () {}.constructor,
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/meetings-app/src/app/components/createMeetingModal/createMeetingModal.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 38,
                    column: 12
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 4
                },
                end: {
                    line: 6,
                    column: 67
                }
            },
            '2': {
                start: {
                    line: 10,
                    column: 22
                },
                end: {
                    line: 10,
                    column: 26
                }
            },
            '3': {
                start: {
                    line: 11,
                    column: 8
                },
                end: {
                    line: 18,
                    column: 10
                }
            },
            '4': {
                start: {
                    line: 12,
                    column: 12
                },
                end: {
                    line: 17,
                    column: 15
                }
            },
            '5': {
                start: {
                    line: 23,
                    column: 8
                },
                end: {
                    line: 23,
                    column: 61
                }
            },
            '6': {
                start: {
                    line: 24,
                    column: 8
                },
                end: {
                    line: 24,
                    column: 61
                }
            },
            '7': {
                start: {
                    line: 25,
                    column: 8
                },
                end: {
                    line: 25,
                    column: 34
                }
            },
            '8': {
                start: {
                    line: 26,
                    column: 8
                },
                end: {
                    line: 28,
                    column: 10
                }
            },
            '9': {
                start: {
                    line: 27,
                    column: 12
                },
                end: {
                    line: 27,
                    column: 31
                }
            },
            '10': {
                start: {
                    line: 30,
                    column: 8
                },
                end: {
                    line: 36,
                    column: 10
                }
            },
            '11': {
                start: {
                    line: 31,
                    column: 35
                },
                end: {
                    line: 31,
                    column: 58
                }
            },
            '12': {
                start: {
                    line: 32,
                    column: 12
                },
                end: {
                    line: 32,
                    column: 66
                }
            },
            '13': {
                start: {
                    line: 33,
                    column: 12
                },
                end: {
                    line: 35,
                    column: 15
                }
            },
            '14': {
                start: {
                    line: 34,
                    column: 16
                },
                end: {
                    line: 34,
                    column: 40
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 1,
                        column: 1
                    },
                    end: {
                        line: 1,
                        column: 2
                    }
                },
                loc: {
                    start: {
                        line: 1,
                        column: 13
                    },
                    end: {
                        line: 38,
                        column: 1
                    }
                },
                line: 1
            },
            '1': {
                name: 'NewMeetingModalService',
                decl: {
                    start: {
                        line: 9,
                        column: 13
                    },
                    end: {
                        line: 9,
                        column: 35
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 48
                    },
                    end: {
                        line: 19,
                        column: 5
                    }
                },
                line: 9
            },
            '2': {
                name: '(anonymous_2)',
                decl: {
                    start: {
                        line: 11,
                        column: 23
                    },
                    end: {
                        line: 11,
                        column: 24
                    }
                },
                loc: {
                    start: {
                        line: 11,
                        column: 35
                    },
                    end: {
                        line: 18,
                        column: 9
                    }
                },
                line: 11
            },
            '3': {
                name: 'CreateMeetingModalController',
                decl: {
                    start: {
                        line: 22,
                        column: 13
                    },
                    end: {
                        line: 22,
                        column: 41
                    }
                },
                loc: {
                    start: {
                        line: 22,
                        column: 101
                    },
                    end: {
                        line: 37,
                        column: 5
                    }
                },
                line: 22
            },
            '4': {
                name: '(anonymous_4)',
                decl: {
                    start: {
                        line: 26,
                        column: 29
                    },
                    end: {
                        line: 26,
                        column: 30
                    }
                },
                loc: {
                    start: {
                        line: 26,
                        column: 41
                    },
                    end: {
                        line: 28,
                        column: 9
                    }
                },
                line: 26
            },
            '5': {
                name: '(anonymous_5)',
                decl: {
                    start: {
                        line: 30,
                        column: 31
                    },
                    end: {
                        line: 30,
                        column: 32
                    }
                },
                loc: {
                    start: {
                        line: 30,
                        column: 43
                    },
                    end: {
                        line: 36,
                        column: 9
                    }
                },
                line: 30
            },
            '6': {
                name: '(anonymous_6)',
                decl: {
                    start: {
                        line: 33,
                        column: 44
                    },
                    end: {
                        line: 33,
                        column: 45
                    }
                },
                loc: {
                    start: {
                        line: 33,
                        column: 63
                    },
                    end: {
                        line: 35,
                        column: 13
                    }
                },
                line: 33
            }
        },
        branchMap: {},
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0,
            '7': 0,
            '8': 0,
            '9': 0,
            '10': 0,
            '11': 0,
            '12': 0,
            '13': 0,
            '14': 0
        },
        f: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0
        },
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_x60onx50x.s[0]++;
(function () {
    'use strict';

    NewMeetingModalService.$inject = ["$mdDialog"];
    CreateMeetingModalController.$inject = ["$scope", "$mdDialog", "MeetingsTable", "NewMeetingModalService"];
    cov_x60onx50x.f[0]++;
    cov_x60onx50x.s[1]++;
    angular.module('app').service('NewMeetingModalService', NewMeetingModalService);

    /* @ngInject */
    function NewMeetingModalService($mdDialog) {
        cov_x60onx50x.f[1]++;

        var Service = (cov_x60onx50x.s[2]++, this);
        cov_x60onx50x.s[3]++;
        this.display = function () {
            cov_x60onx50x.f[2]++;
            cov_x60onx50x.s[4]++;

            return $mdDialog.show({
                templateUrl: 'app/components/createMeetingModal/createMeetingModal.html',
                controller: CreateMeetingModalController,
                clickOutsideToClose: true,
                escapeToClose: true
            });
        };
    }

    /* @ngInject */
    function CreateMeetingModalController($scope, $mdDialog, MeetingsTable, NewMeetingModalService) {
        cov_x60onx50x.f[3]++;
        cov_x60onx50x.s[5]++;

        this.NewMeetingModalService = NewMeetingModalService;
        cov_x60onx50x.s[6]++;
        $scope.newMeeting = MeetingsTable.$build({ name: '' });
        cov_x60onx50x.s[7]++;
        $scope.duration = '00:00';
        cov_x60onx50x.s[8]++;
        $scope.closeDialog = function () {
            cov_x60onx50x.f[4]++;
            cov_x60onx50x.s[9]++;

            $mdDialog.cancel();
        };

        cov_x60onx50x.s[10]++;
        $scope.createMeeting = function () {
            cov_x60onx50x.f[5]++;

            var scheduleDuration = (cov_x60onx50x.s[11]++, $scope.duration + ':00');
            cov_x60onx50x.s[12]++;
            $scope.newMeeting.scheduleDuration = scheduleDuration;
            cov_x60onx50x.s[13]++;
            $scope.newMeeting.$save().$then(function (meeting) {
                cov_x60onx50x.f[6]++;
                cov_x60onx50x.s[14]++;

                $mdDialog.hide(meeting);
            });
        };
    }
})(angular);
'use strict';

var cov_21mpb8zq5i = function () {
    var path = '/home/lobo/repos/meetings-app/src/app/components/auth/auth.set.password.controller.js',
        hash = 'c2ca8a7c1cd8a086fbe57775c13e0b7842719543',
        Function = function () {}.constructor,
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/meetings-app/src/app/components/auth/auth.set.password.controller.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 50,
                    column: 5
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 4
                },
                end: {
                    line: 6,
                    column: 76
                }
            },
            '2': {
                start: {
                    line: 10,
                    column: 17
                },
                end: {
                    line: 10,
                    column: 21
                }
            },
            '3': {
                start: {
                    line: 12,
                    column: 8
                },
                end: {
                    line: 12,
                    column: 30
                }
            },
            '4': {
                start: {
                    line: 14,
                    column: 8
                },
                end: {
                    line: 14,
                    column: 37
                }
            },
            '5': {
                start: {
                    line: 16,
                    column: 8
                },
                end: {
                    line: 16,
                    column: 19
                }
            },
            '6': {
                start: {
                    line: 19,
                    column: 12
                },
                end: {
                    line: 21,
                    column: 13
                }
            },
            '7': {
                start: {
                    line: 20,
                    column: 16
                },
                end: {
                    line: 20,
                    column: 35
                }
            },
            '8': {
                start: {
                    line: 25,
                    column: 12
                },
                end: {
                    line: 47,
                    column: 15
                }
            },
            '9': {
                start: {
                    line: 34,
                    column: 16
                },
                end: {
                    line: 38,
                    column: 18
                }
            },
            '10': {
                start: {
                    line: 39,
                    column: 16
                },
                end: {
                    line: 39,
                    column: 35
                }
            },
            '11': {
                start: {
                    line: 41,
                    column: 16
                },
                end: {
                    line: 45,
                    column: 18
                }
            },
            '12': {
                start: {
                    line: 46,
                    column: 16
                },
                end: {
                    line: 46,
                    column: 34
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 1,
                        column: 1
                    },
                    end: {
                        line: 1,
                        column: 2
                    }
                },
                loc: {
                    start: {
                        line: 1,
                        column: 13
                    },
                    end: {
                        line: 50,
                        column: 1
                    }
                },
                line: 1
            },
            '1': {
                name: 'AuthSetPasswordController',
                decl: {
                    start: {
                        line: 9,
                        column: 13
                    },
                    end: {
                        line: 9,
                        column: 38
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 91
                    },
                    end: {
                        line: 49,
                        column: 5
                    }
                },
                line: 9
            },
            '2': {
                name: 'activate',
                decl: {
                    start: {
                        line: 18,
                        column: 17
                    },
                    end: {
                        line: 18,
                        column: 25
                    }
                },
                loc: {
                    start: {
                        line: 18,
                        column: 28
                    },
                    end: {
                        line: 22,
                        column: 9
                    }
                },
                line: 18
            },
            '3': {
                name: 'setPassword',
                decl: {
                    start: {
                        line: 24,
                        column: 17
                    },
                    end: {
                        line: 24,
                        column: 28
                    }
                },
                loc: {
                    start: {
                        line: 24,
                        column: 31
                    },
                    end: {
                        line: 48,
                        column: 9
                    }
                },
                line: 24
            },
            '4': {
                name: 'successCallback',
                decl: {
                    start: {
                        line: 33,
                        column: 29
                    },
                    end: {
                        line: 33,
                        column: 44
                    }
                },
                loc: {
                    start: {
                        line: 33,
                        column: 47
                    },
                    end: {
                        line: 40,
                        column: 13
                    }
                },
                line: 33
            },
            '5': {
                name: '(anonymous_5)',
                decl: {
                    start: {
                        line: 40,
                        column: 15
                    },
                    end: {
                        line: 40,
                        column: 16
                    }
                },
                loc: {
                    start: {
                        line: 40,
                        column: 27
                    },
                    end: {
                        line: 47,
                        column: 13
                    }
                },
                line: 40
            }
        },
        branchMap: {
            '0': {
                loc: {
                    start: {
                        line: 19,
                        column: 12
                    },
                    end: {
                        line: 21,
                        column: 13
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 19,
                        column: 12
                    },
                    end: {
                        line: 21,
                        column: 13
                    }
                }, {
                    start: {
                        line: 19,
                        column: 12
                    },
                    end: {
                        line: 21,
                        column: 13
                    }
                }],
                line: 19
            },
            '1': {
                loc: {
                    start: {
                        line: 19,
                        column: 16
                    },
                    end: {
                        line: 19,
                        column: 58
                    }
                },
                type: 'binary-expr',
                locations: [{
                    start: {
                        line: 19,
                        column: 16
                    },
                    end: {
                        line: 19,
                        column: 35
                    }
                }, {
                    start: {
                        line: 19,
                        column: 39
                    },
                    end: {
                        line: 19,
                        column: 58
                    }
                }],
                line: 19
            }
        },
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0,
            '7': 0,
            '8': 0,
            '9': 0,
            '10': 0,
            '11': 0,
            '12': 0
        },
        f: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0
        },
        b: {
            '0': [0, 0],
            '1': [0, 0]
        },
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_21mpb8zq5i.s[0]++;
(function () {
    'use strict';

    AuthSetPasswordController.$inject = ["$state", "$http", "AppSettings", "$stateParams", "$mdToast"];
    cov_21mpb8zq5i.f[0]++;
    cov_21mpb8zq5i.s[1]++;
    angular.module('app').controller('AuthSetPasswordController', AuthSetPasswordController);

    /* @ngInject */
    function AuthSetPasswordController($state, $http, AppSettings, $stateParams, $mdToast) {
        cov_21mpb8zq5i.f[1]++;

        var vm = (cov_21mpb8zq5i.s[2]++, this);

        cov_21mpb8zq5i.s[3]++;
        vm.requestStatus = {};

        cov_21mpb8zq5i.s[4]++;
        vm.setPassword = setPassword;

        cov_21mpb8zq5i.s[5]++;
        activate();

        function activate() {
            cov_21mpb8zq5i.f[2]++;
            cov_21mpb8zq5i.s[6]++;

            if ((cov_21mpb8zq5i.b[1][0]++, !$stateParams.email) || (cov_21mpb8zq5i.b[1][1]++, !$stateParams.token)) {
                cov_21mpb8zq5i.b[0][0]++;
                cov_21mpb8zq5i.s[7]++;

                $state.go('login');
            } else {
                cov_21mpb8zq5i.b[0][1]++;
            }
        }

        function setPassword() {
            cov_21mpb8zq5i.f[3]++;
            cov_21mpb8zq5i.s[8]++;

            vm.requestStatus = $http({
                method: 'POST',
                url: AppSettings.apiUrl + '/users/set_password/',
                data: {
                    email: $stateParams.email,
                    token: $stateParams.token,
                    password: vm.password
                }
            }).then(function successCallback() {
                cov_21mpb8zq5i.f[4]++;
                cov_21mpb8zq5i.s[9]++;

                $mdToast.show($mdToast.simple().textContent('Your password has been changed!').hideDelay(3000));
                cov_21mpb8zq5i.s[10]++;
                $state.go('login');
            }, function () {
                cov_21mpb8zq5i.f[5]++;
                cov_21mpb8zq5i.s[11]++;

                $mdToast.show($mdToast.simple().textContent('An error has ocurred!').hideDelay(3000));
                cov_21mpb8zq5i.s[12]++;
                $state.go('home');
            });
        }
    }
})();
'use strict';

var cov_1p3jp13ebb = function () {
    var path = '/home/lobo/repos/meetings-app/src/app/components/auth/auth.service.js',
        hash = 'b33edab10dd84b49d8a5b3dfe1549269071013a4',
        Function = function () {}.constructor,
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/meetings-app/src/app/components/auth/auth.service.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 40,
                    column: 5
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 4
                },
                end: {
                    line: 6,
                    column: 41
                }
            },
            '2': {
                start: {
                    line: 10,
                    column: 26
                },
                end: {
                    line: 10,
                    column: 30
                }
            },
            '3': {
                start: {
                    line: 11,
                    column: 8
                },
                end: {
                    line: 20,
                    column: 10
                }
            },
            '4': {
                start: {
                    line: 12,
                    column: 31
                },
                end: {
                    line: 12,
                    column: 78
                }
            },
            '5': {
                start: {
                    line: 13,
                    column: 12
                },
                end: {
                    line: 17,
                    column: 15
                }
            },
            '6': {
                start: {
                    line: 14,
                    column: 16
                },
                end: {
                    line: 14,
                    column: 62
                }
            },
            '7': {
                start: {
                    line: 16,
                    column: 16
                },
                end: {
                    line: 16,
                    column: 29
                }
            },
            '8': {
                start: {
                    line: 19,
                    column: 12
                },
                end: {
                    line: 19,
                    column: 32
                }
            },
            '9': {
                start: {
                    line: 22,
                    column: 8
                },
                end: {
                    line: 29,
                    column: 10
                }
            },
            '10': {
                start: {
                    line: 23,
                    column: 12
                },
                end: {
                    line: 26,
                    column: 15
                }
            },
            '11': {
                start: {
                    line: 24,
                    column: 16
                },
                end: {
                    line: 24,
                    column: 53
                }
            },
            '12': {
                start: {
                    line: 25,
                    column: 16
                },
                end: {
                    line: 25,
                    column: 37
                }
            },
            '13': {
                start: {
                    line: 28,
                    column: 12
                },
                end: {
                    line: 28,
                    column: 42
                }
            },
            '14': {
                start: {
                    line: 31,
                    column: 8
                },
                end: {
                    line: 38,
                    column: 10
                }
            },
            '15': {
                start: {
                    line: 32,
                    column: 32
                },
                end: {
                    line: 32,
                    column: 46
                }
            },
            '16': {
                start: {
                    line: 33,
                    column: 12
                },
                end: {
                    line: 36,
                    column: 15
                }
            },
            '17': {
                start: {
                    line: 34,
                    column: 16
                },
                end: {
                    line: 34,
                    column: 38
                }
            },
            '18': {
                start: {
                    line: 35,
                    column: 16
                },
                end: {
                    line: 35,
                    column: 40
                }
            },
            '19': {
                start: {
                    line: 37,
                    column: 12
                },
                end: {
                    line: 37,
                    column: 33
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 1,
                        column: 1
                    },
                    end: {
                        line: 1,
                        column: 2
                    }
                },
                loc: {
                    start: {
                        line: 1,
                        column: 13
                    },
                    end: {
                        line: 40,
                        column: 1
                    }
                },
                line: 1
            },
            '1': {
                name: 'service',
                decl: {
                    start: {
                        line: 9,
                        column: 13
                    },
                    end: {
                        line: 9,
                        column: 20
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 60
                    },
                    end: {
                        line: 39,
                        column: 5
                    }
                },
                line: 9
            },
            '2': {
                name: '(anonymous_2)',
                decl: {
                    start: {
                        line: 11,
                        column: 21
                    },
                    end: {
                        line: 11,
                        column: 22
                    }
                },
                loc: {
                    start: {
                        line: 11,
                        column: 48
                    },
                    end: {
                        line: 20,
                        column: 9
                    }
                },
                line: 11
            },
            '3': {
                name: '(anonymous_3)',
                decl: {
                    start: {
                        line: 13,
                        column: 30
                    },
                    end: {
                        line: 13,
                        column: 31
                    }
                },
                loc: {
                    start: {
                        line: 13,
                        column: 42
                    },
                    end: {
                        line: 15,
                        column: 13
                    }
                },
                line: 13
            },
            '4': {
                name: '(anonymous_4)',
                decl: {
                    start: {
                        line: 15,
                        column: 15
                    },
                    end: {
                        line: 15,
                        column: 16
                    }
                },
                loc: {
                    start: {
                        line: 15,
                        column: 32
                    },
                    end: {
                        line: 17,
                        column: 13
                    }
                },
                line: 15
            },
            '5': {
                name: '(anonymous_5)',
                decl: {
                    start: {
                        line: 22,
                        column: 40
                    },
                    end: {
                        line: 22,
                        column: 41
                    }
                },
                loc: {
                    start: {
                        line: 22,
                        column: 52
                    },
                    end: {
                        line: 29,
                        column: 9
                    }
                },
                line: 22
            },
            '6': {
                name: '(anonymous_6)',
                decl: {
                    start: {
                        line: 23,
                        column: 57
                    },
                    end: {
                        line: 23,
                        column: 58
                    }
                },
                loc: {
                    start: {
                        line: 23,
                        column: 69
                    },
                    end: {
                        line: 26,
                        column: 13
                    }
                },
                line: 23
            },
            '7': {
                name: '(anonymous_7)',
                decl: {
                    start: {
                        line: 31,
                        column: 22
                    },
                    end: {
                        line: 31,
                        column: 23
                    }
                },
                loc: {
                    start: {
                        line: 31,
                        column: 34
                    },
                    end: {
                        line: 38,
                        column: 9
                    }
                },
                line: 31
            },
            '8': {
                name: '(anonymous_8)',
                decl: {
                    start: {
                        line: 33,
                        column: 31
                    },
                    end: {
                        line: 33,
                        column: 32
                    }
                },
                loc: {
                    start: {
                        line: 33,
                        column: 43
                    },
                    end: {
                        line: 36,
                        column: 13
                    }
                },
                line: 33
            }
        },
        branchMap: {},
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0,
            '7': 0,
            '8': 0,
            '9': 0,
            '10': 0,
            '11': 0,
            '12': 0,
            '13': 0,
            '14': 0,
            '15': 0,
            '16': 0,
            '17': 0,
            '18': 0,
            '19': 0
        },
        f: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0,
            '7': 0,
            '8': 0
        },
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_1p3jp13ebb.s[0]++;
(function () {
    'use strict';

    service.$inject = ["$auth", "$rootScope", "$state", "UsersTable"];
    cov_1p3jp13ebb.f[0]++;
    cov_1p3jp13ebb.s[1]++;
    angular.module('app').service('AuthService', service);

    /* @ngInject */
    function service($auth, $rootScope, $state, UsersTable) {
        cov_1p3jp13ebb.f[1]++;

        var AuthService = (cov_1p3jp13ebb.s[2]++, this);
        cov_1p3jp13ebb.s[3]++;
        this.login = function (email, password) {
            cov_1p3jp13ebb.f[2]++;

            var loginPromise = (cov_1p3jp13ebb.s[4]++, $auth.login({ email: email, password: password }));
            cov_1p3jp13ebb.s[5]++;
            loginPromise.then(function () {
                cov_1p3jp13ebb.f[3]++;
                cov_1p3jp13ebb.s[6]++;

                return AuthService.refreshAuthenticatedInfo();
            }, function (error) {
                cov_1p3jp13ebb.f[4]++;
                cov_1p3jp13ebb.s[7]++;

                return error;
            });

            cov_1p3jp13ebb.s[8]++;
            return loginPromise;
        };

        cov_1p3jp13ebb.s[9]++;
        this.refreshAuthenticatedInfo = function () {
            cov_1p3jp13ebb.f[5]++;
            cov_1p3jp13ebb.s[10]++;

            $rootScope.me = UsersTable.$find('me').$then(function () {
                cov_1p3jp13ebb.f[6]++;
                cov_1p3jp13ebb.s[11]++;

                $rootScope.me.$pk = $rootScope.me.id;
                cov_1p3jp13ebb.s[12]++;
                return $rootScope.me;
            });

            cov_1p3jp13ebb.s[13]++;
            return $rootScope.me.$promise;
        };

        cov_1p3jp13ebb.s[14]++;
        this.logout = function () {
            cov_1p3jp13ebb.f[7]++;

            var logoutPromise = (cov_1p3jp13ebb.s[15]++, $auth.logout());
            cov_1p3jp13ebb.s[16]++;
            logoutPromise.then(function () {
                cov_1p3jp13ebb.f[8]++;
                cov_1p3jp13ebb.s[17]++;

                $rootScope.me = false;
                cov_1p3jp13ebb.s[18]++;
                $rootScope.cart = false;
            });
            cov_1p3jp13ebb.s[19]++;
            return logoutPromise;
        };
    }
})();
'use strict';

var cov_uu2hhxgev = function () {
    var path = '/home/lobo/repos/meetings-app/src/app/components/auth/auth.run.js',
        hash = '91188ef744dbacf0a9d781957c675be4538825b4',
        Function = function () {}.constructor,
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/meetings-app/src/app/components/auth/auth.run.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 25,
                    column: 5
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 4
                },
                end: {
                    line: 6,
                    column: 23
                }
            },
            '2': {
                start: {
                    line: 11,
                    column: 8
                },
                end: {
                    line: 15,
                    column: 11
                }
            },
            '3': {
                start: {
                    line: 12,
                    column: 12
                },
                end: {
                    line: 14,
                    column: 13
                }
            },
            '4': {
                start: {
                    line: 13,
                    column: 15
                },
                end: {
                    line: 13,
                    column: 34
                }
            },
            '5': {
                start: {
                    line: 17,
                    column: 8
                },
                end: {
                    line: 22,
                    column: 9
                }
            },
            '6': {
                start: {
                    line: 18,
                    column: 12
                },
                end: {
                    line: 21,
                    column: 15
                }
            },
            '7': {
                start: {
                    line: 20,
                    column: 16
                },
                end: {
                    line: 20,
                    column: 62
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 1,
                        column: 1
                    },
                    end: {
                        line: 1,
                        column: 2
                    }
                },
                loc: {
                    start: {
                        line: 1,
                        column: 13
                    },
                    end: {
                        line: 25,
                        column: 1
                    }
                },
                line: 1
            },
            '1': {
                name: 'runBlock',
                decl: {
                    start: {
                        line: 9,
                        column: 13
                    },
                    end: {
                        line: 9,
                        column: 21
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 76
                    },
                    end: {
                        line: 23,
                        column: 5
                    }
                },
                line: 9
            },
            '2': {
                name: '(anonymous_2)',
                decl: {
                    start: {
                        line: 11,
                        column: 33
                    },
                    end: {
                        line: 11,
                        column: 34
                    }
                },
                loc: {
                    start: {
                        line: 11,
                        column: 50
                    },
                    end: {
                        line: 15,
                        column: 9
                    }
                },
                line: 11
            },
            '3': {
                name: '(anonymous_3)',
                decl: {
                    start: {
                        line: 18,
                        column: 56
                    },
                    end: {
                        line: 18,
                        column: 57
                    }
                },
                loc: {
                    start: {
                        line: 18,
                        column: 68
                    },
                    end: {
                        line: 19,
                        column: 13
                    }
                },
                line: 18
            },
            '4': {
                name: '(anonymous_4)',
                decl: {
                    start: {
                        line: 19,
                        column: 15
                    },
                    end: {
                        line: 19,
                        column: 16
                    }
                },
                loc: {
                    start: {
                        line: 19,
                        column: 27
                    },
                    end: {
                        line: 21,
                        column: 13
                    }
                },
                line: 19
            }
        },
        branchMap: {
            '0': {
                loc: {
                    start: {
                        line: 12,
                        column: 12
                    },
                    end: {
                        line: 14,
                        column: 13
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 12,
                        column: 12
                    },
                    end: {
                        line: 14,
                        column: 13
                    }
                }, {
                    start: {
                        line: 12,
                        column: 12
                    },
                    end: {
                        line: 14,
                        column: 13
                    }
                }],
                line: 12
            },
            '1': {
                loc: {
                    start: {
                        line: 12,
                        column: 16
                    },
                    end: {
                        line: 12,
                        column: 201
                    }
                },
                type: 'binary-expr',
                locations: [{
                    start: {
                        line: 12,
                        column: 16
                    },
                    end: {
                        line: 12,
                        column: 30
                    }
                }, {
                    start: {
                        line: 12,
                        column: 35
                    },
                    end: {
                        line: 12,
                        column: 62
                    }
                }, {
                    start: {
                        line: 12,
                        column: 66
                    },
                    end: {
                        line: 12,
                        column: 94
                    }
                }, {
                    start: {
                        line: 12,
                        column: 98
                    },
                    end: {
                        line: 12,
                        column: 132
                    }
                }, {
                    start: {
                        line: 12,
                        column: 136
                    },
                    end: {
                        line: 12,
                        column: 166
                    }
                }, {
                    start: {
                        line: 12,
                        column: 170
                    },
                    end: {
                        line: 12,
                        column: 200
                    }
                }],
                line: 12
            },
            '2': {
                loc: {
                    start: {
                        line: 17,
                        column: 8
                    },
                    end: {
                        line: 22,
                        column: 9
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 17,
                        column: 8
                    },
                    end: {
                        line: 22,
                        column: 9
                    }
                }, {
                    start: {
                        line: 17,
                        column: 8
                    },
                    end: {
                        line: 22,
                        column: 9
                    }
                }],
                line: 17
            }
        },
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0,
            '7': 0
        },
        f: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0
        },
        b: {
            '0': [0, 0],
            '1': [0, 0, 0, 0, 0, 0],
            '2': [0, 0]
        },
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_uu2hhxgev.s[0]++;
(function () {
    'use strict';

    runBlock.$inject = ["$rootScope", "$state", "$auth", "AuthService", "$transitions"];
    cov_uu2hhxgev.f[0]++;
    cov_uu2hhxgev.s[1]++;
    angular.module('app').run(runBlock);

    /** @ngInject */
    function runBlock($rootScope, $state, $auth, AuthService, $transitions) {
        cov_uu2hhxgev.f[1]++;
        cov_uu2hhxgev.s[2]++;


        $transitions.onStart({}, function (trans) {
            cov_uu2hhxgev.f[2]++;
            cov_uu2hhxgev.s[3]++;

            if ((cov_uu2hhxgev.b[1][0]++, !$rootScope.me) && (cov_uu2hhxgev.b[1][1]++, trans.to().name !== 'login') && (cov_uu2hhxgev.b[1][2]++, trans.to().name !== 'forgot') && (cov_uu2hhxgev.b[1][3]++, trans.to().name !== 'set_password') && (cov_uu2hhxgev.b[1][4]++, trans.to().name !== 'register') && (cov_uu2hhxgev.b[1][5]++, trans.to().name !== 'activate')) {
                cov_uu2hhxgev.b[0][0]++;
                cov_uu2hhxgev.s[4]++;

                $state.go("login");
            } else {
                cov_uu2hhxgev.b[0][1]++;
            }
        });

        cov_uu2hhxgev.s[5]++;
        if ($auth.isAuthenticated()) {
            cov_uu2hhxgev.b[2][0]++;
            cov_uu2hhxgev.s[6]++;

            AuthService.refreshAuthenticatedInfo().then(function () {
                cov_uu2hhxgev.f[3]++;
            }, function () {
                cov_uu2hhxgev.f[4]++;
                cov_uu2hhxgev.s[7]++;

                AuthService.logout().then($state.go('login'));
            });
        } else {
            cov_uu2hhxgev.b[2][1]++;
        }
    }
})();
'use strict';

var cov_29t30s5osx = function () {
    var path = '/home/lobo/repos/meetings-app/src/app/components/auth/auth.register.controller.js',
        hash = '41a1484352dc324140cc93a155e24bc085463d4e',
        Function = function () {}.constructor,
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/meetings-app/src/app/components/auth/auth.register.controller.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 51,
                    column: 5
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 4
                },
                end: {
                    line: 6,
                    column: 66
                }
            },
            '2': {
                start: {
                    line: 10,
                    column: 17
                },
                end: {
                    line: 10,
                    column: 21
                }
            },
            '3': {
                start: {
                    line: 12,
                    column: 8
                },
                end: {
                    line: 12,
                    column: 30
                }
            },
            '4': {
                start: {
                    line: 13,
                    column: 8
                },
                end: {
                    line: 13,
                    column: 38
                }
            },
            '5': {
                start: {
                    line: 14,
                    column: 8
                },
                end: {
                    line: 14,
                    column: 32
                }
            },
            '6': {
                start: {
                    line: 15,
                    column: 8
                },
                end: {
                    line: 15,
                    column: 26
                }
            },
            '7': {
                start: {
                    line: 17,
                    column: 8
                },
                end: {
                    line: 17,
                    column: 31
                }
            },
            '8': {
                start: {
                    line: 18,
                    column: 8
                },
                end: {
                    line: 18,
                    column: 27
                }
            },
            '9': {
                start: {
                    line: 20,
                    column: 8
                },
                end: {
                    line: 20,
                    column: 19
                }
            },
            '10': {
                start: {
                    line: 27,
                    column: 12
                },
                end: {
                    line: 31,
                    column: 15
                }
            },
            '11': {
                start: {
                    line: 28,
                    column: 16
                },
                end: {
                    line: 28,
                    column: 39
                }
            },
            '12': {
                start: {
                    line: 30,
                    column: 16
                },
                end: {
                    line: 30,
                    column: 100
                }
            },
            '13': {
                start: {
                    line: 35,
                    column: 12
                },
                end: {
                    line: 48,
                    column: 15
                }
            },
            '14': {
                start: {
                    line: 42,
                    column: 16
                },
                end: {
                    line: 42,
                    column: 33
                }
            },
            '15': {
                start: {
                    line: 43,
                    column: 16
                },
                end: {
                    line: 43,
                    column: 98
                }
            },
            '16': {
                start: {
                    line: 44,
                    column: 16
                },
                end: {
                    line: 44,
                    column: 32
                }
            },
            '17': {
                start: {
                    line: 46,
                    column: 16
                },
                end: {
                    line: 46,
                    column: 99
                }
            },
            '18': {
                start: {
                    line: 47,
                    column: 16
                },
                end: {
                    line: 47,
                    column: 32
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 1,
                        column: 1
                    },
                    end: {
                        line: 1,
                        column: 2
                    }
                },
                loc: {
                    start: {
                        line: 1,
                        column: 13
                    },
                    end: {
                        line: 51,
                        column: 1
                    }
                },
                line: 1
            },
            '1': {
                name: 'AuthRegisterController',
                decl: {
                    start: {
                        line: 9,
                        column: 13
                    },
                    end: {
                        line: 9,
                        column: 35
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 78
                    },
                    end: {
                        line: 50,
                        column: 5
                    }
                },
                line: 9
            },
            '2': {
                name: 'activate',
                decl: {
                    start: {
                        line: 22,
                        column: 17
                    },
                    end: {
                        line: 22,
                        column: 25
                    }
                },
                loc: {
                    start: {
                        line: 22,
                        column: 28
                    },
                    end: {
                        line: 23,
                        column: 9
                    }
                },
                line: 22
            },
            '3': {
                name: 'register',
                decl: {
                    start: {
                        line: 26,
                        column: 17
                    },
                    end: {
                        line: 26,
                        column: 25
                    }
                },
                loc: {
                    start: {
                        line: 26,
                        column: 28
                    },
                    end: {
                        line: 32,
                        column: 9
                    }
                },
                line: 26
            },
            '4': {
                name: '(anonymous_4)',
                decl: {
                    start: {
                        line: 27,
                        column: 34
                    },
                    end: {
                        line: 27,
                        column: 35
                    }
                },
                loc: {
                    start: {
                        line: 27,
                        column: 46
                    },
                    end: {
                        line: 29,
                        column: 13
                    }
                },
                line: 27
            },
            '5': {
                name: '(anonymous_5)',
                decl: {
                    start: {
                        line: 29,
                        column: 15
                    },
                    end: {
                        line: 29,
                        column: 16
                    }
                },
                loc: {
                    start: {
                        line: 29,
                        column: 27
                    },
                    end: {
                        line: 31,
                        column: 13
                    }
                },
                line: 29
            },
            '6': {
                name: 'resend',
                decl: {
                    start: {
                        line: 34,
                        column: 17
                    },
                    end: {
                        line: 34,
                        column: 23
                    }
                },
                loc: {
                    start: {
                        line: 34,
                        column: 26
                    },
                    end: {
                        line: 49,
                        column: 9
                    }
                },
                line: 34
            },
            '7': {
                name: 'successCallback',
                decl: {
                    start: {
                        line: 41,
                        column: 29
                    },
                    end: {
                        line: 41,
                        column: 44
                    }
                },
                loc: {
                    start: {
                        line: 41,
                        column: 55
                    },
                    end: {
                        line: 45,
                        column: 13
                    }
                },
                line: 41
            },
            '8': {
                name: '(anonymous_8)',
                decl: {
                    start: {
                        line: 45,
                        column: 15
                    },
                    end: {
                        line: 45,
                        column: 16
                    }
                },
                loc: {
                    start: {
                        line: 45,
                        column: 35
                    },
                    end: {
                        line: 48,
                        column: 13
                    }
                },
                line: 45
            }
        },
        branchMap: {},
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0,
            '7': 0,
            '8': 0,
            '9': 0,
            '10': 0,
            '11': 0,
            '12': 0,
            '13': 0,
            '14': 0,
            '15': 0,
            '16': 0,
            '17': 0,
            '18': 0
        },
        f: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0,
            '7': 0,
            '8': 0
        },
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_29t30s5osx.s[0]++;
(function () {
    'use strict';

    AuthRegisterController.$inject = ["UsersTable", "$mdToast", "$http", "AppSettings"];
    cov_29t30s5osx.f[0]++;
    cov_29t30s5osx.s[1]++;
    angular.module('app').controller('AuthRegisterController', AuthRegisterController);

    /* @ngInject */
    function AuthRegisterController(UsersTable, $mdToast, $http, AppSettings) {
        cov_29t30s5osx.f[1]++;

        var vm = (cov_29t30s5osx.s[2]++, this);

        cov_29t30s5osx.s[3]++;
        vm.registering = true;
        cov_29t30s5osx.s[4]++;
        vm.user = UsersTable.$build();
        cov_29t30s5osx.s[5]++;
        vm.resendStatus = false;
        cov_29t30s5osx.s[6]++;
        vm.resent = false;

        cov_29t30s5osx.s[7]++;
        vm.register = register;
        cov_29t30s5osx.s[8]++;
        vm.resend = resend;

        cov_29t30s5osx.s[9]++;
        activate();

        function activate() {
            cov_29t30s5osx.f[2]++;
        }

        function register() {
            cov_29t30s5osx.f[3]++;
            cov_29t30s5osx.s[10]++;

            vm.user.$save().$then(function () {
                cov_29t30s5osx.f[4]++;
                cov_29t30s5osx.s[11]++;

                vm.registering = false;
            }, function () {
                cov_29t30s5osx.f[5]++;
                cov_29t30s5osx.s[12]++;

                $mdToast.show($mdToast.simple().textContent('Please fill in all required fields!'));
            });
        }

        function resend() {
            cov_29t30s5osx.f[6]++;
            cov_29t30s5osx.s[13]++;

            vm.resendStatus = $http({
                method: 'POST',
                url: AppSettings.apiUrl + '/users/resend_verification_email/',
                data: {
                    email: vm.user.email
                }
            }).then(function successCallback(response) {
                cov_29t30s5osx.f[7]++;
                cov_29t30s5osx.s[14]++;

                vm.resent = true;
                cov_29t30s5osx.s[15]++;
                $mdToast.show($mdToast.simple().textContent('We sent an email to your account!'));
                cov_29t30s5osx.s[16]++;
                return response;
            }, function (response) {
                cov_29t30s5osx.f[8]++;
                cov_29t30s5osx.s[17]++;

                $mdToast.show($mdToast.simple().textContent(response.data['non_field_errors'][0]));
                cov_29t30s5osx.s[18]++;
                return response;
            });
        }
    }
})();
'use strict';

var cov_1tnffrk175 = function () {
    var path = '/home/lobo/repos/meetings-app/src/app/components/auth/auth.logout.controller.js',
        hash = 'd749da350f0982afcdd2657a4e0f73b7f2f0c96c',
        Function = function () {}.constructor,
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/meetings-app/src/app/components/auth/auth.logout.controller.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 28,
                    column: 5
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 4
                },
                end: {
                    line: 6,
                    column: 56
                }
            },
            '2': {
                start: {
                    line: 10,
                    column: 17
                },
                end: {
                    line: 10,
                    column: 21
                }
            },
            '3': {
                start: {
                    line: 11,
                    column: 8
                },
                end: {
                    line: 11,
                    column: 28
                }
            },
            '4': {
                start: {
                    line: 12,
                    column: 8
                },
                end: {
                    line: 12,
                    column: 27
                }
            },
            '5': {
                start: {
                    line: 14,
                    column: 8
                },
                end: {
                    line: 14,
                    column: 19
                }
            },
            '6': {
                start: {
                    line: 17,
                    column: 12
                },
                end: {
                    line: 17,
                    column: 24
                }
            },
            '7': {
                start: {
                    line: 21,
                    column: 12
                },
                end: {
                    line: 24,
                    column: 15
                }
            },
            '8': {
                start: {
                    line: 22,
                    column: 16
                },
                end: {
                    line: 22,
                    column: 57
                }
            },
            '9': {
                start: {
                    line: 23,
                    column: 16
                },
                end: {
                    line: 23,
                    column: 35
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 1,
                        column: 1
                    },
                    end: {
                        line: 1,
                        column: 2
                    }
                },
                loc: {
                    start: {
                        line: 1,
                        column: 13
                    },
                    end: {
                        line: 28,
                        column: 1
                    }
                },
                line: 1
            },
            '1': {
                name: 'Controller',
                decl: {
                    start: {
                        line: 9,
                        column: 13
                    },
                    end: {
                        line: 9,
                        column: 23
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 57
                    },
                    end: {
                        line: 27,
                        column: 5
                    }
                },
                line: 9
            },
            '2': {
                name: 'activate',
                decl: {
                    start: {
                        line: 16,
                        column: 17
                    },
                    end: {
                        line: 16,
                        column: 25
                    }
                },
                loc: {
                    start: {
                        line: 16,
                        column: 28
                    },
                    end: {
                        line: 18,
                        column: 9
                    }
                },
                line: 16
            },
            '3': {
                name: 'logout',
                decl: {
                    start: {
                        line: 20,
                        column: 17
                    },
                    end: {
                        line: 20,
                        column: 23
                    }
                },
                loc: {
                    start: {
                        line: 20,
                        column: 26
                    },
                    end: {
                        line: 25,
                        column: 9
                    }
                },
                line: 20
            },
            '4': {
                name: '(anonymous_4)',
                decl: {
                    start: {
                        line: 21,
                        column: 38
                    },
                    end: {
                        line: 21,
                        column: 39
                    }
                },
                loc: {
                    start: {
                        line: 21,
                        column: 49
                    },
                    end: {
                        line: 24,
                        column: 13
                    }
                },
                line: 21
            }
        },
        branchMap: {},
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0,
            '7': 0,
            '8': 0,
            '9': 0
        },
        f: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0
        },
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_1tnffrk175.s[0]++;
(function () {
    'use strict';

    Controller.$inject = ["$rootScope", "$state", "AuthService"];
    cov_1tnffrk175.f[0]++;
    cov_1tnffrk175.s[1]++;
    angular.module('app').controller('AuthLogoutController', Controller);

    /* @ngInject */
    function Controller($rootScope, $state, AuthService) {
        cov_1tnffrk175.f[1]++;

        var vm = (cov_1tnffrk175.s[2]++, this);
        cov_1tnffrk175.s[3]++;
        vm.title = 'Logout';
        cov_1tnffrk175.s[4]++;
        vm.logout = logout;

        cov_1tnffrk175.s[5]++;
        activate();

        function activate() {
            cov_1tnffrk175.f[2]++;
            cov_1tnffrk175.s[6]++;

            vm.logout();
        }

        function logout() {
            cov_1tnffrk175.f[3]++;
            cov_1tnffrk175.s[7]++;

            AuthService.logout().then(function () {
                cov_1tnffrk175.f[4]++;
                cov_1tnffrk175.s[8]++;

                $rootScope.profileMenuPageActive = false;
                cov_1tnffrk175.s[9]++;
                $state.go('login');
            });
        }
    }
})();
'use strict';

var cov_84hv59vtw = function () {
    var path = '/home/lobo/repos/meetings-app/src/app/components/auth/auth.login.controller.js',
        hash = '4ad5a9943bbc734171e66488e797b460cde99a07',
        Function = function () {}.constructor,
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/meetings-app/src/app/components/auth/auth.login.controller.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 40,
                    column: 5
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 4
                },
                end: {
                    line: 6,
                    column: 51
                }
            },
            '2': {
                start: {
                    line: 10,
                    column: 17
                },
                end: {
                    line: 10,
                    column: 21
                }
            },
            '3': {
                start: {
                    line: 11,
                    column: 8
                },
                end: {
                    line: 11,
                    column: 25
                }
            },
            '4': {
                start: {
                    line: 13,
                    column: 8
                },
                end: {
                    line: 13,
                    column: 30
                }
            },
            '5': {
                start: {
                    line: 15,
                    column: 8
                },
                end: {
                    line: 15,
                    column: 19
                }
            },
            '6': {
                start: {
                    line: 21,
                    column: 12
                },
                end: {
                    line: 25,
                    column: 15
                }
            },
            '7': {
                start: {
                    line: 22,
                    column: 16
                },
                end: {
                    line: 22,
                    column: 29
                }
            },
            '8': {
                start: {
                    line: 24,
                    column: 16
                },
                end: {
                    line: 24,
                    column: 34
                }
            },
            '9': {
                start: {
                    line: 29,
                    column: 12
                },
                end: {
                    line: 29,
                    column: 33
                }
            },
            '10': {
                start: {
                    line: 33,
                    column: 12
                },
                end: {
                    line: 33,
                    column: 40
                }
            },
            '11': {
                start: {
                    line: 34,
                    column: 12
                },
                end: {
                    line: 36,
                    column: 15
                }
            },
            '12': {
                start: {
                    line: 35,
                    column: 16
                },
                end: {
                    line: 35,
                    column: 42
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 1,
                        column: 1
                    },
                    end: {
                        line: 1,
                        column: 2
                    }
                },
                loc: {
                    start: {
                        line: 1,
                        column: 13
                    },
                    end: {
                        line: 40,
                        column: 1
                    }
                },
                line: 1
            },
            '1': {
                name: 'Controller',
                decl: {
                    start: {
                        line: 9,
                        column: 13
                    },
                    end: {
                        line: 9,
                        column: 23
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 72
                    },
                    end: {
                        line: 39,
                        column: 5
                    }
                },
                line: 9
            },
            '2': {
                name: 'activate',
                decl: {
                    start: {
                        line: 17,
                        column: 17
                    },
                    end: {
                        line: 17,
                        column: 25
                    }
                },
                loc: {
                    start: {
                        line: 17,
                        column: 29
                    },
                    end: {
                        line: 18,
                        column: 9
                    }
                },
                line: 17
            },
            '3': {
                name: 'login',
                decl: {
                    start: {
                        line: 20,
                        column: 17
                    },
                    end: {
                        line: 20,
                        column: 22
                    }
                },
                loc: {
                    start: {
                        line: 20,
                        column: 26
                    },
                    end: {
                        line: 26,
                        column: 9
                    }
                },
                line: 20
            },
            '4': {
                name: '(anonymous_4)',
                decl: {
                    start: {
                        line: 21,
                        column: 58
                    },
                    end: {
                        line: 21,
                        column: 59
                    }
                },
                loc: {
                    start: {
                        line: 21,
                        column: 76
                    },
                    end: {
                        line: 23,
                        column: 13
                    }
                },
                line: 21
            },
            '5': {
                name: '(anonymous_5)',
                decl: {
                    start: {
                        line: 23,
                        column: 15
                    },
                    end: {
                        line: 23,
                        column: 16
                    }
                },
                loc: {
                    start: {
                        line: 23,
                        column: 32
                    },
                    end: {
                        line: 25,
                        column: 13
                    }
                },
                line: 23
            },
            '6': {
                name: 'logout',
                decl: {
                    start: {
                        line: 28,
                        column: 17
                    },
                    end: {
                        line: 28,
                        column: 23
                    }
                },
                loc: {
                    start: {
                        line: 28,
                        column: 27
                    },
                    end: {
                        line: 30,
                        column: 9
                    }
                },
                line: 28
            },
            '7': {
                name: 'afterLogin',
                decl: {
                    start: {
                        line: 32,
                        column: 17
                    },
                    end: {
                        line: 32,
                        column: 27
                    }
                },
                loc: {
                    start: {
                        line: 32,
                        column: 31
                    },
                    end: {
                        line: 37,
                        column: 9
                    }
                },
                line: 32
            },
            '8': {
                name: '(anonymous_8)',
                decl: {
                    start: {
                        line: 34,
                        column: 32
                    },
                    end: {
                        line: 34,
                        column: 33
                    }
                },
                loc: {
                    start: {
                        line: 34,
                        column: 44
                    },
                    end: {
                        line: 36,
                        column: 13
                    }
                },
                line: 34
            }
        },
        branchMap: {},
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0,
            '7': 0,
            '8': 0,
            '9': 0,
            '10': 0,
            '11': 0,
            '12': 0
        },
        f: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0,
            '7': 0,
            '8': 0
        },
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_84hv59vtw.s[0]++;
(function () {
    'use strict';

    Controller.$inject = ["$state", "AuthService", "$rootScope", "$stateParams"];
    cov_84hv59vtw.f[0]++;
    cov_84hv59vtw.s[1]++;
    angular.module('app').controller('AuthLoginController', Controller);

    /* @ngInject */
    function Controller($state, AuthService, $rootScope, $stateParams) {
        cov_84hv59vtw.f[1]++;

        var vm = (cov_84hv59vtw.s[2]++, this);
        cov_84hv59vtw.s[3]++;
        vm.login = login;

        cov_84hv59vtw.s[4]++;
        vm.authenticated = {};

        cov_84hv59vtw.s[5]++;
        activate();

        function activate() {
            cov_84hv59vtw.f[2]++;
        }

        function login() {
            cov_84hv59vtw.f[3]++;
            cov_84hv59vtw.s[6]++;

            AuthService.login(vm.email, vm.password).then(function (result) {
                cov_84hv59vtw.f[4]++;
                cov_84hv59vtw.s[7]++;

                afterLogin();
            }, function (error) {
                cov_84hv59vtw.f[5]++;
                cov_84hv59vtw.s[8]++;

                vm.member = error;
            });
        }

        function logout() {
            cov_84hv59vtw.f[6]++;
            cov_84hv59vtw.s[9]++;

            AuthService.logout();
        }

        function afterLogin() {
            cov_84hv59vtw.f[7]++;
            cov_84hv59vtw.s[10]++;

            $rootScope.loadStaticData();
            cov_84hv59vtw.s[11]++;
            $rootScope.me.$then(function () {
                cov_84hv59vtw.f[8]++;
                cov_84hv59vtw.s[12]++;

                $state.go('meetingsList');
            });
        }
    }
})();
'use strict';

var cov_2alx57we5s = function () {
    var path = '/home/lobo/repos/meetings-app/src/app/components/auth/auth.forgot.controller.js',
        hash = 'f05c54f0c5a616c1d6665de4952288410a88c144',
        Function = function () {}.constructor,
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/meetings-app/src/app/components/auth/auth.forgot.controller.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 35,
                    column: 5
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 4
                },
                end: {
                    line: 6,
                    column: 66
                }
            },
            '2': {
                start: {
                    line: 10,
                    column: 17
                },
                end: {
                    line: 10,
                    column: 21
                }
            },
            '3': {
                start: {
                    line: 12,
                    column: 8
                },
                end: {
                    line: 12,
                    column: 30
                }
            },
            '4': {
                start: {
                    line: 14,
                    column: 8
                },
                end: {
                    line: 14,
                    column: 41
                }
            },
            '5': {
                start: {
                    line: 16,
                    column: 8
                },
                end: {
                    line: 16,
                    column: 19
                }
            },
            '6': {
                start: {
                    line: 22,
                    column: 12
                },
                end: {
                    line: 32,
                    column: 15
                }
            },
            '7': {
                start: {
                    line: 29,
                    column: 16
                },
                end: {
                    line: 29,
                    column: 32
                }
            },
            '8': {
                start: {
                    line: 31,
                    column: 16
                },
                end: {
                    line: 31,
                    column: 32
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 1,
                        column: 1
                    },
                    end: {
                        line: 1,
                        column: 2
                    }
                },
                loc: {
                    start: {
                        line: 1,
                        column: 13
                    },
                    end: {
                        line: 35,
                        column: 1
                    }
                },
                line: 1
            },
            '1': {
                name: 'AuthForgotController',
                decl: {
                    start: {
                        line: 9,
                        column: 13
                    },
                    end: {
                        line: 9,
                        column: 33
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 54
                    },
                    end: {
                        line: 34,
                        column: 5
                    }
                },
                line: 9
            },
            '2': {
                name: 'activate',
                decl: {
                    start: {
                        line: 18,
                        column: 17
                    },
                    end: {
                        line: 18,
                        column: 25
                    }
                },
                loc: {
                    start: {
                        line: 18,
                        column: 28
                    },
                    end: {
                        line: 19,
                        column: 9
                    }
                },
                line: 18
            },
            '3': {
                name: 'requestChange',
                decl: {
                    start: {
                        line: 21,
                        column: 17
                    },
                    end: {
                        line: 21,
                        column: 30
                    }
                },
                loc: {
                    start: {
                        line: 21,
                        column: 33
                    },
                    end: {
                        line: 33,
                        column: 9
                    }
                },
                line: 21
            },
            '4': {
                name: 'successCallback',
                decl: {
                    start: {
                        line: 28,
                        column: 29
                    },
                    end: {
                        line: 28,
                        column: 44
                    }
                },
                loc: {
                    start: {
                        line: 28,
                        column: 55
                    },
                    end: {
                        line: 30,
                        column: 13
                    }
                },
                line: 28
            },
            '5': {
                name: '(anonymous_5)',
                decl: {
                    start: {
                        line: 30,
                        column: 15
                    },
                    end: {
                        line: 30,
                        column: 16
                    }
                },
                loc: {
                    start: {
                        line: 30,
                        column: 35
                    },
                    end: {
                        line: 32,
                        column: 13
                    }
                },
                line: 30
            }
        },
        branchMap: {},
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0,
            '7': 0,
            '8': 0
        },
        f: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0
        },
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_2alx57we5s.s[0]++;
(function () {
    'use strict';

    AuthForgotController.$inject = ["$http", "AppSettings"];
    cov_2alx57we5s.f[0]++;
    cov_2alx57we5s.s[1]++;
    angular.module('app').controller('AuthForgotController', AuthForgotController);

    /* @ngInject */
    function AuthForgotController($http, AppSettings) {
        cov_2alx57we5s.f[1]++;

        var vm = (cov_2alx57we5s.s[2]++, this);

        cov_2alx57we5s.s[3]++;
        vm.requestStatus = {};

        cov_2alx57we5s.s[4]++;
        vm.requestChange = requestChange;

        cov_2alx57we5s.s[5]++;
        activate();

        function activate() {
            cov_2alx57we5s.f[2]++;
        }

        function requestChange() {
            cov_2alx57we5s.f[3]++;
            cov_2alx57we5s.s[6]++;

            vm.requestStatus = $http({
                method: 'POST',
                url: AppSettings.apiUrl + '/users/reset_password/',
                data: {
                    email: vm.email
                }
            }).then(function successCallback(response) {
                cov_2alx57we5s.f[4]++;
                cov_2alx57we5s.s[7]++;

                return response;
            }, function (response) {
                cov_2alx57we5s.f[5]++;
                cov_2alx57we5s.s[8]++;

                return response;
            });
        }
    }
})();
'use strict';

var cov_2122wmzekt = function () {
    var path = '/home/lobo/repos/meetings-app/src/app/components/auth/auth.config.js',
        hash = '7d571084ed1b4c9ddda00092bdebd431ad780c76',
        Function = function () {}.constructor,
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/meetings-app/src/app/components/auth/auth.config.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 14,
                    column: 5
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 4
                },
                end: {
                    line: 6,
                    column: 24
                }
            },
            '2': {
                start: {
                    line: 10,
                    column: 8
                },
                end: {
                    line: 10,
                    column: 51
                }
            },
            '3': {
                start: {
                    line: 12,
                    column: 8
                },
                end: {
                    line: 12,
                    column: 52
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 1,
                        column: 1
                    },
                    end: {
                        line: 1,
                        column: 2
                    }
                },
                loc: {
                    start: {
                        line: 1,
                        column: 13
                    },
                    end: {
                        line: 14,
                        column: 1
                    }
                },
                line: 1
            },
            '1': {
                name: 'Config',
                decl: {
                    start: {
                        line: 9,
                        column: 13
                    },
                    end: {
                        line: 9,
                        column: 19
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 48
                    },
                    end: {
                        line: 13,
                        column: 5
                    }
                },
                line: 9
            }
        },
        branchMap: {},
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0
        },
        f: {
            '0': 0,
            '1': 0
        },
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_2122wmzekt.s[0]++;
(function () {
    'use strict';

    Config.$inject = ["$authProvider", "AppSettings"];
    cov_2122wmzekt.f[0]++;
    cov_2122wmzekt.s[1]++;
    angular.module('app').config(Config);

    /* @ngInject */
    function Config($authProvider, AppSettings) {
        cov_2122wmzekt.f[1]++;
        cov_2122wmzekt.s[2]++;

        $authProvider.baseUrl = AppSettings.apiUrl;

        cov_2122wmzekt.s[3]++;
        $authProvider.loginUrl = '/api-token-auth/';
    }
})();
'use strict';

var cov_lelujn63z = function () {
    var path = '/home/lobo/repos/meetings-app/src/app/components/auth/auth.activate.controller.js',
        hash = '74028529a67fd761d9d1933779740705aa1f60e4',
        Function = function () {}.constructor,
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/meetings-app/src/app/components/auth/auth.activate.controller.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 40,
                    column: 5
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 4
                },
                end: {
                    line: 6,
                    column: 66
                }
            },
            '2': {
                start: {
                    line: 10,
                    column: 17
                },
                end: {
                    line: 10,
                    column: 21
                }
            },
            '3': {
                start: {
                    line: 12,
                    column: 8
                },
                end: {
                    line: 12,
                    column: 19
                }
            },
            '4': {
                start: {
                    line: 15,
                    column: 12
                },
                end: {
                    line: 17,
                    column: 13
                }
            },
            '5': {
                start: {
                    line: 16,
                    column: 16
                },
                end: {
                    line: 16,
                    column: 31
                }
            },
            '6': {
                start: {
                    line: 18,
                    column: 12
                },
                end: {
                    line: 37,
                    column: 15
                }
            },
            '7': {
                start: {
                    line: 22,
                    column: 16
                },
                end: {
                    line: 26,
                    column: 18
                }
            },
            '8': {
                start: {
                    line: 27,
                    column: 16
                },
                end: {
                    line: 29,
                    column: 19
                }
            },
            '9': {
                start: {
                    line: 28,
                    column: 20
                },
                end: {
                    line: 28,
                    column: 65
                }
            },
            '10': {
                start: {
                    line: 31,
                    column: 16
                },
                end: {
                    line: 35,
                    column: 18
                }
            },
            '11': {
                start: {
                    line: 36,
                    column: 16
                },
                end: {
                    line: 36,
                    column: 35
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 1,
                        column: 1
                    },
                    end: {
                        line: 1,
                        column: 2
                    }
                },
                loc: {
                    start: {
                        line: 1,
                        column: 13
                    },
                    end: {
                        line: 40,
                        column: 1
                    }
                },
                line: 1
            },
            '1': {
                name: 'AuthActivateController',
                decl: {
                    start: {
                        line: 9,
                        column: 13
                    },
                    end: {
                        line: 9,
                        column: 35
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 100
                    },
                    end: {
                        line: 39,
                        column: 5
                    }
                },
                line: 9
            },
            '2': {
                name: 'activate',
                decl: {
                    start: {
                        line: 14,
                        column: 17
                    },
                    end: {
                        line: 14,
                        column: 25
                    }
                },
                loc: {
                    start: {
                        line: 14,
                        column: 28
                    },
                    end: {
                        line: 38,
                        column: 9
                    }
                },
                line: 14
            },
            '3': {
                name: 'successCallback',
                decl: {
                    start: {
                        line: 21,
                        column: 29
                    },
                    end: {
                        line: 21,
                        column: 44
                    }
                },
                loc: {
                    start: {
                        line: 21,
                        column: 47
                    },
                    end: {
                        line: 30,
                        column: 13
                    }
                },
                line: 21
            },
            '4': {
                name: '(anonymous_4)',
                decl: {
                    start: {
                        line: 27,
                        column: 47
                    },
                    end: {
                        line: 27,
                        column: 48
                    }
                },
                loc: {
                    start: {
                        line: 27,
                        column: 59
                    },
                    end: {
                        line: 29,
                        column: 17
                    }
                },
                line: 27
            },
            '5': {
                name: '(anonymous_5)',
                decl: {
                    start: {
                        line: 30,
                        column: 15
                    },
                    end: {
                        line: 30,
                        column: 16
                    }
                },
                loc: {
                    start: {
                        line: 30,
                        column: 27
                    },
                    end: {
                        line: 37,
                        column: 13
                    }
                },
                line: 30
            }
        },
        branchMap: {
            '0': {
                loc: {
                    start: {
                        line: 15,
                        column: 12
                    },
                    end: {
                        line: 17,
                        column: 13
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 15,
                        column: 12
                    },
                    end: {
                        line: 17,
                        column: 13
                    }
                }, {
                    start: {
                        line: 15,
                        column: 12
                    },
                    end: {
                        line: 17,
                        column: 13
                    }
                }],
                line: 15
            }
        },
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0,
            '7': 0,
            '8': 0,
            '9': 0,
            '10': 0,
            '11': 0
        },
        f: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0
        },
        b: {
            '0': [0, 0]
        },
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_lelujn63z.s[0]++;
(function () {
    'use strict';

    AuthActivateController.$inject = ["$http", "$state", "$stateParams", "AppSettings", "$mdToast", "$rootScope"];
    cov_lelujn63z.f[0]++;
    cov_lelujn63z.s[1]++;
    angular.module('app').controller('AuthActivateController', AuthActivateController);

    /* @ngInject */
    function AuthActivateController($http, $state, $stateParams, AppSettings, $mdToast, $rootScope) {
        cov_lelujn63z.f[1]++;

        var vm = (cov_lelujn63z.s[2]++, this);

        cov_lelujn63z.s[3]++;
        activate();

        function activate() {
            cov_lelujn63z.f[2]++;
            cov_lelujn63z.s[4]++;

            if (!$stateParams.token) {
                cov_lelujn63z.b[0][0]++;
                cov_lelujn63z.s[5]++;

                $state.go('/');
            } else {
                cov_lelujn63z.b[0][1]++;
            }
            cov_lelujn63z.s[6]++;
            vm.requestStatus = $http({
                method: 'GET',
                url: AppSettings.apiUrl + '/users/activate/?token=' + $stateParams.token
            }).then(function successCallback() {
                cov_lelujn63z.f[3]++;
                cov_lelujn63z.s[7]++;

                $mdToast.show($mdToast.simple().textContent('Your account has been activated!').hideDelay(3000));
                cov_lelujn63z.s[8]++;
                $state.go('projectsList').then(function () {
                    cov_lelujn63z.f[4]++;
                    cov_lelujn63z.s[9]++;

                    $rootScope.openHeaderPage('loginPageActive');
                });
            }, function () {
                cov_lelujn63z.f[5]++;
                cov_lelujn63z.s[10]++;

                $mdToast.show($mdToast.simple().textContent('Activation error!').hideDelay(3000));
                cov_lelujn63z.s[11]++;
                $state.go('login');
            });
        }
    }
})();
angular.module("app").run(["$templateCache", function($templateCache) {$templateCache.put("app/components/createMeetingModal/createMeetingModal.html","<md-dialog aria-label=\"List dialog\">\n    <md-dialog-content class=\"md-dialog-content\" cg-busy=\"newMeeting.$promise\">\n\n        <form name=\"meetingModal\">\n            <div layout=\"column\">\n                <div layout=\"row\" layout-align=\"center center\" style=\"margin-bottom: 20px\">\n                    <h1 style=\"margin: 0\">Create new meeting</h1>\n                    <span flex></span>\n                    <md-button ng-click=\"closeDialog()\" class=\"md-icon-button\" style=\"margin-left: 20px\">\n                        <md-icon>close</md-icon>\n                    </md-button>\n                </div>\n                <md-input-container class=\"md-block\">\n                    <label>Execution name</label>\n                    <input type=\"text\" name=\"meetingName\" ng-model=\"newMeeting.name\" maxlength=\"50\" required>\n                </md-input-container>\n\n                <md-input-container>\n                    <label>Schedule date</label>\n                    <input type=\"datetime-local\" ng-model=\"newMeeting.scheduleDate\">\n                </md-input-container>\n\n                <md-input-container>\n                    <label>Duration</label>\n                    <input type=\"text\" ng-model=\"duration\" ui-mask=\"99:99\" model-view-value=\"true\" ui-mask-placeholder ui-mask-placeholder-char=\"0\">\n                </md-input-container>\n\n                <br> <br>\n\n                <div layout=\"row\" layout-align=\"center center\">\n                    <md-button ng-disabled=\"!meetingModal.meetingName.$valid\" class=\"md-raised md-accent\" ng-click=\"createMeeting()\">Create Meeting</md-button>\n                </div>\n            </div>\n        </form>\n    </md-dialog-content>\n</md-dialog>\n");
$templateCache.put("app/components/createProjectModal/createProjectModal.html","<md-dialog aria-label=\"List dialog\">\n    <md-dialog-content class=\"md-dialog-content\" cg-busy=\"newProject.$promise\">\n\n        <div layout=\"row\" layout-align=\"center center\" style=\"margin-bottom: 20px\">\n            <h1 style=\"margin: 0\">Create new project</h1>\n            <span flex></span>\n            <md-button ng-click=\"closeDialog()\" class=\"md-icon-button\" style=\"margin-left: 20px\">\n                <md-icon>close</md-icon>\n            </md-button>\n        </div>\n\n        <md-input-container class=\"md-block\">\n            <label>Project name</label>\n            <input type=\"text\" ng-model=\"newProject.name\" maxlength=\"50\">\n        </md-input-container>\n\n        <div layout=\"row\" layout-align=\"center center\">\n            <md-button class=\"md-raised md-accent\" ng-click=\"createProject()\">Create project</md-button>\n        </div>\n\n    </md-dialog-content>\n</md-dialog>\n");
$templateCache.put("app/components/createTemplateModal/createTemplateModal.html","<md-dialog aria-label=\"List dialog\">\n    <md-dialog-content class=\"md-dialog-content\" cg-busy=\"newTemplate.$promise\">\n\n        <div layout=\"row\" layout-align=\"center center\" style=\"margin-bottom: 20px\">\n            <h1 style=\"margin: 0\">Create new template</h1>\n            <span flex></span>\n            <md-button ng-click=\"closeDialog()\" class=\"md-icon-button\" style=\"margin-left: 20px\">\n                <md-icon>close</md-icon>\n            </md-button>\n        </div>\n\n        <md-input-container class=\"md-block\">\n            <label>Template name</label>\n            <input type=\"text\" ng-model=\"newTemplate.name\" maxlength=\"50\">\n        </md-input-container>\n\n        <div layout=\"row\" layout-align=\"center center\">\n            <md-button class=\"md-raised md-accent\" ng-click=\"createTemplate()\">Create template</md-button>\n        </div>\n\n    </md-dialog-content>\n</md-dialog>\n");
$templateCache.put("app/components/editProfile/editProfile.html","<maintoolbar></maintoolbar>\n\n<md-content>\n    <div class=\"\" layout=\"column\" layout-gt-xs=\"row\" layout-margin>\n        <md-card flex=\"50\" style=\"min-width: 250px\">\n            <md-card-content cg-busy=\"$ctrl.user.$promise\">\n                <h1 class=\"text-center text-fade\">Personal information</h1>\n                <br>\n                <div layout=\"row\" layout-align=\"center center\">\n                    <img ng-src=\"{{$ctrl.user.avatar | mediaUrl}}\" style=\"max-width:200px; max-height: 200px; border-radius: 600px\">\n                </div>\n                <br>\n                <div layout=\"row\" layout-align=\"center center\">\n                    <div id=\"change-avatar-area\" layout=\"row\" layout-align=\"center center\">\n                        <md-button class=\"change-avatar-btn md-raised md-accent\" layout=\"row\" layout-align=\"center center\" ngf-select media-auto-upload ng-model=\"$ctrl.fileUpload\" ngf-model-invalid=\"$ctrl.invalidUploadedFiles\" ngf-resize=\"{ratio: \'1:1\', centerCrop: true}\" ngf-max-size=\"2MB\" accept=\"image/*\">\n                            Change avatar\n                        </md-button>\n                    </div>\n                </div>\n                <md-input-container class=\"md-block\">\n                    <label>Name</label>\n                    <input type=\"text\" ng-model=\"$ctrl.user.name\" minlength=\"3\" ng-model-options=\"{\'*\': \'$inherit\'}\" ng-change=\"$ctrl.changeInfo()\">\n                    <div ng-messages>\n                        <div ng-repeat=\"message in $ctrl.user.$response.data.name\">\n                            {{message}}\n                        </div>\n                    </div>\n                </md-input-container>\n                <md-input-container class=\"md-block\">\n                    <label>Email</label>\n                    <input type=\"email\" ng-model=\"$ctrl.user.email\" disabled=\"disabled\">\n                    <div ng-messages>\n                        <div ng-repeat=\"message in $ctrl.user.$response.data.email\">\n                            {{message}}\n                        </div>\n                    </div>\n                </md-input-container>\n            </md-card-content>\n        </md-card>\n        <br>\n        <div flex=\"50\">\n            <md-card>\n                <md-card-content>\n                    <form ng-submit=\"$ctrl.changePass()\">\n                        <h1 class=\"text-center text-fade\">Change password</h1>\n                        <br>\n                        <md-input-container class=\"md-block\">\n                            <label>Password</label>\n                            <input type=\"password\" ng-model=\"$ctrl.user.password\" minlength=\"6\">\n                        </md-input-container>\n                        <md-input-container class=\"md-block\">\n                            <label>Confirm password</label>\n                            <input type=\"password\" ng-model=\"$ctrl.user.confirm_password\">\n                        </md-input-container>\n\n                        <div layout=\"row\" layout-align=\"center\">\n                            <input type=\"submit\" class=\"md-button md-raised md-accent\" value=\"Change\">\n                        </div>\n                    </form>\n                </md-card-content>\n            </md-card>\n        </div>\n    </div>\n</md-content>\n\n");
$templateCache.put("app/components/meetingDetails/meetingDetails.html","<md-toolbar>\n    <div class=\"md-toolbar-tools\">\n        <div layout=\"row\" layout-align=\"center center\" style=\"width: 100%\">\n            <md-button class=\"md-icon-button\" ui-sref=\"meetingsList\" layout=\"column\" layout-align=\"center center\">\n                <md-icon>arrow_back</md-icon>\n            </md-button>\n            <div layout=\"column\" flex>\n                <md-input-container>\n                    <input type=\"text\" ng-model=\"$ctrl.meeting.name\" ng-change=\"$ctrl.meeting.$save([\'name\'])\" aria-label=\"Name\">\n                </md-input-container>\n            </div>\n            <div layout=\"column\">\n                <project-selector class=\"meeting-project\" ng-model=\"$ctrl.meeting.project\" ng-change=\"$ctrl.meeting.project = $project; $ctrl.meeting.$save([\'project\'])\"></project-selector>\n            </div>\n            <div layout=\"column\">\n                <md-input-container>\n                    <input type=\"datetime-local\" ng-model=\"$ctrl.meeting.scheduleDate\" ng-change=\"$ctrl.meeting.$save([\'scheduleDate\'])\" style=\"max-width: 210px\" aria-label=\"Schedule Date\">\n                </md-input-container>\n            </div>\n            <div layout=\"column\">\n                <md-input-container>\n                    <input type=\"text\" ng-model=\"$ctrl.duration\" ui-mask=\"99:99\" model-view-value=\"true\" ui-mask-placeholder ui-mask-placeholder-char=\"0\" ui-options=\"{clearOnBlur: false}\" ng-change=\"$ctrl.editDuration()\" style=\"max-width: 60px\" aria-label=\"Duration\">\n                </md-input-container>\n            </div>\n\n            <md-button aria-label=\"Complete\" class=\"md-icon-button\" ng-if=\"$ctrl.meeting.state == \'CREATED\'\" ng-click=\"$ctrl.meeting.state=\'COMPLETED\'; $ctrl.meeting.$save([\'state\']);\">\n                <md-tooltip md-direction=\"down\">Finish meeting</md-tooltip>\n                <md-icon md-menu-origin>stop</md-icon>\n            </md-button>\n            <div aria-label=\"Completed\" class=\"md-icon-button\" ng-if=\"$ctrl.meeting.state == \'COMPLETED\'\">\n                <md-tooltip md-direction=\"down\">Finished meeting</md-tooltip>\n                <md-icon md-menu-origin>done</md-icon>\n            </div>\n\n            <md-button aria-label=\"Open notes\" class=\"md-icon-button\" ng-click=\"$ctrl.toggleRight()\" ng-if=\"$ctrl.meetingUser.notes && $ctrl.meetingUser.notes !== \'\'\">\n                <md-icon md-menu-origin style=\"color: yellow\">note_add</md-icon>\n            </md-button>\n            <md-button aria-label=\"Open notes\" class=\"md-icon-button\" ng-click=\"$ctrl.toggleRight()\" ng-if=\"!$ctrl.meetingUser.notes || $ctrl.meetingUser.notes == \'\'\">\n                <md-icon md-menu-origin>note_add</md-icon>\n            </md-button>\n\n        </div>\n    </div>\n</md-toolbar>\n\n<md-sidenav class=\"md-sidenav-right\" md-component-id=\"right\" md-disable-backdrop md-whiteframe=\"4\">\n\n    <md-toolbar class=\"md-theme-indigo\">\n        <div layout=\"row\" layout-align=\"center center\">\n            <h1 class=\"md-toolbar-tools\">My notes</h1>\n            <span flex></span>\n            <md-button class=\"md-icon-button\" ng-click=\"$ctrl.toggleRight()\">\n                <md-icon>close</md-icon>\n            </md-button>\n        </div>\n    </md-toolbar>\n\n    <md-content layout-margin>\n        <md-input-container style=\"width:90%\">\n            <textarea type=\"text\" class=\"meeting-notes\" ng-model=\"$ctrl.meetingUser.notes\" ng-change=\"$ctrl.meetingUser.$save([\'notes\'])\" aria-label=\"Notes\" ng-model-options=\"{updateOn: \'default blur\', debounce: {\'default\': 1000, \'blur\': 0}, updateOnDefault: true}\"></textarea>\n        </md-input-container>\n    </md-content>\n\n</md-sidenav>\n\n<md-content ng-model-options=\"{updateOn: \'default blur\', debounce: {\'default\': 1000, \'blur\': 0}, updateOnDefault: true}\" flex>\n    <div class=\"padding\">\n        <div layout=\"row\" layout-xs=\"column\">\n            <div layout=\"column\">\n                <md-card>\n                    <md-card-header layout=\"row\" layout-align=\"center center\">\n                        <md-card-header-text>\n                            <md-title flex>\n                                <span class=\"md-headline\">Participants</span>\n                            </md-title>\n                        </md-card-header-text>\n                        <md-menu>\n                            <md-button aria-label=\"Open menu\" class=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\">\n                                <md-icon>person_add</md-icon>\n                            </md-button>\n                            <md-menu-content width=\"4\">\n                                <md-menu-item ng-repeat=\"user in $ctrl.users\" ng-if=\"!$ctrl.userIsParticipant(user)\">\n                                    <md-button ng-click=\"$ctrl.addUser(user.id)\" style=\"padding-left: 10px !important\">\n                                        <span>{{user.name}}</span>\n                                    </md-button>\n                                </md-menu-item>\n                            </md-menu-content>\n                        </md-menu>\n                    </md-card-header>\n                    <md-card-content>\n                        <md-list>\n                            <md-list-item ng-repeat=\"meetingUser in $ctrl.meeting.$meetingUsers\">\n                                <div layout=\"row\" style=\"width: 100%\" layout-align=\"start center\">\n                                    <span flex>\n                                        {{ meetingUser.$user.name }}\n                                    </span>\n                                    <md-button class=\"md-icon-button\" ng-click=\"$ctrl.confirmDelete(meetingUser)\">\n                                        <md-icon>delete</md-icon>\n                                    </md-button>\n                                </div>\n                            </md-list-item>\n                        </md-list>\n                    </md-card-content>\n                </md-card>\n                <md-card>\n                    <md-card-header layout=\"row\" layout-align=\"center center\">\n                        <md-card-header-text>\n                            <md-title flex>\n                                <span class=\"md-headline\">Agenda</span>\n                            </md-title>\n                        </md-card-header-text>\n                        <md-menu>\n                            <md-button aria-label=\"Open menu\" class=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\">\n                                <md-icon>playlist_add</md-icon>\n                            </md-button>\n                            <md-menu-content width=\"2\">\n                                <md-menu-item>\n                                    <md-menu>\n                                        <md-button aria-label=\"Open menu\" ng-click=\"$mdMenu.open($event)\" flex>\n                                            Import\n                                        </md-button>\n                                        <md-menu-content width=\"3\">\n                                            <md-menu-item ng-repeat=\"template in $ctrl.templates\">\n                                                <md-button ng-click=\"$ctrl.addTemplate(template.id)\" style=\"padding-left: 10px !important\">\n                                                    <span>{{template.name}}</span>\n                                                </md-button>\n                                            </md-menu-item>\n                                        </md-menu-content>\n                                    </md-menu>\n                                </md-menu-item>\n                                <md-button ng-click=\"$ctrl.createNewTemplate()\">\n                                    Create New\n                                </md-button>\n                                <md-button ng-click=\"$ctrl.createNewTemplate()\">\n                                    Save As New\n                                </md-button>\n                            </md-menu-content>\n                        </md-menu>\n                    </md-card-header>\n                    <md-card-content>\n                        <md-list data-as-sortable=\"$ctrl.sortableListeners\" data-ng-model=\"$ctrl.meeting.$topics\" cg-busy=\"$ctrl.meeting.$topics.$promise\">\n                            <md-list-item ng-repeat=\"topic in $ctrl.meeting.$topics | orderBy: \'order\'\" cg-busy=\"topic.$promise\" data-as-sortable-item=\"topic\">\n                                <div layout=\"row\" layout-align=\"start center\">\n                                    <div layout=\"column\">\n                                        <md-icon data-as-sortable-item-handle style=\"margin-right: 5px; opacity: 0.5; cursor: move\" show-gt-xs>\n                                            drag_handle\n                                        </md-icon>\n                                    </div>\n                                    <div layout=\"column\" flex>\n                                        <md-input-container class=\"md-block\">\n                                            <textarea ng-keyup=\"autoExpand($event)\" ng-model=\"topic.description\" rows=\"1\" ng-model-options=\"{\'*\': \'$inherit\'}\" aria-label=\"topic\" ng-change=\"topic.$save([\'description\'])\"></textarea>\n                                        </md-input-container>\n                                    </div>\n                                    <div layout=\"column\">\n                                        <md-button class=\"md-icon-button\" ng-click=\"$ctrl.confirmDelete(topic)\">\n                                            <md-icon>delete</md-icon>\n                                        </md-button>\n                                    </div>\n                                </div>\n                            </md-list-item>\n                            <md-list-item>\n                                <md-input-container class=\"md-block\" flex>\n                                    <label>New topic</label>\n                                    <textarea ng-model=\"$ctrl.newDescription\" rows=\"1\" aria-label=\"NewTopic\" ng-keypress=\"autoExpand($event); $ctrl.isEnter($event) && $ctrl.addTopic($ctrl.newDescription)\"></textarea>\n                                </md-input-container>\n                                <md-button class=\"md-icon-button\" ng-click=\"$ctrl.addTopic($ctrl.newDescription); newDescription = \'\'\">\n                                    <md-icon>save</md-icon>\n                                </md-button>\n                            </md-list-item>\n                        </md-list>\n                    </md-card-content>\n                </md-card>\n                <md-card>\n                    <md-card-header layout=\"row\" layout-align=\"center center\">\n                        <md-card-header-text>\n                            <md-title flex>\n                                <span class=\"md-headline\">Files</span>\n                            </md-title>\n                        </md-card-header-text>\n                        <md-button class=\"md-icon-button\" ngf-select media-auto-upload ng-model=\"$ctrl.fileUpload\" ngf-model-invalid=\"$ctrl.invalidUploadedFiles\" ngf-max-size=\"2MB\">\n                            <md-icon>file_upload</md-icon>\n                        </md-button>\n                    </md-card-header>\n                    <md-card-content>\n                        <div layout=\"row\" ng-repeat=\"file in $ctrl.meeting.$meetingFiles\" style=\"padding: 2px 5px\">\n                            <div layout=\"row\" layout-align=\"center center\" class=\"file-preview editable-wrap\">\n                                <div layout=\"column\" flex>\n                                    <a href=\"{{file.file | mediaUrl}}\" target=\"_blank\" flex>\n                                        <textarea>{{::$ctrl.fileToName(file.file)}}</textarea>\n                                    </a>\n                                </div>\n                                <div layout=\"column\" layout-align=\"center center\">\n                                    <a href=\"{{file.file | mediaUrl}}\" target=\"_blank\" download>\n                                        <md-icon>file_download</md-icon>\n                                    </a>\n                                </div>\n                            </div>\n                            <div layout=\"column\" layout-align=\"center center\">\n                                <md-button class=\"md-icon-button\" style=\"margin: 0px !important\" ng-click=\"file.$destroy().$then($ctrl.meeting.$refresh(\'meetingFiles\'))\">\n                                    <md-icon style=\"font-size: 20px\">delete</md-icon>\n                                </md-button>\n                            </div>\n                        </div>\n                    </md-card-content>\n                </md-card>\n            </div>\n            <div layout=\"column\" flex>\n                <md-card>\n                    <md-card-header layout=\"row\" layout-align=\"center center\">\n                        <md-card-header-text>\n                            <md-title flex>\n                                <span class=\"md-headline\">Decisions</span>\n                            </md-title>\n                        </md-card-header-text>\n                    </md-card-header>\n                    <md-card-content>\n                        <md-list cg-busy=\"$ctrl.meeting.$decisions.$promise\">\n                            <md-list-item ng-repeat=\"decision in $ctrl.meeting.$decisions\" cg-busy=\"decision.$promise\">\n                                <div layout=\"row\" layout-align=\"start center\" flex>\n                                    <div layout=\"column\" flex>\n                                        <md-input-container class=\"md-block\" flex>\n                                            <textarea ng-keyup=\"autoExpand($event)\" ng-model=\"decision.description\" ng-model-options=\"{\'*\': \'$inherit\'}\" aria-label=\"NewDecision\" ng-change=\"decision.$save([\'description\'])\"></textarea>\n                                        </md-input-container>\n                                    </div>\n                                    <div layout=\"column\">\n                                        <md-button class=\"md-icon-button\" ng-click=\"$ctrl.confirmDelete(decision)\">\n                                            <md-icon>delete</md-icon>\n                                        </md-button>\n                                    </div>\n                                </div>\n                            </md-list-item>\n                            <md-list-item>\n                                <md-input-container class=\"md-block\" flex>\n                                    <label>New Decision</label>\n                                    <textarea ng-model=\"$ctrl.newDecisionDescription\" rows=\"1\" ng-keypress=\"autoExpand($event); $ctrl.isEnter($event) && $ctrl.addDecision($ctrl.newDecisionDescription)\"></textarea>\n                                </md-input-container>\n                                <md-button class=\"md-icon-button\" ng-click=\"$ctrl.addDecision($ctrl.newDecisionDescription); newDecisionDescription = \'\'\">\n                                    <md-icon>save</md-icon>\n                                </md-button>\n                            </md-list-item>\n                        </md-list>\n                    </md-card-content>\n                </md-card>\n            </div>\n        </div>\n    </div>\n</md-content>\n");
$templateCache.put("app/components/meetingsList/meetingsList.html","<maintoolbar></maintoolbar>\n\n<md-content>\n    <div class=\"padding\">\n        <div layout=\"row\" layout-xs=\"column\" layout-align=\"space-between none\">\n            <div layout=\"column\" layout-align=\"center stretch\" flex>\n                <div layout=\"row\" class=\"filters-bar\">\n                    <div layout=\"column\" layout-align=\"center center\">\n                        <md-icon>search</md-icon>\n                    </div>\n                    <input type=\"text\" flex placeholder=\"Search meetings\" ng-model=\"searchMeetings\">\n                </div>\n            </div>\n            <div style=\"margin:8px\"></div>\n            <div layout=\"row\" layout-align=\"end center\">\n\n                <div layout=\"column\" layout-align=\"center end\">\n		    <div class=\"filters-bar\" flex layout=\"column\" layout-align=\"center center\" style=\"min-width: 150px; min-height: 50px; background: #e6e6e6\">\n			<md-input-container class=\"execution-info-select\">\n			    <label>Project</label>\n			    <md-select placeholder=\"Project\" ng-model=\"$ctrl.projectFilter\" ng-change=\"$ctrl.changeFilters(\'project\', $ctrl.projectFilter)\" class=\"md-no-underline\">\n				<md-select-header>\n				    <input ng-model=\"projectSearchTerm\" type=\"search\" ng-keydown=\"$event.stopPropagation();\" force-select-focus class=\"md-text select-search\">\n				</md-select-header>\n				<md-option value=\"\"><i class=\"text-fade\">Any project</i></md-option>\n				<md-option value=\"null\"><i class=\"text-fade\">No project</i></md-option>\n\n				<md-option ng-repeat=\"project in $root.projects | filter: {name: projectSearchTerm} track by project.id\" value=\"{{::project.id}}\">\n				    {{::project.name}}\n				</md-option>\n			    </md-select>\n			</md-input-container>\n		    </div>\n                </div>\n                <div style=\"margin:8px\"></div>\n                <md-input-container layout=\"column\" layout-align=\"center center\" class=\"filters-bar\" style=\"min-height: 50px; background: #e6e6e6; margin: 0px\">\n                    <label>State</label>\n                    <md-select ng-model=\"$ctrl.filterState\" class=\"md-no-underline\">\n                        <md-option value=\"\"><i class=\"text-fade\">All</i></md-option>\n                        <md-option value=\"CREATED\">\n                            <div layout=\"row\" layout-align=\"center center\">\n                                <span>Created</span>\n                            </div>\n                        </md-option>\n                        <md-option value=\"COMPLETED\">\n                            <div layout=\"row\" layout-align=\"center center\">\n                                <span>Completed</span>\n                            </div>\n                        </md-option>\n                    </md-select>\n                </md-input-container>\n            </div>\n\n        </div>\n\n        <br>\n\n        <md-list>\n            <md-list-item ng-repeat=\"(key, value) in $ctrl.meetings | filter: {project : $ctrl.filterProject, state: $ctrl.filterState} | filter:searchMeetings | orderBy: \'-scheduleDate\' | groupBy: \'scheduleDate | date: \\\'MM-yyyy\\\'\'\">\n                <div layout=\"column\" flex>\n                    <div layout=\"row\" style=\"width: 100%\" layout-align=\"start center\">\n                        <h2 flex>{{::(key +\'\').toVerboseDate() | uppercase}}</h2>\n                    </div>\n                    <div layout=\"row\">\n                        <md-list style=\"width: 100%\">\n                            <md-list-item class=\"day\" ng-repeat=\"(day, meetings) in value | filter:searchMeetings | orderBy: \'-scheduleDate\' | groupBy: \'scheduleDate | date: \\\'dd-MM-yyyy\\\'\'\">\n                                <div layout=\"column\" flex>\n                                    <div class=\"day-title\" layout=\"row\" style=\"width: 100%\" layout-align=\"start center\">\n                                        <h4 flex>{{day.toVerboseDate()}}</h4>\n                                    </div>\n                                    <div class=\"day-meetings\" layout=\"row\">\n                                        <md-list style=\"width: 100%\">\n                                            <md-list-item class=\"meeting-details\" ui-sref=\"meetingDetails({id: meeting.id})\" ng-repeat=\"meeting in meetings | orderBy: \'scheduleDate\'\">\n                                                <div layout=\"row\" style=\"width: 100%\" layout-align=\"start stretch\">\n                                                    <div layout=\"column\" layout-align=\"center start\" flex>\n                                                        <span flex>{{::meeting.name}}</span>\n                                                    </div>\n                                                    <div layout=\"column\" layout-align=\"center center\" style=\"margin-left: 20px; min-width:25px\" ng-if=\"meeting.state == \'COMPLETED\'\">\n                                                        <md-icon>done</md-icon>\n                                                    </div>\n                                                    <div layout=\"column\" layout-align=\"center center\" style=\"margin-left: 15px; min-width:50px\">\n                                                        <span class=\"text-fade\">{{::meeting.project | projects}}</span>\n                                                    </div>\n                                                    <div layout=\"column\" layout-align=\"center center\" style=\"margin-left: 20px; min-width:25px\">\n                                                        <div layout=\"row\">\n                                                            <md-icon style=\"margin-right: 3px\">schedule</md-icon>\n                                                            <div layout=\"column\" ng-if=\"meeting.scheduleDate\"><span class=\"text-fade\">{{::meeting.scheduleDate | date:\'HH:mm\'}}</span></div>\n                                                            <div layout=\"column\" ng-if=\"!meeting.scheduleDate\"><span class=\"text-fade\">00:00</span></div>\n                                                        </div>\n                                                    </div>\n                                                    <div layout=\"column\" layout-align=\"center center\" style=\"margin-left: 15px; min-width:30px\">\n                                                        <div layout=\"row\">\n                                                            <md-icon style=\"margin-right: 3px\">hourglass_empty</md-icon>\n                                                            <div ng-if=\"meeting.scheduleDuration\"><span class=\"text-fade\">{{::meeting.scheduleDuration | limitTo:5}}</span></div>\n                                                            <div ng-if=\"!meeting.scheduleDuration\"><span class=\"text-fade\">00:00</span></div>\n                                                        </div>\n                                                    </div>\n                                                </div>\n                                            </md-list-item>\n                                        </md-list>\n                                    </div>\n                                </div>\n                            </md-list-item>\n                        </md-list>\n                    </div>\n                </div>\n            </md-list-item>\n        </md-list>\n    </div>\n    <paginator collection=\"::$ctrl.meetings\" style=\"margin: 30px 0\"></paginator>\n</md-content>\n\n<md-button class=\"md-fab md-mini create-meeting\" aria-label=\"Create Meeting\" ui-sref=\"newMeeting\">\n    <md-tooltip md-direction=\"top\">\n        New Meeting\n    </md-tooltip>\n    <md-icon>add</md-icon>\n</md-button>\n");
$templateCache.put("app/components/newMeeting/newMeeting.html","<md-toolbar>\n    <div class=\"md-toolbar-tools\">\n        <div layout=\"row\" layout-align=\"center center\" style=\"width: 100%\">\n            <md-button class=\"md-icon-button\" ui-sref=\"meetingsList\" layout=\"column\" layout-align=\"center center\">\n                <md-icon>arrow_back</md-icon>\n            </md-button>\n            <div layout=\"column\" flex>\n                <span style=\"font-size: 24px\">\n                    New Deploy\n                </span>\n            </div>\n            <md-button aria-label=\"Open notes\" class=\"md-icon-button\" ng-click=\"$ctrl.toggleRight()\" ng-if=\"$ctrl.userNotes && $ctrl.userNotes !== \'\'\">\n                <md-tooltip md-direction=\"down\">See your Notes</md-tooltip>\n                <md-icon md-menu-origin style=\"color: yellow\">note_add</md-icon>\n            </md-button>\n            <md-button aria-label=\"Open notes\" class=\"md-icon-button\" ng-click=\"$ctrl.toggleRight()\" ng-if=\"!$ctrl.userNotes || $ctrl.userNotes == \'\'\">\n                <md-tooltip md-direction=\"down\">Add Notes</md-tooltip>\n                <md-icon md-menu-origin>note_add</md-icon>\n            </md-button>\n            <md-button class=\"md-raised md-icon-button\" ng-click=\"$ctrl.saveMeeting()\" ng-disabled=\"$ctrl.requirements();\">\n                <md-tooltip md-direction=\"down\">Save Meeting</md-tooltip>\n                <md-icon>save</md-icon>\n            </md-button>\n        </div>\n    </div>\n</md-toolbar>\n\n<md-sidenav class=\"md-sidenav-right\" md-component-id=\"right\" md-disable-backdrop md-whiteframe=\"4\">\n\n    <md-toolbar class=\"md-theme-indigo\">\n        <div layout=\"row\" layout-align=\"center center\">\n            <h1 class=\"md-toolbar-tools\">My notes</h1>\n            <span flex></span>\n            <md-button class=\"md-icon-button\" ng-click=\"$ctrl.toggleRight()\">\n                <md-icon>close</md-icon>\n            </md-button>\n        </div>\n    </md-toolbar>\n\n    <md-content layout-margin>\n        <md-input-container style=\"width:90%\">\n            <textarea type=\"text\" class=\"meeting-notes\" ng-model=\"$ctrl.userNotes\" aria-label=\"Notes\" ng-model-options=\"{updateOn: \'default blur\', debounce: {\'default\': 1000, \'blur\': 0}, updateOnDefault: true}\"></textarea>\n        </md-input-container>\n    </md-content>\n\n</md-sidenav>\n\n<md-content ng-model-options=\"{updateOn: \'default blur\', debounce: {\'default\': 1000, \'blur\': 0}, updateOnDefault: true}\" flex>\n    <div class=\"padding\">\n        <div layout=\"row\" layout-xs=\"column\">\n            <div layout=\"column\">\n                <md-card>\n                    <md-card-header layout=\"row\" layout-align=\"center center\">\n                        <md-card-header-text>\n                            <md-title flex>\n                                <span class=\"md-headline\">Participants</span>\n                            </md-title>\n                        </md-card-header-text>\n                        <md-menu>\n                            <md-button aria-label=\"Open menu\" class=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\">\n                                <md-icon>person_add</md-icon>\n                            </md-button>\n                            <md-menu-content width=\"4\">\n                                <md-menu-item ng-repeat=\"user in $ctrl.users\" ng-if=\"!$ctrl.userIsParticipant(user) && user.id !== $ctrl.$rootScope.me.id\">\n                                    <md-button ng-click=\"$ctrl.addUser(user)\" style=\"padding-left: 10px !important\">\n                                        <span>{{user.name}}</span>\n                                    </md-button>\n                                </md-menu-item>\n                            </md-menu-content>\n                        </md-menu>\n                    </md-card-header>\n                    <md-card-content>\n                        <md-list>\n                            <md-list-item>\n                                <div layout=\"row\" style=\"width: 100%\" layout-align=\"start center\">\n                                    <span flex>\n                                        {{ $ctrl.$rootScope.me.name }}\n                                    </span>\n                                </div>\n                            </md-list-item>\n                            <md-list-item ng-repeat=\"meetingUser in $ctrl.meetingUsers\">\n                                <div layout=\"row\" style=\"width: 100%\" layout-align=\"start center\">\n                                    <span flex>\n                                        {{ meetingUser.name }}\n                                    </span>\n                                    <md-button class=\"md-icon-button\" ng-click=\"$ctrl.confirmRemoveUser(meetingUser)\">\n                                        <md-icon>delete</md-icon>\n                                    </md-button>\n                                </div>\n                            </md-list-item>\n                        </md-list>\n                    </md-card-content>\n                </md-card>\n                <md-card>\n                    <md-card-header layout=\"row\" layout-align=\"center center\">\n                        <md-card-header-text>\n                            <md-title flex>\n                                <span class=\"md-headline\">Files</span>\n                            </md-title>\n                        </md-card-header-text>\n                        <md-button class=\"md-icon-button\" ngf-select media-auto-upload ng-model=\"$ctrl.fileUpload\" ngf-model-invalid=\"$ctrl.invalidUploadedFiles\" ngf-max-size=\"2MB\">\n                            <md-icon>file_upload</md-icon>\n                        </md-button>\n                    </md-card-header>\n                    <md-card-content>\n                        <div layout=\"row\" ng-repeat=\"file in $ctrl.meetingFiles\" style=\"padding: 2px 5px\">\n                            <div layout=\"row\" layout-align=\"center center\" class=\"file-preview editable-wrap\">\n                                <div layout=\"column\" flex>\n                                    <a href=\"{{file | mediaUrl}}\" target=\"_blank\" flex>\n                                        <textarea>{{::$ctrl.fileToName(file)}}</textarea>\n                                    </a>\n                                </div>\n                                <div layout=\"column\" layout-align=\"center center\">\n                                    <a href=\"{{file | mediaUrl}}\" target=\"_blank\" download>\n                                        <md-icon>file_download</md-icon>\n                                    </a>\n                                </div>\n                            </div>\n                            <div layout=\"column\" layout-align=\"center center\">\n                                <md-button class=\"md-icon-button\" style=\"margin: 0px !important\" ng-click=\"$ctrl.removeMeetingFile(file)\">\n                                <md-icon style=\"font-size: 20px\">delete</md-icon>\n                                </md-button>\n                            </div>\n                        </div>\n                    </md-card-content>\n                </md-card>\n            </div>\n            <div layout=\"column\" flex>\n                <md-card>\n                    <md-card-header layout=\"row\" layout-align=\"center center\">\n                        <md-card-header-text>\n                            <md-title flex>\n                                <span class=\"md-headline\">Meeting Details</span>\n                            </md-title>\n                        </md-card-header-text>\n                    </md-card-header>\n                    <md-card-content class=\"padding\">\n                        <div layout=\"row\">\n                            <div layout=\"column\" flex style=\"margin-right: 10px\">\n                                <md-input-container>\n                                    <input type=\"text\" ng-model=\"$ctrl.meeting.name\" aria-label=\"Name\">\n                                </md-input-container>\n                            </div>\n                            <div layout=\"column\" style=\"margin-right: 10px\">\n                                <project-selector class=\"meeting-project\" ng-model=\"$ctrl.meeting.project\" ng-change=\"$ctrl.meeting.project = $project;\" style=\"color: black !important\">\n                                </project-selector>\n                            </div>\n                            <div layout=\"column\" style=\"margin-right: 10px\">\n                                <md-input-container>\n                                    <input type=\"datetime-local\" ng-model=\"$ctrl.meeting.scheduleDate\" style=\"max-width: 210px\" aria-label=\"Schedule Date\">\n                                </md-input-container>\n                            </div>\n                            <div layout=\"column\">\n                                <md-input-container>\n                                    <input type=\"text\" ng-model=\"$ctrl.duration\" ui-mask=\"99:99\" model-view-value=\"true\" ui-mask-placeholder ui-mask-placeholder-char=\"0\" ui-options=\"{clearOnBlur: false}\" ng-change=\"$ctrl.editDuration()\" style=\"max-width: 60px; text-align: center\" aria-label=\"Duration\">\n                                </md-input-container>\n                            </div>\n                        </div>\n                    </md-card-content>\n                </md-card>\n                <md-card>\n                    <md-card-header layout=\"row\" layout-align=\"center center\">\n                        <md-card-header-text>\n                            <md-title flex>\n                                <span class=\"md-headline\">Agenda</span>\n                            </md-title>\n                        </md-card-header-text>\n                        <md-menu>\n                            <md-button aria-label=\"Open menu\" class=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\">\n                                <md-icon>playlist_add</md-icon>\n                            </md-button>\n                            <md-menu-content width=\"2\">\n                                <md-menu-item>\n                                    <md-menu>\n                                        <md-button aria-label=\"Open menu\" ng-click=\"$mdMenu.open($event)\" flex>\n                                            Import\n                                        </md-button>\n                                        <md-menu-content width=\"3\">\n                                            <md-menu-item ng-repeat=\"template in $ctrl.templates\">\n                                                <md-button ng-click=\"$ctrl.addTemplate(template.id)\" style=\"padding-left: 10px !important\">\n                                                    <span>{{template.name}}</span>\n                                                </md-button>\n                                            </md-menu-item>\n                                        </md-menu-content>\n                                    </md-menu>\n                                </md-menu-item>\n                                <md-button ng-click=\"$ctrl.createNewTemplate()\">\n                                    Create New\n                                </md-button>\n                                <md-button ng-click=\"$ctrl.createNewTemplate()\">\n                                    Save As New\n                                </md-button>\n                            </md-menu-content>\n                        </md-menu>\n                    </md-card-header>\n                    <md-card-content>\n                        <md-list data-as-sortable=\"$ctrl.sortableListeners\" data-ng-model=\"$ctrl.meetingTopics\" cg-busy=\"$ctrl.meetingTopics.$promise\">\n                            <md-list-item ng-repeat=\"topic in $ctrl.meetingTopics\" cg-busy=\"topic.$promise\" data-as-sortable-item=\"topic\">\n                                <div layout=\"row\" layout-align=\"start center\">\n                                    <div layout=\"column\">\n                                        <md-icon data-as-sortable-item-handle style=\"margin-right: 5px; opacity: 0.5; cursor: move\" show-gt-xs>\n                                            drag_handle\n                                        </md-icon>\n                                    </div>\n                                    <div layout=\"column\" flex>\n                                        <md-input-container class=\"md-block\">\n                                            <textarea ng-keyup=\"autoExpand($event)\" ng-model=\"topic.description\" rows=\"1\" ng-model-options=\"{\'*\': \'$inherit\'}\" aria-label=\"topic\"></textarea>\n                                        </md-input-container>\n                                    </div>\n                                    <div layout=\"column\">\n                                        <md-button class=\"md-icon-button\" ng-click=\"$ctrl.confirmDeleteTopic(topic)\">\n                                            <md-icon>delete</md-icon>\n                                        </md-button>\n                                    </div>\n                                </div>\n                            </md-list-item>\n                            <md-list-item>\n                                <md-input-container class=\"md-block\" flex>\n                                    <label>New topic</label>\n                                    <textarea ng-model=\"$ctrl.newDescription\" rows=\"1\" aria-label=\"NewTopic\" ng-keypress=\"autoExpand($event); $ctrl.isEnter($event) && $ctrl.addTopic($ctrl.newDescription)\"></textarea>\n                                </md-input-container>\n                                <md-button class=\"md-icon-button\" ng-click=\"$ctrl.addTopic($ctrl.newDescription); $ctrl.newDescription = \'\'\">\n                                    <md-icon>save</md-icon>\n                                </md-button>\n                            </md-list-item>\n                        </md-list>\n                    </md-card-content>\n                </md-card>\n            </div>\n        </div>\n    </div>\n</md-content>\n\n");
$templateCache.put("app/components/paginator/paginator.html","<div layout=\"row\" layout-align=\"center center\">\n    <md-button class=\"md-icon-button md-accent\" ng-click=\"$ctrl.goToPreviousPage()\" ng-disabled=\"$ctrl.collection.$page == 1\">\n        <md-icon>chevron_left</md-icon>\n    </md-button>\n    <div class=\"text-fade text-center\">\n        <span style=\"font-size: 14px; text-transform: uppercase\">Página</span>\n        <span>{{$ctrl.collection.$page}} de {{$ctrl.collection.$totalCount / $ctrl.pageSize | number:0}}</span>\n    </div>\n    <md-button class=\"md-icon-button md-accent\" ng-click=\"$ctrl.goToNextPage()\" ng-disabled=\"($ctrl.collection.$page * $ctrl.pageSize) >= $ctrl.collection.$totalCount\">\n        <md-icon>chevron_right</md-icon>\n    </md-button>\n\n</div>\n");
$templateCache.put("app/components/projectSelector/projectSelector.html","<md-input-container class=\"execution-info-select\">\n    <label>Project</label>\n    <md-select ng-model=\"$ctrl.ngModel\" ng-change=\"$ctrl.changed()\" class=\"md-no-underline\">\n        <md-select-header>\n            <input ng-model=\"searchTerm\" type=\"search\" placeholder=\"Search Project\" class=\"md-text select-search\" ng-keydown=\"$event.stopPropagation();\" force-select-focus ng-model-options=\"{updateOn: \'default blur\', debounce: {\'default\': 0, \'blur\': 0}, updateOnDefault: true}\">\n        </md-select-header>\n\n        <md-option value=\"\"><i class=\"text-fade\">Any project</i></md-option>\n        <md-option value=\"null\"><i class=\"text-fade\">No project</i></md-option>\n        <md-option ng-value=\"project.id\" ng-repeat=\"project in $root.projects | fuzzyBy: \'name\' : searchTerm  | orderBy: \'name\'\" class=\"hide-icons\">\n            <div layout=\"row\" layout-align=\"center center\">\n                <span>{{project.name}}</span>\n            </div>\n        </md-option>\n    </md-select>\n</md-input-container>\n");
$templateCache.put("app/components/projectsList/projectsList.html","<maintoolbar></maintoolbar>\n\n<md-content>\n\n    <div class=\"padding\">\n        <div layout=\"row\" layout-align=\"center center\">\n            <h1>Projects</h1>\n            <span flex></span>\n            <md-button class=\"md-raised md-accent\" ng-click=\"$ctrl.displayNewProjectModal()\">\n                <md-icon>add</md-icon>\n                Create Project\n            </md-button>\n        </div>\n\n        <div layout=\"row\" layout-align=\"start stretch\" class=\"filters-bar\">\n            <div layout=\"column\" layout-align=\"center center\">\n                <md-icon>search</md-icon>\n            </div>\n            <input type=\"text\" flex placeholder=\"Search project\" ng-model=\"searchProjects\">\n        </div>\n\n        <md-list>\n            <md-list-item ng-repeat=\"project in $ctrl.projects | orderBy: \'name\' | fuzzyBy: \'name\' :searchProjects\">\n\n                <div layout=\"row\" style=\"width: 100%\" layout-align=\"start center\">\n                    <h3 flex>{{project.name}}</h3>\n\n                    <div layout=\"column\" layout-align=\"center center\" style=\"margin-left: 15px; min-width:50px\" class=\"text-fade\">\n                        <small>ETA</small>\n                        <div ng-if=\"project.totalEta\">{{::(project.totalEta + \'\').toHHMM()}}</div>\n                        <div ng-if=\"!project.totalEta\">00:00</div>\n                    </div>\n\n                    <div layout=\"column\" layout-align=\"center center\" style=\"margin-left: 15px; min-width:50px\" class=\"text-fade\">\n                        <small>Completed</small>\n                        <div ng-if=\"project.totalDuration\">{{::(project.totalDuration + \'\').toHHMM()}}</div>\n                        <div ng-if=\"!project.totalDuration\">00:00</div>\n                    </div>\n\n                    <div layout=\"row\" layout-align=\"end end\" style=\"margin-left: 15px; min-width:50px\" class=\"text-fade\">\n                        <div ng-if=\"project.totalDuration != null && project.totalEta\">\n                            {{::(project.totalDuration / project.totalEta * 100).toFixed(0)}}%\n                        </div>\n                        <div ng-if=\"!(project.totalDuration != null && project.totalEta)\">- - -</div>\n                        <md-icon>timelapse</md-icon>\n                    </div>\n                </div>\n\n            </md-list-item>\n        </md-list>\n    </div>\n</md-content>\n");
$templateCache.put("app/components/templateDetails/templateDetails.html","<md-toolbar>\n    <div class=\"md-toolbar-tools\">\n        <div layout=\"row\" layout-align=\"center center\" style=\"width: 100%\">\n            <md-button class=\"md-icon-button\" ui-sref=\"templatesList\">\n                <md-icon>arrow_back</md-icon>\n            </md-button>\n            <div layout=\"column\" flex>\n                <md-input-container>\n                    <input type=\"text\" ng-model=\"$ctrl.template.name\" ng-change=\"$ctrl.template.$save([\'name\'])\" aria-label=\"Name\">\n                </md-input-container>\n            </div>\n        </div>\n    </div>\n</md-toolbar>\n\n<md-content ng-model-options=\"{updateOn: \'default blur\', debounce: {\'default\': 1000, \'blur\': 0}, updateOnDefault: true}\" flex>\n    <div class=\"padding\">\n        <md-card>\n            <md-card-header layout=\"row\" layout-align=\"center center\">\n                <md-card-header-text>\n                    <md-title flex>\n                        <span class=\"md-headline\">Agenda</span>\n                    </md-title>\n                </md-card-header-text>\n            </md-card-header>\n            <md-card-content>\n                <md-list data-as-sortable=\"$ctrl.sortableListeners\" data-ng-model=\"$ctrl.template.$templateTopics\" cg-busy=\"$ctrl.template.$templateTopics.$promise\">\n                    <md-list-item ng-repeat=\"topic in $ctrl.template.$templateTopics | orderBy: \'order\'\" cg-busy=\"topic.$promise\" data-as-sortable-item=\"topic\">\n                        <div layout=\"row\" layout-align=\"start center\">\n                            <div layout=\"column\">\n                                <md-icon data-as-sortable-item-handle style=\"margin-right: 5px; opacity: 0.5; cursor: move\" show-gt-xs>\n                                    drag_handle\n                                </md-icon>\n                            </div>\n                            <div layout=\"column\" flex>\n                                <md-input-container class=\"md-block\">\n                                    <textarea ng-keyup=\"autoExpand($event)\" ng-model=\"topic.name\" rows=\"1\" ng-model-options=\"{\'*\': \'$inherit\'}\" aria-label=\"topic\" ng-change=\"topic.$save([\'name\'])\"></textarea>\n                                </md-input-container>\n                            </div>\n                            <div layout=\"column\">\n                                <md-button class=\"md-icon-button\" ng-click=\"$ctrl.confirmDelete(topic)\">\n                                    <md-icon>delete</md-icon>\n                                </md-button>\n                            </div>\n                        </div>\n                    </md-list-item>\n                    <md-list-item>\n                        <md-input-container class=\"md-block\" flex>\n                            <label>New topic</label>\n                            <textarea ng-model=\"$ctrl.newDescription\" rows=\"1\" aria-label=\"NewTopic\" ng-keypress=\"autoExpand($event); $ctrl.isEnter($event) && $ctrl.addTopic($ctrl.newDescription)\"></textarea>\n                        </md-input-container>\n                        <md-button class=\"md-icon-button\" ng-click=\"$ctrl.addTopic($ctrl.newDescription); newDescription = \'\'\">\n                            <md-icon>save</md-icon>\n                        </md-button>\n                    </md-list-item>\n                </md-list>\n            </md-card-content>\n        </md-card>\n    </div>\n</md-content>\n");
$templateCache.put("app/components/templatesList/templatesList.html","<maintoolbar></maintoolbar>\n\n<md-content>\n\n    <div class=\"padding\">\n        <div layout=\"row\" layout-align=\"center center\">\n            <h1>Templates</h1>\n            <span flex></span>\n            <md-button class=\"md-raised md-accent\" ng-click=\"$ctrl.displayNewTemplateModal()\">\n                <md-icon>add</md-icon>\n                Create Template\n            </md-button>\n        </div>\n\n        <div layout=\"row\" layout-align=\"start stretch\" class=\"filters-bar\">\n            <div layout=\"column\" layout-align=\"center center\">\n                <md-icon>search</md-icon>\n            </div>\n            <input type=\"text\" flex placeholder=\"Search template\" ng-model=\"searchTemplates\">\n        </div>\n\n        <md-list>\n            <md-list-item ng-repeat=\"template in $ctrl.templates | orderBy: \'name\' | fuzzyBy: \'name\' :searchTemplates\" ui-sref=\"templateDetails({id: template.id})\">\n\n                <div layout=\"row\" style=\"width: 100%\" layout-align=\"start center\">\n                    <h3 flex>{{template.name}}</h3>\n\n                    <div layout=\"column\" layout-align=\"center center\" style=\"margin-left: 15px; min-width:30px\">\n                        <div layout=\"row\" layout-align=\"center center\">\n                            <span class=\"text-fade\">{{::template.topicsCount}}</span>\n                            <md-icon style=\"margin-left: 3px; font-size: 22px\">format_list_bulleted</md-icon>\n                        </div>\n                    </div>\n                </div>\n\n            </md-list-item>\n        </md-list>\n    </div>\n</md-content>\n");
$templateCache.put("app/components/auth/views/auth.forgot.html","<div layout=\"column\" flex>\n    <md-toolbar>\n        <div class=\"md-toolbar-tools\">\n            <md-button class=\"md-icon-button\" ui-sref=\"login\">\n                <md-icon>arrow_back</md-icon>\n            </md-button>\n            <span>Recover password</span>\n        </div>\n    </md-toolbar>\n\n    <md-content class=\"no-background\" id=\"login-view\" flex layout=\"column\" layout-align=\"center center\">\n\n        <md-card>\n            <md-card-content class=\"auth-wrapper\">\n                <md-input-container class=\"general-login-error\" ng-if=\"vm.member.data.non_field_errors\">\n                    <div ng-messages>\n                        <div ng-repeat=\"message in vm.member.data.non_field_errors\">\n                            {{message}}\n                        </div>\n                    </div>\n                </md-input-container>\n\n                <p class=\"text-fade\">\n                    <small>Enter your email and we\'ll send you instructions to recover your password.</small>\n                </p>\n                <form ng-submit=\"vm.requestChange();\" cg-busy=\"vm.requestStatus\" ng-hide=\"vm.requestStatus.$$state.value.status==200\">\n                    <md-input-container class=\"md-block\" flex-gt-sm>\n                        <label>Email</label> <input ng-model=\"vm.email\" type=\"email\">\n                        <div ng-messages>\n                            <div ng-if=\"vm.requestStatus.$$state.value.data.detail\">\n                                {{vm.requestStatus.$$state.value.data.detail}}\n                            </div>\n                            <div ng-repeat=\"message in vm.requestStatus.$$state.value.data.email\" ng-if=\"vm.requestStatus.$$state.value.data.email\">\n                                {{message}}\n                            </div>\n                        </div>\n                    </md-input-container>\n\n                    <div layout=\"row\" layout-align=\"end center\">\n                        <md-button class=\"no-margin md-raised md-accent\" type=\"submit\" ng-disabled=\"!vm.email\"><span>Recover password</span>\n                        </md-button>\n                    </div>\n                    <p class=\"text-justify text-xs text-second text-fade\">\n                        <small>\n                            If you don\'t receive an email within the next 2 minutes, please check the spam.\n                        </small>\n                    </p>\n\n                </form>\n\n                <div ng-if=\"vm.requestStatus.$$state.value.status==200\" layout=\"column\" layout-padding=\"\" layout-align=\"center center\" style=\"border: solid rgba(150, 255, 150, 0.6) 2px; background-color: rgba(150, 255, 150, 0.2)\">\n                    <md-icon>email_outline</md-icon>\n                    <p style=\"text-align: center\">\n                        A link has been sent to your email to change your password <br>\n                    </p>\n                </div>\n            </md-card-content>\n        </md-card>\n\n    </md-content>\n\n    <style>\n        .wrapper {\n            max-width: 400px;\n            margin: auto;\n            padding-top: 50px;\n        }\n\n        #menu-sidenav {\n            border-right: solid 1px rgba(0, 0, 0, 0.1);\n        }\n    </style>\n</div>\n");
$templateCache.put("app/components/auth/views/auth.login.view.html","<md-content class=\"no-background\" id=\"login-view\" flex layout=\"column\" layout-align=\"center center\">\n\n    <h1 style=\"font-size: 70px; font-weight: 300; opacity: 0.7; letter-spacing: 1px; text-transform: uppercase\">Meetings</h1>\n\n    <md-card>\n        <md-card-content class=\"auth-wrapper\">\n            <br>\n            <form ng-submit=\"vm.login();\" style=\"min-width: 400px\">\n                <md-input-container class=\"general-login-error no-margin\" ng-if=\"vm.member.data.non_field_errors\">\n                    <div ng-messages class=\"text-center\">\n                        <small ng-repeat=\"message in vm.member.data.non_field_errors\">\n                            {{message}}\n                        </small>\n                    </div>\n                </md-input-container>\n                <md-input-container class=\"md-block\" flex-gt-sm>\n                    <label>Email</label>\n                    <input type=\"email\" ng-model=\"vm.email\">\n                    <div ng-messages>\n                        <div ng-repeat=\"message in vm.member.data.email\">\n                            {{message}}\n                        </div>\n                    </div>\n                </md-input-container>\n\n                <md-input-container class=\"md-block\" flex-gt-sm>\n                    <label>Password</label>\n                    <input type=\"password\" ng-model=\"vm.password\">\n                    <div ng-messages>\n                        <div ng-repeat=\"message in vm.member.data.password\">\n                            {{message}}\n                        </div>\n                    </div>\n                </md-input-container>\n\n                <div layout=\"column\" layout-align=\"center center\">\n                    <input type=\"submit\" value=\"Log in\" class=\"md-button md-raised md-accent\">\n                    <a ui-sref=\"forgot\"><small>Forgot your password?</small></a>\n                </div>\n            </form>\n        </md-card-content>\n    </md-card>\n\n    <div style=\"font-size: 11px\" class=\"text-center\">\n        <span>Need an account?</span>&nbsp<a ui-sref=\"register\">Sign up.</a>\n    </div>\n\n</md-content>\n\n");
$templateCache.put("app/components/auth/views/auth.register.view.html","<div layout=\"column\" flex>\n    <md-toolbar>\n            <div class=\"md-toolbar-tools\">\n                <md-button class=\"md-icon-button\" ui-sref=\"login\">\n                    <md-icon>arrow_back</md-icon>\n                </md-button>\n                <span>Create account</span>\n            </div>\n    </md-toolbar>\n\n    <md-content class=\"no-background\" id=\"login-view\" flex layout=\"column\" layout-align=\"center center\">\n        <md-card>\n            <md-card-content class=\"auth-wrapper\" style=\"min-width: 500px\">\n                <h1 align=\"center\">Create account</h1>\n                <br>\n                <div ng-if=\"vm.registering\">\n                    <form ng-submit=\"vm.register();\">\n                        <md-input-container class=\"general-login-error\" ng-if=\"vm.user.$response.data.non_field_errors\">\n                            <div ng-messages>\n                                <div ng-repeat=\"message in vm.user.data.non_field_errors\">\n                                    {{message}}\n                                </div>\n                            </div>\n                        </md-input-container>\n\n                        <md-input-container class=\"md-block\" flex-gt-sm>\n                            <label>Name</label>\n                            <input type=\"text\" ng-model=\"vm.user.name\">\n                            <div ng-messages>\n                                <div ng-repeat=\"message in vm.user.$response.data.name\">\n                                    {{message}}\n                                </div>\n                            </div>\n                        </md-input-container>\n\n                        <md-input-container class=\"md-block\" flex-gt-sm>\n                            <label>Email</label>\n                            <input ng-model=\"vm.user.email\" type=\"email\">\n                            <div ng-messages>\n                                <div ng-repeat=\"message in vm.user.$response.data.email\">\n                                    {{message}}\n                                </div>\n                            </div>\n                        </md-input-container>\n\n                        <md-input-container class=\"md-block\" flex-gt-sm>\n                            <label>Password</label>\n                            <input type=\"password\" ng-model=\"vm.user.password\">\n                            <div ng-messages>\n                                <div ng-repeat=\"message in vm.user.$response.data.password\">\n                                    {{message}}\n                                </div>\n                            </div>\n                        </md-input-container>\n\n                        <md-input-container class=\"md-block\" flex-gt-sm>\n                            <label>Confirm password</label>\n                            <input type=\"password\" ng-model=\"vm.user.confirmPassword\">\n                        </md-input-container>\n\n\n                        <div layout=\"row\" layout-align=\"center center\">\n                            <md-button type=\"submit\" class=\"md-button md-raised md-accent\"><span>Create account</span></md-button>\n                        </div>\n\n                    </form>\n                </div>\n                <div ng-if=\"!vm.registering\" cg-busy=\"vm.resendStatus.promise\">\n                    <br>\n                    <p class=\"text-sm\">\n                        <span ng-if=\"!vm.resent\">We sent an email</span>\n                        <span ng-if=\"vm.resent\">We resend the email</span>\n                        <span>to <b>{{vm.user.email}}</b>, with instructions to activate your account.</span>\n                    </p>\n\n                    <p class=\"text-sm\" ng-if=\"!vm.resent\">\n                        This check protects your account.\n                    </p>\n\n                    <p class=\"text-sm\">\n                        If you don\'t receive an email within the next two minutes, please check your spam.\n                    </p>\n\n                    <div layout=\"row\" layout-align=\"end\" ng-if=\"!vm.resent\">\n                        <md-button class=\"md-button md-raised md-accent\" ng-click=\"vm.resend();\">\n                            <span>Resend email</span>\n                        </md-button>\n                    </div>\n                </div>\n            </md-card-content>\n        </md-card>\n    </md-content>\n</div>\n\n\n");
$templateCache.put("app/components/auth/views/auth.set.password.html","<div layout=\"column\" flex>\n    <md-toolbar>\n        <div class=\"md-toolbar-tools\">\n            <md-button class=\"md-icon-button\" ui-sref=\"login\">\n                <md-icon>arrow_back</md-icon>\n            </md-button>\n            <span>Recover password</span>\n        </div>\n    </md-toolbar>\n\n    <md-content class=\"no-background\" id=\"login-view\" flex layout=\"column\" layout-align=\"center center\">\n        <md-card>\n            <md-card-content class=\"auth-wrapper\" style=\"min-width: 500px\">\n                <h1 align=\"center\">Recover password</h1>\n                <br>\n                    <form ng-submit=\"vm.setPassword();\" cg-busy=\"vm.requestStatus\">\n                        <md-input-container class=\"md-block\" flex-gt-sm>\n                            <label>New password</label> <input type=\"password\" ng-model=\"vm.password\">\n                            <div ng-messages>\n                                <div>\n                                    {{vm.requestStatus.$$state.value.data.detail}}\n                                </div>\n                            </div>\n                        </md-input-container>\n                        <md-input-container class=\"md-block\" flex-gt-sm>\n                            <label>Confirm password</label>\n                            <input type=\"password\" ng-model=\"vm.confirmPassword\">\n                            <div ng-messages>\n                                <div>\n                                    {{vm.requestStatus.$$state.value.data.detail}}\n                                </div>\n                            </div>\n                        </md-input-container>\n                        <div layout=\"row\" layout-align=\"end end\">\n                            <md-tooltip ng-if=\"vm.password != vm.confirmPassword\">\n                                <span>Please check that both passwords matches</span>\n                            </md-tooltip>\n                            <md-button class=\"no-margin\" type=\"submit\" ng-disabled=\"(vm.password != vm.confirmPassword) || !vm.password\">\n                                <span class=\"md-button md-raised md-accent\">Change password</span>\n                            </md-button>\n                        </div>\n                    </form>\n                </md-card-content>\n            </md-card>\n        </md-content></div>\n    \n\n    <style>\n        .wrapper {\n            max-width: 400px;\n            margin: auto;\n            padding-top: 50px;\n        }\n\n        #menu-sidenav {\n            border-right: solid 1px rgba(0, 0, 0, 0.1);\n        }\n    </style>\n\n");
$templateCache.put("app/shared/html/cgbusy/cgbusy.template.html","<div class=\"cg-busy-processing-wrapper\" layout=\"row\" layout-align=\"center center\">\n    <span>{{$message}}</span>\n    <md-progress-circular md-mode=\"indeterminate\"></md-progress-circular>\n</div>\n\n\n<style>\n    .cg-busy-processing-wrapper {\n        position: relative;\n        width: 100%;\n        height: 100%;\n    }\n</style>\n");
$templateCache.put("app/shared/html/maintoolbar/maintoolbar.html","<md-toolbar>\n    <div class=\"md-toolbar-tools\">\n        <div layout=\"row\" layout-align=\"center center\" style=\"width: 100%\">\n            <md-menu>\n                <md-button aria-label=\"Open menu\" class=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\">\n                    <md-icon md-menu-origin>menu</md-icon>\n                </md-button>\n                <md-menu-content width=\"4\" style=\"padding-top: 0\" class=\"top-menu\">\n                    <md-menu-item layout=\"row\" layout-align=\"center center\">\n                        <md-button ui-sref=\"meetingsList\">\n                            <md-icon style=\"padding-left: 10px\">event_note</md-icon>\n                            <span>Meetings</span>\n                        </md-button>\n                    </md-menu-item>\n                    <md-menu-item>\n                        <md-button ui-sref=\"projectsList\">\n                            <md-icon style=\"padding-left: 10px\">work</md-icon>\n                            Projects\n                        </md-button>\n                    </md-menu-item>\n                    <md-menu-item>\n                        <md-button ui-sref=\"templatesList\">\n                            <md-icon style=\"padding-left: 10px\">library_books</md-icon>\n                            Templates\n                        </md-button>\n                    </md-menu-item>\n                </md-menu-content>\n            </md-menu>\n            <span flex></span>\n            <md-menu md-position-mode=\"target-right target\">\n\n                <md-button aria-label=\"Open profile menu\" class=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\">\n                    <img ng-src=\"{{$ctrl.user.avatar | mediaUrl}}\" style=\"max-width:30px; max-height: 30px; border-radius: 600px; margin-right: 10px\">\n                </md-button>\n                <md-menu-content width=\"4\" style=\"padding-top: 0\">\n                    <md-toolbar layout=\"row\" layout-align=\"center center\">\n                        <div layout=\"row\" layout-align=\"center center\" style=\"margin-left: 10px; margin-right: 10px\">\n                            <div layout=\"column\">\n                                <img ng-src=\"{{$ctrl.user.avatar | mediaUrl}}\" style=\"max-width:40px; max-height: 40px; border-radius: 600px; margin-right: 10px\">\n                            </div>\n                            <div layout=\"column\">\n                                <small>{{$ctrl.user.name}}</small>\n                            </div>\n                        </div>\n                    </md-toolbar>\n                    <md-menu-item>\n                        <md-button ui-sref=\"profile\">\n                            <md-icon>settings</md-icon>\n                            Edit Profile\n                        </md-button>\n                    </md-menu-item>\n                    <md-menu-item>\n                        <md-button ui-sref=\"logout\">\n                            <md-icon>exit_to_app</md-icon>\n                            Log Out\n                        </md-button>\n                    </md-menu-item>\n                </md-menu-content>\n            </md-menu>\n        </div>\n    </div>\n</md-toolbar>\n");}]);
'use strict';

var cov_2mi9unfvmc = function () {
    var path = '/home/lobo/repos/meetings-app/src/routes.js',
        hash = 'f4b90a14bf860a8babe5bfa069a1c7bac2a53441',
        Function = function () {}.constructor,
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/meetings-app/src/routes.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 3,
                    column: 22
                }
            },
            '1': {
                start: {
                    line: 7,
                    column: 4
                },
                end: {
                    line: 7,
                    column: 54
                }
            },
            '2': {
                start: {
                    line: 8,
                    column: 4
                },
                end: {
                    line: 8,
                    column: 38
                }
            },
            '3': {
                start: {
                    line: 10,
                    column: 4
                },
                end: {
                    line: 98,
                    column: 7
                }
            },
            '4': {
                start: {
                    line: 51,
                    column: 34
                },
                end: {
                    line: 51,
                    column: 47
                }
            },
            '5': {
                start: {
                    line: 64,
                    column: 41
                },
                end: {
                    line: 64,
                    column: 103
                }
            },
            '6': {
                start: {
                    line: 64,
                    column: 85
                },
                end: {
                    line: 64,
                    column: 93
                }
            },
            '7': {
                start: {
                    line: 71,
                    column: 54
                },
                end: {
                    line: 71,
                    column: 127
                }
            },
            '8': {
                start: {
                    line: 71,
                    column: 110
                },
                end: {
                    line: 71,
                    column: 117
                }
            },
            '9': {
                start: {
                    line: 78,
                    column: 41
                },
                end: {
                    line: 78,
                    column: 103
                }
            },
            '10': {
                start: {
                    line: 78,
                    column: 85
                },
                end: {
                    line: 78,
                    column: 93
                }
            },
            '11': {
                start: {
                    line: 85,
                    column: 43
                },
                end: {
                    line: 85,
                    column: 108
                }
            },
            '12': {
                start: {
                    line: 85,
                    column: 89
                },
                end: {
                    line: 85,
                    column: 98
                }
            },
            '13': {
                start: {
                    line: 92,
                    column: 56
                },
                end: {
                    line: 92,
                    column: 132
                }
            },
            '14': {
                start: {
                    line: 92,
                    column: 114
                },
                end: {
                    line: 92,
                    column: 122
                }
            }
        },
        fnMap: {
            '0': {
                name: 'routesConfig',
                decl: {
                    start: {
                        line: 6,
                        column: 9
                    },
                    end: {
                        line: 6,
                        column: 21
                    }
                },
                loc: {
                    start: {
                        line: 6,
                        column: 78
                    },
                    end: {
                        line: 99,
                        column: 1
                    }
                },
                line: 6
            },
            '1': {
                name: '(anonymous_1)',
                decl: {
                    start: {
                        line: 51,
                        column: 18
                    },
                    end: {
                        line: 51,
                        column: 19
                    }
                },
                loc: {
                    start: {
                        line: 51,
                        column: 34
                    },
                    end: {
                        line: 51,
                        column: 47
                    }
                },
                line: 51
            },
            '2': {
                name: '(anonymous_2)',
                decl: {
                    start: {
                        line: 64,
                        column: 22
                    },
                    end: {
                        line: 64,
                        column: 23
                    }
                },
                loc: {
                    start: {
                        line: 64,
                        column: 41
                    },
                    end: {
                        line: 64,
                        column: 103
                    }
                },
                line: 64
            },
            '3': {
                name: '(anonymous_3)',
                decl: {
                    start: {
                        line: 64,
                        column: 71
                    },
                    end: {
                        line: 64,
                        column: 72
                    }
                },
                loc: {
                    start: {
                        line: 64,
                        column: 85
                    },
                    end: {
                        line: 64,
                        column: 93
                    }
                },
                line: 64
            },
            '4': {
                name: '(anonymous_4)',
                decl: {
                    start: {
                        line: 71,
                        column: 21
                    },
                    end: {
                        line: 71,
                        column: 22
                    }
                },
                loc: {
                    start: {
                        line: 71,
                        column: 54
                    },
                    end: {
                        line: 71,
                        column: 127
                    }
                },
                line: 71
            },
            '5': {
                name: '(anonymous_5)',
                decl: {
                    start: {
                        line: 71,
                        column: 97
                    },
                    end: {
                        line: 71,
                        column: 98
                    }
                },
                loc: {
                    start: {
                        line: 71,
                        column: 110
                    },
                    end: {
                        line: 71,
                        column: 117
                    }
                },
                line: 71
            },
            '6': {
                name: '(anonymous_6)',
                decl: {
                    start: {
                        line: 78,
                        column: 22
                    },
                    end: {
                        line: 78,
                        column: 23
                    }
                },
                loc: {
                    start: {
                        line: 78,
                        column: 41
                    },
                    end: {
                        line: 78,
                        column: 103
                    }
                },
                line: 78
            },
            '7': {
                name: '(anonymous_7)',
                decl: {
                    start: {
                        line: 78,
                        column: 71
                    },
                    end: {
                        line: 78,
                        column: 72
                    }
                },
                loc: {
                    start: {
                        line: 78,
                        column: 85
                    },
                    end: {
                        line: 78,
                        column: 93
                    }
                },
                line: 78
            },
            '8': {
                name: '(anonymous_8)',
                decl: {
                    start: {
                        line: 85,
                        column: 23
                    },
                    end: {
                        line: 85,
                        column: 24
                    }
                },
                loc: {
                    start: {
                        line: 85,
                        column: 43
                    },
                    end: {
                        line: 85,
                        column: 108
                    }
                },
                line: 85
            },
            '9': {
                name: '(anonymous_9)',
                decl: {
                    start: {
                        line: 85,
                        column: 74
                    },
                    end: {
                        line: 85,
                        column: 75
                    }
                },
                loc: {
                    start: {
                        line: 85,
                        column: 89
                    },
                    end: {
                        line: 85,
                        column: 98
                    }
                },
                line: 85
            },
            '10': {
                name: '(anonymous_10)',
                decl: {
                    start: {
                        line: 92,
                        column: 22
                    },
                    end: {
                        line: 92,
                        column: 23
                    }
                },
                loc: {
                    start: {
                        line: 92,
                        column: 56
                    },
                    end: {
                        line: 92,
                        column: 132
                    }
                },
                line: 92
            },
            '11': {
                name: '(anonymous_11)',
                decl: {
                    start: {
                        line: 92,
                        column: 100
                    },
                    end: {
                        line: 92,
                        column: 101
                    }
                },
                loc: {
                    start: {
                        line: 92,
                        column: 114
                    },
                    end: {
                        line: 92,
                        column: 122
                    }
                },
                line: 92
            }
        },
        branchMap: {},
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0,
            '7': 0,
            '8': 0,
            '9': 0,
            '10': 0,
            '11': 0,
            '12': 0,
            '13': 0,
            '14': 0
        },
        f: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0,
            '7': 0,
            '8': 0,
            '9': 0,
            '10': 0,
            '11': 0
        },
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_2mi9unfvmc.s[0]++;
angular.module('app').config(routesConfig);

/** @ngInject */
function routesConfig($stateProvider, $urlRouterProvider, $locationProvider) {
    cov_2mi9unfvmc.f[0]++;
    cov_2mi9unfvmc.s[1]++;

    $locationProvider.html5Mode(true).hashPrefix('!');
    cov_2mi9unfvmc.s[2]++;
    $urlRouterProvider.otherwise('/');

    cov_2mi9unfvmc.s[3]++;
    $stateProvider.state('login', {
        url: '/login',
        templateUrl: 'app/components/auth/views/auth.login.view.html',
        controller: 'AuthLoginController',
        controllerAs: 'vm'
    }).state('logout', {
        url: '/logout',
        template: '<div></div>',
        controller: 'AuthLogoutController',
        controllerAs: 'vm'
    }).state('forgot', {
        url: '/forgot_password',
        templateUrl: 'app/components/auth/views/auth.forgot.html',
        controller: 'AuthForgotController',
        controllerAs: 'vm'
    }).state('set_password', {
        url: '/reset_password?token=&email=',
        templateUrl: 'app/components/auth/views/auth.set.password.html',
        controller: 'AuthSetPasswordController',
        controllerAs: 'vm'
    }).state('register', {
        url: '/register',
        templateUrl: 'app/components/auth/views/auth.register.view.html',
        controller: 'AuthRegisterController',
        controllerAs: 'vm'
    }).state('activate', {
        url: '/activate?token=',
        template: '<div></div>',
        controller: 'AuthActivateController',
        controllerAs: 'vm'
    }).state('profile', {
        url: '/profile',
        template: '<edit-profile user="$resolve.user" flex layout="column"/>',
        resolve: {
            user: ["$rootScope", function user($rootScope) {
                cov_2mi9unfvmc.f[1]++;
                cov_2mi9unfvmc.s[4]++;
                return $rootScope.me;
            }]
        }
    }).state('dashboard', {
        url: '/',
        controller: 'DashboardController',
        controllerAs: 'vm',
        template: '<div></div>'
    }).state('meetingsList', {
        url: '/meetings?page&project',
        template: '<meetings-list meetings="$resolve.meetings" flex layout="column"/>',
        resolve: {
            meetings: ["MeetingsTable", function meetings(MeetingsTable) {
                cov_2mi9unfvmc.f[2]++;
                cov_2mi9unfvmc.s[5]++;
                return MeetingsTable.$search().$then(function (meetings) {
                    cov_2mi9unfvmc.f[3]++;
                    cov_2mi9unfvmc.s[6]++;
                    return meetings;
                }).$promise;
            }]
        }
    }).state('meetingDetails', {
        url: '/meeting/:id',
        template: '<meeting-details meeting="$resolve.meeting" flex layout="column">',
        resolve: {
            meeting: ["MeetingsTable", "$stateParams", function meeting(MeetingsTable, $stateParams) {
                cov_2mi9unfvmc.f[4]++;
                cov_2mi9unfvmc.s[7]++;
                return MeetingsTable.$find($stateParams.id).$then(function (meeting) {
                    cov_2mi9unfvmc.f[5]++;
                    cov_2mi9unfvmc.s[8]++;
                    return meeting;
                }).$promise;
            }]
        }
    }).state('projectsList', {
        url: '/projects',
        template: '<projects-list projects="$resolve.projects" flex layout="column"/>',
        resolve: {
            projects: ["ProjectsTable", function projects(ProjectsTable) {
                cov_2mi9unfvmc.f[6]++;
                cov_2mi9unfvmc.s[9]++;
                return ProjectsTable.$search().$then(function (projects) {
                    cov_2mi9unfvmc.f[7]++;
                    cov_2mi9unfvmc.s[10]++;
                    return projects;
                }).$promise;
            }]
        }
    }).state('templatesList', {
        url: '/templates',
        template: '<templates-list templates="$resolve.templates" flex layout="column"/>',
        resolve: {
            templates: ["TemplatesTable", function templates(TemplatesTable) {
                cov_2mi9unfvmc.f[8]++;
                cov_2mi9unfvmc.s[11]++;
                return TemplatesTable.$search().$then(function (templates) {
                    cov_2mi9unfvmc.f[9]++;
                    cov_2mi9unfvmc.s[12]++;
                    return templates;
                }).$promise;
            }]
        }
    }).state('templateDetails', {
        url: '/template/:id',
        template: '<template-details template="$resolve.template" flex layout="column">',
        resolve: {
            template: ["TemplatesTable", "$stateParams", function template(TemplatesTable, $stateParams) {
                cov_2mi9unfvmc.f[10]++;
                cov_2mi9unfvmc.s[13]++;
                return TemplatesTable.$find($stateParams.id).$then(function (template) {
                    cov_2mi9unfvmc.f[11]++;
                    cov_2mi9unfvmc.s[14]++;
                    return template;
                }).$promise;
            }]
        }
    }).state('newMeeting', {
        url: '/meetings/new',
        template: '<new-meeting flex layout="column">'
    });
}